/**
 * THIS FILE IS GENERATED, DO NOT MODIFY THEM...
 */
import { Callbacks, ExecuteRequest } from './apiRuntime';

 export interface MessageResponse {
    path: string;
    scope: ScopeEnum;
    type: TypeEnum;
    message: string;
    params?: string[];
    locized?: boolean;
}

export interface ResponseResult {
    success: boolean;
    errorType?: ErrorTypeEnum;
    messages: MessageResponse[];
    payload?: any;
}

export interface NullableBigDecimalWrapper {
    value?: number;
}

export interface NullableStringWrapper {
    value?: string;
}

export interface UpdateCmrCustomDataV2ManipulationUnitRequestInDTO {
    mpSignoNumber?: NullableStringWrapper;
    mpCount?: NullableBigDecimalWrapper;
    mpPackagingName?: NullableStringWrapper;
    mpName?: NullableStringWrapper;
    mpStatisticsNumber?: NullableStringWrapper;
    mpCompleteWeight?: NullableBigDecimalWrapper;
    mpVolume?: NullableBigDecimalWrapper;
}

export interface UpdateCmrCustomDataV2RequestInDTO {
    completeSender?: NullableStringWrapper;
    completeConsignee?: NullableStringWrapper;
    successiveCarriers?: NullableStringWrapper;
    attachedDocumentsNumber5?: NullableStringWrapper;
    sendersInstructions?: NullableStringWrapper;
    toBePaidBy?: NullableStringWrapper;
    instructionAsToPaymentForCarriage?: NullableStringWrapper;
    specialAgreements?: NullableStringWrapper;
    estabilishedIn?: NullableStringWrapper;
    dzvvNumber?: NullableStringWrapper;
    rideNumber?: NullableStringWrapper;
    borderCrossings?: NullableStringWrapper;
    others?: NullableStringWrapper;
    attachedDocumentsNumber30?: NullableStringWrapper;
    confirmationOfCustomsPapers?: NullableStringWrapper;
    cashOnDelivery?: NullableStringWrapper;
    carriersReservationsAndObservations?: NullableStringWrapper;
    weight?: NullableBigDecimalWrapper;
    unClass?: NullableStringWrapper;
    manipulationUnits?: UpdateCmrCustomDataV2ManipulationUnitRequestInDTO[];
}

export interface SaveUserTableFilterFavouritesRequestInDTO {
    filterKeys: string[];
}

export interface UpdateReportPermissionRequest {
    wholeCompany: boolean;
    permittedUserIds: string[];
}

export interface UpdateDocumentRequest {
    documentType: DocumentTypeEnum;
    userDateLocalDate?: string;
    userNote?: string;
}

export interface TurnOffResolvedEmailRequestInDTO {
    turnOff: boolean;
    sleep: number;
}

export interface TableViewColumnDTO {
    id: string;
    members: string[];
    title?: string;
    width?: number;
}

export interface TableViewSortDTO {
    sortField: string;
    sortDirection: string;
}

export interface UpdateTableViewInDTO {
    name: string;
    filter: string;
    sort: TableViewSortDTO;
    columns: TableViewColumnDTO[];
    favouriteFilters?: string[];
    pageSize?: number;
    pagingMode?: PagingModeEnum;
    version: number;
}

export interface TableViewOutDTO {
    id: string;
    tableKey: TableKeyEnum;
    name: string;
    viewVisibility: ViewVisibilityEnum;
    ownerId: string;
    ownerFullName: string;
    editable: boolean;
    version: number;
    createdAt: string;
    updatedAt: string;
    filter: string;
    sort: TableViewSortDTO;
    columns: TableViewColumnDTO[];
    favouriteFilters?: string[];
    pageSize?: number;
    pagingMode?: PagingModeEnum;
}

export interface SetTableViewVisibilityInDTO {
    viewVisibility: ViewVisibilityEnum;
    version: number;
}

export interface TableViewPrefsInDTO {
    order: string[];
    hidden: string[];
    activeViewId?: string;
    pagingModes: any;
    columnWidths: any;
}

export interface TableViewPrefsOutDTO {
    tableKey: TableKeyEnum;
    order: string[];
    hidden: string[];
    activeViewId?: string;
    pagingModes: any;
    columnWidths: any;
}

export interface UpdateTransportTypeDAPSNOutDTO {
    transportationType: TransportationTypeEnum;
}

export interface UpdateShipmentDAPSNOutDTO {
    shipmentNumber: string;
}

export interface UpdateResponsiblePersonDAPSNOutDTO {
    responsiblePersonId?: string;
}

export interface ExternalOrderRequest {
    orderNumber: string;
    timeFrom?: string;
    timeTo?: string;
}

export interface GlobalOrderItemDetailsRequest {
    externalId?: string;
    name?: string;
    count?: number;
    weight?: number;
    size?: string;
    wheelbase?: string;
}

export interface GlobalOrderItemsRequest {
    cargoTemplateCode: string;
    stackable: boolean;
    amount: number;
    height?: number;
    width?: number;
    length?: number;
    weight?: number;
    itemNote?: string;
    details?: GlobalOrderItemDetailsRequest[];
}

export interface GlobalOrdersRequest {
    id?: string;
    orderName: string;
    orderNote?: string;
    orderValue?: PriceRequest;
    orderAmount?: number;
    orderDescription?: string;
    orderTotalWeight?: number;
    items: GlobalOrderItemsRequest[];
    externalOrders?: ExternalOrderRequest[];
}

export interface PriceRequest {
    price?: number;
    currency: string;
}

export interface UpdateOrdersDAPSNOutDTO {
    orders: GlobalOrdersRequest[];
}

export interface UpdateNotifyUsersDAPSNOutDTO {
    userIdsToNotify?: string[];
}

export interface UpdateNotifyByRoleDAPSNOutDTO {
    notifyUsersDependsOnRole: boolean;
}

export interface UpdateNoteDAPSNOutDTO {
    note?: string;
}

export interface GlobalDayWithInterval {
    /**
     * @deprecated 
The specific date and time for this timeslot. Typically represents the start of the day.
The date component determines which calendar day these intervals apply to.
Take LocalDate from it.

     */
    day: string;
    utcDay?: string;
    openingMode: OpeningModeEnum;
    intervals: GlobalInterval[];
}

export interface GlobalInterval {
    sinceHoursString: string;
    tillHoursString: string;
}

export interface GlobalTimeslots {
    dayWithInterval: GlobalDayWithInterval[];
    timezoneId?: string;
}

export interface UpdateLocationDAPSNOutDTO {
    companyId: string;
    locationId: string;
    timeslots: GlobalTimeslots;
}

export interface UpdateInternalInvoiceDAPSNOutDTO {
    internalInvoiceNumber?: string;
    invoiceDueDate?: string;
}

export interface UpdateInternalNoteDAPSNOutDTO {
    internalNote?: string;
}

export interface UpdateFolderSNInDTO {
    /**
     * @deprecated RD-2977: use folderIds
     */
    folderId?: string;
    folderIds?: string[];
}

export interface UpdateCarrierNameDAPSNOutDTO {
    carrierName: string;
}

export interface SendToEurowagInDTO {
    customerId: string;
    applicationId: string;
}

export interface SendToEurowagOutDTO {
    ewShipmentID: string;
}

export interface ReservationFlagDTO {
    reservationFlagType: ReservationFlagTypeEnum;
    units?: number;
    discrepancyUnits?: number;
}

export interface UpdateReservationFlagsInDTO {
    flags: ReservationFlagDTO[];
}

export interface UpdateReservationFlagsOutDTO {
    reservationId: string;
    flags: ReservationFlagDTO[];
}

export interface ReservationStatisticsRequestInDTO {
    fromDay: string;
    futureDay: number;
    rampIds: string[];
}

export interface ReservationStatisticsInnerDayResponseOutDTO {
    date: string;
    count: number;
}

export interface ReservationStatisticsInnerResponseOutDTO {
    sum: number;
    days: ReservationStatisticsInnerDayResponseOutDTO[];
}

export interface ReservationStatisticsResponseOutDTO {
    countReservationStats: ReservationStatisticsInnerResponseOutDTO;
    countManUnitsStats: ReservationStatisticsInnerResponseOutDTO;
    countTimeStats: ReservationStatisticsInnerResponseOutDTO;
}

export interface SchenkerAdditionalInfoInDTO {
    declarantInfo?: SchenkerDeclarantContactDTO;
    valueOfGoods?: SchenkerValueOfGoodsDTO;
}

export interface SchenkerDeclarantContactDTO {
    companyName: string;
    street: string;
    postalCode: string;
    city: string;
    countryCode: string;
    phone: string;
    email: string;
}

export interface SchenkerValueOfGoodsDTO {
    price: number;
    currency: string;
}

export interface SchenkerAdditionalInfoOutDTO {
    declarantInfo?: SchenkerDeclarantContactDTO;
    valueOfGoods?: SchenkerValueOfGoodsDTO;
}

export interface FedexBrokerDTO {
    accountNumber?: string;
    tinNumber?: string;
    tinType?: string;
    companyName?: string;
    personName?: string;
    phoneNumber?: string;
    email?: string;
    street?: string;
    city?: string;
    postalCode?: string;
    country?: string;
}

export interface FedexCommodityInDTO {
    description: string;
    harmonizedCode: string;
    countryOfManufacture: string;
    quantity: number;
    quantityUnits: string;
    unitPrice: number;
    weightKg: number;
    merchantProductId?: string;
    manufacturerProductId?: string;
    standardProductId?: string;
}

export interface FedexCustomsInfoInDTO {
    totalCustomsValue: number;
    currency: string;
    shipmentPurpose: string;
    consumerRecipient: boolean;
    commodities: FedexCommodityInDTO[];
    dutiesPaymentType?: string;
    dutiesPayerAccountNumber?: string;
    dutiesPayerCountry?: string;
    comments?: string;
    originatorName?: string;
    taxesOrMiscellaneousChargeAmount?: number;
    taxesOrMiscellaneousChargeCurrency?: string;
    insuranceChargeAmount?: number;
    insuranceChargeCurrency?: string;
    freightChargeAmount?: number;
    freightChargeCurrency?: string;
    invoiceCustomerReference?: string;
    isDocumentOnly: boolean;
    electronicTradeDocuments: boolean;
    recipientCustomsIdType?: string;
    recipientCustomsIdValue?: string;
    customsOptionType?: string;
    customsOptionDescription?: string;
    broker?: FedexBrokerDTO;
    specialCargo?: FedexSpecialCargoDTO;
}

export interface FedexSpecialCargoDTO {
    type: string;
    batteryMaterialType?: string;
    batteryPackingType?: string;
    dgAccessibility?: string;
    dgCargoAircraftOnly?: boolean;
}

export interface FedexCommodityDTO {
    description: string;
    harmonizedCode: string;
    countryOfManufacture: string;
    quantity: number;
    quantityUnits: string;
    unitPrice: number;
    weightKg: number;
    merchantProductId?: string;
    manufacturerProductId?: string;
    standardProductId?: string;
}

export interface FedexCustomsInfoDTO {
    totalCustomsValue: number;
    currency: string;
    shipmentPurpose: string;
    consumerRecipient: boolean;
    commodities: FedexCommodityDTO[];
    dutiesPaymentType?: string;
    dutiesPayerAccountNumber?: string;
    dutiesPayerCountry?: string;
    comments?: string;
    originatorName?: string;
    taxesOrMiscellaneousChargeAmount?: number;
    taxesOrMiscellaneousChargeCurrency?: string;
    insuranceChargeAmount?: number;
    insuranceChargeCurrency?: string;
    freightChargeAmount?: number;
    freightChargeCurrency?: string;
    invoiceCustomerReference?: string;
    isDocumentOnly: boolean;
    electronicTradeDocuments: boolean;
    recipientCustomsIdType?: string;
    recipientCustomsIdValue?: string;
    customsOptionType?: string;
    customsOptionDescription?: string;
    broker?: FedexBrokerDTO;
    specialCargo?: FedexSpecialCargoDTO;
}

export interface FedexCertOverridesDTO {
    customerTransactionId?: string;
    imageType?: string;
    labelStockType?: string;
    labelResponseOptions?: string;
    rateRequestTypes?: string[];
    preferredCurrency?: string;
    recipientResidential?: boolean;
    recipientStateOrProvinceCode?: string;
    customerReference?: string;
    shipperTin?: string;
}

export interface DHLExportDeclarationInfoInDTO {
    declaredValue: number;
    declaredValueCurrency: string;
    lineItems: DHLExportLineItemInDTO[];
}

export interface DHLExportLineItemInDTO {
    description: string;
    quantity: number;
    unitOfMeasurement: string;
    piecePrice: number;
    manufacturerCountry: string;
    commodityCodeExport: string;
    commodityCodeImport: string;
    netWeight: number;
    grossWeight: number;
}

export interface DHLExportDeclarationInfoOutDTO {
    declaredValue: number;
    declaredValueCurrency: string;
    lineItems: DHLExportLineItemOutDTO[];
}

export interface DHLExportLineItemOutDTO {
    description: string;
    quantity: number;
    unitOfMeasurement: string;
    piecePrice: number;
    manufacturerCountry: string;
    commodityCodeExport: string;
    commodityCodeImport: string;
    netWeight: number;
    grossWeight: number;
}

export interface SetNotificationTypeSettingInDTO {
    emailType: EmailTypeEnum;
    email: boolean;
    notificationCenter: boolean;
}

export interface ReadNotificationRequestInDTO {
    ids: string[];
}

export interface SetExternalIdForCompanyInDTO {
    externalIds?: string;
    externalIdType: ExternalIdTypeEnum;
}

export interface FedexShipmentSettingsDTO {
    referenceSource: ReferenceSourceEnum;
    mergeLabels: boolean;
}

export interface FedexAccountRenameInDTO {
    name?: string;
}

export interface FedexAccountOutDTO {
    id: string;
    accountNumber: string;
    name?: string;
    createdAt?: string;
}

export interface FedexRegistrationStatusOutDTO {
    registered: boolean;
    accounts: FedexAccountOutDTO[];
    eulaAccepted: boolean;
    eulaAcceptedAt?: string;
}

export interface CreateExternalManipulationUnitRequestDTO {
    externalId: string;
    name?: string;
    unitWeight: number;
    unitsOnPallet: number;
    unitsInBox: number;
    boxOnPallet: number;
    boxWeight: number;
    palletWeight: number;
    cargoTemplateCode: string;
}

export interface ExternalManipulationUnitDTO {
    id: string;
    externalId: string;
    name?: string;
    unitWeight: number;
    unitsOnPallet: number;
    unitsInBox: number;
    boxOnPallet: number;
    boxWeight: number;
    palletWeight: number;
    cargoTemplateId: string;
    cargoTemplateCode: string;
    cargoTemplateName: string;
}

export interface UpdateExpeditionUtnCodeRequestInDTO {
    utnCode?: string;
}

export interface UpdateExpeditionTrackingNumberRequestInDTO {
    trackingNumber?: string;
}

export interface UpdateExpeditionRoUitRequestInDTO {
    roUitNumber?: string;
}

export interface UpdateExpeditionPolandSentRequestInDTO {
    sentNumber?: string;
    sentCarrierUpdateKey?: string;
}

export interface UpdateExpeditionNameRequestInDTO {
    name?: string;
}

export interface EditLocationTimeslotExpeditionRequestInDTO {
    timeslots: GlobalTimeslots;
    fedexPickup?: FedexPickupRebookInDTO;
}

export interface FedexPickupRebookInDTO {
    pickupDate: string;
    readyTime: string;
    closeTime: string;
}

export interface EditLoadingLocationOrderExpeditionRequestInDTO {
    loadingLocationOrders: EditLoadingLocationOrderRequestInDTO[];
}

export interface EditLoadingLocationOrderRequestInDTO {
    order: GlobalOrdersRequest;
    unloadingLocationId: string;
}

export interface AddressRequest {
    name: string;
    city: string;
    postalCode: string;
    streetNr: string;
    country: string;
}

export interface EditLocationManualExpeditionRequestInDTO {
    address: AddressRequest;
    loadingReference?: string;
    selectedPerson?: SaveExpeditionContanctPersonRequest;
    notifySelectedPerson: boolean;
    additionalContacts?: SaveExpeditionContanctPersonRequest[];
    timezoneId?: string;
}

export interface SaveExpeditionContanctPersonRequest {
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
}

export interface EditLocationCompanyLocationExpeditionRequestInDTO {
    companyLocationId?: string;
    loadingReference?: string;
    selectedPerson?: SaveExpeditionContanctPersonRequest;
    additionalContacts?: SaveExpeditionContanctPersonRequest[];
}

export interface CompanyCodeListsWrapper {
    internalInfoAccountCodeListId?: string;
    internalInfoCostCenterCodeListId?: string;
    internalInfoCostUnitCodeListId?: string;
    internalInfoProjectCodeListId?: string;
}

export interface CustomsDeclarationCompaniesWrapper {
    companies: string[];
}

export interface DisponentPersonWrapper {
    disponentPersonId?: string;
}

export interface EditInternalInfoExpeditionRequestInDTO {
    responsiblePerson?: ResponsiblePersonWrapper;
    notifiedPersons?: NotifiedPersonsWrapper;
    notifiedTargets?: NotifiedTargetsWrapper;
    notifyByRole?: NotifyByRoleWrapper;
    rebilling?: RebillingWrapper;
    disponentPerson?: DisponentPersonWrapper;
    pairingSymbol?: PairingSymbolWrapper;
    internalNote?: InternalNoteWrapper;
    invoiceState?: InvoiceStateWrapper;
    /**
     * @deprecated RD-2977: use folders
     */
    folder?: FolderWrapper;
    folders?: FoldersWrapper;
    customsDeclarationCompanies?: CustomsDeclarationCompaniesWrapper;
    companyCodeLists?: CompanyCodeListsWrapper;
}

export interface FolderWrapper {
    folderId?: string;
}

export interface FoldersWrapper {
    folderIds: string[];
}

export interface InternalNoteWrapper {
    internalNote?: string;
}

export interface InvoiceStateWrapper {
    invoiceState?: InvoiceStateEnum;
}

export interface NotifiedPersonsWrapper {
    notifiedPersonIds: string[];
}

export interface NotifiedTargetsWrapper {
    targets: NotifyTargetInnerInDTO[];
}

export interface NotifyByRoleWrapper {
    notifyByRole?: string;
}

export interface NotifyTargetInnerInDTO {
    id: string;
    notifyTargetType: NotifyTargetTypeEnum;
}

export interface PairingSymbolWrapper {
    pairingSymbol?: string;
}

export interface RebillingRequestInDTO {
    invoiceRebillingType: InvoiceRebillingTypeEnum;
    invoiceDepartment?: string;
    invoicePartnerId?: string;
}

export interface RebillingWrapper {
    rebilling?: RebillingRequestInDTO;
}

export interface ResponsiblePersonWrapper {
    responsiblePersonId: string;
}

export interface UpdateExpeditionIncotermsRequest {
    incotermsValue?: IncotermsValueEnum;
    incotermsDescription?: string;
}

export interface UpdateExpeditionHuEkaerRequestInDTO {
    huEkaerNumber?: string;
}

export interface CargoTypeWrapper {
    cargoTypeCode?: string;
    adrWeight?: number;
}

export interface CarrierNoteWrapper {
    carrierNote?: string;
}

export interface EditHeaderExpeditionRequestInDTO {
    loadingTypes?: LoadingTypesWrapper;
    truckType?: TruckTypeWrapper;
    cargoType?: CargoTypeWrapper;
    specialRequirements?: SpecialRequirementWrapper;
    carrierNote?: CarrierNoteWrapper;
    expeditionType?: ExpeditionTypeWrapper;
    transportationType?: TransportationTypeWrapper;
}

export interface ExpeditionTypeWrapper {
    expeditionType?: ExpeditionTypeEnum;
}

export interface LoadingTypesWrapper {
    loadingTypes: LoadingTypesEnum[];
}

export interface SpecialRequirementWrapper {
    specialRequirementCodes?: string[];
}

export interface TransportationTypeWrapper {
    transportationType?: TransportationTypeEnum;
}

export interface TruckTypeWrapper {
    truckTypeCode: string;
}

export interface ChangePriceInDTO {
    price: number;
    currency: string;
    currencyLockType: CurrencyLockTypeEnum;
}

export interface ChangeFinalPriceInDTO {
    price: number;
    currency: string;
}

export interface ChangeExpeditionDistributionDateInDTO {
    /**
     * @deprecated Use utcDateTime and timezoneId instead
     */
    localDateTime: string;
    /**
     * @deprecated Use utcDateTime and timezoneId instead
     */
    timeZone: string;
    utcDateTime?: string;
    timezoneId?: string;
}

export interface DuplicationMoreReservationTimeslotsDTO {
    locationId: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceHourString: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    durationInMinutes: number;
    id: string;
    localDate: string;
    rampId: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface MultiduplicationV3ItemOverrideInDTO {
    newTimeslots?: DuplicationMoreReservationTimeslotsDTO[];
}

export interface CheckDuplicationExceptionOutDTO {
    exceptionName: string;
    openHourExceptionType: OpenHourExceptionTypeEnum;
}

export interface CheckDuplicationExpeditionResponseOutDTO {
    originalExpeditionId: string;
    originalApplicationId: string;
    firstDay: GlobalDayWithOnlyOneInterval;
    isReservationsPresent: boolean;
    isAttachmentsPresent: boolean;
    distribution?: DistributionDuplicateResponseOutDTO;
    isFinishedState: boolean;
    isSomeReservationFailed: boolean;
    locations: DuplicationLocationOutDTO[];
}

export interface DistributionDuplicateResponseOutDTO {
    fixed?: DistributionInnerResponseOutDTO;
    spot?: DistributionInnerResponseOutDTO;
    assignedCarrierId?: string;
    assignedPrice?: PriceRequest;
}

export interface DistributionInnerResponseOutDTO {
    price?: PriceRequest;
    selectedItems: FindCarrierCarrierOrGroupDTO[];
    dachserProductType?: DachserProductTypeEnum;
    dachserDeliveryTerm?: DachserDeliveryTermEnum;
    schenkerProductType?: SchenkerProductTypeEnum;
    schenkerAddonsType?: SchenkerAddonsTypeEnum[];
}

export interface DuplicationItemLocationResult {
    locationName?: string;
    reservationId?: string;
    reservationApplicationId?: string;
    reservationCreated?: boolean;
    hasNoSlots?: boolean;
}

export interface DuplicationLocationOutDTO {
    locationId: string;
    isCompanyLocation: boolean;
    companyLocationId?: string;
    companyLocationOwnerId?: string;
    locationName: string;
    postalCode: string;
    city: string;
    street: string;
    duplications: DuplicationOutDTO[];
    supersededFromLocationName?: string;
    supersededByLocationName?: string;
}

export interface DuplicationOutDTO {
    day: string;
    timezoneId?: string;
    id: string;
    openingHourState?: OpeningHourStateEnum;
    reservationState?: ReservationStateEnum;
    reservationFullDetail?: ReservationFullDetailDTO;
    newReservation?: DuplicationMoreReservationTimeslotsDTO;
    openingHours?: ExpeditionDuplicationGlobalTimeslotsDTO;
    deliverySlots?: ExpeditionDuplicationGlobalTimeslotsDTO;
    exceptionPresent?: CheckDuplicationExceptionOutDTO;
    reservationLink?: LinkedEntityResponseOutDTO;
    expeditionLink?: LinkedEntityResponseOutDTO;
}

export interface ExpeditionDuplicationGlobalDayWithInterval {
    day: string;
    timezoneId?: string;
    localDate: string;
    openingMode: OpeningModeEnum;
    isCollision: boolean;
    intervals: GlobalInterval[];
    collision?: boolean;
}

export interface ExpeditionDuplicationGlobalTimeslotsDTO {
    timezoneId?: string;
    dayWithInterval: ExpeditionDuplicationGlobalDayWithInterval[];
}

export interface FindCarrierCarrierOrGroupDTO {
    id: string;
    carrierOrGroup: CarrierOrGroupEnum;
    name: string;
    selectedItemType: SelectedItemTypeEnum;
    apiType?: ApiTypeEnum;
    userId?: string;
}

export interface GlobalDayWithOnlyOneInterval {
    day: string;
    timezoneId?: string;
    localDate: string;
    openingMode: OpeningModeEnum;
    intervals?: GlobalInterval;
}

export interface LabelPreview {
    labelId: string;
    labelValue: string;
    labelColor: string;
}

export interface LinkedEntityResponseOutDTO {
    id?: string;
    applicationId?: string;
    isCreated: boolean;
    hasNoSlots: boolean;
}

export interface MultiduplicationV3ItemConfigOutDTO {
    targetDate?: string;
    newTimeslots?: DuplicationMoreReservationTimeslotsDTO[];
}

export interface MultiduplicationV3ItemDetailOutDTO {
    item: MultiduplicationV3JobItemOutDTO;
    config?: MultiduplicationV3ItemConfigOutDTO;
    check?: CheckDuplicationExpeditionResponseOutDTO;
}

export interface MultiduplicationV3ItemExecutionOutDTO {
    expeditionId?: string;
    expeditionApplicationId?: string;
    someReservationFailed: boolean;
    locations: DuplicationItemLocationResult[];
}

export interface MultiduplicationV3JobItemOutDTO {
    id: string;
    itemId: string;
    kept: boolean;
    expeditionId: string;
    sortOrder: number;
    itemStatus: ItemStatusEnum;
    targetDate?: string;
    hasOverrides: boolean;
    errorMessage?: string;
    error?: MessageResponse;
    originalApplicationId?: string;
    openingCollisions?: number;
    reservationConflicts?: number;
    routeSummary: MultiduplicationV3RouteStopOutDTO[];
    execution?: MultiduplicationV3ItemExecutionOutDTO;
    labels: LabelPreview[];
    expeditionType?: ExpeditionTypeEnum;
    responsiblePerson?: string;
    orderCount?: number;
    dateFrom?: string;
    dateTo?: string;
}

export interface MultiduplicationV3RouteStopOutDTO {
    locationName?: string;
    city?: string;
    postalCode?: string;
}

export interface ReservationFullDetailDTO {
    rampId: string;
    rampName: string;
    companyLocationId: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    till: string;
    localDate: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface MultiduplicationV3KeepItemsInDTO {
    itemIds: string[];
    kept: boolean;
}

export interface FavoriteExpeditionRequestInDTO {
    favorite: boolean;
}

export interface AdditionalDataDistributionInDTO {
    dachserProductType?: DachserProductTypeEnum;
    dachserDeliveryTerm?: DachserDeliveryTermEnum;
    schenkerProductType?: SchenkerProductTypeEnum;
    schenkerAddonsType?: SchenkerAddonsTypeEnum[];
    dhlProductType?: DhlProductTypeEnum;
    dhlPickupReadyTime?: string;
    dhlPickupCloseTime?: string;
    dhlCourierRequested?: boolean;
    dhlPayerAccountNumber?: string;
    dhlDutiesTaxesAccountNumber?: string;
    fedexProductType?: string;
    fedexPickupReadyTime?: string;
    fedexPickupCloseTime?: string;
    fedexCourierRequested?: boolean;
    fedexPayerType?: string;
    fedexPayerAccountNumber?: string;
    fedexPayerCountry?: string;
    fedexDeclaredValue?: number;
    fedexDeclaredValueCurrency?: string;
    fedexSignatureOption?: string;
    fedexPackagingType?: string;
    fedexBookingConfirmationNumber?: string;
    fedexAccountId?: string;
}

export interface CarrierGroupInDTO {
    id: string;
    carrierOrGroup: CarrierOrGroupEnum;
    selectedItemType: SelectedItemTypeEnum;
    apiType?: ApiTypeEnum;
    userId?: string;
}

export interface DirectAssignRequestDistributionRequestInDTO {
    price: PriceRequest;
    carrierId: string;
    notifyAssignedCarrier: boolean;
    userIds?: string[];
}

export interface FixedSpotRequestDistributionRequestInDTO {
    price?: PriceRequest;
    selectedItems: CarrierGroupInDTO[];
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    responseDeadlineLocalTime: string;
    /**
     * @deprecated Use timezoneId instead
     */
    responseDeadlineTimezone: string;
    utcEnd?: string;
    timezoneId?: string;
    currencyLockType: CurrencyLockTypeEnum;
    ladenFactor?: number;
    allowPartialDelivery: boolean;
    additionalData?: AdditionalDataDistributionInDTO;
}

export interface SaveDistributionRequestInDTO {
    fixedRequest?: FixedSpotRequestDistributionRequestInDTO;
    spotRequest?: FixedSpotRequestDistributionRequestInDTO;
    directAssign?: DirectAssignRequestDistributionRequestInDTO;
    fedexAccountId?: string;
}

export interface SaveDuplicationExpeditionRequestInDTO {
    fromExpeditionId: string;
    duplicateReservations: boolean;
    copyAttachments: boolean;
    expeditionName?: string;
    applicationId?: string;
    distribution?: SaveDistributionRequestInDTO;
    copyToLocalDates: string[];
    copyCarPlates: boolean;
    newTimeslots?: DuplicationMoreReservationTimeslotsDTO[];
    copyLabels: boolean;
    prefixApplicationId: boolean;
}

export interface CheckDuplicationExpeditionRequestInDTO {
    fromExpeditionId: string;
    duplicateReservations: boolean;
    copyAttachments: boolean;
    copyToLocalDates: string[];
    newTimeslots?: DuplicationMoreReservationTimeslotsDTO[];
}

export interface MassActionExpeditionInDTO {
    expIds: string[];
    internalData: MassActionExpeditionValuesInDTO;
}

export interface MassActionExpeditionValuesInDTO {
    overwriteLabels: boolean;
    labels: string[];
    overwriteArchiveExpeditions: boolean;
    archiveLinkedSN?: boolean;
    overwriteFolder: boolean;
    /**
     * @deprecated RD-2977: use folderIds
     */
    folderId?: string;
    folderIds?: string[];
    overwriteFinish: boolean;
    finishExpeditions?: boolean;
    overwriteCarrierNote: boolean;
    carrierNote?: string;
    overwriteTruckType: boolean;
    truckTypeCode?: string;
    overwritePairingSymbol: boolean;
    pairingSymbol?: string;
}

export interface ETransportAddressDTO {
    borderId?: number;
    regionId?: number;
    town?: string;
    street?: string;
}

export interface ETransportCompanyDTO {
    transportCompanyName: string;
    transportCompanyCountry: string;
    transportCompanyVatId: string;
}

export interface ETransportDTO {
    id?: string;
    reservationId?: string;
    referenceNumber: string;
    supplierName: string;
    licencePlate: string;
    transportCompany: ETransportCompanyDTO;
    document: ETransportDocumentDTO;
    transportDate: string;
    transportMode: number;
    originAddress: ETransportAddressDTO;
    destinationAddress: ETransportAddressDTO;
    products: ETransportProductDTO[];
    uitCode?: string;
    errorMessage?: string;
}

export interface ETransportDocumentDTO {
    documentType: number;
    documentName?: string;
    documentNumber: string;
    documentDate: string;
}

export interface ETransportProductDTO {
    name: string;
    ean: string;
    nomenclature: string;
    quantity: number;
    weightNetto: number;
    priceExVat: PriceDTO;
}

export interface PriceDTO {
    price: number;
    currency: string;
    companyComputedPrice?: number;
    companyComputedCurrency?: string;
    conversationRate?: number;
}

export interface AttachmentIdWithTypeV2InDTO {
    attachmentId: string;
    documentType: DocumentTypeEnum;
    userNote?: string;
    userDateLocalDate?: string;
    accessType: AccessTypeEnum;
    labelIds: string[];
}

export interface DhlAccountSettingsInDTO {
    username?: string;
    password?: string;
}

export interface DhlAccountSettingsOutDTO {
    configured: boolean;
    username?: string;
    passwordSet: boolean;
}

export interface CompanyPartnerInfoInDTO {
    partnerCompanyId: string;
    partnerNote?: string;
}

export interface CompanyFolderInDTO {
    entityType: EntityTypeEnum;
    name: string;
    externalId?: string;
    folderVisibility: FolderVisibilityEnum;
    departmentIds: string[];
    userIds: string[];
}

export interface CompanyFolderOutDTO {
    folderId: string;
    folderName: string;
    entityType: EntityTypeEnum;
    externalId?: string;
    folderVisibility: FolderVisibilityEnum;
    departments: LovDTO[];
    users: LovDTO[];
    expeditionCount: number;
}

export interface LovDTO {
    id: string;
    name: string;
    active: boolean;
}

export interface CompanyCodeListNotificationEmailsSetting {
    id?: string;
    companyLocationId?: string;
    cityMatch: boolean;
    cityMatcher?: string;
    emails: string[];
}

export interface UpdateCompanyCodeListRequest {
    id: string;
    externalId: string;
    name?: string;
    description?: string;
    htmlContent?: string;
    notificationEmails: CompanyCodeListNotificationEmailsSetting[];
}

export interface CompanyCodeListCityEmailsSetting {
    cityMatcher?: string;
    emails: string[];
}

export interface CompanyCodeListLocationEmailsSetting {
    companyLocationId?: string;
    emails: string[];
}

export interface MassActionCompanyCodeListDataRequest {
    overwriteHtmlContent: boolean;
    htmlContent?: string;
    overwriteLocationSettings: boolean;
    locationSettings?: CompanyCodeListLocationEmailsSetting[];
    overwriteCitySettings: boolean;
    citySettings?: CompanyCodeListCityEmailsSetting[];
}

export interface MassActionCompanyCodeListRequest {
    codeListIds: string[];
    internalData: MassActionCompanyCodeListDataRequest;
}

export interface ChangeGDNameRequest {
    name: string;
}

export interface UpdateCalendarLayoutModelInDTO {
    name: string;
    description?: string;
    calendarLayoutStatus?: CalendarLayoutStatusEnum;
}

export interface CalendarLayoutModelDetailOutDTO {
    id: string;
    name: string;
    description?: string;
    systemWide: boolean;
    ownerCompanyId?: string;
    ownerCompanyName?: string;
    editable: boolean;
    calendarLayoutStatus: CalendarLayoutStatusEnum;
    publishedPayload?: CalendarLayoutPayloadDTO;
    publishedAt?: string;
    publishedByFullName?: string;
    draftPayload?: CalendarLayoutPayloadDTO;
    draftSavedAt?: string;
    draftSavedByFullName?: string;
    canRevert: boolean;
    previousPublishedAt?: string;
    assignmentCount: number;
    createdAt: string;
    createdByFullName?: string;
    updatedAt?: string;
    updatedByFullName?: string;
}

export interface CalendarLayoutPayloadDTO {
    version: number;
    card: any;
    detail: any;
}

export interface FragmentPlacementDTO {
    key: string;
    showIcon?: boolean;
}

export interface SaveCalendarLayoutDraftInDTO {
    payload: CalendarLayoutPayloadDTO;
}

export interface SetCalendarLayoutDefaultInDTO {
    modelId: string;
}

export interface CalendarLayoutDefaultOutDTO {
    calendarLayoutSource: CalendarLayoutSourceEnum;
    modelId: string;
    modelName: string;
    publishedAt?: string;
    config: CalendarLayoutPayloadDTO;
}

export interface MassActionAttachmentInDTO {
    attachmentIds: string[];
    overwriteLabels: boolean;
    labelIds: string[];
    overwriteDocumentType: boolean;
    documentType?: DocumentTypeEnum;
    overwriteAccessType: boolean;
    accessType?: AccessTypeEnum;
}

export interface ActionCall {
    action: string;
    params: any;
}

export interface AndNode {
}

export interface ComparisonNode {
}

export interface ConditionNode {
    op: string;
}

export interface JsonNode {
}

export interface NotNode {
}

export interface OrNode {
}

export interface RuleAst {
    trigger: TriggerSpec;
    condition?: any;
    actions: ActionCall[];
}

export interface SaveRuleInDTO {
    sourceText?: string;
    ast?: RuleAst;
    name?: string;
    enabled?: boolean;
    priority?: number;
    description?: string;
}

export interface TriggerSpec {
    type: string;
    delayMinutes?: number;
}

export interface DiagnosticOutDTO {
    diagnosticSeverity: DiagnosticSeverityEnum;
    diagnosticCode: DiagnosticCodeEnum;
    messageKey: string;
    params: string[];
    line: number;
    column: number;
    length: number;
    hintKey?: string;
    hintParams: string[];
}

export interface RuleDetailOutDTO {
    id: string;
    name: string;
    description?: string;
    enabled: boolean;
    priority: number;
    entityType: EntityTypeEnum;
    triggerType: string;
    ruleEditMode: RuleEditModeEnum;
    sourceText: string;
    ast: RuleAst;
    pausedUntil?: string;
    createdBy?: string;
    createdAt: string;
    updatedBy?: string;
    updatedAt: string;
}

export interface SaveRuleOutDTO {
    saved: boolean;
    rule?: RuleDetailOutDTO;
    diagnostics: DiagnosticOutDTO[];
}

export interface AdminWebAlertRequestInDTO {
    name: string;
    text: string;
    showFrom: string;
    showTo: string;
}

export interface AdminWebAlertResponseOutDTO {
    id: string;
    name: string;
    text: string;
    showFrom: string;
    showTo: string;
}

export interface EntityPrefixDTO {
    idEntityType: IdEntityTypeEnum;
    prefix: string;
}

export interface UpdateCompanyDetailInDTO {
    name?: string;
    companyCode?: string;
    contentPrefix?: string;
    features?: FeaturesEnum[];
    dachserLastExportId?: string;
    enabledExpRequirementCodes?: string[];
    prefillRequirementCodes?: string[];
    customerReportingId?: string;
    defaultCurrencyIsoCode?: string;
    defaultDistributionIntervalInHours?: number;
    aiPriceAlertsMinimalSeverity?: AiPriceAlertsMinimalSeverityEnum;
    invoicePublishServiceType?: InvoicePublishServiceTypeEnum;
    crn?: string;
    tin?: string;
    bypassTinValidation?: boolean;
    prefixManualAppId?: string;
    entityPrefixes?: EntityPrefixDTO[];
    autoAcceptModules?: boolean;
    availableCurrencies?: string[];
    priceDisplayType?: PriceDisplayTypeEnum;
    defaultTimezoneId?: string;
    cargoTemplateIds?: string[];
    externalIdType?: ExternalIdTypeEnum[];
    carrierQuoteValidTillDefaultInHours?: number;
    responseDeadlineMode?: ResponseDeadlineModeEnum;
}

export interface FlagSetting {
    visible: boolean;
    visibleAdditionalField: boolean;
    additionalFieldRequired: boolean;
}

export interface UpsertTimeslotModuleSettingRequestInDTO {
    minimalDuration: number;
    defaultDuration: number;
    ownerCanEdit: boolean;
    counterPartyCanEdit: boolean;
    units: UpsertTimeslotModuleSettingUnitRequestInDTO[];
    showHistoricalFreeSlots: boolean;
    showHistoricalFreeSlotsCounterParty: boolean;
    slotsRequired: boolean;
    slotsRequiredCounterParty: boolean;
    editDurationCounterParty: boolean;
    editDuration: boolean;
    ownerManipulationItemsRequired: boolean;
    counterPartyManipulationItemsRequired: boolean;
    truckTypeRequired: boolean;
    nextDayReservationJustBefore: boolean;
    nextDayReservationJustBeforeHours?: number;
    ownerCanDelete: boolean;
    counterPartyCanDelete: boolean;
    ownerShowActionTypes: boolean;
    counterPartyShowActionTypes: boolean;
    nextDayReservationJustBeforeExcept: boolean;
    nextDayReservationJustBeforeExceptCompanyIds: string[];
    flags?: any;
    externalOrdersApiType?: ExternalOrdersApiTypeEnum;
    noShowSchedulerEnabled: boolean;
    doubleLoadingUnloadingTime: boolean;
    counterPartyEditBlockedMinutesBeforeStart?: number;
    showCarrierAnonymousReservations: boolean;
    counterPartyShowWorkflowStatus: boolean;
    driverNameRequired: boolean;
    driverNameRequiredCounterParty: boolean;
    driverPhoneRequired: boolean;
    driverPhoneRequiredCounterParty: boolean;
    driverIdRequired: boolean;
    driverIdRequiredCounterParty: boolean;
    carPlateRequired: boolean;
    carPlateRequiredCounterParty: boolean;
    ownerDefaultActionType: OwnerDefaultActionTypeEnum;
    counterPartyDefaultActionType: CounterPartyDefaultActionTypeEnum;
    restrictToExpeditionHoursOwner: boolean;
    restrictToExpeditionHoursCounterParty: boolean;
    ownerActionTypeRequired: boolean;
    counterPartyActionTypeRequired: boolean;
    foldersRequired?: boolean;
    foldersRestrictVisibility?: boolean;
}

export interface UpsertTimeslotModuleSettingUnitRequestInDTO {
    duration: number;
    cargoItemType: string;
}

export interface FieldMode {
    visible: boolean;
    editable: boolean;
    required: boolean;
}

export interface SnCommonConfigDTO {
    externalOrdersApiType?: ExternalOrdersApiTypeEnum;
}

export interface SnFolderSettingsDTO {
    required: boolean;
    restrictVisibility: boolean;
}

export interface SnModuleSettingsDTO {
    common: SnCommonConfigDTO;
    owner: SnPartyConfigDTO;
    inheritor: SnPartyConfigDTO;
    folders: SnFolderSettingsDTO;
}

export interface SnPartyConfigDTO {
    timeslots: FieldMode;
    manipulationUnitNote: FieldMode;
    stackable: FieldMode;
    amountOfOrder: FieldMode;
    orderValue: FieldMode;
    supplierAndCustomer: FieldMode;
    requestNotifiedPersonInSn: FieldMode;
    shippingTags: any;
}

export interface SnTagSetting {
    visible: boolean;
    editable: boolean;
    required: boolean;
    defaultValue: string[];
    visibleWhen?: TagCondition;
    requiredWhen?: TagCondition;
}

export interface TagCondition {
    tag: TagEnum;
    values: string[];
}

export interface ReminderLineDTO {
    emailType: EmailTypeEnum;
    enabled: boolean;
    values: number[];
    transportationType: TransportationTypeEnum[];
}

export interface ReminderSettingsDTO {
    active: boolean;
    lines: ReminderLineDTO[];
}

export interface CreateShipmentPrefillSettingsDTO {
    routeAndTransport: boolean;
    cargoAndOrders: boolean;
    labels: boolean;
    internalInfo: boolean;
    documents: boolean;
    carrierChoice: boolean;
    carrierNote: boolean;
    sn: CreateShipmentPrefillSnDTO;
}

export interface CreateShipmentPrefillSnDTO {
    linkToSn: boolean;
    copySnAttachments: boolean;
    markAsPrivate: boolean;
}

export interface ExpeditionModuleSettingsDTO {
    createShipmentPrefill: CreateShipmentPrefillSettingsDTO;
    folders: FolderSettingsDTO;
}

export interface FolderSettingsDTO {
    required: boolean;
    restrictVisibility: boolean;
    defaultImportFolderId?: string;
}

export interface AdminReadAllCompanyNotificationsOutDTO {
    companyId: string;
    updatedCount: number;
}

export interface BetaFeatureDTO {
    defaultVersion: DefaultVersionEnum;
    switchVisible: boolean;
}

export interface SetBetaFeaturesInDTO {
    features: any;
}

export interface CargoTemplateRequestInDTO {
    name: string;
    width?: number;
    height?: number;
    length?: number;
    weight?: number;
    count: number;
    stackable: boolean;
    disabled: boolean;
    code: string;
    order: number;
    ewMapping?: string;
    dachserMapping?: string;
    decimalSpaces: number;
    schenkerMapping?: string;
}

export interface CargoTemplateDetailOutDTO {
    id: string;
    name: string;
    width?: number;
    height?: number;
    length?: number;
    weight?: number;
    count: number;
    stackable: boolean;
    disabled: boolean;
    code: string;
    order?: number;
    ewMapping?: string;
    dachserMapping?: string;
    decimalSpaces: number;
    schenkerMapping?: string;
}

export interface UserCompanyUserInDTO {
    firstname: string;
    surname: string;
    email?: string;
    phone?: string;
    securityRolesIds: string[];
    securityGroupsIds: string[];
    updateUserInAuth0?: boolean;
    departmentNames?: string[];
}

export interface ValidationAttachmentInfoDTO {
    documentType: DocumentTypeEnum;
    contentType?: string;
}

export interface ValidationCargoItemInDTO {
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
    amount?: number;
}

export interface ValidationCargoTypeInDTO {
    cargoTypeCode?: string;
}

export interface ValidationCarriersRequestInDTO {
    q?: string;
    expeditionValidations?: ValidationExpeditionRequestInDTO[];
}

export interface ValidationDeliverySlotDayInDTO {
    day: string;
    utcDay?: string;
    openingMode: OpeningModeEnum;
    intervals: GlobalInterval[];
}

export interface ValidationDeliverySlotInDTO {
    days: ValidationDeliverySlotDayInDTO[];
}

export interface ValidationExpeditionRequestInDTO {
    locations: ValidationLocationInDTO[];
    cargoType?: ValidationCargoTypeInDTO;
    incotermsValue?: string;
    incotermsDescription?: string;
    polandSentNumber?: string;
    polandSentCarrierUpdateKey?: string;
    huEkaerNumber?: string;
    roUitNumber?: string;
    utnCode?: string;
    attachments: ValidationAttachmentInfoDTO[];
}

export interface ValidationLocationInDTO {
    id?: string;
    companyLocationId?: string;
    country: string;
    postalCode: string;
    orders?: ValidationOrderInDTO[];
    deliverySlot?: ValidationDeliverySlotInDTO;
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
}

export interface ValidationOrderInDTO {
    items?: ValidationCargoItemInDTO[];
    loadingLocationId?: string;
    unloadingLocationId?: string;
    totalWeight?: number;
    orderValue?: number;
    orderCurrency?: string;
}

export interface FindCarrierAdditionalInfoOutDTO {
    id: string;
    text: string;
}

export interface FindCarrierAiInfoOutDTO {
    id: string;
    info: string;
}

export interface FindCarrierResponseOutDTO {
    id: string;
    findCarrierType: FindCarrierTypeEnum;
    name: string;
    carrierName?: string;
    groupNames?: string[];
    apiTypes?: ApiTypesEnum[];
    userIds?: string[];
    carrierIds?: string[];
    labels?: LabelPreview[];
    carrierAdditionalInfos?: FindCarrierAdditionalInfoOutDTO[];
    aiInfos?: FindCarrierAiInfoOutDTO[];
    unavailableMessages?: FindCarrierUnavailableMessageOutDTO[];
}

export interface FindCarrierUnavailableMessageOutDTO {
    field: string;
    translateKey: string;
}

export interface CarrierGroupsInIdsV2 {
    carrierGroupIds: CatalogCarrierGroupInDTO[];
}

export interface CatalogCarrierGroupInDTO {
    id?: string;
    name: string;
}

export interface CatalogCarrierGroupNameInDTO {
    groupName: string;
}

export interface CatalogCarrierGroupNameExistsOutDTO {
    groupName: string;
    groupId?: string;
    isExists: boolean;
}

export interface ProfileSettingsPhoneInDTO {
    phone: string;
}

export interface NotifyTargetInDTO {
    targets: NotifyTargetInnerInDTO[];
}

export interface CargoIn14DTO {
    width: number;
    height: number;
    length: number;
    weight: number;
    amount: number;
    quantityUnit: string;
    stackable: boolean;
    weightMode: WeightModeEnum;
    cargoItemTypeCode: string;
    itemNote?: string;
}

export interface LocationEditInDTO {
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    pickupCode?: string;
    loadedOrders?: LocationOrderEditInDTO[];
    timeslots: GlobalTimeslots;
    enabledEmailNotificationForContactPerson: boolean;
}

export interface LocationOrderEditInDTO {
    id: string;
    orderName: string;
    items: CargoIn14DTO[];
    weight?: number;
}

export interface ExpeditionInternalInformationInDTO {
    responsiblePersonId?: string;
    subscribersIds: string[];
    invoiceUserId?: string;
    invoiceState?: InvoiceStateEnum;
    invoiceRebillingType?: InvoiceRebillingTypeEnum;
    invoicePartnerId?: string;
    invoiceDepartment?: string;
    internalNote?: string;
    pairingSymbol?: string;
}

export interface UpdateDistributionInDTO {
    price?: number;
    currency?: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: string;
    isPublish: boolean;
    utcEnd?: string;
    timezoneId?: string;
}

export interface CarrierRequirementEditInDTO {
    loadingTypes: LoadingTypesEnum[];
    carrierNote?: string;
    requirements?: string[];
    truckType?: string;
    cargoType?: string;
    adrWeight?: number;
}

export interface EditTemplateNameInDTO {
    templateName: string;
}

export interface CargoTemplateInDTO {
    width: number;
    height: number;
    length: number;
    weight: number;
    amount: number;
    quantityUnit: string;
    stackable: boolean;
    cargoItemTypeCode: string;
    weightMode: WeightModeEnum;
    itemNote?: string;
}

export interface EditLocationAndOrderInDTO {
    locationName: string;
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    pickupCode?: string;
    streetNr: string;
    country: string;
    zipCode: string;
    city: string;
    timezoneId: string;
    orders?: EditTemplateLocationOrderInDTO[];
    fromAddressBookId?: string;
    openingHourDefinitions: OpeningHourDefinitionsInDTO;
}

export interface EditTemplateLocationOrderInDTO {
    id: string;
    orderName: string;
    items: CargoTemplateInDTO[];
}

export interface OpeningHourDefinitionsInDTO {
    id?: string;
    entityId?: string;
    openingEntityType: OpeningEntityTypeEnum;
    openingHoursDays: OpeningHoursDayInDTO[];
}

export interface OpeningHoursDTO {
    since: string;
    till: string;
}

export interface OpeningHoursDayInDTO {
    day: DayEnum;
    openingMode: OpeningModeEnum;
    openingHours?: OpeningHoursDTO[];
}

export interface EditTemplateInternalInformation {
    subscribers: string[];
    responsiblePersonId?: string;
    internalNote?: string;
}

export interface DistributionTemplateInDTO {
    name?: string;
    distributionType: DistributionTypeEnum;
    intervalHour: number;
    price?: number;
    currency?: string;
    templateExpeditionId?: string;
    carriersAndGroups: CarrierGroupInDTO[];
    shouldExpeditionAutomaticallyPublished: boolean;
}

export interface EditTemplateCarrierRequirementInDTO {
    loadingTypes: LoadingTypesEnum[];
    carrierNote?: string;
    requirements?: string[];
    truckType?: string;
    cargoType?: string;
    expeditionType?: ExpeditionTypeEnum;
}

export interface MassActionExpeditionInternalInformationInDTO {
    responsiblePersonId?: string;
    overwriteResponsiblePersonId: boolean;
    subscribersIds: string[];
    overwriteSubscribersIds: boolean;
    notifiedTargets?: NotifyTargetInnerInDTO[];
    addNotifiedTargets: boolean;
    notifiedTargetsToAdd?: NotifyTargetInnerInDTO[];
    invoiceUserId?: string;
    overwriteInvoiceUserId: boolean;
    invoiceState?: InvoiceStateEnum;
    overwriteInvoiceState: boolean;
    invoiceRebillingType?: InvoiceRebillingTypeEnum;
    overwriteInvoiceRebillingType: boolean;
    invoicePartnerId?: string;
    invoiceDepartment?: string;
    internalNote?: string;
    overwriteInternalNote: boolean;
    appendInternalNote?: string;
    overwriteAppendInternalNote: boolean;
}

export interface MassInternalInfoExpeditionsInDTO {
    expeditionIds: string[];
    internalData: MassActionExpeditionInternalInformationInDTO;
}

export interface PartnerDetailInDTO {
    name: string;
    streetNr: string;
    country: string;
    zipCode: string;
    city: string;
    crn?: string;
    contactPerson?: string;
    contactPhone?: string;
    contactEmail?: string;
    timezoneId?: string;
}

export interface PartnerLocationContactPersonInDTO {
    contactEmail?: string;
    contactPhone?: string;
    contactName?: string;
}

export interface PartnerLocationInDTO {
    name: string;
    streetNr: string;
    country: string;
    zipCode: string;
    city: string;
    timezoneId?: string;
    contactEmail?: string;
    contactPhone?: string;
    contactName?: string;
    openingHourDefinitions: OpeningHourDefinitionsInDTO;
    contacts: PartnerLocationContactPersonInDTO[];
    enabledEmailNotificationForContactPerson?: boolean;
    locationNote?: string;
}

export interface SetCompanyModuleInDTO {
    enabled: boolean;
}

export interface BlacklistCarrierUserStateInDTO {
    toBlacklist: boolean;
}

export interface BlacklistCarrierUserStateOutDTO {
    isBlacklisted: boolean;
}

export interface CarrierGroupsInIds {
    carrierGroupIds: string[];
}

export interface CarriersInToGroupIds {
    carrierIds: string[];
}

export interface UserSecurityRolesInDTO {
    name: string;
    permissionTypes: PermissionTypesEnum[];
    translateKey?: string;
    descriptionKey?: string;
    isPrivate: boolean;
    isOnlyInternal: boolean;
    companyModules?: CompanyModulesEnum[];
}

export interface CompanyInfoInDTO {
    companyName: string;
    city: string;
    streetNr: string;
    zipCode: string;
    country: string;
}

export interface EditTimeslotCarrierInDTO {
    locationTimeslotIds: LocationTimeslotFormInDTO[];
}

export interface LocationTimeslotFormInDTO {
    locationId: string;
    timeslotId?: string;
    newTimeslot?: NewTimeslotEditInDTO;
}

export interface NewTimeslotEditInDTO {
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    timeslotSince: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    timeslotTill?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface EditCarInfoInDTO {
    carPlate?: string;
    driverId?: string;
    driverName?: string;
    dispatcherId?: string;
}

export interface CarrierExpeditionId {
    customerId: string;
    applicationId: string;
}

export interface EditDataDTO {
    changeCarPlate: boolean;
    carPlate?: string;
    changeDriverId: boolean;
    driverId?: string;
    changeDispatcherId: boolean;
    dispatcherId?: string;
    changeDriverName: boolean;
    driverName?: string;
}

export interface MassEditCarInfoInDTO {
    expeditionCoordinates: CarrierExpeditionId[];
    editData: EditDataDTO;
}

export interface AdminModuleNotInheritedInDTO {
    companyModule: CompanyModuleEnum;
    isActive: boolean;
}

export interface WorkflowTransitionAdditionalFieldInDTO {
    additionalFieldName: string;
    additionalFieldValue: string[];
}

export interface WorkflowTransitionInDTO {
    transitionToName: string;
    additionalField?: WorkflowTransitionAdditionalFieldInDTO;
}

export interface AdditionalContactDTO {
    contactName?: string;
    contactId?: string;
}

export interface CarPlateVisitorRecordTO {
    carPlate?: string;
    expectedArrivalDate?: string;
    expectedArrivalTime?: string;
    durationMinutes?: number;
}

export interface VisitorRecordInDTO {
    locationId?: string;
    labelIds: string[];
    responsiblePersonId?: string;
    mainContactName?: string;
    mainContactId?: string;
    mainContactCompany?: string;
    car?: CarPlateVisitorRecordTO;
    note?: string;
    additionalContacts?: AdditionalContactDTO[];
}

export interface VisitorRecordOutDTO {
    id: string;
    applicationId: string;
}

export interface ArchiveVisitorRecordInDTO {
    isArchived: boolean;
}

export interface SNUpdateDataTimeslotsInDTO {
    unloadingDeliverySlot: GlobalTimeslots;
    loadingDeliverySlot: GlobalTimeslots;
}

export interface SNUpdateDataLocationInDTO {
    supplierLocationId: string;
    customerLocationId: string;
    shipmentStateCode?: ShipmentStateCodeEnum;
    transportationType: TransportationTypeEnum;
}

export interface SNUpdateDataInternalNoteInDTO {
    internalNote?: string;
}

export interface InternalInfoInDTO {
    internalInvoiceNumber?: string;
    invoiceDueDate?: string;
    deliveryConditionsIncotermCode?: string;
    folderIds?: string[];
}

export interface NotificationEntityInDTO {
    responsiblePersonId?: string;
    userIdsToNotify?: string[];
    notifyUsersDependsOnRole: boolean;
}

export interface SNUpdateDataInternalInfoInDTO {
    notifyData: NotificationEntityInDTO;
    internalData?: InternalInfoInDTO;
}

export interface CargoTypeInDTO {
    cargoTypeCode: string;
    adrWeight?: number;
}

export interface ContainerInfoInDTO {
    containerId: string;
    containerInfoCode: string;
}

export interface SNUpdateDataInfoCargoInDTO {
    cargoType: CargoTypeInDTO;
    containerInfo?: ContainerInfoInDTO;
    customsTypeCode?: string;
    referralCode?: string;
    /**
     * @deprecated dual-written from the active CMR/BL/AWB number
     */
    shipmentId?: string;
    cmrNumber?: string;
    blNumber?: string;
    awbNumber?: string;
    specialRequirementIds: string[];
    note?: string;
}

export interface SNUpdateDataCargosInDTO {
    orders: GlobalOrdersRequest[];
}

export interface SHSNArchivedInDTO {
    archive: boolean;
}

export interface MassActionSNInformationInDTO {
    responsiblePersonId?: string;
    overwriteResponsiblePersonId: boolean;
    overwriteLoadingTimeslots: boolean;
    shipmentStateCode?: ShipmentStateCodeEnum;
    overwriteShipmentStateCode: boolean;
    overwriteDatesWithOpeningTimes: boolean;
    /**
     * @deprecated Use loadingLocalDateSince instead
     */
    loadingDatesSince?: string;
    /**
     * @deprecated Use loadingLocalDateUntil instead
     */
    loadingDatesUntil?: string;
    /**
     * @deprecated Use unloadingLocalDateSince instead
     */
    unloadingDatesSince?: string;
    /**
     * @deprecated Use unloadingLocalDateUntil instead
     */
    unloadingDatesUntil?: string;
    loadingLocalDateSince?: string;
    loadingLocalDateUntil?: string;
    unloadingLocalDateSince?: string;
    unloadingLocalDateUntil?: string;
    overwriteLabels: boolean;
    labels?: string[];
    unloadingDeliverySlot?: GlobalTimeslots;
    loadingDeliverySlot?: GlobalTimeslots;
    overwriteFolder: boolean;
    /**
     * @deprecated RD-2977: use folderIds
     */
    folderId?: string;
    folderIds?: string[];
    createExpedition: boolean;
    distribution?: DirectAssignRequestDistributionRequestInDTO;
}

export interface MassActionSupplierNotificationInDTO {
    snIds: string[];
    internalData: MassActionSNInformationInDTO;
}

export interface SHUpdateDataTimeslotsInDTO {
    departureAt: string;
    arrivalAt: string;
    departureAtUtc?: string;
    arrivalAtUtc?: string;
}

export interface SHUpdateDataLocationInDTO {
    loadingLocationId: string;
    unloadingLocationId: string;
    transportationType: TransportationTypeEnum;
}

export interface CurrencyOrderValueInDTO {
    amount: number;
    currencyCode: string;
}

export interface SHUpdateDataCargosInDTO {
    orders: ShipmentOrderInDTO[];
}

export interface ShipmentItemInDTO {
    stackable: boolean;
    cargoItemTypeCode: string;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
    amount: number;
    quantityUnitCode: string;
}

export interface ShipmentOrderInDTO {
    orderName: string;
    items: ShipmentItemInDTO[];
    orderValue: CurrencyOrderValueInDTO;
    weight: WeightInDTO;
    orderAmount: number;
    orderDescription?: string;
}

export interface WeightInDTO {
    value?: number;
    weightModeTypeOrder: WeightModeTypeOrderEnum;
}

export interface SHUpdateDataInfoCargoInDTO {
    cargoType: CargoTypeInDTO;
    containerInfo?: ContainerInfoInDTO;
    customsTypeCode: string;
    referralCode?: string;
    shipmentId?: string;
    specialRequirementIds: string[];
}

export interface InvoiceInDTO {
    version?: number;
    requestId?: string;
    senderId?: string;
    parentId: string;
    attachmentId?: string;
    invoiceId?: string;
    customerCompanyId?: string;
    sourceType?: SourceTypeEnum;
    state?: StateEnum;
    stateMessage?: string;
    externalReferenceId?: string;
    issueDate?: string;
    taxPointDate?: string;
    paymentDueDate?: string;
    supplierCRN?: string;
    supplierName?: string;
    supplierTaxId?: string;
    customerCRN?: string;
    customerName?: string;
    customerTaxId?: string;
    bankAccountId?: string;
    bankIBAN?: string;
    bankBIC?: string;
    bankCode?: string;
    variableSymbol?: string;
    constantSymbol?: string;
    transactionCurrCode?: string;
    homeCurrCode?: string;
    currRate?: number;
    taxExclusiveTransactionCurrAmount?: number;
    taxInclusiveTransactionCurrAmount?: number;
    taxTransactionCurrAmount?: number;
    taxExclusiveHomeCurrAmount?: number;
    taxInclusiveHomeCurrAmount?: number;
    taxHomeCurrAmount?: number;
    taxRate?: number;
    invoiceLines: InvoiceLineInDTO[];
    invoiceMessages: InvoiceMessageInDTO[];
}

export interface InvoiceLineInDTO {
    id?: string;
    invoiceLineId?: string;
    expeditionId?: string;
    lineTransactionCurrAmount?: number;
    lineTaxInclusiveTransactionCurrAmount?: number;
    lineHomeCurrAmount?: number;
    lineTaxInclusiveHomeCurrAmount?: number;
    currency?: string;
}

export interface InvoiceMessageInDTO {
    id?: string;
    severity: SeverityEnum;
    messageKey: string;
    message: string;
    messageArgs?: string;
}

export interface InvoiceLineOutDTO {
    id?: string;
    version?: number;
    invoiceLineId?: string;
    expeditionId?: string;
    lineTransactionCurrAmount?: number;
    lineTaxInclusiveTransactionCurrAmount?: number;
    lineHomeCurrAmount?: number;
    lineTaxInclusiveHomeCurrAmount?: number;
    currency?: string;
    createdAt?: string;
}

export interface InvoiceMessageOutDTO {
    id?: string;
    version?: number;
    severity: SeverityEnum;
    messageKey: string;
    message: string;
    messageArgs?: string;
    createdAt: string;
}

export interface InvoiceOutDTO {
    id: string;
    version: number;
    requestId?: string;
    senderId?: string;
    parentId?: string;
    attachmentId?: string;
    invoiceId?: string;
    customerCompanyId?: string;
    sourceType?: SourceTypeEnum;
    state: StateEnum;
    stateMessage?: string;
    externalReferenceId?: string;
    issueDate?: string;
    taxPointDate?: string;
    paymentDueDate?: string;
    supplierCRN?: string;
    supplierName?: string;
    supplierTaxId?: string;
    customerCRN?: string;
    customerName?: string;
    customerTaxId?: string;
    bankAccountId?: string;
    bankIBAN?: string;
    bankBIC?: string;
    bankCode?: string;
    variableSymbol?: string;
    constantSymbol?: string;
    transactionCurrCode?: string;
    homeCurrCode?: string;
    currRate?: number;
    taxExclusiveTransactionCurrAmount?: number;
    taxInclusiveTransactionCurrAmount?: number;
    taxTransactionCurrAmount?: number;
    taxExclusiveHomeCurrAmount?: number;
    taxInclusiveHomeCurrAmount?: number;
    taxHomeCurrAmount?: number;
    taxRate?: number;
    createdAt: string;
    updatedAt: string;
    archived: boolean;
    invoiceLines: InvoiceLineOutDTO[];
    invoiceMessages: InvoiceMessageOutDTO[];
}

export interface GroupDemandsMoreCarrierInDTO {
    selectedItems: CarrierGroupInDTO[];
}

export interface GroupDemandChangeValidTillInDTO {
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface AttachmentSendEmailInDTO {
    filesIds: string[];
    emailsToSendAttachment: string[];
    titleName: string;
    messageBody: string;
}

export interface EntityLabelsInDTO {
    labelIds: string[];
}

export interface InternalCommentUpdateInDTO {
    content: string;
}

export interface InternalCommentOutDTO {
    id: string;
    content: string;
    authorId?: string;
    authorName?: string;
    createdDate?: string;
    lastModifiedDate?: string;
    edited: boolean;
    canEdit: boolean;
}

export interface ExpeditionInternalNoteInDTO {
    internalNote?: string;
}

export interface ExpeditionInternalNoteOutDTO {
    internalNote?: string;
}

export interface ExpeditionArchiveInDTO {
    archive: boolean;
    archiveSN: boolean;
}

export interface EditReservationTimeslotsInDTO {
    sinceHourString: string;
    durationInMinutes: number;
    localDate: string;
    rampId: string;
}

export interface EditReservationTimeslotsDurationInDTO {
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    till: string;
    calendarId: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface EditReservationOnBehalfOfInDTO {
    onBehalfOfCodeListId?: string;
}

export interface EditReservationCarrierEntityInDTO {
    carrierId?: string;
}

export interface EditOrderDiscrepanciesRequestDTO {
    reservationId: string;
    orderDiscrepancies: OrderDiscrepancyRequestDTO[];
    crossDockDiscrepancyUnits?: number;
}

export interface OrderDiscrepancyRequestDTO {
    id: string;
    discrepancyNote?: string;
    discrepancies: OrderItemDiscrepancyRequestDTO[];
}

export interface OrderItemDiscrepancyRequestDTO {
    id: string;
    discrepancyAmount?: number;
}

export interface EditOrderDiscrepanciesResponseDTO {
    reservationId: string;
    orders: GlobalOrderResponse[];
    flags: ReservationFlagDTO[];
}

export interface ExternalOrderDataResponse {
    orderNumber: string;
    timeFrom?: string;
    timeTo?: string;
}

export interface GlobalOrderItemCargoTemplateResponseOutDTO {
    name: string;
    code: string;
    decimalPlaces: number;
}

export interface GlobalOrderItemInfoDetailOutDTO {
    externalId?: string;
    name?: string;
    count?: number;
    weight?: number;
    size?: string;
    wheelbase?: string;
}

export interface GlobalOrderItemsResponse {
    id: string;
    cargoTemplate: GlobalOrderItemCargoTemplateResponseOutDTO;
    stackable: boolean;
    amount: number;
    height?: number;
    width?: number;
    length?: number;
    weight?: number;
    itemNote?: string;
    discrepancyAmount?: number;
    manipulationUnitInfo?: GlobalOrderItemInfoDetailOutDTO[];
}

export interface GlobalOrderResponse {
    id: string;
    orderName?: string;
    orderNote?: string;
    orderValue?: PriceDTO;
    orderAmount?: number;
    orderDescription?: string;
    orderTotalWeight?: number;
    totalVolume?: number;
    items: GlobalOrderItemsResponse[];
    unloadingLocationId?: string;
    discrepancyNote?: string;
    loadedEans?: string[];
    externalData?: ExternalOrderDataResponse[];
}

export interface ACLInDTO {
    visibility: VisibilityEnum;
    visibleToCompanies: LovDTO[];
}

export interface CMRSigningDataInDTO {
    textEnabled: boolean;
    text?: string;
    imageEnabled: boolean;
    imageData?: FileV2InDTO;
    userEnabled: boolean;
    updateImage: boolean;
}

export interface CompanyLocationContactPersonInDTO {
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
    automaticPrefillToNotify: boolean;
}

export interface CompanyLocationInDTO {
    name: string;
    city: string;
    postalCode: string;
    streetNr: string;
    country: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    contactAutomaticPrefillToNotify: boolean;
    concurrentlyActiveEventsCount: number;
    isNotIncludedPrivateRamps: boolean;
    contacts: CompanyLocationContactPersonInDTO[];
    acl: ACLInDTO;
    isExternal: boolean;
    externalName?: string;
    externalId?: string;
    externalIds?: string[];
    tvDashboard?: TvDashboardSettingsDTO;
    isPartnerLocation: boolean;
    enableVisitor: boolean;
    dachserCustomerNumber?: string;
    dachserBranch?: string;
    dachserToken?: string;
    schenkerReferenceNumber?: string;
    dhlAccountNumberExport?: string;
    dhlAccountNumberImport?: string;
    fedexAccountIds?: string[];
    isDeleted: boolean;
    senderSigningEnabled: boolean;
    senderSigningData?: CMRSigningDataInDTO;
    receiverSigningEnabled: boolean;
    receiverSigningData?: CMRSigningDataInDTO;
    timezoneId?: string;
    sharing: LocationSharingInDTO[];
    locationNote?: string;
}

export interface FileV2InDTO {
    dataURL: string;
    fileName: string;
}

export interface LocationSharingInDTO {
    companyId: string;
    locationSharingPrivilege: LocationSharingPrivilegeEnum;
}

export interface TvDashboardSettingsDTO {
    columnsCount: number;
    reservationName: TvFieldSettingDTO;
    orderIds: TvFieldSettingDTO;
    time: TvFieldSettingDTO;
    carrier: TvFieldSettingDTO;
    carPlate: TvFieldSettingDTO;
    showUnfinished: boolean;
}

export interface TvFieldSettingDTO {
    mode: ModeEnum;
    bold: boolean;
}

export interface SupersedeCompanyLocationInDTO {
    supersededByLocationId: string;
}

export interface CompanyLocationRampsOrderInDTO {
    rampIds: string[];
}

export interface CompanyLocationRampsConfigInDTO {
    concurrentlyActiveEventsCount: number;
    excludePrivateRampsFromCapacity: boolean;
    tvDashboard: TvDashboardSettingsDTO;
}

export interface CompanyLocationRampInDTO {
    name: string;
    isPrivate: boolean;
    isShowOnRampDashboard: boolean;
    /**
     * @deprecated timeZone is deprecated; use timezoneId instead
     */
    timeZone: string;
    openingHourDefinitions: OpeningHourDefinitionsInDTO;
    maxSkuAmount?: number;
    maxReservationCount?: number;
    weeklyMaxSkuAmount?: number;
    weeklyMaxReservationCount?: number;
    isTemporaryClosed: boolean;
    timezoneId?: string;
}

export interface LocationContactInDTO {
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    automaticPrefillToNotify: boolean;
}

export interface CompanyLocationCmrSigningInDTO {
    enabled: boolean;
    data?: CMRSigningDataInDTO;
}

export interface CompanyLocationCarriersApiInDTO {
    dachserBranch?: string;
    dachserCustomerNumber?: string;
    dachserToken?: string;
    schenkerReferenceNumber?: string;
    dhlAccountNumberExport?: string;
    dhlAccountNumberImport?: string;
    fedexAccountIds?: string[];
}

export interface CompanyLocationBasicInfoInDTO {
    name: string;
    streetNr: string;
    city: string;
    postalCode: string;
    country: string;
    timezoneId?: string;
    externalId?: string;
    externalIds?: string[];
    enableVisitor: boolean;
    isPartnerLocation: boolean;
    locationNote?: string;
    latitude?: number;
    longitude?: number;
}

export interface LocRampTableDataOutDTO {
    rampId: string;
    locationId: string;
    text: string;
    reservationId: string;
    /**
     * @deprecated Use putOnTableAtUtc instead
     */
    putOnTableAt?: string;
    putOnTableAtUtc?: string;
}

export interface LocRampTableDefinedAreaOutDTO {
    locationId: string;
    maxRows: number;
    name: string;
    currentData: LocRampTableDataOutDTO[];
}

export interface LocationRampTableOutDTO {
    id: string;
    version: number;
    name: string;
    definedArea: LocRampTableDefinedAreaOutDTO;
}

export interface MaxCountResponseRampsOutDTO {
    rampId: string;
    rampName: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    timeslotFrom?: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    timeslotTo?: string;
    carPlate?: string;
    reservationApplicationId: string;
    reservationId: string;
    orderPlace: number;
    textOnRamp: string;
    /**
     * @deprecated Use putOnTableAtUtc instead
     */
    putOnTableAt?: string;
    putOnTableAtUtc?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface UpdateLocationRampTableResponseOutDTO {
    tableResponse?: LocationRampTableOutDTO;
    errorMaxCountResponse?: MaxCountResponseRampsOutDTO[];
}

export interface SetCompanyUserDriverDeletedRequest {
    isDeleted: boolean;
}

export interface EditShippingCompanyRequestInDTO {
    name: string;
    position: number;
}

export interface EditShippingCompanyResponseOutDTO {
    id: string;
    name: string;
    position: number;
}

export interface AttachmentUploadedOutDTO {
    attachmentId: string;
    fileName: string;
    size: number;
    contentType: string;
    userId: string;
    userName: string;
    companyId: string;
    uploadedAt: string;
    companyName: string;
    accessType?: AccessTypeEnum;
    accessTypeName?: string;
    documentType?: DocumentTypeEnum;
    documentTypeName?: string;
    canBeDeleted: boolean;
    userNote?: string;
    userDateLocalDate?: string;
    processedByAi: boolean;
    invoiceData?: InvoiceDataDTO;
    isAiProcessingEnabledForOwnerCompany: boolean;
}

export interface BigDecimalWithErrorsDTO {
    value?: number;
    errors: InvoiceErrorDTO[];
}

export interface InvoiceDataDTO {
    status: StatusEnum;
    stateMessage?: string;
    stateErrors: InvoiceErrorDTO[];
    carrierName?: StringWithErrorsDTO;
    tin?: StringWithErrorsDTO;
    invoiceNumber?: StringWithErrorsDTO;
    taxPointDate?: LocalDateWithErrorsDTO;
    issueDate?: LocalDateWithErrorsDTO;
    variableSymbol?: StringWithErrorsDTO;
    taxInclusiveAmounts?: InvoicePriceDTO[];
    taxExclusiveAmounts?: InvoicePriceDTO[];
    taxAmounts?: InvoicePriceDTO[];
    exchangeRate?: BigDecimalWithErrorsDTO;
    taxRate?: BigDecimalWithErrorsDTO;
    externalReferenceId?: string;
    items: InvoiceItemDTO[];
}

export interface InvoiceErrorDTO {
    invoiceSeverity: InvoiceSeverityEnum;
    messageKey: string;
    message: string;
    messageArgs: any;
}

export interface InvoiceItemDTO {
    id?: string;
    withTaxAmount?: number;
    withoutTaxAmount?: number;
    taxAmount?: number;
    currency?: string;
    shipmentIds: string[];
    errors: InvoiceErrorDTO[];
}

export interface InvoicePriceDTO {
    amount?: number;
    currency?: string;
    originalAmount?: number;
    originalCurrency?: string;
    errors: InvoiceErrorDTO[];
}

export interface LocalDateWithErrorsDTO {
    value?: string;
    errors: InvoiceErrorDTO[];
}

export interface StringWithErrorsDTO {
    value?: string;
    errors: InvoiceErrorDTO[];
}

export interface ManualWebhookSendOutDTO {
    queuedWebhookTypes: string[];
}

export interface SaveUserVisitorRecordFiltersResponseInDTO {
    name: string;
    data: VisitorRecordFilterInDTO;
}

export interface VisitorRecordFilterInDTO {
    locationIds?: string[];
    responsiblePersonIds?: string[];
    statuses?: string[];
    visitorName?: string;
    isArchived?: boolean;
    arrivalDateFrom?: string;
    arrivalDateTo?: string;
    departureDateFrom?: string;
    departureDateTo?: string;
    userTimezoneId: string;
}

export interface CalendarFilter {
    locationIds: string[];
    rampIds: string[];
    applicationIds: string[];
    carPlates: string[];
    carrierIds: string[];
    expeditionApplicationIds: string[];
    supplierIds: string[];
}

export interface SaveUserTimeslotCalendarFiltersResponseInDTO {
    name: string;
    data: CalendarFilter;
}

export interface AllSupplierNotificationFilter {
    applicationId?: string;
    expeditionConnectApplicationId?: string;
    groupDemandConnectName?: string;
    responsiblePersonIds?: string[];
    supplierId?: string;
    customerId?: string;
    loadingDateFromISO?: string;
    loadingDateToISO?: string;
    loadingLocationName?: string;
    supplierLocationCountry?: string;
    supplierLocationCity?: string;
    showArchived?: boolean;
    /**
     * @deprecated Use supplierNotificationType instead
     */
    onlyDAP?: boolean;
    supplierNotificationType?: SupplierNotificationTypeEnum;
    labelIds?: string[];
    shipmentNumber?: string;
    cmrNumber?: string;
    blNumber?: string;
    awbNumber?: string;
    folderIds?: string[];
    onlyWithoutExpedition?: boolean;
    referenceOrderId?: string;
    userTimezoneId: string;
    attachmentName?: string;
    requestedByUserId?: string;
}

export interface SaveUserSupplierNotificationFiltersResponseInDTO {
    name: string;
    data: AllSupplierNotificationFilter;
}

export interface AllReservationsFilter {
    locationName?: string;
    applicationId?: string;
    timeslotDaySince?: string;
    timeslotDayTill?: string;
    carrierIds?: string[];
    customerIds?: string[];
    driverName?: string;
    referenceOrderId?: string;
    carPlate?: string;
    reservationName?: string;
    isArchived?: boolean;
    reservationActionType?: ReservationActionTypeEnum[];
    labelIds?: string[];
    states?: string[];
    onBehalfOfIds?: string[];
    userTimezoneId: string;
    attachmentName?: string;
    folderIds?: string[];
    requestedByUserId?: string;
}

export interface SaveUserReservationFiltersResponseInDTO {
    name: string;
    data: AllReservationsFilter;
}

export interface NotificationCenterFilter {
    entityType?: EntityTypeEnum;
    applicationId?: string;
    isRead?: boolean;
    emailType?: EmailTypeEnum[];
    isUserMessage?: boolean;
    performedBy?: string;
}

export interface SaveUserNotificationFiltersResponseInDTO {
    name: string;
    data: NotificationCenterFilter;
}

export interface CompanyJobsFilter {
    applicationId?: string;
    jobType?: JobTypeEnum[];
    categories?: CategoriesEnum[];
    jobStatuses?: JobStatusesEnum[];
    createdByIds?: string[];
    createdAtFrom?: string;
    createdAtTill?: string;
    resultStates?: ResultStatesEnum[];
}

export interface SaveUserJobFiltersResponseInDTO {
    name: string;
    data: CompanyJobsFilter;
}

export interface AllExpeditionCustomerFilter {
    onlyManual?: boolean;
    applicationId?: string;
    responsiblePersonIds?: string[];
    createdByIds?: string[];
    carrierIds?: string[];
    statusEnums?: StatusEnumsEnum[];
    loadingDateFromISO?: string;
    loadingDateToISO?: string;
    unloadingDateFromISO?: string;
    unloadingDateToISO?: string;
    allTimeDateFromISO?: string;
    allTimeDateToISO?: string;
    expeditionType?: ExpeditionTypeEnum;
    loadingLocationName?: string;
    unLoadingLocationName?: string;
    validDistribution?: ValidDistributionEnum;
    onlyUnpublished?: boolean;
    showArchived?: boolean;
    labelIds?: string[];
    pairingSymbol?: string;
    countryCode?: string;
    loadingCountryCode?: string;
    unloadingCountryCode?: string;
    allLocationName?: string;
    folderIds?: string[];
    showFavourite?: boolean;
    mrnNumber?: string;
    trackingNumber?: string;
    referenceOrderId?: string;
    transportationType?: TransportationTypeEnum[];
    customsStatus?: CustomsStatusEnum[];
    userTimezoneId: string;
    showWithoutLinkedReservation?: boolean;
    attachmentName?: string;
    invoiceStates?: string[];
    withoutPairingSymbol?: boolean;
    aiDispatcherChanged?: boolean;
    requestedByUserId?: string;
}

export interface SaveUserExpeditionFiltersResponseInDTO {
    name: string;
    data: AllExpeditionCustomerFilter;
}

export interface FindEmailHistoryFilter {
    createdFrom?: string;
    createdTill?: string;
    ownerCompanyId?: string;
    entityType?: EntityTypeEnum;
    action?: string;
    recipientEmail?: string;
    subject?: string;
    hasError?: boolean;
    requestId?: string;
    senderName?: string;
    createdByName?: string;
    emailHistoryAggStatus?: EmailHistoryAggStatusEnum;
}

export interface SaveUserEmailHistoryFiltersResponseInDTO {
    name: string;
    data: FindEmailHistoryFilter;
}

export interface CreateTableViewInDTO {
    name: string;
    filter: JsonNode;
    sort: TableViewSortDTO;
    columns: TableViewColumnDTO[];
    favouriteFilters?: string[];
    pageSize?: number;
    pagingMode?: PagingModeEnum;
}

export interface CancelSnResponseInDTO {
    reasonCode: string;
}

export interface DAPSupplierNotificationInDTO {
    companyId: string;
    supplierId: string;
    attachments: AttachmentIdWithTypeV2InDTO[];
    responsiblePersonId?: string;
    userIdsToNotify?: string[];
    notifyUsersDependsOnRole: boolean;
    transportationType: TransportationTypeEnum;
    carrierName: string;
    shipmentNumber: string;
    orders: GlobalOrdersRequest[];
    supplierLocationId: string;
    customerLocationId: string;
    internalInvoiceNumber?: string;
    invoiceDueDate?: string;
    deliveryConditions?: string;
    internalNote?: string;
    note?: string;
    /**
     * @deprecated RD-2977: use folderIds
     */
    folderId?: string;
    folderIds?: string[];
    loadingGlobalTimeslots: GlobalTimeslots;
    unloadingGlobalTimeslots: GlobalTimeslots;
    labelIds: string[];
}

export interface ImportPriceJsonRootEntry {
    ValidFrom?: string;
    ValidTo?: string;
    ParameterName?: string;
    soho: SohoEntry[];
}

export interface ImportPriceJsonToDbRequest {
    jsonData: ImportPriceJsonRootEntry[];
    isExport: boolean;
}

export interface SohkEntry {
    ZoneName?: string;
    UnloadingZone?: string;
    sp: SpEntry[];
}

export interface SohoEntry {
    LoadingZone?: string;
    sohk: SohkEntry[];
}

export interface SpEntry {
    cislo_subjektu?: number;
    cislo_objektu?: number;
    cislo_radky: number;
    pasmo?: string;
    kam?: number;
    s1?: number;
    s2?: number;
    s3?: number;
    s4?: number;
    s5?: number;
    s6?: number;
    s7?: number;
    s8?: number;
    s9?: number;
    s10?: number;
    s11?: number;
    s12?: number;
    s13?: number;
    s14?: number;
    s15?: number;
    s16?: number;
    s17?: number;
    s18?: number;
    s19?: number;
    s20?: number;
    s21?: number;
    s22?: number;
    s23?: number;
}

export interface ImportPriceJsonToDbResponse {
    weightBandsCount: number;
    priceMatrixCount: number;
    skippedCount: number;
    message: string;
}

export interface ImportSchenkerCountryConfigurationRequestInDTO {
    configs: ImportSchenkerCountryConfigurationRequestItemInDTO[];
    currency: string;
}

export interface ImportSchenkerCountryConfigurationRequestItemInDTO {
    countryIso3: string;
    weightCBMCoeff: number;
    tollFee: number;
    fuelSurchargePercentage: number;
    fixDayPrice: number;
    fixDayPrice10?: number;
    fixDayPrice13?: number;
    longGoodPrice?: number;
    fixDayToAgreedPrice?: number;
    automatedFixDayToAgreed?: number;
    premium10?: number;
    premium13?: number;
    ecoFee?: number;
}

export interface ImportSchenkerCountryConfigurationResponseDTO {
    created: number;
    updated: number;
    total: number;
}

export interface SaveUpdateCameraRequest {
    id?: string;
    externalId: string;
    name: string;
    companyLocationId: string;
    cameraType: CameraTypeEnum;
}

export interface SaveUpdateAllowedCarPlateRequest {
    id?: string;
    carPlate: string;
    firstName?: string;
    secondName?: string;
    cardId?: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceLocalDate?: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    tillLocalDate?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
    allowedCarPlateMatchType?: AllowedCarPlateMatchTypeEnum;
}

export interface RunnerRequest {
    command: string;
}

export interface RunnerResponse {
    response: string;
}

export interface UpdateTruckRequest {
    truckTypeCode?: string;
}

export interface UpdateReservationNameRequest {
    reservationName: string;
}

export interface UpdateOrdersAndTimeslotRequest {
    actionTypes: ActionTypesEnum[];
    orders: GlobalOrdersRequest[];
    timeslot: EditReservationTimeslotsInDTO;
}

export interface UpdateNoteRequest {
    reservationNote: string;
}

export interface UpdateNoteForCarrierRequest {
    carrierNote: string;
}

export interface UpdateInternalNoteRequest {
    internalNote?: string;
}

export interface UpdateFoldersRequest {
    folderIds: string[];
}

export interface UpdateDriverPhoneRequest {
    driverPhone: string;
}

export interface UpdateDriverNameRequest {
    driverName: string;
    driverId?: string;
}

export interface UpdateCarPlateRequest {
    carPlate: string;
}

export interface NotifyDriverRequest {
    drivePhone: string;
}

export interface MassDeleteReservationsInDTO {
    reservationIds: string[];
}

export interface MassActionReservationRejectedDTO {
    reservationId: string;
    applicationId?: string;
    reservationRejectionReason: ReservationRejectionReasonEnum;
}

export interface MassActionReservationsOutDTO {
    processedIds: string[];
    rejected: MassActionReservationRejectedDTO[];
}

export interface MassArchiveReservationsInDTO {
    reservationIds: string[];
}

export interface CreateReservationMultiDuplicationJobInDTO {
    sourceReservationId: string;
    template: ReservationDataInDTO;
    slots: TimeslotCalendarDTO[];
    sendNotification: boolean;
}

export interface OrderReservationInDTO {
    orderId?: string;
    orderNote?: string;
    orderType?: string;
    reservationName?: string;
    items?: ReservationCargoItemInDTO[];
}

export interface ReservationCargoItemInDTO {
    width?: number;
    height?: number;
    length?: number;
    weight?: number;
    amount?: number;
    quantityUnit?: string;
    stackable?: boolean;
    weightMode?: WeightModeEnum;
    cargoItemTypeCode?: string;
    itemNote?: string;
}

export interface ReservationDataInDTO {
    customerId: string;
    carrierId?: string;
    locationId?: string;
    rampId?: string;
    timeslot?: TimeslotCalendarDTO;
    /**
     * @deprecated Use orders instead
     */
    order?: OrderReservationInDTO;
    carPlate?: string;
    carrierNote?: string;
    driverInfo?: ReservationDriverInfoInDTO;
    labelIds: string[];
    preferredDate?: string;
    preferredRampId?: string;
    reservationActionTypes?: ReservationActionTypesEnum[];
    linkToExpeditionLocationId?: string;
    reservationName?: string;
    reservationNote?: string;
    orders?: GlobalOrdersRequest[];
    openGate: boolean;
    cameraId?: string;
    cameraLogId?: string;
    createExpedition: boolean;
    fromReservationId?: string;
    truckTypeCode?: string;
    flags?: ReservationFlagDTO[];
    onBehalfOfCodeListId?: string;
    sendNotification: boolean;
    folderIds?: string[];
}

export interface ReservationDriverInfoInDTO {
    driverId?: string;
    driverName?: string;
    driverPhone?: string;
}

export interface TimeslotCalendarDTO {
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    till: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface ReservationMultiDuplicationJobStartedOutDTO {
    jobId: string;
    totalCount: number;
}

export interface CheckIfExpeditionCanBeCreatedRequestInDTO {
    reservationOrderNames: string[];
    originalExpeditionId: string;
}

export interface CheckIfExpeditionCanBeCreatedResponseOutDTO {
    expeditionApplicationId: string;
    cannotBeCreated: boolean;
    locations: LocationPreviewForCheckExpResponseOutDTO[];
}

export interface LocationPreviewForCheckExpResponseOutDTO {
    id: string;
    name: string;
    country: string;
    streetNr: string;
    city: string;
    zipCode: string;
    orderNames: string[];
}

export interface TestPushPublishRequest {
    target: TargetEnum;
    message: string;
}

export interface TestPushPublishResponse {
    channel: string;
}

export interface RegisterCompanyRequestInDTO {
    companyName: string;
    city: string;
    zipCode: string;
    streetNr: string;
    adminFirstName: string;
    adminLastName: string;
    adminEmail: string;
    crn: string;
    vat: string;
    country: string;
    phone: string;
    defaultTimezoneId?: string;
}

export interface AdHocRegistrationCompanyRequestInDTO {
    crn: string;
    country: string;
    code: string;
    contactEmail: string;
    registerMessage: string;
}

export interface CheckIfCompanyExistsRequestInDTO {
    crn: string;
    country: string;
    code: string;
}

export interface CheckIfCompanyExistsResponseOutDTO {
    isExists: boolean;
    codeIsOk: boolean;
}

export interface MassActionAcceptModuleRequestInDTO {
    inheritedCompanyIds: string[];
}

export interface RegenerateLinkedCodeRequestIdDTO {
    modules: ModulesEnum[];
}

export interface ImportCompanyCodeListItem {
    externalId: string;
    name: string;
    description?: string;
}

export interface ImportCompanyCodeListRequest {
    items: ImportCompanyCodeListItem[];
}

export interface ImportCompanyCodeListResponse {
    summary: ImportSummary;
    results: ImportResult[];
}

export interface ImportResult {
    externalId: string;
    status: string;
    id?: string;
    errorMessage?: string;
}

export interface ImportSummary {
    total: number;
    created: number;
    updated: number;
    errors: number;
}

export interface CompanyInfo {
    crn: string;
    companyName: string;
    city: string;
    zipCode: string;
    streetNr: string;
    vat: string;
    country: string;
    adminFirstName: string;
    adminLastName: string;
    adminEmail: string;
    adminPhone: string;
    localityName: string;
    localityCountry: string;
    localityZipCode: string;
    localityCity: string;
    localityStreetNr: string;
    localityContactName: string;
    localityContactPhone: string;
    localityContactEmail: string;
    defaultTimezoneId?: string;
}

export interface ImportCompanyAndLocationInDTO {
    companyInfoList: CompanyInfo[];
}

export interface ImportCameraInput {
    externalId: string;
    name: string;
    cameraType: CameraTypeEnum;
    companyLocationId: string;
}

export interface ImportCamerasInput {
    cameras: ImportCameraInput[];
}

export interface ImportAllowedCarPlateRequest {
    carPlate: string;
    firstName?: string;
    secondName?: string;
    cardId?: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    validSince: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface ImportAllowedCarPlatesRequest {
    allowedCarPlates: ImportAllowedCarPlateRequest[];
}

export interface FedexRegistrationStartInDTO {
    accountNumber: string;
    name?: string;
    street: string;
    city: string;
    postalCode: string;
    countryCode: string;
    residential: boolean;
    customerName: string;
}

export interface FedexRegistrationMfaOutDTO {
    accountAuthToken: string;
    maskedEmail?: string;
    maskedPhone?: string;
    pinOptions: string[];
    invoiceAllowed: boolean;
}

export interface FedexRegistrationStepOutDTO {
    fedexRegistrationStatus: FedexRegistrationStatusEnum;
    mfa?: FedexRegistrationMfaOutDTO;
}

export interface FedexRegistrationPinSendInDTO {
    accountAuthToken: string;
    option: string;
}

export interface FedexRegistrationPinSentOutDTO {
    sent: boolean;
}

export interface FedexRegistrationPinConfirmInDTO {
    accountAuthToken: string;
    accountNumber: string;
    name?: string;
    secureCodePin: string;
}

export interface FedexRegistrationInvoiceConfirmInDTO {
    accountAuthToken: string;
    accountNumber: string;
    name?: string;
    invoiceNumber: number;
    invoiceDate: string;
    invoiceAmount: number;
    invoiceCurrency: string;
}

export interface FedexEulaAcceptInDTO {
    eulaVersion: string;
}

export interface FedexPickupAvailabilityInDTO {
    countryFrom: string;
    countryTo: string;
    postalCodeFrom: string;
    cityFrom?: string;
    streetFrom?: string;
    dispatchDate: string;
    serviceType?: string;
    fedexAccountId?: string;
    fromCompanyLocationId?: string;
    toCompanyLocationId?: string;
}

export interface FedexPickupAvailabilityOutDTO {
    available: boolean;
    pickupDate?: string;
    cutOffTime?: string;
    accessTimeMinutes?: number;
    earliestReadyTime?: string;
    latestCloseTime?: string;
    options: FedexPickupDateOptionOutDTO[];
}

export interface FedexPickupDateOptionOutDTO {
    pickupDate: string;
    cutOffTime?: string;
    accessTimeMinutes?: number;
    readyTimeOptions: string[];
    latestTimeOptions: string[];
}

export interface FedexEtdImageUploadInDTO {
    fileName: string;
    dataURL: string;
}

export interface FedexEtdImagesOutDTO {
    signatureConfigured: boolean;
    signatureUploadedAt?: string;
    letterheadConfigured: boolean;
    letterheadUploadedAt?: string;
}

export interface FedexCertRequoteInDTO {
    expeditionId: string;
    quoteDemandId: string;
}

export interface FedexCreateQuoteResponseOutDTO {
    success: boolean;
    price?: PriceDTO;
    priceWithVat?: PriceDTO;
    serviceType?: string;
    estimatedDeliveryDate?: string;
    appendToNote?: string;
}

export interface FedexAvailableProductsRequestDTO {
    countryFrom: string;
    countryTo: string;
    postalCodeFrom: string;
    postalCodeTo: string;
    cityFrom: string;
    cityTo: string;
    streetFrom?: string;
    streetTo?: string;
    fromDeliverySlot?: ValidationDeliverySlotInDTO;
    allPackages: FedexPackageDTO[];
    fedexAccountId?: string;
    fromCompanyLocationId?: string;
    toCompanyLocationId?: string;
}

export interface FedexPackageDTO {
    weight: number;
    length: number;
    width: number;
    height: number;
    amount: number;
}

export interface FedexAvailableProductDTO {
    serviceType: string;
    serviceName?: string;
    price?: PriceDTO;
    priceWithVat?: PriceDTO;
    estimatedDeliveryDate?: string;
    transitDaysDescription?: string;
}

export interface ExportColumnInDTO {
    field: string;
    header: string;
}

export interface ExportJobRequestInDTO {
    entityType: EntityTypeEnum;
    exportFormat: ExportFormatEnum;
    filter: JsonNode;
    columns?: ExportColumnInDTO[];
}

export interface ExportJobStartedOutDTO {
    jobId: string;
    entityType: EntityTypeEnum;
    exportFormat: ExportFormatEnum;
    totalCount: number;
    cappedAt: number;
}

export interface ExportAsyncJobStartedOutDTO {
    jobId: string;
    totalCount: number;
    cappedAt: number;
}

export interface FinishLocationByCustomerRequestInDTO {
    /**
     * @deprecated Use completedAtUtc instead
     */
    completedAt: string;
    completedAtUtc?: string;
}

export interface CarrierPodResult {
    successfulDownload: boolean;
}

export interface MultiduplicationV3CreateJobInDTO {
    expeditionIds: string[];
    shiftDays: number;
}

export interface MultiduplicationV3JobStartedOutDTO {
    jobId: string;
    totalCount: number;
}

export interface FilterRequestInDTO {
    filterRequests: FilterRequestInnerInDTO[];
}

export interface FilterRequestInnerInDTO {
    fieldName: string;
    filterFieldType: FilterFieldTypeEnum;
    filterComparisonType: FilterComparisonTypeEnum;
    value: any;
}

export interface Pageable {
    pageSize?: number;
    offset?: number;
    pageNumber?: number;
    sortField?: string;
    sortDirection?: string;
    sortCriteriaList?: SortCriteria[];
}

export interface SortCriteria {
    field?: string;
    direction?: string;
}

export interface AiChatClassificationOutDTO {
    intent: IntentEnum;
    topic: TopicEnum;
}

export interface CarInfoPreviewOutDTO {
    carPlate: string;
    /**
     * @deprecated use assignedDriver
     */
    driverFullName?: string;
}

export interface CargoPreviewPlanOutDTO {
    name: string;
    quantityUnit: string;
    amount: number;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
    stackable: boolean;
    cargoItemTypeCode: string;
    decimalPlaces: number;
    itemNote?: string;
    weightMode: WeightModeEnum;
    manipulationUnitInfo?: GlobalOrderItemInfoDetailOutDTO[];
}

export interface DistributionExpeditionPreviewOutDTO {
    isClosed: boolean;
    isExpiredDistribution: boolean;
    distributionType: DistributionTypeEnum;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    expiredUntil: string;
    /**
     * @deprecated Use bestQuoteUtcEnd and timezoneId instead
     */
    bestQuoteExpiredUntil?: string;
    quotesOfferCount: number;
    quotesCount: number;
    utcEnd?: string;
    bestQuoteUtcEnd?: string;
    timezoneId?: string;
}

export interface ExpeditionListDataOutDTO {
    expeditions: PageResponseExpeditionPreviewOutDTO;
    unpublishedExpeditionCount: number;
    groupedFilter?: ExpedtionListGroupedFilterDTO;
}

export interface ExpeditionPreviewOutDTO {
    id: string;
    applicationId?: string;
    companyId: string;
    distribution?: DistributionExpeditionPreviewOutDTO;
    price?: number;
    currency?: string;
    expeditionCurrency?: string;
    expeditionPrice?: number;
    expeditionPriceDTO?: PriceDTO;
    assignedCarrierName?: string;
    responsiblePerson: string;
    locations: LocationExpeditionPreviewOutDTO[];
    expeditionType?: ExpeditionTypeEnum;
    expeditionStatus: ExpeditionStatusEnum;
    /**
     * @deprecated use orders
     */
    ordersName: string[];
    isManualExpedition: boolean;
    expeditionToId?: string;
    expeditionFromId?: string;
    isPublished: boolean;
    lastExpeditionStatus: LastExpeditionStatusEnum;
    orders: OrderPreviewExpeditionListOutDTO[];
    isRoundtrip: boolean;
    labels: LabelPreview[];
    isDriverCurrentlyActive: boolean;
    extraCosts?: ExtraCostsListPreview[];
    note?: string;
    carInfo?: CarInfoPreviewOutDTO;
    carrierDispatcherEmail?: string;
    carrierDispatcherName?: string;
    isInvoiced: boolean;
    isArchived: boolean;
    supplierNotificationId?: string;
    supplierNotificationAppId?: string;
    supplierManifestAppId?: string;
    supplierManifestId?: string;
    folderNames: string[];
    customsLoadingNumber?: string;
    customsStatus?: CustomsStatusEnum;
    name?: string;
    pairingSymbol?: string;
    trackingNumber?: string;
    isFavorite: boolean;
    attachmentInfo?: ListAttachmentInfoOutDTO;
    assignedDriver?: string;
    apiType?: ApiTypeEnum;
    createdByFullName: string;
    aiChatClassification?: AiChatClassificationOutDTO;
    allowPartialDelivery: boolean;
    ladenFactor?: number;
    bestQuoteTransportLegs: QuoteDemandTransportLegOutDTO[];
    createdAt: string;
    transportationType?: TransportationTypeEnum;
    aiDispatcherFirstChangeAt?: string;
    aiDispatcherLastChangeAt?: string;
}

export interface ExpedtionListGroupedFilterDTO {
    responsiblePersons: LovDTO[];
    carrierIds: LovDTO[];
    statusEnums: StatusEnumsEnum[];
    labelValues: LabelPreviewWithTypeOutDTO[];
    countryCodes: LovWithoutIdDTO[];
    folderIds: LovDTO[];
    expeditionTypes: ExpeditionTypesEnum[];
    loadingCountryCodes: LovWithoutIdDTO[];
    unloadingCountryCodes: LovWithoutIdDTO[];
    createdByUsers: LovDTO[];
    transportationType: TransportationTypeEnum[];
    customsStatus: CustomsStatusEnum[];
}

export interface ExtraCostsListPreview {
    name: string;
    description: string;
    price: number;
    currency: string;
    priceDTO: PriceDTO;
}

export interface LabelPreviewWithTypeOutDTO {
    entityType: EntityTypeEnum;
    labelValue: string;
    labelColor: string;
    labelId: string;
}

export interface ListAttachmentInfoOutDTO {
    attachmentSize: number;
    attachments: ListAttachmentInnerOutDTO[];
}

export interface ListAttachmentInnerOutDTO {
    id: string;
    name: string;
    documentType: DocumentTypeEnum;
}

export interface LocationExpeditionPreviewOutDTO {
    name: string;
    timeslots: GlobalTimeslots;
}

export interface LovWithoutIdDTO {
    name: string;
    code: string;
}

export interface OrderPreviewExpeditionListOutDTO {
    orderName: string;
    locationName: string;
    items: CargoPreviewPlanOutDTO[];
}

export interface PageResponseExpeditionPreviewOutDTO {
    data: ExpeditionPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface QuoteDemandTransportLegOutDTO {
    transportationType: TransportationTypeEnum;
    route?: string;
    fromDate?: string;
    toDate?: string;
    position: number;
    note?: string;
    flightNumber?: string;
    flightType?: string;
    voyageNumber?: string;
    shipType?: string;
    shipCompanyId?: string;
    shipCompanyName?: string;
    trainNumber?: string;
    trainType?: string;
    vehicleType?: string;
}

export interface EnnoviImportExpeditionRequestInDTO {
    rows: EnnoviImportExpeditionRowRequestInDTO[];
}

export interface EnnoviImportExpeditionRowRequestInDTO {
    id: string;
    delivery?: string;
    shipToParty?: string;
    shipFromParty?: string;
    loadingDate?: string;
    unloadingDate?: string;
    material?: string;
    quantity?: string;
    incotermsValue?: string;
    incotermsDescription?: string;
}

export interface EnnoviImportExpeditionResponseOutDTO {
    rows: EnnoviImportExpeditionRowResponseOutDTO[];
    countSuccessRows: number;
    countCreatedExpeditions: number;
    countFailedRows: number;
}

export interface EnnoviImportExpeditionRowResponseOutDTO {
    id: string;
    isSuccess: boolean;
    errorMessage?: string;
    expeditionCoordinate?: ExpeditionCoordinate;
}

export interface ExpeditionCoordinate {
    applicationId: string;
    expeditionId: string;
    isCarrier: boolean;
    customerId: string;
}

export interface CheckEnnoviImportExpeditionResponseOutDTO {
    rows: EnnoviImportExpeditionRowCheckOutDTO[];
}

export interface EnnoviImportExpeditionRowCheckOutDTO {
    id: string;
    errorMessages?: string[];
}

export interface DuplicationJobStartedOutDTO {
    jobId: string;
    totalCount: number;
}

export interface ExpeditionBulkDistributionCreateJobInDTO {
    expeditionIds: string[];
    distribution: SaveDistributionRequestInDTO;
}

export interface ExpeditionBulkDistributionJobStartedOutDTO {
    jobId: string;
    totalCount: number;
}

export interface MassActionInfoExpeditionInDTO {
    expIds: string[];
}

export interface LinkedEntityOutDTO {
    id: string;
    appId: string;
}

export interface MassActionExpeditionResponseOutDTO {
    allSNCoords: LinkedEntityOutDTO[];
}

export interface ResendResolvedEmailOutDTO {
    newResolvedEmailId: string;
}

export interface BatchResendResolvedEmailsInDTO {
    resolvedEmailIds: string[];
}

export interface BatchResendRejectedDTO {
    resolvedEmailId: string;
    reason: ReasonEnum;
}

export interface BatchResendResolvedEmailsOutDTO {
    correlationId: string;
    acceptedIds: string[];
    rejected: BatchResendRejectedDTO[];
}

export interface CreateTiebreakerInDTO {
    carrierCompanyIds: string[];
    utcEnd: string;
    timezoneId: string;
    message?: string;
}

export interface CreateTiebreakerOutDTO {
    tiebreakerId: string;
    utcEnd: string;
    timezoneId: string;
}

export interface DHLAvailableProductsRequestDTO {
    countryFrom: string;
    countryTo: string;
    postalCodeFrom: string;
    postalCodeTo: string;
    cityFrom: string;
    cityTo: string;
    streetFrom?: string;
    streetTo?: string;
    fromCompanyLocationId?: string;
    toCompanyLocationId?: string;
    fromDeliverySlot?: ValidationDeliverySlotInDTO;
    allPackages: DHLPackageDTO[];
}

export interface DHLPackageDTO {
    weight: number;
    length: number;
    width: number;
    height: number;
    amount: number;
}

export interface DHLAvailableProductDTO {
    productCode?: ProductCodeEnum;
    productName?: string;
    price?: PriceDTO;
    priceWithVat?: PriceDTO;
    estimatedDeliveryDate?: string;
    totalTransitDays?: number;
    pickupCapabilities?: DHLPickupCapabilitiesDTO;
}

export interface DHLPickupCapabilitiesDTO {
    pickupEarliest?: string;
    pickupLatest?: string;
    localCutoffDateAndTime?: string;
    pickupDayOfWeek?: number;
    nextBusinessDay?: boolean;
}

export interface Expeditions {
    expeditionIds: string[];
}

export interface CreateCustomsInvoicesRequestInDTO {
    invoiceNumber: string;
    invoiceNote?: string;
    price?: PriceRequest;
}

export interface DeleteCustomerNotificationRequest {
    notificationIds: string[];
}

export interface SecurityGroupOutDTO {
    id: string;
    name: string;
}

export interface SecurityRoleOutDTO {
    id: string;
    name: string;
    isPrivate: boolean;
    isOnlyInternal: boolean;
}

export interface UserCompanyUserDetailOutDTO {
    userId: string;
    firstname: string;
    surname: string;
    email: string;
    phone?: string;
    /**
     * @deprecated Legacy LogsteoUser.roles (dead-write); use securityRoles instead
     */
    roles: string[];
    securityRoles: SecurityRoleOutDTO[];
    securityGroups: SecurityGroupOutDTO[];
    isRegistered: boolean;
    isActive: boolean;
    isItMe: boolean;
    isVirtual: boolean;
    hasToken: boolean;
    isSso: boolean;
    departmentNames?: string[];
}

export interface CopyAttachmentToEntityRequest {
    entityId: string;
    entityType: EntityTypeEnum;
    attachmentIds: string[];
    copyAsInternal: boolean;
}

export interface ComputeReservationDurationCargoItemInDTO {
    quantity: number;
    cargoItemType: string;
}

export interface ComputeReservationDurationInDTO {
    items: ComputeReservationDurationCargoItemInDTO[];
}

export interface ComputeReservationDurationOutDTO {
    canEditDuration: boolean;
    computedDuration: number;
}

export interface CustomValueDateInDTO {
    customsLocalDate?: string;
    customsLocalDateTimezone?: string;
}

export interface CustomsAreaWrapper {
    customsArea?: CustomsAreaEnum;
}

export interface CustomsCustomsInDTO {
    customsArea?: CustomsAreaWrapper;
    internalNote?: CustomsInternalNoteWrapper;
    internalPDNumber?: CustomsInternalPDNumberWrapper;
    loadingNumber?: CustomsLoadingNumberWrapper;
    mrnNumber?: CustomsMrnNumberWrapper;
    customsStatus?: CustomsStatusWrapper;
    customsValue?: CustomsValueWrapper;
}

export interface CustomsInternalNoteWrapper {
    internalNote?: string;
}

export interface CustomsInternalPDNumberWrapper {
    internalPDNumber?: string;
}

export interface CustomsLoadingNumberWrapper {
    loadingNumber?: string;
}

export interface CustomsMrnNumberWrapper {
    mrnNumber?: string;
}

export interface CustomsStatusWrapper {
    customsStatus?: CustomsStatusEnum;
    date?: CustomValueDateInDTO;
}

export interface CustomsValueWrapper {
    customsValue?: CustomsValueEnum;
    price?: PriceRequest;
}

export interface CreateCompanyCodeListRequest {
    externalId: string;
    name?: string;
    description?: string;
    htmlContent?: string;
    codeType: CodeTypeEnum;
    notificationEmails: CompanyCodeListNotificationEmailsSetting[];
}

export interface CreateCompanyCodeListResponse {
    id: string;
}

export interface WSCameraGateOpeningRequest {
    externalCamId: string;
}

export interface WSCameraGateOpeningResponse {
    isWSNotified: boolean;
}

export interface CreateCalendarLayoutModelInDTO {
    name: string;
    description?: string;
    systemWide: boolean;
    ownerCompanyId?: string;
    payload: CalendarLayoutPayloadDTO;
}

export interface ArchiveCalendarLayoutModelsInDTO {
    modelIds: string[];
}

export interface ArchiveCalendarLayoutModelResultOutDTO {
    modelId: string;
    modelName: string;
    impact: CalendarLayoutImpactOutDTO;
}

export interface ArchiveCalendarLayoutModelsOutDTO {
    results: ArchiveCalendarLayoutModelResultOutDTO[];
}

export interface CalendarLayoutImpactOutDTO {
    assignmentCount: number;
    affected: CalendarLayoutImpactRowOutDTO[];
}

export interface CalendarLayoutImpactRowOutDTO {
    assignmentId: string;
    calendarLayoutScopeType: CalendarLayoutScopeTypeEnum;
    companyId?: string;
    companyName?: string;
    locationId?: string;
    locationName?: string;
    fallsBackToModelId?: string;
    fallsBackToModelName?: string;
}

export interface ApplyCalendarLayoutAssignmentsInDTO {
    modelId?: string;
    replaceExisting: boolean;
    targets: CalendarLayoutAssignmentTargetInDTO[];
}

export interface CalendarLayoutAssignmentTargetInDTO {
    calendarLayoutAction: CalendarLayoutActionEnum;
    companyId: string;
    locationId?: string;
    modelId?: string;
}

export interface ApplyCalendarLayoutAssignmentsOutDTO {
    results: CalendarLayoutAssignmentResultOutDTO[];
}

export interface CalendarLayoutAssignmentResultOutDTO {
    companyId: string;
    locationId?: string;
    calendarLayoutAction: CalendarLayoutActionEnum;
    calendarLayoutOutcome: CalendarLayoutOutcomeEnum;
    assignmentId?: string;
    reason?: string;
}

export interface CreateCustomerNotificatioMessage {
    subject: string;
    body: string;
    language: string;
}

export interface CreateCustomerNotificationRequest {
    companyModules: CompanyModulesEnum[];
    since: string;
    till: string;
    timezoneId?: string;
    messages: CreateCustomerNotificatioMessage[];
    attachmentIds?: string[];
}

export interface ValidateRuleInDTO {
    sourceText: string;
}

export interface ValidateRuleOutDTO {
    valid: boolean;
    name?: string;
    enabled?: boolean;
    priority?: number;
    ast?: RuleAst;
    formatted?: string;
    diagnostics: DiagnosticOutDTO[];
}

export interface FormatRuleInDTO {
    name: string;
    enabled: boolean;
    priority: number;
    ast: RuleAst;
}

export interface FormatRuleOutDTO {
    sourceText: string;
    diagnostics: DiagnosticOutDTO[];
}

export interface DryRunInDTO {
    sourceText?: string;
    ast?: RuleAst;
    entityRef: string;
}

export interface DryRunOutDTO {
    matched: boolean;
    entityId: string;
    explain?: any;
    plannedActions: PlannedActionOutDTO[];
    diagnostics: DiagnosticOutDTO[];
}

export interface PlannedActionOutDTO {
    action: string;
    params: any;
    wouldRefuse?: string;
    wouldRefuseParams: string[];
}

export interface WebhookTestRequestInDTO {
    entityId: string;
    webhookType: WebhookTypeEnum;
    webhookActionType?: WebhookActionTypeEnum;
    cameraId?: string;
}

export interface WebhookTestPreviewOutDTO {
    webhookType: string;
    webhookUrl?: string;
    implementationType?: string;
    payloadJson: string;
}

export interface CompanyDetailDuplicateCheckInDTO {
    crn?: string;
    tin?: string;
}

export interface CompanyDetailDuplicateCheckOutDTO {
    crnDuplicate: boolean;
    tinDuplicate: boolean;
}

export interface CreateCompanyNotificationSettingRequestInDTO {
    entityType: EntityTypeEnum;
    actionName?: string;
    notificationChannels: NotificationChannelsEnum[];
    notifyUserWithRole?: string;
    notifyUsers: string[];
}

export interface AdminDeleteCompanyResponseDTO {
    companyId: string;
    deletedUserCount: number;
    deletedAuth0UserCount: number;
}

export interface CameraGateOpeningRequest {
    carPlate: string;
    externalCamId: string;
}

export interface CameraGateOpeningResponse {
    allowedToProceed: boolean;
}

export interface MoveLogsteoUserToCompanyUserRequest {
    logsteoUserId: string;
    companyUserType: CompanyUserTypeEnum;
}

export interface AdminImportUserRequest {
    companyId: string;
    userEmail: string;
    firstName: string;
    lastName: string;
    userPhone: string;
    userDepartments?: string[];
    securityRolesNames: string[];
    securityGroupsName: string[];
}

export interface AdminImportUserResponse {
    userId?: string;
    userEmail: string;
    message?: string;
    retryable: boolean;
    error: boolean;
}

export interface AdminImportCompanyRequest {
    crn: string;
    companyName: string;
    city: string;
    zipCode: string;
    street: string;
    vat: string;
    country: string;
    adminFirstName: string;
    adminLastName: string;
    adminEmail: string;
    adminPhone: string;
    /**
     * @deprecated We move to defaultTimezoneId
     */
    timeZone: string;
    defaultTimezoneId?: string;
    populateSampleData: string;
    userOneFirstName?: string;
    userOneLastName?: string;
    userOneLastEmail?: string;
    userOnePhone?: string;
    userTwoFirstName?: string;
    userTwoLastName?: string;
    userTwoLastEmail?: string;
    userTwoPhone?: string;
    userThreeFirstName?: string;
    userThreeLastName?: string;
    userThreeLastEmail?: string;
    userThreePhone?: string;
    userFourFirstName?: string;
    userFourLastName?: string;
    userFourLastEmail?: string;
    userFourPhone?: string;
    userFiveFirstName?: string;
    userFiveLastName?: string;
    userFiveLastEmail?: string;
    userFivePhone?: string;
}

export interface AdminImportCompanyResponse {
    companyCrn: string;
    message: string;
    error: boolean;
}

export interface AdminImportCompanyLocationRequest {
    companyId: string;
    locationName: string;
    country: string;
    zipCode: string;
    city: string;
    street: string;
    concurrentReservation: number;
    includeInternal: boolean;
    contactOneName?: string;
    contactOnePhone?: string;
    contactOneEmail?: string;
    contactTwoName?: string;
    contactTwoPhone?: string;
    contactTwoEmail?: string;
    contactThreeName?: string;
    contactThreePhone?: string;
    contactThreeEmail?: string;
    contactFourName?: string;
    contactFourPhone?: string;
    contactFourEmail?: string;
    contactFiveName?: string;
    contactFivePhone?: string;
    contactFiveEmail?: string;
    visibility: string;
    visibilityCompanies?: string;
    monday?: string;
    tuesday?: string;
    wednesday?: string;
    thursday?: string;
    friday?: string;
    saturday?: string;
    sunday?: string;
    isPartnerLocation?: boolean;
    externalId?: string;
    timezoneId?: string;
}

export interface AdminImportCompanyLocationResponse {
    locationName: string;
    companyId: string;
    message: string;
    error: boolean;
}

export interface AdminHTTPRequestSettingsUpdateRequest {
    enabled: boolean;
    ignoredUrls: string[];
    disabledHttpStatuses: number[];
}

export interface AdminCreateUserInAuth0InDTO {
    userId: string;
}

export interface CompanyPreview {
    companyId: string;
    companyName: string;
}

export interface CreateOrUpdateAdditionalTermInDTO {
    id?: string;
    name: string;
    isOnSinglePage: boolean;
    isMandatory: boolean;
    isForAllCompanies: boolean;
    termText: string;
    companies?: CompanyPreview[];
}

export interface ExpeditionCarrierNoteOutDTO {
    carrierNote?: string;
}

export interface AiCarrierAutoSelectionInDTO {
    loadingLocationId?: string;
    unloadingLocationId?: string;
    loadingCity?: string;
    loadingCountry?: string;
    unloadingCity?: string;
    unloadingCountry?: string;
    weight?: number;
    countPallets?: number;
    distance?: number;
    cargoAmount?: number;
    q?: string;
}

export interface CargoType {
    cargoTypeCode?: CargoTypeCodeEnum;
    adrWeight?: number;
}

export interface MergeInfoInDTO {
    mergedExpeditionIds: string[];
    mergedSupplierNotificationIds: string[];
    archiveReservations: boolean;
    sendCancelEmails: boolean;
    archiveSupplierNotifications: boolean;
}

export interface PolandSentRequest {
    sentNumber?: string;
    sentCarrierUpdateKey?: string;
}

export interface SaveExpeditionLocationRequestInDTO {
    companyLocationId?: string;
    address?: AddressRequest;
    loadingReference?: string;
    orders?: GlobalOrdersRequest[];
    unloadingOrderIds?: string[];
    selectedPerson?: SaveExpeditionContanctPersonRequest;
    notifySelectedPerson: boolean;
    additionalContacts?: SaveExpeditionContanctPersonRequest[];
    timeslots: GlobalTimeslots;
    timezoneId?: string;
    requirements?: string[];
    locationNote?: string;
}

export interface SaveExpeditionRequestInDTO {
    applicationId?: string;
    name?: string;
    expeditionType?: ExpeditionTypeEnum;
    truckTypeCode?: string;
    locations: SaveExpeditionLocationRequestInDTO[];
    carrierNote?: string;
    loadingTypes?: string[];
    cargoType?: CargoType;
    requirements?: string[];
    duplicatedFromExpeditionId?: string;
    prefilledFromExpeditionId?: string;
    templateFromId?: string;
    fromSupplierNotificationId?: string;
    responsiblePersonId?: string;
    notifiedPersonIds?: string[];
    notifiedTargets?: NotifyTargetInnerInDTO[];
    distribution?: SaveDistributionRequestInDTO;
    internalNote?: string;
    disponentPersonId?: string;
    invoiceState?: InvoiceStateEnum;
    pairingSymbol?: string;
    rebilling?: RebillingRequestInDTO;
    notifyByRole?: string;
    /**
     * @deprecated RD-2977: use folderIds
     */
    folderId?: string;
    folderIds?: string[];
    labelIds?: string[];
    copySNAttachments?: boolean;
    linkToSN?: boolean;
    copyAttachments?: boolean;
    attachments: AttachmentIdWithTypeV2InDTO[];
    transportationType?: TransportationTypeEnum;
    externalId?: string;
    externalApplicationId?: string;
    incoterms?: UpdateExpeditionIncotermsRequest;
    customsDeclarationCompanyIds?: string[];
    internalInfoAccountCodeListId?: string;
    internalInfoCostCenterCodeListId?: string;
    internalInfoCostUnitCodeListId?: string;
    internalInfoProjectCodeListId?: string;
    defaultLadenFactor?: number;
    defaultResponsiblePersonId?: string;
    polandSent?: PolandSentRequest;
    huEkaerNumber?: string;
    roUitNumber?: string;
    utnCode?: string;
    mergeInfo?: MergeInfoInDTO;
}

export interface SaveExpeditionResponseOutDTO {
    applicationId: string;
    expeditionId: string;
}

export interface FreeSlotsWrapperOutDTO {
    day: string;
    freeSlots: RampFreeSlotsInnerOutDTO[];
}

export interface RampFreeSlotsInnerOutDTO {
    calendarId: string;
    rampId: string;
    name: string;
    calendarName: string;
    slots: TimeslotCalendarDTO[];
    unavailability?: ReservationUnavailabilityOutDTO;
}

export interface ReservationUnavailabilityOutDTO {
    unavailabilityReason: UnavailabilityReasonEnum;
    messageKey: string;
    params: string[];
}

export interface TimeslotOnTimeCheckRequestDTO {
    phoneNumber: string;
    reservationId: string;
}

export interface TimeslotGoToRampRequestDTO {
    phoneNumber: string;
    reservationId: string;
}

export interface SendMessagesInV3DTO {
    message: string;
}

export interface EmailDetailV3DTO {
    subject: string;
    from: string;
    to: string;
    wholeEmail: string;
    wholeEmailHtml?: string;
}

export interface ListMessagesOutV3DTO {
    messages: MessageOutV3DTO[];
    conversationName: string;
}

export interface MessageOutV3DTO {
    id: string;
    message: string;
    initials: string;
    fullName: string;
    companyName: string;
    created: string;
    isOtherSide: boolean;
    isMine: boolean;
    isEmail: boolean;
    isRead: boolean;
    emailDetail?: EmailDetailV3DTO;
}

export interface SendMessagesMultipleV3DTO {
    message: string;
    couterPartyIds: string[];
}

export interface GenericAttachmentV2InDTO {
    entityType: EntityTypeEnum;
    entityIds: string[];
    attachments: AttachmentIdWithTypeV2InDTO[];
}

export interface CatalogCarrierAddOutDTO {
    carrierId: string;
    isAdded: boolean;
}

export interface DeliveryTermsCarriersRequestDTO {
    carriersIds: string[];
}

export interface RejectMessageInDTO {
    message?: string;
}

export interface AcceptQuoteByCustomerRequestDTO {
    isReconfirmedNeeded?: boolean;
    acceptedManipulationUnits?: number;
    price?: PriceRequest;
    reconfirmedNeeded?: boolean;
}

export interface DistributionInDTO {
    distributionType: DistributionTypeEnum;
    price?: number;
    currency?: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: string;
    utcEnd?: string;
    timezoneId?: string;
    selectedItems: CarrierGroupInDTO[];
    ladenFactor?: number;
    allowPartialDelivery: boolean;
    currencyLockType: CurrencyLockTypeEnum;
    dachserProductType?: DachserProductTypeEnum;
    dachserDeliveryTerm?: DachserDeliveryTermEnum;
    schenkerProductType?: SchenkerProductTypeEnum;
    schenkerAddonsType?: SchenkerAddonsTypeEnum[];
    dhlProductType?: DhlProductTypeEnum;
    dhlPickupReadyTime?: string;
    dhlPickupCloseTime?: string;
    dhlCourierRequested?: boolean;
    dhlPayerAccountNumber?: string;
    dhlDutiesTaxesAccountNumber?: string;
    fedexProductType?: string;
    fedexPickupReadyTime?: string;
    fedexPickupCloseTime?: string;
    fedexCourierRequested?: boolean;
    fedexPayerType?: string;
    fedexPayerAccountNumber?: string;
    fedexPayerCountry?: string;
    fedexDeclaredValue?: number;
    fedexDeclaredValueCurrency?: string;
    fedexSignatureOption?: string;
    fedexPackagingType?: string;
    fedexBookingConfirmationNumber?: string;
    fedexAccountId?: string;
}

export interface AddMoreCarrierInDTO {
    carriers: CarrierGroupInDTO[];
    dachserProductType?: DachserProductTypeEnum;
    dachserDeliveryTerm?: DachserDeliveryTermEnum;
    schenkerProductType?: SchenkerProductTypeEnum;
    schenkerAddonsType?: SchenkerAddonsTypeEnum[];
}

export interface CancelExpeditionInDTO {
    reasonCode: string;
    deleteReservations: boolean;
    archiveReservations: boolean;
}

export interface LocationOrderTemplate11DTO {
    name: string;
    id?: number;
    unloadingLocationId: number;
    loadingLocationId: number;
    items: CargoTemplateInDTO[];
}

export interface LocationTemplateInDTO {
    id: number;
    name: string;
    country: string;
    postalCode: string;
    city: string;
    streetNr: string;
    timezoneId: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    pickupCode?: string;
    loadedOrders?: LocationOrderTemplate11DTO[];
    fromAddressBookId?: string;
    openingHourDefinitions: OpeningHourDefinitionsInDTO;
}

export interface TemplateExpeditionInputInDTO {
    name: string;
    expeditionType?: ExpeditionTypeEnum;
    truckType?: string;
    loadingTypes: string[];
    cargoType?: string;
    requirements?: string[];
    locations: LocationTemplateInDTO[];
    note?: string;
    distributionTemplate?: DistributionTemplateInDTO;
    responsiblePersonId?: string;
    internalCustomerNote?: string;
    subscribers: string[];
}

export interface ExpeditionCarrierNoteInDTO {
    carrierNote: string;
}

export interface CarrierContactPersonDTO {
    contactPerson?: string;
    contactPhone?: string;
    contactEmail: string;
}

export interface CarrierCreateInDTO {
    name: string;
    crn: string;
    tin?: string;
    streetNr?: string;
    country: string;
    zipCode?: string;
    city?: string;
    timezoneId: string;
    version?: number;
    contacts: CarrierContactPersonDTO[];
}

export interface CreatedIdEntityOutDTO {
    id: string;
    isCreatedNew: boolean;
}

export interface AddCarrierUserInDTO {
    firstname: string;
    surname: string;
    email: string;
    phone?: string;
}

export interface CarrierGroupNameInDTO {
    carrierGroupName: string;
}

export interface UserCompanyWebAccessEmailInDTO {
    email: string;
}

export interface MakeOfferInDTO {
    price: number;
    currency: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: string;
    timeslots: MakeOfferLocationSlotInDTO[];
    units?: number;
    note?: string;
    transportLegs?: MakeOfferTransportLegInDTO[];
    utcEnd?: string;
    timezoneId?: string;
}

export interface MakeOfferLocationSlotInDTO {
    locationId: string;
    useCustomerSlot: boolean;
    differentTimeslots: TimeslotMakeQuoteInDTO[];
}

export interface MakeOfferTransportLegInDTO {
    transportationType: TransportationTypeEnum;
    route?: string;
    fromDate?: string;
    toDate?: string;
    position: number;
    note?: string;
    flightNumber?: string;
    flightType?: string;
    voyageNumber?: string;
    shipType?: string;
    shipCompanyId?: string;
    trainNumber?: string;
    trainType?: string;
    vehicleType?: string;
}

export interface TimeslotMakeQuoteInDTO {
    /**
     * @deprecated Use utcStart instead
     */
    timeslotSince: string;
    /**
     * @deprecated Use utcEnd instead
     */
    timeslotTill: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface ShipmentProgressFormDataInDTO {
    locationTimeslotIds: LocationTimeslotFormInDTO[];
    carPlate?: string;
    driverId?: string;
    dispatcherId?: string;
}

export interface FinishLocationActionInnerInDTO {
    isFinished: boolean;
    /**
     * @deprecated Use finishedAtUtc and timezoneId instead
     */
    finishedAt?: string;
    finishedAtUtc?: string;
}

export interface FinishLocationActionWrapperInDTO {
    noActionFinishedAt?: FinishLocationActionInnerInDTO;
    loadingLocationFinished?: FinishLocationActionInnerInDTO;
    unloadingLocationFinished?: FinishLocationActionInnerInDTO;
}

export interface FixedPriceAcceptOfferInDTO {
    note?: string;
    transportLegs?: MakeOfferTransportLegInDTO[];
}

export interface FirstCompanyRegistrationInDTO {
    companyName: string;
    city: string;
    zipCode: string;
    streetNr: string;
    adminFirstName: string;
    adminLastName: string;
    adminEmail: string;
    crn: string;
    vat: string;
    country: string;
    phone?: string;
    logo?: FileV2InDTO;
    /**
     * @deprecated We move to defaultTimezoneId
     */
    timeZone: string;
    defaultTimezoneId?: string;
}

export interface CreateFirstCompanyResponse {
    createdCompanyId: string;
}

export interface DashboardRebuildTriggerDTO {
    started: boolean;
    message: string;
}

export interface SupplierNotificationInDTO {
    companyId: string;
    supplierId: string;
    attachments: AttachmentIdWithTypeV2InDTO[];
    notifyData?: NotificationEntityInDTO;
    transportationType: TransportationTypeEnum;
    cargoType: CargoTypeInDTO;
    containerInfo?: ContainerInfoInDTO;
    customsTypeCode?: string;
    referralCode?: string;
    /**
     * @deprecated dual-written from the active CMR/BL/AWB number
     */
    shipmentId?: string;
    cmrNumber?: string;
    blNumber?: string;
    awbNumber?: string;
    orders: GlobalOrdersRequest[];
    specialRequirementIds: string[];
    supplierLocationId: string;
    customerLocationId: string;
    shipmentStateCode?: ShipmentStateCodeEnum;
    internalInvoiceNumber?: string;
    invoiceDueDate?: string;
    deliveryConditionsIncotermCode?: string;
    fromShipmentId?: string;
    internalNote?: string;
    note?: string;
    loadingGlobalTimeslots: GlobalTimeslots;
    unloadingGlobalTimeslots: GlobalTimeslots;
    counterPartyNotifyPersonsIds?: string[];
    labelIds?: string[];
    folderIds?: string[];
}

export interface ShipmentAddressInDTO {
    locationName: string;
    streetNr: string;
    zipCode: string;
    city: string;
    country: string;
    locationId?: string;
    timezoneId?: string;
}

export interface ShipmentInDTO {
    companyId: string;
    supplierId: string;
    attachments: AttachmentIdWithTypeV2InDTO[];
    notifyData?: NotificationEntityInDTO;
    transportationType: TransportationTypeEnum;
    cargoType: CargoTypeInDTO;
    containerInfo?: ContainerInfoInDTO;
    customsTypeCode: string;
    referralCode?: string;
    shipmentId?: string;
    orders: ShipmentOrderInDTO[];
    loadingAddress: ShipmentAddressInDTO;
    unloadingAddress: ShipmentAddressInDTO;
    /**
     * @deprecated Use departureAtUtc instead
     */
    departureAt: string;
    /**
     * @deprecated Use arrivalAtUtc instead
     */
    arrivalAt: string;
    departureAtUtc?: string;
    arrivalAtUtc?: string;
}

export interface SendExternalQuoteResponseDTO {
    success: boolean;
    message: string;
    expeditionId?: string;
    sequenceNumber: number;
}

export interface GroupDemandInDTO {
    groupDemandName: string;
    supplierNotificationIds: string[];
}

export interface GroupDemandsDistributionInDTO {
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: string;
    selectedItems: CarrierGroupInDTO[];
    utcEnd?: string;
    timezoneId?: string;
}

export interface ExpeditionCreateFromGDPerSN {
    quotes: ExpeditionCreateInnerSNWithQuote[];
}

export interface ExpeditionCreateInnerSNWithQuote {
    snId: string;
    quoteSnId: string;
    appliedAdditionalTermsIds: string[];
}

export interface ExpeditionTimeslotReminderOutDTO {
    emailCount: number;
}

export interface LinkTokenToUserOutDTO {
    token: string;
    isLinked: boolean;
}

export interface ChangeVisibilityInDTO {
    accessType: AccessTypeEnum;
}

export interface PowerBiReportInDTO {
    reportId: string;
}

export interface PowerBiTokenDetailOutDTO {
    reportName: string;
    pageView?: string;
    datasetId: string;
    accessToken: string;
    customerGUID: string;
    width: string;
    height: string;
    reportId: string;
    embedUrl: string;
    groupId: string;
    sectionId?: string;
}

export interface InternalCommentInDTO {
    entityType: EntityTypeEnum;
    entityId: string;
    content: string;
}

export interface ExtraCostsInDTO {
    typeEnum: string;
    description: string;
    price: number;
    currency: string;
    internal: boolean;
}

export interface DirectAssigmentDataInDTO {
    carrierId: string;
    price: number;
    currency: string;
    informCarrier: boolean;
    userIds?: string[];
}

export interface ExpeditionToPublishInDTO {
    expeditionsToPublish: string[];
}

export interface AdditionalInfoCarrierInnerRequestInDTO {
    text: string;
    from?: string;
    to?: string;
}

export interface AdditionalInfoCarrierRequestInDTO {
    infos: AdditionalInfoCarrierInnerRequestInDTO[];
}

export interface CSVInDTO {
    data: string;
}

export interface CompanySettingsInDTO {
    identifier: string;
    payload: string;
    inheritToPartners: boolean;
}

export interface CompanySettingsOutDTO {
    identifier: string;
    payload?: any;
    inheritToPartners?: boolean;
}

export interface Icon {
    name: string;
    color: string;
}

export interface ReservationCoordinates {
    id: string;
    applicationId: string;
    state?: State;
}

export interface State {
    name: string;
    icon?: Icon;
    transitions: Transition[];
    additionalField?: WorkflowTransitionAdditionalFieldOutDTO;
    orderIndex?: number;
}

export interface Transition {
    to: string;
    actionName: string;
}

export interface WorkflowTransitionAdditionalFieldOutDTO {
    additionalFieldName: string;
    additionalFieldType: AdditionalFieldTypeEnum;
    additionalFieldValue?: string[];
    additionalFieldAvailableValues?: string[];
}

export interface RequestParamsForMultipleLocationReservationInDTO {
    locationIds: string[];
    dayToShow: string;
    rampIds?: string[];
}

export interface LovCompanyCodeListDTO {
    id: string;
    externalId: string;
    name?: string;
}

export interface OrderReservationOutDTO {
    orderId?: string;
    orderNote?: string;
    orderType?: string;
    reservationName?: string;
    items?: ReservationCargoItemOutDTO[];
}

export interface ReservationCalendarGroupedOutDTO {
    rampId: string;
    isShowOnRampDashboard: boolean;
    calendarId: string;
    name: string;
    /**
     * @deprecated This seems to be set null all the time, remove it later
     */
    openHour?: string;
    /**
     * @deprecated This seems to be set null all the time, remove it later
     */
    closedHour?: string;
    reservations: ReservationsDataOutDTO[];
}

export interface ReservationCargoItemOutDTO {
    width?: number;
    height?: number;
    length?: number;
    weight?: number;
    amount?: number;
    quantityUnit?: string;
    stackable?: boolean;
    weightMode?: WeightModeEnum;
    cargoItemTypeCode?: string;
    cargoName?: string;
    itemNote?: string;
}

export interface ReservationDriverInfoOutDTO {
    driverId?: string;
    driverName?: string;
    driverPhone?: string;
}

export interface ReservationLinkedSupplierNotificationOutDTO {
    supplierNotificationId: string;
    applicationId?: string;
    supplierCompanyId?: string;
    supplierCompanyName?: string;
}

export interface ReservationsDataOutDTO {
    reservationId: string;
    reservationApplicationId: string;
    version: number;
    customerId: string;
    customerName: string;
    carrierId?: string;
    carrierName?: string;
    locationId: string;
    locationName: string;
    calendarId?: string;
    rampId?: string;
    timezoneId?: string;
    timeslot?: TimeslotCalendarDTO;
    carPlate?: string;
    driverInfo?: ReservationDriverInfoOutDTO;
    order?: OrderReservationOutDTO;
    orders: GlobalOrderResponse[];
    labels: LabelPreview[];
    createdAt: string;
    createdByFullName: string;
    updatedByFullName: string;
    updatedAt: string;
    state?: State;
    isPinnedOnLocRampTable: boolean;
    reservationName?: string;
    reservationActionTypes?: ReservationActionTypesEnum[];
    flags: ReservationFlagDTO[];
    onBehalfOf?: LovCompanyCodeListDTO;
    anonymous: boolean;
    linkedToExpCoords?: ExpeditionCoordinate;
    linkedSupplierNotification?: ReservationLinkedSupplierNotificationOutDTO;
}

export interface CreateCompanyLocationOutDTO {
    locationId: string;
}

export interface CreateLocationContactOutDTO {
    contactId: string;
}

export interface CompanyLocationMassActionChangeACLInDTO {
    locationIds: string[];
    visibility: VisibilityEnum;
    visibleToCompanies: LovDTO[];
}

export interface CompanyLocationExceptionInDTO {
    /**
     * @deprecated Use localDates instead
     */
    dates: string[];
    exceptionName: string;
    openHourExceptionType: OpenHourExceptionTypeEnum;
    locationSelectMode: LocationSelectModeEnum;
    locationsAndRamps?: LocationAndRampsCompanyLocExceptionInDTO[];
    openingHours?: ExceptionTimeIntervalInDTO[];
    /**
     * @deprecated Use localDates instead
     */
    timeZone?: string;
    isOnlyForExternalPartners: boolean;
    localDates?: string[];
}

export interface ExceptionTimeIntervalInDTO {
    since: string;
    till: string;
}

export interface LocationAndRampsCompanyLocExceptionInDTO {
    locationId: string;
    enabled: boolean;
    ramps: string[];
}

export interface CreateNewLabelInDTO {
    entityType: EntityTypeEnum;
    labelValue: string;
    labelColor: string;
}

export interface CreateCompanyUserDriverRequest {
    logsteoUserId?: string;
    driverName?: string;
}

export interface CreateCompanyUserDriverResponse {
    companyUserId: string;
}

export interface InheritedModulesWrapper {
    modules: ModulesEnum[];
}

export interface CarrierCreateGDSNInDTO {
    snId: string;
    isNotInterested: boolean;
    price?: Price;
}

export interface CarrierCreateQuoteGroupDemandInDTO {
    supplierNotificationQuotes: CarrierCreateGDSNInDTO[];
    isDifferentPriceForAll: boolean;
    differentPrice?: Price;
}

export interface Price {
    id?: string;
    version?: number;
    price?: number;
    currency?: string;
    companyComputedPrice?: number;
    companyComputedCurrency?: string;
    dateOfValidity?: string;
    conversionRateDate?: string;
    rate?: number;
}

export interface AttachmentsUploadInDTO {
    fileInDTOs: FileV2InDTO[];
}

export interface AttachmentsUploadedOutDTO {
    attachmentId: string;
    fileName: string;
    size: number;
    contentType: string;
    userId: string;
    userName: string;
    companyId: string;
    uploadedAt: string;
    companyName: string;
    accessType?: AccessTypeEnum;
    accessTypeName?: string;
    documentType?: DocumentTypeEnum;
    documentTypeName?: string;
    canBeDeleted: boolean;
    userNote?: string;
    userDate?: string;
}

export interface AttachmentsZipDownloadInDTO {
    attachmentIds: string[];
}

export interface CreateShippingCompanyRequestInDTO {
    name: string;
    position: number;
}

export interface CreateShippingCompanyResponseOutDTO {
    id: string;
    name: string;
    position: number;
}

export interface AdminCatalogCreatingInDTO {
    carrierId?: string;
    frontendId?: string;
    name: string;
    crn: string;
    tin?: string;
    streetNr?: string;
    country: string;
    zipCode?: string;
    city?: string;
    wwwPage?: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail: string;
    exportCountries: string[];
    exportNote?: string;
    importCountries: string[];
    importNote?: string;
    cars: AdminTruckCarCountInDTO[];
    countryRegionId?: string;
    version?: number;
}

export interface AdminTruckCarCountInDTO {
    code: string;
    count: number;
}

export interface AdminCatalogCreatedOutDTO {
    id: string;
    frontendId?: string;
    isCreatedNew: boolean;
}

export interface AdditionalDataDistributionOutDTO {
    dachserProductType?: DachserProductTypeEnum;
    dachserDeliveryTerm?: DachserDeliveryTermEnum;
    schenkerProductType?: SchenkerProductTypeEnum;
    schenkerAddonsType?: SchenkerAddonsTypeEnum[];
    dhlProductType?: DhlProductTypeEnum;
    dhlPickupReadyTime?: string;
    dhlPickupCloseTime?: string;
    dhlCourierRequested?: boolean;
    dhlPayerAccountNumber?: string;
    dhlDutiesTaxesAccountNumber?: string;
    fedexProductType?: string;
    fedexPickupReadyTime?: string;
    fedexPickupCloseTime?: string;
    fedexCourierRequested?: boolean;
    fedexPayerType?: string;
    fedexPayerAccountNumber?: string;
    fedexPayerCountry?: string;
    fedexDeclaredValue?: number;
    fedexDeclaredValueCurrency?: string;
    fedexSignatureOption?: string;
    fedexPackagingType?: string;
    fedexBookingConfirmationNumber?: string;
    fedexAccountId?: string;
    fedexAccountNumber?: string;
}

export interface BasicContactPerson {
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
}

export interface CarrierContactDetailOutDTO {
    fullName?: string;
    phone?: string;
    email?: string;
    externalIdsInfo: GetDetailCompanyLinkedExternalIdsInfoOutDTO[];
}

export interface CarrierOrGroupOutDTO {
    id: string;
    name: string;
    carrierOrGroup: CarrierOrGroupEnum;
    selectedItemType: SelectedItemTypeEnum;
    apiType?: ApiTypeEnum;
    userId?: string;
}

export interface CompanyWithNameDTO {
    companyId: string;
    companyName: string;
}

export interface DetailExpeditionFolderResponseOutDTO {
    folderId: string;
    folderName: string;
}

export interface DistributionWithQuotesV4Response {
    distributionId: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: TimeResponse;
    remainingTimeInHours: number;
    price?: number;
    priceDTO?: PriceDTO;
    currency?: string;
    createdByName: string;
    createdByEmail: string;
    createdAt: string;
    distributionType: DistributionTypeEnum;
    currencyLockType: CurrencyLockTypeEnum;
    selectedItems: CarrierOrGroupOutDTO[];
    additionalData?: AdditionalDataDistributionOutDTO;
    isActive: boolean;
    ladenFactor?: number;
    utcEnd?: string;
    timezoneId?: string;
    quotesCount: number;
    isAssignFixedDistribution: boolean;
    tiebreakers: TiebreakerInfoOutDTO[];
}

export interface ExpeditionDetailV4OutDTO {
    id: string;
    applicationId?: string;
    customerId: string;
    expeditionStatus: ExpeditionStatusEnum;
    cargoTypeCode?: string;
    expeditionType?: ExpeditionTypeEnum;
    distance?: number;
    locations: LocationPreviewV4OutDTO[];
    requirementCodes: string[];
    loadingTypes: string[];
    truckType?: TruckTypeV4OutDTO;
    distributionType?: DistributionTypeEnum;
    customerName: string;
    isDistributionCreated: boolean;
    isCarrierAssigned: boolean;
    assignedCarrierName?: string;
    sumPrice?: SumPriceExpeditionPreviewOutDTO;
    expeditionCurrency?: string;
    isPublished: boolean;
    labels: LabelPreview[];
    cancellationReasonCode?: string;
    carrierDispatcherEmail?: string;
    carrierDispatcherName?: string;
    assignedCarrierId?: string;
    carPlate?: string;
    assignedDriver?: string;
    isArchived: boolean;
    supplierNotificationLink?: SupplierNotificationPreviewOutDTO;
    handlingUnitCount?: number;
    systemLabels?: SystemLabel[];
    adrWeight?: number;
    distributions: DistributionWithQuotesV4Response[];
    extraCosts: ExtraCostsPreviewOutDTO[];
    routes: ExpeditionRouteV4Response[];
    carrierNote?: string;
    isReservationOrderLinkedToExpOrder: boolean;
    internalInfo?: ExpeditionInternalInfo;
    customsLoadingNumber?: string;
    ladenFactor?: number;
    defaultLadenFactor?: number;
    allowPartialDelivery: boolean;
    ladenFactorExpeditions?: LadenFactorExpeditionOutDTO[];
    ladenFactorParentExpedition?: LadenFactorParentExpeditionOutDTO;
    mergedToExpedition?: MergedExpeditionPreviewOutDTO;
    mergedExpeditions?: MergedExpeditionPreviewOutDTO[];
    mergedSupplierNotifications: SupplierNotificationPreviewOutDTO[];
    name?: string;
    isFavorite: boolean;
    transportationType?: TransportationTypeEnum;
    incoterms?: IncotermsResponseOutDTO;
    aiChatClassification?: AiChatClassificationOutDTO;
    polandSent?: PolandSentOutDTO;
    huEkaerNumber?: string;
    roUitNumber?: string;
    utnCode?: string;
    trackingNumber?: string;
    createdAt: string;
    createdByEmail?: string;
    totalVolume?: number;
    volumeOfOrderEnabled: boolean;
    aiDispatcherFirstChangeAt?: string;
    aiDispatcherLastChangeAt?: string;
}

export interface ExpeditionInternalInfo {
    responsiblePerson?: PersonDetail;
    notifiedPerson?: PersonDetail[];
    internalNote?: string;
    disponentPerson?: PersonDetail;
    invoiceState?: InvoiceStateEnum;
    pairingSymbol?: string;
    rebilling?: RebillingResponseOutDTO;
    notifyByRole?: boolean;
    folders: DetailExpeditionFolderResponseOutDTO[];
    customsDeclarationCompanies?: LovDTO[];
    internalInfoAccount?: LovCompanyCodeListDTO;
    internalInfoCostCenter?: LovCompanyCodeListDTO;
    internalInfoCostUnit?: LovCompanyCodeListDTO;
    internalInfoProject?: LovCompanyCodeListDTO;
    codeListNotificationEmails: string[];
}

export interface ExpeditionRouteV4Response {
    expeditionId: string;
    expeditionLocationId: string;
    routeName: string;
    companyName?: string;
    addressLine: string;
    actionType: ActionTypeEnum[];
    selectedSlot?: TimeSlotResponse;
    actionSlot?: TimeResponse;
    isLate: boolean;
    companyLocationId?: string;
    companyLocationCustomerId?: string;
    linkedReservation?: ReservationCoordinates;
    linkedToExpOrderActive: boolean;
    isPartnerLocation: boolean;
}

export interface ExtraCostsPreviewOutDTO {
    id: string;
    createdAt: string;
    type: string;
    description: string;
    price: number;
    currency: string;
    internal?: boolean;
    priceDTO: PriceDTO;
}

export interface GetDetailCompanyLinkedExternalIdsInfoOutDTO {
    externalIds: string;
    externalIdType: ExternalIdTypeEnum;
}

export interface IncotermsResponseOutDTO {
    incotermsValue?: IncotermsValueEnum;
    incotermsDescription?: string;
}

export interface LadenFactorExpeditionOutDTO {
    carrierId: string;
    carrierName?: string;
    expeditionId: string;
    expeditionApplicationId?: string;
    price?: number;
    manipulationUnits?: number;
    currency?: string;
    priceDTO?: PriceDTO;
    distance?: number;
    expeditionStatus: ExpeditionStatusEnum;
    carrierContactDetails: CarrierContactDetailOutDTO;
}

export interface LadenFactorParentExpeditionOutDTO {
    expeditionId: string;
    expeditionApplicationId?: string;
}

export interface LocationPreviewV4OutDTO {
    id: string;
    name: string;
    companyName?: string;
    city: string;
    postalCode: string;
    country: string;
    streetNr: string;
    deliverySlot: GlobalTimeslots;
    selectedPerson?: BasicContactPerson;
    additionalContacts?: BasicContactPerson[];
    loadingReference?: string;
    loadedOrders: GlobalOrderResponse[];
    unloadedOrders: GlobalOrderResponse[];
    companyLocationId?: string;
    isExternal: boolean;
    notifySelectedPerson: boolean;
    isPartnerLocation: boolean;
    requirementCodes: string[];
    timezoneId?: string;
    linkedReservation?: ReservationCoordinates;
    locationNote?: string;
}

export interface MergedExpeditionPreviewOutDTO {
    expeditionId: string;
    expeditionApplicationId?: string;
}

export interface PersonDetail {
    userId: string;
    userFullName: string;
    companyId: string;
    phoneNumber?: string;
}

export interface PolandSentOutDTO {
    sentNumber?: string;
    sentCarrierUpdateKey?: string;
}

export interface RebillingResponseOutDTO {
    invoiceRebillingType: InvoiceRebillingTypeEnum;
    invoiceDepartment?: string;
    invoicePartner?: CompanyWithNameDTO;
}

export interface SumPriceExpeditionPreviewOutDTO {
    agreedPrice: number;
    agreedPriceCurrency: string;
    agreedPriceOutDTO: PriceDTO;
    extraCostSumPrice: number;
    extraCostSumPriceInternal?: number;
    extraCostsInternalPriceDTO?: PriceDTO;
    extraCostSumCurrency?: string;
    extraCostsPriceDTO: PriceDTO;
    finalPrice: number;
    finalPriceCurrency: string;
    finalPriceDTO: PriceDTO;
}

export interface SupplierNotificationPreviewOutDTO {
    supplierNotificationId: string;
    supplierNotificationApplicationId: string;
    supplierName?: string;
}

export interface SystemLabel {
    name: string;
    additionalInfo?: string;
}

export interface TiebreakerInfoOutDTO {
    tiebreakerId: string;
    utcEnd: string;
    timezoneId: string;
    message?: string;
    carrierCompanyIds: string[];
}

export interface TimeResponse {
    /**
     * @deprecated Use actionAtUtc and timezoneId instead
     */
    localDate: string;
    /**
     * @deprecated Use actionAtUtc and timezoneId instead
     */
    hourString: string;
    /**
     * @deprecated Use timezoneId instead
     */
    timeZone: string;
    actionAtUtc?: string;
    timezoneId?: string;
}

export interface TimeSlotResponse {
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    localDate: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceHourString: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    tillHourString: string;
    /**
     * @deprecated Use timezoneId instead
     */
    timeZone: string;
    durationInMin: number;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface TruckTypeV4OutDTO {
    code: string;
    loadingCapacity: number;
}

export interface MultipleDistributionWithQuotesV4Response {
    distributionId: string;
    price?: number;
    priceDTO?: PriceDTO;
    currency?: string;
    createdByName: string;
    createdByEmail: string;
    createdAt: string;
    distributionType: DistributionTypeEnum;
    currencyLockType: CurrencyLockTypeEnum;
    selectedItems: CarrierOrGroupOutDTO[];
    additionalData?: AdditionalDataDistributionOutDTO;
    isActive: boolean;
    ladenFactor?: number;
    utcEnd?: string;
    timezoneId?: string;
    quotesCount: number;
    isAssignFixedDistribution: boolean;
}

export interface MultipleExpeditionDetailV4OutDTO {
    id: string;
    applicationId?: string;
    customerId: string;
    expeditionStatus: ExpeditionStatusEnum;
    cargoTypeCode?: string;
    expeditionType?: ExpeditionTypeEnum;
    locations: LocationPreviewV4OutDTO[];
    requirementCodes: string[];
    loadingTypes: string[];
    truckType?: TruckTypeV4OutDTO;
    distributionType?: DistributionTypeEnum;
    isDistributionCreated: boolean;
    isCarrierAssigned: boolean;
    expeditionCurrency?: string;
    isPublished: boolean;
    labels: LabelPreview[];
    cancellationReasonCode?: string;
    assignedCarrierId?: string;
    carPlate?: string;
    isArchived: boolean;
    supplierNotificationLink?: SupplierNotificationPreviewOutDTO;
    systemLabels?: SystemLabel[];
    adrWeight?: number;
    distributions: MultipleDistributionWithQuotesV4Response[];
    routes: MultipleExpeditionRouteV4Response[];
    carrierNote?: string;
    isReservationOrderLinkedToExpOrder: boolean;
    internalInfo?: ExpeditionInternalInfo;
    customsLoadingNumber?: string;
    ladenFactor?: number;
    defaultLadenFactor?: number;
    allowPartialDelivery: boolean;
    name?: string;
    isFavorite: boolean;
    transportationType?: TransportationTypeEnum;
    incoterms?: IncotermsResponseOutDTO;
    polandSent?: PolandSentOutDTO;
    huEkaerNumber?: string;
    roUitNumber?: string;
    utnCode?: string;
    trackingNumber?: string;
    createdAt: string;
    totalVolume?: number;
    volumeOfOrderEnabled: boolean;
}

export interface MultipleExpeditionRouteV4Response {
    expeditionId: string;
    expeditionLocationId: string;
    routeName: string;
    companyName?: string;
    addressLine: string;
    actionType: ActionTypeEnum[];
    selectedSlot?: TimeSlotResponse;
    actionSlot?: TimeResponse;
    companyLocationId?: string;
    companyLocationCustomerId?: string;
    linkedReservation?: ReservationCoordinates;
    linkedToExpOrderActive: boolean;
    isPartnerLocation: boolean;
}

export interface CGV2LocationFilterInDTO {
    query?: string;
}

export interface AddressBookAddressOutDTO {
    name: string;
    city: string;
    postalCode: string;
    streetNr: string;
    country: string;
    timezoneId?: string;
}

export interface CGV2SmallCompanyOutDTO {
    companyName: string;
    companyId: string;
    locations: CGV2SmallLocationOutDTO[];
    locationContactType: LocationContactTypeEnum;
}

export interface CGV2SmallLocationOutDTO {
    locationId: string;
    locationName: string;
    companyName: string;
    addressTemplate: AddressBookAddressOutDTO;
    isExternal: boolean;
    externalName?: string;
    isPartnerLocation: boolean;
}

export interface AddressBookDefaultContactOutDTO {
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
}

export interface CGV2LocationOutDTO {
    locationId: string;
    locationName: string;
    companyName: string;
    addressTemplate: AddressBookAddressOutDTO;
    defaultContact: AddressBookDefaultContactOutDTO;
    contactPersons: ContactPerson[];
    contacts: ContactPerson[];
    enabledEmailNotificationForContactPerson: boolean;
    locationContactType: LocationContactTypeEnum;
    isExternal: boolean;
    externalName?: string;
    isPartnerLocation: boolean;
    timezoneId?: string;
    locationNote?: string;
    supersededBy?: SupersededByLocationOutDTO;
}

export interface ContactPerson {
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
    automaticPrefillToNotify: boolean;
}

export interface SupersededByLocationOutDTO {
    id: string;
    name: string;
}

export interface ExpeditionQuoteCarrierFilterInDTO {
    carrierName?: string;
    onlyOffers?: boolean;
}

export interface AiPriceAlertOutDTO {
    aiPriceAlertType: AiPriceAlertTypeEnum;
    typicalPrice?: number;
    typicalPriceCurrency?: string;
    aiPriceAlertSeverity?: AiPriceAlertSeverityEnum;
}

export interface CarrierDetailAdditionalInfoOutDTO {
    text: string;
    from?: string;
    to?: string;
}

export interface EmailStatusQuoteOutDTO {
    emailStatus: EmailStatusEnum;
    /**
     * @deprecated Use utcTime instead
     */
    time: string;
    utcTime?: string;
    userName: string;
    email: string;
    description?: string;
}

export interface LocationQuotePreviewOutDTO {
    locationId: string;
    name: string;
    city: string;
    isDifferent: boolean;
    timeslots: TimeSlotExpeditionDetailOutDTO[];
}

export interface PageResponseQuotesPreviewOutDTO {
    data: QuotesPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface QuoteDemandAdditionalQuoteDataOutDTO {
    apiType: ApiTypeEnum;
    required: boolean;
    filled: boolean;
    data?: any;
}

export interface QuotesPreviewOutDTO {
    id: string;
    name: string;
    messagesCount: number;
    offeredPrice?: number;
    priceDTO?: PriceDTO;
    currency?: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill?: string;
    utcEnd?: string;
    timezoneId?: string;
    isExpired: boolean;
    customerQuoteState?: CustomerQuoteStateEnum;
    carrierQuoteState?: CarrierQuoteStateEnum;
    /**
     * @deprecated Use rejectedByCustomerAtUtc instead
     */
    rejectedByCustomerAt?: string;
    rejectedByCustomerAtUtc?: string;
    rejectedMessage?: string;
    rejectedByFullName?: string;
    /**
     * @deprecated Use carrierActionAtUtc instead
     */
    carrierActionAt?: string;
    carrierActionAtUtc?: string;
    carrierActionByFullName?: string;
    emailStatus?: EmailStatusEnum;
    /**
     * @deprecated Use emailStatusCreatedAtUtc instead
     */
    emailStatusCreatedAt?: string;
    emailStatusCreatedAtUtc?: string;
    emailStatusDetail: EmailStatusQuoteOutDTO[];
    locations: LocationQuotePreviewOutDTO[];
    distributionType: DistributionTypeEnum;
    carrierId: string;
    /**
     * @deprecated Use reconfirmedAtUtc and timezoneId instead
     */
    reconfirmedAt?: string;
    reconfirmedAtUtc?: string;
    isReconfirmedByCarrier?: boolean;
    /**
     * @deprecated Use acceptedAtUtc and timezoneId instead
     */
    acceptedAt?: string;
    acceptedAtUtc?: string;
    quoteGroup: QuoteGroupEnum;
    distance?: number;
    carrierName: string;
    expeditionApplicationId: string;
    offeredManipulationUnits?: number;
    chosenManipulationUnits?: number;
    dachserProductType?: DachserProductTypeEnum;
    dachserDeliveryTermTranslated?: string;
    schenkerProductType?: SchenkerProductTypeEnum;
    schenkerAddonsType?: SchenkerAddonsTypeEnum[];
    dhlProductType?: DhlProductTypeEnum;
    aiPriceAlert?: AiPriceAlertOutDTO;
    fedexProductType?: string;
    fedexAccountNumber?: string;
    labels?: LabelPreview[];
    additionalInfo?: CarrierDetailAdditionalInfoOutDTO[];
    carrierGroups?: string[];
    transportLegs: QuoteDemandTransportLegOutDTO[];
    quoteDemandNote?: string;
    additionalQuoteData?: QuoteDemandAdditionalQuoteDataOutDTO;
    carrierContactDetails: CarrierContactDetailOutDTO;
    isTieBreaker: boolean;
    tiebreakerUtcEnd?: string;
    tiebreakerTimezoneId?: string;
}

export interface TimeSlotExpeditionDetailOutDTO {
    id: string;
    isCarrier: boolean;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceInUTC: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    tillInUTC?: string;
    isNotSpecifiedTime: boolean;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
    isSelected: boolean;
}

export interface GetCmrCustomDataV2ManipulationUnitDTO {
    id: string;
    mpSignoNumber?: string;
    mpCount?: number;
    mpPackagingName?: string;
    mpName?: string;
    mpStatisticsNumber?: string;
    mpCompleteWeight?: number;
    mpVolume?: number;
    createdAt: string;
    position: number;
}

export interface GetCmrCustomDataV2ResponseOutDTO {
    id: string;
    entityId: string;
    entityType: EntityTypeEnum;
    cmrApplicationId: string;
    completeSender?: string;
    completeConsignee?: string;
    successiveCarriers?: string;
    attachedDocumentsNumber5?: string;
    sendersInstructions?: string;
    toBePaidBy?: string;
    instructionAsToPaymentForCarriage?: string;
    specialAgreements?: string;
    estabilishedIn?: string;
    dzvvNumber?: string;
    rideNumber?: string;
    borderCrossings?: string;
    others?: string;
    attachedDocumentsNumber30?: string;
    confirmationOfCustomsPapers?: string;
    cashOnDelivery?: string;
    carriersReservationsAndObservations?: string;
    weight?: number;
    unClass?: string;
    manipulationUnits: GetCmrCustomDataV2ManipulationUnitDTO[];
    createdAt: string;
    updatedAt?: string;
}

export interface CarPlateDTO {
    id: string;
    number: string;
}

export interface AddressNullableOutDTO {
    streetNr?: string;
    country: string;
    zipCode?: string;
    city?: string;
    timezoneId?: string;
}

export interface CompanyListOutDTO {
    companyId: string;
    name: string;
    crn: string;
    address: AddressNullableOutDTO;
    createdAt: string;
}

export interface PageResponseCompanyListOutDTO {
    data: CompanyListOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ManualWebhookAvailabilityOutDTO {
    available: boolean;
    webhookTypes: string[];
    pendingDeliveries: number;
}

export interface GetUserTableFilterFavouritesInnerResponseOutDTO {
    viewKey: string;
    filterKeys: string[];
}

export interface GetUserTableFilterFavouritesResponseOutDTO {
    views: GetUserTableFilterFavouritesInnerResponseOutDTO[];
}

export interface GetUserVisitorRecordFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: VisitorRecordFilterInDTO;
}

export interface GetUserVisitorRecordFiltersResponseOutDTO {
    filters: GetUserVisitorRecordFiltersInnerResponseOutDTO[];
}

export interface GetUserTimeslotCalendarFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: CalendarFilter;
}

export interface GetUserTimeslotCalendarFiltersResponseOutDTO {
    filters: GetUserTimeslotCalendarFiltersInnerResponseOutDTO[];
}

export interface GetUserSupplierNotificationFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: AllSupplierNotificationFilter;
}

export interface GetUserSupplierNotificationFiltersResponseOutDTO {
    filters: GetUserSupplierNotificationFiltersInnerResponseOutDTO[];
}

export interface GetUserReservationFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: AllReservationsFilter;
}

export interface GetUserReservationFiltersResponseOutDTO {
    filters: GetUserReservationFiltersInnerResponseOutDTO[];
}

export interface GetUserNotificationFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: NotificationCenterFilter;
}

export interface GetUserNotificationFiltersResponseOutDTO {
    filters: GetUserNotificationFiltersInnerResponseOutDTO[];
}

export interface GetUserJobFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: CompanyJobsFilter;
}

export interface GetUserJobFiltersResponseOutDTO {
    filters: GetUserJobFiltersInnerResponseOutDTO[];
}

export interface GetUserExpeditionFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: AllExpeditionCustomerFilter;
}

export interface GetUserExpeditionFiltersResponseOutDTO {
    filters: GetUserExpeditionFiltersInnerResponseOutDTO[];
}

export interface GetUserEmailHistoryFiltersInnerResponseOutDTO {
    id: string;
    name: string;
    data: FindEmailHistoryFilter;
}

export interface GetUserEmailHistoryFiltersResponseOutDTO {
    filters: GetUserEmailHistoryFiltersInnerResponseOutDTO[];
}

export interface ListUserDepartmentOutDTO {
    id: string;
    name: string;
}

export interface ComputeReservationDurationConfiguration {
    defaultDuration: number;
    minimalDuration: number;
    companyName?: string;
    /**
     * @deprecated Use companyId instead
     */
    companyCode: string;
    ownerCompanyId?: string;
    companyLocationId?: string;
    ownerCanEdit: boolean;
    counterPartyCanEdit: boolean;
    showHistoricalFreeSlots: boolean;
    showHistoricalFreeSlotsCounterParty: boolean;
    units: ComputeReservationDurationUnitConfiguration[];
    slotsRequired: boolean;
    slotsRequiredCounterParty: boolean;
    editDuration: boolean;
    editDurationCounterParty: boolean;
    ownerManipulationItemsRequired: boolean;
    counterPartyManipulationItemsRequired: boolean;
    truckTypeEnabled: boolean;
    truckTypeRequired: boolean;
    nextDayReservationJustBefore: boolean;
    nextDayReservationJustBeforeHours?: number;
    ownerCanDelete: boolean;
    counterPartyCanDelete: boolean;
    ownerShowActionTypes: boolean;
    counterPartyShowActionTypes: boolean;
    nextDayReservationJustBeforeExceptCompanies: boolean;
    nextDayReservationJustBeforeExceptCompaniesList?: LovDTO[];
    flags: any;
    externalOrdersApiType?: ExternalOrdersApiTypeEnum;
    noShowSchedulerEnabled: boolean;
    doubleLoadingUnloadingTime: boolean;
    onBehalfOfEnabled: boolean;
    counterPartyEditBlockedMinutesBeforeStart?: number;
    showCarrierAnonymousReservations: boolean;
    counterPartyShowWorkflowStatus: boolean;
    foldersRequired: boolean;
    foldersRestrictVisibility: boolean;
    driverNameRequired: boolean;
    driverNameRequiredCounterParty: boolean;
    driverPhoneRequired: boolean;
    driverPhoneRequiredCounterParty: boolean;
    driverIdRequired: boolean;
    driverIdRequiredCounterParty: boolean;
    carPlateRequired: boolean;
    carPlateRequiredCounterParty: boolean;
    ownerDefaultActionType: OwnerDefaultActionTypeEnum;
    counterPartyDefaultActionType: CounterPartyDefaultActionTypeEnum;
    restrictToExpeditionHoursOwner: boolean;
    restrictToExpeditionHoursCounterParty: boolean;
    ownerActionTypeRequired: boolean;
    counterPartyActionTypeRequired: boolean;
}

export interface ComputeReservationDurationUnitConfiguration {
    duration: number;
    cargoItemType: string;
}

export interface TableViewsOutDTO {
    views: TableViewOutDTO[];
    prefs: TableViewPrefsOutDTO;
}

export interface DAPSupplierNotificationLocationInfoOutDTO {
    country: string;
    locationId: string;
    zipCode: string;
    city: string;
    streetNr: string;
    locationName: string;
    timezoneId?: string;
}

export interface DetailDAPSNResponseOut {
    id: string;
    version: number;
    applicationId: string;
    transportationType: TransportationTypeEnum;
    createdBy: UserLovOutDTO;
    customerCompany: LovDTO;
    supplierCompany: LovDTO;
    createdAt: string;
    updatedAt: string;
    updatedBy: UserLovOutDTO;
    shipmentNumber: string;
    carrierName: string;
    orders: GlobalOrderResponse[];
    customerLocation: DAPSupplierNotificationLocationInfoOutDTO;
    supplierLocation: DAPSupplierNotificationLocationInfoOutDTO;
    attachments: AttachmentUploadedOutDTO[];
    responsiblePerson?: LovDTO;
    usersToNotify: LovDTO[];
    notifyUsersDependsOnRole: boolean;
    totalWeight: number;
    distance: number;
    cargoCount: number;
    internalNote?: string;
    note?: string;
    internalInvoiceNumber?: string;
    isArchived: boolean;
    invoiceDueDate?: string;
    deliveryConditions?: string;
    customerDeliverySlots: GlobalTimeslots;
    supplierDeliverySlots: GlobalTimeslots;
    /**
     * @deprecated RD-2977: use folders
     */
    folder?: DetailExpeditionFolderResponseOutDTO;
    folders: DetailExpeditionFolderResponseOutDTO[];
}

export interface UserLovOutDTO {
    id: string;
    fullName: string;
    email: string;
}

export interface ExternalOrderResponse {
    orderNumber: string;
    timeFrom?: string;
    timeTo?: string;
    createdBy?: string;
    warehouseName?: string;
}

export interface GetExternalOrdersResponse {
    externalIdPresent: boolean;
    externalIdLocationPresent: boolean;
    orders: ExternalOrderResponse[];
}

export interface ReservationDataExportResponseOutDTO {
    id: string;
    applicationId: string;
    locationName?: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    since?: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    till?: string;
    carrierName?: string;
    reference?: string;
    carPlate?: string;
    currentState?: string;
    problemStateReasons: string[];
    /**
     * @deprecated Use utcProcessingAt instead
     */
    processingAt?: string;
    /**
     * @deprecated Use utcFinishedAt instead
     */
    finishedAt?: string;
    isArchived?: boolean;
    /**
     * @deprecated Use utcArchivedAt and archivedBy instead
     */
    archivedAt?: string;
    archivedBy?: string;
    totalHandlingUnits?: string;
    totalDiscrepancyUnits?: string;
    carrierNote?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
    utcProcessingAt?: string;
    utcFinishedAt?: string;
    utcArchivedAt?: string;
    expeditionApplicationId?: string;
}

export interface AsyncJobOutDTO {
    jobId: string;
    applicationId?: string;
    jobType: JobTypeEnum;
    jobStatus: JobStatusEnum;
    totalCount?: number;
    processedCount: number;
    successCount: number;
    failedCount: number;
    errorMessage?: string;
    resultJson?: string;
    createdAt: string;
    startedAt?: string;
    finishedAt?: string;
}

export interface ReservationMultiDuplicationJobDetailOutDTO {
    job: AsyncJobOutDTO;
    createdByName?: string;
    jobCategory: JobCategoryEnum;
    expiresAt: string;
    sendNotification: boolean;
    source?: ReservationMultiDuplicationJobSourceOutDTO;
}

export interface ReservationMultiDuplicationJobSourceOutDTO {
    reservationId: string;
    applicationId?: string;
    customerId?: string;
    locationName?: string;
    rampName?: string;
}

export interface ReservationMultiDuplicationJobItemsFilter {
    stateFilter?: StateFilterEnum;
}

export interface PageResponseReservationMultiDuplicationJobItemOutDTO {
    data: ReservationMultiDuplicationJobItemOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ReservationMultiDuplicationJobItemOutDTO {
    id: string;
    sortOrder: number;
    itemStatus: ItemStatusEnum;
    since?: string;
    till?: string;
    timezoneId?: string;
    reservationId?: string;
    reservationApplicationId?: string;
    errorMessage?: string;
    error?: MessageResponse;
}

export interface GetPushTokenResponse {
    enabled: boolean;
    token?: string;
    expiresAt?: string;
}

export interface GetPushSubscriptionTokenResponse {
    enabled: boolean;
    token?: string;
    expiresAt?: string;
}

export interface OfferAlert {
    snId: string;
    offerId: string;
    currency: string;
    reasonSn?: string;
    reasonGk?: string;
    severitySn: number;
    severityGk: number;
    standardPrice?: number;
}

export interface TheOriginsPriceAlertResponseBody {
    groupDemandId: string;
    companyId: string;
    offerAlerts: OfferAlert[];
}

export interface LovGetPermissionResponse {
    permissions: SecurityPermission[];
}

export interface SecurityPermission {
    id?: string;
    version?: number;
    deprecated?: boolean;
    name?: NameEnum;
    translateKeyName?: string;
    translateKeyDescription?: string;
    deprecatedMessage?: string;
    notShowForUser?: boolean;
}

export interface OpeningHourDefinitionsDTO {
    id?: string;
    entityId: string;
    openingEntityType: OpeningEntityTypeEnum;
    openingHoursDays: OpeningHoursDayDTO[];
}

export interface OpeningHoursDayDTO {
    day: DayEnum;
    openingMode: OpeningModeEnum;
    openingHours: OpeningHoursDTO[];
}

export interface Order {
    supplierId: number;
    orderCode: string;
}

export interface NotificationTypeSettingOutDTO {
    emailType: EmailTypeEnum;
    groupName: string;
    title?: string;
    email: boolean;
    notificationCenter: boolean;
}

export interface ExpeditionInfoOutDTO {
    firstLocation: LocationRangeOutDTO;
    lastLocation?: LocationRangeOutDTO;
    intermediateStopsCount: number;
}

export interface LocationRangeOutDTO {
    name?: string;
    dateFrom?: string;
    dateTo?: string;
    timezoneId?: string;
}

export interface NotificationAdditionalInfoOutDTO {
    expedition?: ExpeditionInfoOutDTO;
    timeslot?: TimeslotInfoOutDTO;
    supplierNotification?: SupplierNotificationInfoOutDTO;
}

export interface NotificationCenterMessageResponseOutDTO {
    id: string;
    entityType?: EntityTypeEnum;
    entityId?: string;
    title: string;
    message: string;
    isRead: boolean;
    createdAt: string;
    fromUserName?: string;
    counterParty?: string;
    counterPartyId?: string;
    type?: string;
    applicationId?: string;
    additionalInfo?: NotificationAdditionalInfoOutDTO;
    expeditionCoordinate?: ExpeditionCoordinate;
}

export interface PageResponseNotificationCenterMessageResponseOutDTO {
    data: NotificationCenterMessageResponseOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface SupplierNotificationInfoOutDTO {
    supplierName?: string;
    loadingLocation?: LocationRangeOutDTO;
    unloadingLocation?: LocationRangeOutDTO;
}

export interface TimeslotInfoOutDTO {
    locationName?: string;
    rampName?: string;
    date?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface NotificationMessageCountResponseOutDTO {
    count: number;
    userMessageCount: number;
}

export interface LoadEWProposalsOutDTO {
    proposals: LoadEWProposalsOutDTOProposal[];
}

export interface LoadEWProposalsOutDTOProposal {
    proposalId: string;
    proposedPrice?: number;
    proposedCurrency?: ProposedCurrencyEnum;
    companyName: string;
    contactPerson: string;
    email?: string;
    phoneNumber: string;
    state: StateEnum;
}

export interface ListHTTPRequestFilter {
    filterTrcUUID?: string;
    filterUserInfo?: string;
    filterUri?: string;
    filterStatuses?: string[];
    filterMethods?: string[];
}

export interface ListHTTPRequestResponse {
    totalElements: number;
    data: RequestLogElastic[];
}

export interface RequestLogElastic {
    id: string;
    userInfo: string;
    httpMethod: string;
    uri: string;
    status: number;
    requestBody: string;
    responseBody: string;
    exception?: string;
    trcUUID?: string;
    trcRequestDate?: string;
    durationInMS: number;
}

export interface ListCompanyCodeListFilter {
    name?: string;
    externalId?: string;
    codeType?: CodeTypeEnum;
}

export interface ListCompanyCodeListItem {
    id: string;
    externalId: string;
    name?: string;
    description?: string;
    htmlContent?: string;
    codeType: CodeTypeEnum;
    notificationEmails: CompanyCodeListNotificationEmailsSetting[];
}

export interface PageResponseListCompanyCodeListItem {
    data: ListCompanyCodeListItem[];
    total: number;
    page: number;
    size: number;
}

export interface ListCompanyCameraResponse {
    id: string;
    externalId: string;
    name: string;
    cameraType: CameraTypeEnum;
    locationName: string;
}

export interface ListCompanyCamerasResponse {
    cameras: ListCompanyCameraResponse[];
}

export interface ListAllowedCarPlatesFilter {
    carPlate?: string;
    firstName?: string;
    secondName?: string;
    cardId?: string;
}

export interface AllowedCarPlateResponse {
    id: string;
    carPlate: string;
    firstName?: string;
    secondName?: string;
    cardId?: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    validSince: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
    allowedCarPlateMatchType: AllowedCarPlateMatchTypeEnum;
}

export interface PageResponseAllowedCarPlateResponse {
    data: AllowedCarPlateResponse[];
    total: number;
    page: number;
    size: number;
}

export interface GetLinkedCompaniesFilterInDTO {
    companyName?: string;
    companyModules?: CompanyModulesEnum[];
}

export interface GetLinkedCompanyOutDTO {
    companyId: string;
    companyName: string;
    activeCompanyModule?: ActiveCompanyModuleEnum[];
    askedCompanyModule?: AskedCompanyModuleEnum[];
    user?: LinkedCompanyUserDTO;
}

export interface LinkedCompanyUserDTO {
    fullName: string;
    email: string;
    phone?: string;
    id: string;
}

export interface PageResponseGetLinkedCompanyOutDTO {
    data: GetLinkedCompanyOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CompanyModuleForCarrierOutDTO {
    moduleType: ModuleTypeEnum;
    enabled: boolean;
}

export interface GetDetailCompanyLinkedInfoOutDTO {
    createdAt: string;
    createdBy: GetDetailCompanyUserInfoOutDTO;
    modules: ModulesEnum[];
}

export interface GetDetailCompanyUserInfoOutDTO {
    fullName: string;
    email: string;
    phone?: string;
    id: string;
}

export interface GetDetailLinkedAddressOutDTO {
    street: string;
    city: string;
    postalCode: string;
    country: string;
    timezoneId?: string;
}

export interface GetDetailLinkedCompanyInfoOutDTO {
    companyId: string;
    companyName: string;
    originalCompanyName?: string;
    crn: string;
    vat?: string;
    admin?: GetDetailCompanyUserInfoOutDTO;
    companyAddress: GetDetailLinkedAddressOutDTO;
}

export interface GetDetailLinkedCompanyResponseOutDTO {
    companyInfo: GetDetailLinkedCompanyInfoOutDTO;
    linkedInfo?: GetDetailCompanyLinkedInfoOutDTO;
    externalIdsInfo: GetDetailCompanyLinkedExternalIdsInfoOutDTO[];
    companyModules: CompanyModuleForCarrierOutDTO[];
}

export interface GetLinkedCodeOutDTO {
    modules: ModulesEnum[];
    code: string;
    createdAt: string;
    createByFullname?: string;
    order: number;
}

export interface AsyncJobDetailOutDTO {
    job: AsyncJobOutDTO;
    items: AsyncJobItemOutDTO[];
    createdByName?: string;
    jobCategory: JobCategoryEnum;
    expiresAt: string;
}

export interface AsyncJobItemOutDTO {
    itemId: string;
    itemKey?: string;
    sortOrder: number;
    itemStatus: ItemStatusEnum;
    resultJson?: string;
    errorMessage?: string;
    startedAt?: string;
    finishedAt?: string;
}

export interface ExportDownloadUrlOutDTO {
    url: string;
    expiresAt: string;
}

export interface CompanyJobOutDTO {
    jobId: string;
    applicationId?: string;
    jobType: JobTypeEnum;
    jobStatus: JobStatusEnum;
    jobCategory: JobCategoryEnum;
    totalCount?: number;
    processedCount: number;
    successCount: number;
    failedCount: number;
    errorMessage?: string;
    createdByName?: string;
    createdAt: string;
    startedAt?: string;
    finishedAt?: string;
    downloadReady: boolean;
    exportEntityType?: ExportEntityTypeEnum;
}

export interface PageResponseCompanyJobOutDTO {
    data: CompanyJobOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface JobBadgeCountsOutDTO {
    errorCount: number;
    doneWithErrorCount: number;
}

export interface AdminJobsFilter {
    applicationId?: string;
    companyName?: string;
    jobType?: JobTypeEnum[];
    jobStatuses?: JobStatusesEnum[];
    categories?: CategoriesEnum[];
}

export interface AdminAsyncJobOutDTO {
    job: AsyncJobOutDTO;
    createdBy: string;
    createdByEmail?: string;
    companyId: string;
    companyName?: string;
    lockedBy?: string;
    attemptCount: number;
    expiresAt: string;
    jobCategory: JobCategoryEnum;
    archived: boolean;
}

export interface PageResponseAdminAsyncJobOutDTO {
    data: AdminAsyncJobOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface GetWebAppAlertResponse {
    id: string;
    name: string;
    text: string;
    showFrom: string;
    showTo: string;
}

export interface CargoTemplateWithoutIdDTO {
    name: string;
    width?: number;
    length?: number;
    height?: number;
    weight?: number;
    quantity: number;
    code: string;
    decimalPlaces: number;
}

export interface CurrencyOrderValue {
    currencyCode: string;
    amount: number;
}

export interface SupplierNotificationToExpeditionCargoOutDTO {
    name?: string;
    width?: number;
    height?: number;
    length?: number;
    weight?: number;
    amount: number;
    quantityUnit?: string;
    stackable: boolean;
    weightMode?: WeightModeEnum;
    cargoTemplate?: CargoTemplateWithoutIdDTO;
    itemNote?: string;
}

export interface SupplierNotificationToExpeditionLocationOrderOutDTO {
    id: string;
    orderName: string;
    loadingLocationId: string;
    loadingLocationIndex: number;
    unloadingLocationId: string;
    unloadingLocationIndex: number;
    totalWeight: number;
    items: SupplierNotificationToExpeditionCargoOutDTO[];
    orderValue?: CurrencyOrderValue;
    weight: WeightOutDTO;
    orderAmount?: number;
    orderDescription?: string;
}

export interface SupplierNotificationToExpeditionLocationOutDTO {
    id: number;
    partnerLocationId: string;
    fromAddressBookId?: string;
    feKey: string;
    name: string;
    country: string;
    postalCode: string;
    city: string;
    streetNr: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    pickupCode?: string;
    loadedOrders?: SupplierNotificationToExpeditionLocationOrderOutDTO[];
    contactPersons: ContactPerson[];
    enabledEmailNotificationForContactPerson: boolean;
    timeslots: GlobalTimeslots;
    timezoneId?: string;
    locationNote?: string;
}

export interface SupplierNotificationToExpeditionOutDTO {
    maxWeight: number;
    distance: number;
    expeditionType?: ExpeditionTypeEnum;
    locations: SupplierNotificationToExpeditionLocationOutDTO[];
    internalNote?: string;
    cargoType: LovWithoutIdDTO;
    requirements?: LovWithoutIdDTO[];
    supplierNotificationFromId: string;
    note?: string;
    adrWeight?: number;
    transportationType: TransportationTypeEnum;
    applicationId: string;
}

export interface WeightOutDTO {
    value: number;
    weightModeTypeOrder: WeightModeTypeOrderEnum;
}

export interface ReportDefinitionCompanySettingResponse {
    wholeCompany: boolean;
    permittedUsers: LovDTO[];
}

export interface GetPowerBIReportServiceReport {
    reportName: string;
    reportId: string;
}

export interface GetPowerBIReportServiceResponse {
    reports: GetPowerBIReportServiceReport[];
}

export interface GetLinkedEntitiesResponse {
    applicationId: string;
    entityType: EntityTypeEnum;
    id: string;
}

export interface GetInheritedCompanyOutDTO {
    companyId: string;
    name: string;
    modules: string;
    userName?: string;
    userEmail?: string;
    userPhone?: string;
    userId?: string;
}

export interface DistributionResponse {
    validTill: string;
    remainingTimeInHours: number;
    price?: number;
    currency?: string;
    createdByName: string;
    createdAt: string;
    distributionType: DistributionTypeEnum;
}

export interface ExpeditionDetailV3OutDTO {
    id: string;
    applicationId?: string;
    customerId: string;
    expeditionStatus: ExpeditionStatusEnum;
    cargoTypeCode?: string;
    expeditionType?: ExpeditionTypeEnum;
    distance?: number;
    locations: LocationPreviewOutDTO[];
    requirementCodes: string[];
    loadingTypes: string[];
    truckType?: TruckTypeOutDTO;
    distributionType?: DistributionTypeEnum;
    customerName: string;
    isDistributionCreated: boolean;
    isCarrierAssigned: boolean;
    assignedCarrierName?: string;
    sumPrice?: SumPriceExpeditionPreviewOutDTO;
    expeditionCurrency?: string;
    isPublished: boolean;
    labels: LabelPreview[];
    cancellationReasonCode?: string;
    carrierDispatcherEmail?: string;
    carrierDispatcherName?: string;
    assignedCarrierId?: string;
    carPlate?: string;
    assignedDriver?: string;
    isArchived: boolean;
    supplierNotificationLink?: SupplierNotificationPreviewOutDTO;
    handlingUnitCount?: number;
    systemLabels?: SystemLabel[];
    adrWeight?: number;
    distribution?: DistributionResponse;
    quotes: QuotesPreviewOutDTO[];
    extraCosts: ExtraCostsPreviewOutDTO[];
    routes: ExpeditionRouteResponse[];
    carrierNote?: string;
    isReservationOrderLinkedToExpOrder: boolean;
}

export interface ExpeditionRouteResponse {
    expeditionId: string;
    expeditionLocationId: string;
    routeName: string;
    companyName?: string;
    addressLine: string;
    actionType: ActionTypeEnum[];
    selectedSlot?: TimeSlotResponse;
    actionSlot?: TimeResponse;
    isLate: boolean;
    companyLocationId?: string;
    companyLocationCustomerId?: string;
    linkedReservation?: ReservationCoordinates;
}

export interface LocationPreviewOutDTO {
    id: string;
    name: string;
    companyName?: string;
    city: string;
    zipCode: string;
    country: string;
    streetNr: string;
    timeslots: GlobalTimeslots;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    persons: BasicContactPerson[];
    pickupCode?: string;
    loadedOrders: OrderDetailPlanOutDTO[];
    unloadedOrders: OrderDetailPlanOutDTO[];
    requirementCodes: string[];
    timezoneId?: string;
}

export interface OrderDetailPlanOutDTO {
    id: string;
    orderName: string;
    totalWeight?: number;
    totalVolume?: number;
    items: CargoPreviewPlanOutDTO[];
    orderAmount?: number;
    orderDescription?: string;
}

export interface TruckTypeOutDTO {
    code: string;
    loadingCapacity: number;
}

export interface GetDocumentResponse {
    id: string;
    name: string;
    documentType: DocumentTypeEnum;
    userDateLocalDate?: string;
    userNote?: string;
}

export interface CustomerNotificationAttachmentResponse {
    id: string;
    name: string;
    customerNotificationId: string;
}

export interface CustomerNotificationResponse {
    id: string;
    companyModule: CompanyModuleEnum;
    /**
     * @deprecated Use localDateSince and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use localDateTill and timezoneId instead
     */
    till: string;
    localDateSince?: string;
    localDateTill?: string;
    timezoneId?: string;
    companyName: string;
    unread: boolean;
    subject: string;
    body: string;
    attachments: CustomerNotificationAttachmentResponse[];
}

export interface CustomerNotificatonListResponse {
    notifications: CustomerNotificationResponse[];
}

export interface PartnerInfo {
    partnerCompany: CompanyPreview;
    partnerNote?: string;
}

export interface CGCompanyOutDTO {
    companyName: string;
    contacts: CGLocationOutDTO[];
}

export interface CGLocationOutDTO {
    feKey: string;
    locationId: string;
    locationName: string;
    companyName: string;
    addressTemplate: AddressBookAddressOutDTO;
    defaultContact: AddressBookDefaultContactOutDTO;
    contactPersons: BasicContactPerson[];
    enabledEmailNotificationForContactPerson: boolean;
    contactType: ContactTypeEnum;
}

export interface GetAttachmentsFilterInDTO {
    entityType?: EntityTypeEnum;
    applicationId?: string;
    documentType?: DocumentTypeEnum;
    since?: string;
    till?: string;
}

export interface AttachedTo {
    applicationId: string;
    entityId: string;
    entityType: EntityTypeEnum;
    documentType: DocumentTypeEnum;
}

export interface GetAttachmentsOutDTO {
    id: string;
    version: number;
    type?: string;
    user: PersonDetail;
    createdAt: string;
    attachedTo?: AttachedTo;
    name: string;
    size: number;
    contentType: string;
    /**
     * @deprecated Use userDateLocalDate instead
     */
    userDate?: string;
    userDateLocalDate?: string;
    userNote?: string;
}

export interface PageResponseGetAttachmentsOutDTO {
    data: GetAttachmentsOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface FindResolvedEmailFilter {
    id?: string;
    retryCount?: number;
    isSend?: boolean;
    subject?: string;
    recipientEmail?: string;
    cc?: string;
    recipientId?: string;
    senderName?: string;
    senderId?: string;
    entityType?: EntityTypeEnum;
    entityId?: string;
    requestType?: string;
}

export interface PageResponseResolvedEmailOutDTO {
    data: ResolvedEmailOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ResolvedEmailOutDTO {
    id: string;
    retryCount: number;
    emailCreatedAt: string;
    emailLastRetryAt?: string;
    hasToBeSent: boolean;
    reasonNotSent?: string;
    isSend: boolean;
    isMessageCreated: boolean;
    lastException?: string;
    subject?: string;
    recipientEmail?: string;
    cc?: string;
    recipientId?: string;
    senderName?: string;
    senderId?: string;
    emailRequestId?: string;
    requestType?: string;
    notificationType: NotificationTypeEnum;
    title?: string;
    message?: string;
    phoneNumber?: string;
    wrapperId?: string;
    proxyEmailId?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface FindEmailRequestFilter {
    emailType?: string;
    entityType?: EntityTypeEnum;
    applicationId?: string;
}

export interface EmailRequestOutDTO {
    id: string;
    ownerCompanyId: string;
    entityType: EntityTypeEnum;
    action: string;
    createById?: string;
    retryCount: number;
    requestCreatedAt: string;
    requestLastRetryAt?: string;
    isFinished: boolean;
    lastException?: string;
    entityData: string;
    contextData?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface PageResponseEmailRequestOutDTO {
    data: EmailRequestOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface SnFeatureConfigurationOutDTO {
    common: SnCommonConfigDTO;
    config: SnPartyConfigDTO;
    folders: SnFolderSettingsDTO;
}

export interface ExternalManipulationFilterDTO {
    externalId?: string;
    name?: string;
}

export interface PageResponseExternalManipulationUnitDTO {
    data: ExternalManipulationUnitDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ExportJobStatusOutDTO {
    jobId: string;
    entityType: EntityTypeEnum;
    exportFormat: ExportFormatEnum;
    exportJobStatus: ExportJobStatusEnum;
    processedCount: number;
    totalCount?: number;
    errorMessage?: string;
    artifactReady: boolean;
    filename?: string;
}

export interface RobotSuggestionCarrierOutDTO {
    carrierId: string;
    carrierName: string;
    score: number;
    wins: number;
    invited: number;
    responded: number;
    medianPrice?: number;
}

export interface RobotSuggestionOfferOutDTO {
    quoteId: string;
    carrierId: string;
    carrierName: string;
    price: number;
    currency?: string;
    respondedCount: number;
    invitedCount: number;
}

export interface RobotSuggestionOutDTO {
    id: string;
    kind: string;
    createdAt: string;
    ruleId: string;
    ruleName: string;
    ruleDeleted: boolean;
    executionId: string;
    offer?: RobotSuggestionOfferOutDTO;
    carriers: RobotSuggestionCarrierOutDTO[];
    routeMatchLevel?: string;
    refusal?: RobotSuggestionRefusalOutDTO;
}

export interface RobotSuggestionRefusalOutDTO {
    messageKey: string;
    messageParams: string[];
}

export interface GetPreviousDistributionInnerResponseOutDTO {
    fixed?: DistributionInnerResponseOutDTO;
    spot?: DistributionInnerResponseOutDTO;
    currencyLockType: CurrencyLockTypeEnum;
    ladenFactor?: number;
    allowPartialDelivery: boolean;
    assignedCarrierId?: string;
    assignedPrice?: PriceRequest;
}

export interface GetPreviousDistributionResponseOutDTO {
    expeditionId: string;
    previousExpeditionId: string;
    previousDistribution: GetPreviousDistributionInnerResponseOutDTO;
}

export interface FedexExpectedDeliveryOutDTO {
    source: SourceEnum;
    begins?: string;
    ends?: string;
}

export interface FedexExpeditionTrackingOutDTO {
    trackingNumber: string;
    latestStatusCode?: string;
    latestStatusDescription?: string;
    expectedDelivery?: FedexExpectedDeliveryOutDTO;
    serviceCommitMessage?: string;
    scanEvents: FedexTrackingScanEventOutDTO[];
    accountNumber?: string;
}

export interface FedexTrackingScanEventOutDTO {
    date?: string;
    eventDescription?: string;
    derivedStatus?: string;
    exceptionDescription?: string;
}

export interface FedexExpeditionPickupOutDTO {
    applicable: boolean;
    currentPickup?: FedexPickupInfoDTO;
    readyTime?: string;
    closeTime?: string;
    availability?: FedexPickupAvailabilityOutDTO;
}

export interface FedexPickupInfoDTO {
    pickupConfirmationCode: string;
    scheduledDate: string;
    location?: string;
    carrierCode: string;
}

export interface SearchTemplateExpeditionResponseInnerOutDTO {
    id: string;
    name: string;
}

export interface SearchTemplateExpeditionResponseOutDTO {
    templates: SearchTemplateExpeditionResponseInnerOutDTO[];
}

export interface SearchExpeditionResponseInnerOutDTO {
    id: string;
    applicationId: string;
    name?: string;
    isFavorite: boolean;
}

export interface SearchExpeditionResponseOutDTO {
    expeditions: SearchExpeditionResponseInnerOutDTO[];
}

export interface MultiduplicationV3JobDetailOutDTO {
    job: AsyncJobOutDTO;
    phase: PhaseEnum;
    shiftDays: number;
    createdByName?: string;
    jobCategory: JobCategoryEnum;
    expiresAt: string;
    itemsTotal: number;
    itemsWithIssues: number;
}

export interface MultiduplicationV3ItemsFilter {
    stateFilter?: StateFilterEnum;
}

export interface PageResponseMultiduplicationV3JobItemOutDTO {
    data: MultiduplicationV3JobItemOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface DuplicationJobDetailOutDTO {
    job: AsyncJobOutDTO;
    createdByName?: string;
    jobCategory: JobCategoryEnum;
    expiresAt: string;
    someReservationFailed: boolean;
    source?: DuplicationJobSourceOutDTO;
}

export interface DuplicationJobSourceOutDTO {
    expeditionId: string;
    applicationId?: string;
    labels: LabelPreview[];
    supplierNotificationId?: string;
    supplierNotificationAppId?: string;
    routeSummary: string[];
}

export interface DuplicationJobItemsFilter {
    stateFilter?: StateFilterEnum;
}

export interface DuplicationJobItemLocationOutDTO {
    locationName?: string;
    reservationId?: string;
    reservationApplicationId?: string;
    reservationCreated?: boolean;
    hasNoSlots?: boolean;
}

export interface DuplicationJobItemOutDTO {
    id: string;
    date?: string;
    sortOrder: number;
    itemStatus: ItemStatusEnum;
    errorMessage?: string;
    error?: MessageResponse;
    expeditionId?: string;
    expeditionApplicationId?: string;
    someReservationFailed: boolean;
    locations: DuplicationJobItemLocationOutDTO[];
    labels: LabelPreview[];
    expeditionType?: ExpeditionTypeEnum;
    responsiblePerson?: string;
    orderCount?: number;
}

export interface PageResponseDuplicationJobItemOutDTO {
    data: DuplicationJobItemOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ExpeditionBulkDistributionJobDetailOutDTO {
    job: AsyncJobOutDTO;
    createdByName?: string;
    jobCategory: JobCategoryEnum;
    expiresAt: string;
    phase: PhaseEnum;
    distributionKind: DistributionKindEnum;
    price?: PriceRequest;
    utcEnd?: string;
    timezoneId?: string;
    carrierCount: number;
    ladenFactor?: number;
    itemsTotal: number;
    itemsWithIssues: number;
}

export interface ExpeditionBulkDistributionJobItemsFilter {
    stateFilter?: StateFilterEnum;
}

export interface ExpeditionBulkDistributionJobItemOutDTO {
    id: string;
    sortOrder: number;
    itemStatus: ItemStatusEnum;
    expeditionId: string;
    expeditionApplicationId?: string;
    expeditionStatus?: ExpeditionStatusEnum;
    routeSummary: string[];
    handlingUnitCount?: number;
    problems: MessageResponse[];
    distributionId?: string;
    directAssign?: boolean;
    carrierCount?: number;
    errorMessage?: string;
    error?: MessageResponse;
}

export interface PageResponseExpeditionBulkDistributionJobItemOutDTO {
    data: ExpeditionBulkDistributionJobItemOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface EmailFlowEventDTO {
    type: string;
    createdAt: string;
    description?: string;
    severity?: string;
    count: number;
    lastAt?: string;
}

export interface EmailHistoryRecipientRowOutDTO {
    id: string;
    requestId: string;
    ownerCompanyId: string;
    ownerCompanyName?: string;
    entityType: EntityTypeEnum;
    action: string;
    actionTitle?: string;
    createdById?: string;
    createdByName?: string;
    createdByCompanyId?: string;
    createdByCompanyName?: string;
    requestCreatedAt: string;
    recipientEmail?: string;
    recipientName?: string;
    recipientPhone?: string;
    senderName?: string;
    senderEmail?: string;
    senderPhone?: string;
    cc?: string;
    subject?: string;
    applicationId?: string;
    emailCreatedAt?: string;
    emailLastRetryAt?: string;
    rfcMessageId?: string;
    emailHistoryAggStatus: EmailHistoryAggStatusEnum;
    queued: EmailStageDTO;
    sent: EmailStageDTO;
    delivered: EmailStageDTO;
    opened: EmailStageDTO;
    relatedEntities: RelatedEntityDTO[];
    events: EmailFlowEventDTO[];
    canResend: boolean;
    resentFromId?: string;
    resentById?: string;
    resentByName?: string;
}

export interface EmailStageDTO {
    emailStageState: EmailStageStateEnum;
    at?: string;
    detail?: string;
}

export interface PageResponseEmailHistoryRecipientRowOutDTO {
    data: EmailHistoryRecipientRowOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface RelatedEntityDTO {
    entityType: EntityTypeEnum;
    entityId: string;
    snType?: SnTypeEnum;
    applicationId?: string;
}

export interface DistributionSettingsResponseOutDTO {
    defaultHoursInFuture: number;
    responseDeadlineMode: ResponseDeadlineModeEnum;
}

export interface DetailHTTPRequestResponse {
    id: string;
    trcRequestDate?: string;
    trcUUID?: string;
    httpMethod: string;
    uri: string;
    status: number;
    durationInMS: number;
    request: string;
    response: string;
    exception?: string;
}

export interface CustomStatusOutDTO {
    customsStatus?: CustomsStatusEnum;
    date?: CustomValueDateOutDTO;
}

export interface CustomValueDateOutDTO {
    customsLocalDate?: string;
    customsLocalDateTimezone?: string;
}

export interface CustomValueOutDTO {
    customsValue?: CustomsValueEnum;
    price?: PriceDTO;
}

export interface CustomsDetailOutDTO {
    id: string;
    entityId: string;
    entityType: EntityTypeEnum;
    status?: CustomStatusOutDTO;
    customsValue?: CustomValueOutDTO;
    customsArea?: CustomsAreaEnum;
    loadingNumber?: string;
    mrnNumber?: string;
    internalPDNumber?: string;
    internalNote?: string;
}

export interface ListCustomsInvoicesInnerResponseOutDTO {
    id: string;
    invoiceNumber: string;
    invoiceNote?: string;
    price?: PriceDTO;
}

export interface ListCustomsInvoicesResponseOutDTO {
    invoices: ListCustomsInvoicesInnerResponseOutDTO[];
}

export interface GetInfoCancelExpeditionResponseOutDTO {
    expeditionId: string;
    applicationId: string;
    companyId: string;
    isReservationPresent: boolean;
    reservations: ReservationCoordinates[];
}

export interface ListAllCustomerNotificationFilter {
    companyModule?: CompanyModuleEnum;
    companyNotificationValidity?: CompanyNotificationValidityEnum;
}

export interface GetCustomerNotificationMessageResponse {
    language: string;
    body: string;
    subject: string;
}

export interface ListAllCustomerNotification {
    id: string;
    since: string;
    till: string;
    localDateSince?: string;
    localDateTill?: string;
    timezoneId?: string;
    companyModule: CompanyModuleEnum;
    unreadCount: number;
    notifiedCount: number;
    messages: GetCustomerNotificationMessageResponse[];
}

export interface PageResponseListAllCustomerNotification {
    data: ListAllCustomerNotification[];
    total: number;
    page: number;
    size: number;
}

export interface GetCustomerNotificationDetail {
    id: string;
    /**
     * @deprecated Use localDateSince and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use localDateTill and timezoneId instead
     */
    till: string;
    localDateSince?: string;
    localDateTill?: string;
    timezoneId?: string;
    companyModule: CompanyModuleEnum;
    messages: GetCustomerNotificationMessageResponse[];
}

export interface GetColumnOrderSettingItemResponseOutDTO {
    feId: string;
    field: string;
    header: string;
    headerDefault: string;
    width?: string;
    sortable?: boolean;
    order: number;
}

export interface GetColumnOrderSettingResponseOutDTO {
    columnOrders: GetColumnOrderSettingItemResponseOutDTO[];
}

export interface CompanyFolderListOutDTO {
    folders: CompanyFolderOutDTO[];
    availableEntityTypes: AvailableEntityTypesEnum[];
}

export interface NotifyTargetOutDTO {
    id: string;
    name: string;
    notifyTargetType: NotifyTargetTypeEnum;
    userCount?: number;
    departmentNames?: string[];
}

export interface CheckUserCanCreateReservationResponse {
    createReservationCheck: CreateReservationCheckEnum;
}

export interface CheckLocationExceptionOutDTO {
    exceptionName: string;
    openHourExceptionType: OpenHourExceptionTypeEnum;
    dates: string[];
    locations: CompanyLocationPreviewDTO[];
    openingHours: ExceptionTimeIntervalDTO[];
}

export interface CompanyLocationPreviewDTO {
    locationId: string;
    rampIds?: string[];
}

export interface ExceptionTimeIntervalDTO {
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    till: string;
    localStart?: string;
    localEnd?: string;
}

export interface ListArrivalsDeparturesLogFilter {
    carPlate?: string;
    personName?: string;
    cameraName?: string;
    isAllowed?: boolean;
    since?: string;
    till?: string;
}

export interface ArrivalsDeparturesLogResponse {
    id: string;
    carPlate: string;
    personName?: string;
    createdAt: string;
    isArrival: boolean;
    isAllowed: boolean;
    cameraName: string;
    cameraId?: string;
    cameraCompanyLocationId?: string;
    reservationLink?: ReservationCoordinates;
    timezoneId?: string;
}

export interface PageResponseArrivalsDeparturesLogResponse {
    data: ArrivalsDeparturesLogResponse[];
    total: number;
    page: number;
    size: number;
}

export interface LoVCompanyCamerasResponseOutDTO {
    cameraId: string;
    cameraName: string;
    cameraType: CameraTypeEnum;
}

export interface CalendarLayoutModelFilter {
    name?: string;
    modelId?: string;
    systemWide?: boolean;
    ownerCompanyId?: string;
    applied?: boolean;
    calendarLayoutStatus?: CalendarLayoutStatusEnum;
    q?: string;
}

export interface CalendarLayoutModelRowOutDTO {
    id: string;
    name: string;
    description?: string;
    systemWide: boolean;
    ownerCompanyId?: string;
    ownerCompanyName?: string;
    editable: boolean;
    calendarLayoutStatus: CalendarLayoutStatusEnum;
    publishedAt?: string;
    published: boolean;
    hasDraft: boolean;
    canRevert: boolean;
    assignmentCount: number;
    createdAt: string;
    updatedAt?: string;
}

export interface PageResponseCalendarLayoutModelRowOutDTO {
    data: CalendarLayoutModelRowOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CalendarLayoutResolutionOutDTO {
    calendarLayoutSource: CalendarLayoutSourceEnum;
    companyId?: string;
    locationId?: string;
    modelId: string;
    modelName: string;
    publishedAt?: string;
}

export interface EffectiveCalendarLayoutOutDTO {
    configs: any;
    default?: CalendarLayoutResolutionOutDTO;
    overrides: CalendarLayoutResolutionOutDTO[];
}

export interface CalendarLayoutAssignmentFilter {
    name?: string;
    modelId?: string;
    systemWide?: boolean;
    companyId?: string;
    locationId?: string;
    calendarLayoutScopeType?: CalendarLayoutScopeTypeEnum;
    q?: string;
}

export interface CalendarLayoutAssignmentRowOutDTO {
    id: string;
    calendarLayoutScopeType: CalendarLayoutScopeTypeEnum;
    companyId?: string;
    companyName?: string;
    locationId?: string;
    locationName?: string;
    modelId: string;
    modelName: string;
    calendarLayoutModelStatus: CalendarLayoutModelStatusEnum;
    effective: boolean;
    publishedAt?: string;
    createdAt: string;
    updatedAt?: string;
}

export interface PageResponseCalendarLayoutAssignmentRowOutDTO {
    data: CalendarLayoutAssignmentRowOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface GetAllowedCarPlateResponse {
    id: string;
    carPlate: string;
    normalizedCarPlate: string;
    firstName?: string;
    secondName?: string;
    cardId?: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    validSince: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill?: string;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
    allowedCarPlateMatchType: AllowedCarPlateMatchTypeEnum;
}

export interface RuleListItemOutDTO {
    id: string;
    name: string;
    description?: string;
    enabled: boolean;
    priority: number;
    entityType: EntityTypeEnum;
    triggerType: string;
    ruleEditMode: RuleEditModeEnum;
    lastFiredAt?: string;
    executionCount24h: number;
    pausedUntil?: string;
    createdBy?: string;
    updatedAt: string;
}

export interface PageResponsePlannedEventOutDTO {
    data: PlannedEventOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface PlannedEventOutDTO {
    id: string;
    entityType: EntityTypeEnum;
    entityId: string;
    entityLabel?: string;
    triggerType: string;
    eventState: EventStateEnum;
    notBefore: string;
    attempts: number;
    createdAt: string;
    lockedUntil?: string;
}

export interface ActionMetadataOutDTO {
    key: string;
    entityTypes: EntityTypesEnum[];
    i18nKey: string;
    params: ActionParamMetadataOutDTO[];
}

export interface ActionParamMetadataOutDTO {
    name: string;
    paramType: ParamTypeEnum;
    required: boolean;
    enumValues?: string[];
    defaultValue?: any;
    entityRefType?: string;
}

export interface CountryGroupMetadataOutDTO {
    code: string;
    name: string;
}

export interface FactMetadataOutDTO {
    key: string;
    group: string;
    entityType: EntityTypeEnum;
    factType: FactTypeEnum;
    factCost: FactCostEnum;
    operators: string[];
    enumValues?: string[];
    unit?: string;
    entityRefType?: string;
    availableForTriggers: string[];
    i18nKey: string;
    factQuantifier: FactQuantifierEnum;
    factParameters: FactParameterMetadataOutDTO[];
}

export interface FactParameterMetadataOutDTO {
    name: string;
    parameterValues: string[];
    defaultValue: string;
    i18nKey: string;
}

export interface OperatorMetadataOutDTO {
    key: string;
    symbol: string;
    i18nKey: string;
    takesValue: boolean;
    valueEntityRefType?: string;
}

export interface RuleMetadataOutDTO {
    triggers: TriggerMetadataOutDTO[];
    facts: FactMetadataOutDTO[];
    actions: ActionMetadataOutDTO[];
    operators: OperatorMetadataOutDTO[];
    reservedWords: string[];
    countryGroups: CountryGroupMetadataOutDTO[];
}

export interface TriggerMetadataOutDTO {
    key: string;
    entityType: EntityTypeEnum;
    i18nKey: string;
    supportsDelay: boolean;
}

export interface ExecutionListItemOutDTO {
    id: string;
    ruleId: string;
    ruleName?: string;
    eventId: string;
    entityType?: EntityTypeEnum;
    entityId?: string;
    entityLabel?: string;
    triggerType?: string;
    matched: boolean;
    executionState: ExecutionStateEnum;
    error?: string;
    createdAt: string;
    executedAt?: string;
}

export interface PageResponseExecutionListItemOutDTO {
    data: ExecutionListItemOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ExecutionDetailOutDTO {
    id: string;
    ruleId: string;
    ruleName?: string;
    eventId: string;
    entityType?: EntityTypeEnum;
    entityId?: string;
    entityLabel?: string;
    triggerType?: string;
    matched: boolean;
    executionState: ExecutionStateEnum;
    error?: string;
    createdAt: string;
    executedAt?: string;
    explain?: JsonNode;
    actions?: JsonNode;
}

export interface RobotActivityOutDTO {
    inFlight: number;
    dueNow: number;
    scheduled: number;
    executed24h: number;
    skipped24h: number;
    failed24h: number;
    enabledRules: number;
    lastActivityAt?: string;
    lastScanAt?: string;
    scans: RobotScanOutDTO[];
}

export interface RobotScanOutDTO {
    name: string;
    lastScanAt?: string;
}

export interface RobotActionOutDTO {
    action: string;
    ok: boolean;
    detailKey?: string;
    detailParams: string[];
    errorKey?: string;
    errorParams: string[];
}

export interface RobotActivityFeedOutDTO {
    items: RobotActivityItemOutDTO[];
    nextSince?: string;
    hasMore: boolean;
}

export interface RobotActivityItemOutDTO {
    id: string;
    activityKind: ActivityKindEnum;
    at: string;
    ruleId?: string;
    ruleName?: string;
    ruleDeleted: boolean;
    ruleCount?: number;
    notBefore?: string;
    entityType?: EntityTypeEnum;
    entityId?: string;
    entityLabel?: string;
    triggerType?: string;
    actions: RobotActionOutDTO[];
    error?: string;
}

export interface WebhookDefinitionFilter {
    companyName?: string;
    webhookType?: string;
}

export interface PageResponseWebhookDefinitionOutDTO {
    data: WebhookDefinitionOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface WebhookDefinitionOutDTO {
    id: string;
    companyId: string;
    companyName: string;
    webhookType: string;
    url?: string;
    implementationType?: string;
    authenticationType?: string;
}

export interface AdminWebhookDeliveryPayloadOutDTO {
    id: string;
    payloadJson: string;
}

export interface AdminWebhookDeliveryFilter {
    webhookDeliveryStatus?: WebhookDeliveryStatusEnum[];
    companyName?: string;
    webhookType?: string;
    entityId?: string;
}

export interface AdminWebhookDeliveryOutDTO {
    id: string;
    companyId: string;
    companyName?: string;
    webhookType: string;
    entityType: EntityTypeEnum;
    entityId: string;
    action?: string;
    webhookDeliveryStatus: WebhookDeliveryStatusEnum;
    attemptCount: number;
    maxAttempts: number;
    nextAttemptAt: string;
    lastStatusCode?: number;
    lastError?: string;
    lockedBy?: string;
    createdAt: string;
    finishedAt?: string;
}

export interface PageResponseAdminWebhookDeliveryOutDTO {
    data: AdminWebhookDeliveryOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ListWebAlertResponseOutDTO {
    id: string;
    name: string;
    text: string;
    showFrom: string;
    showTo: string;
    isActive: boolean;
}

export interface ReminderLineOutDTO {
    emailType: EmailTypeEnum;
    title: string;
    enabled: boolean;
    values: number[];
    transportationType: TransportationTypeEnum[];
    reminderUnit: ReminderUnitEnum;
    reminderDirection: ReminderDirectionEnum;
    defaults: number[];
    min: number;
    max: number;
    expeditionBased: boolean;
}

export interface ReminderSettingsOutDTO {
    active: boolean;
    lines: ReminderLineOutDTO[];
}

export interface ListResolvedEmailsResponse {
    totalEmailsCount: number;
    inQueue: ResolvedEmailOutDTO[];
    inQueueCount: number;
    failed: ResolvedEmailOutDTO[];
    failedCount: number;
}

export interface ListEmailRequestResponse {
    totalEmailsCount: number;
    inQueue: EmailRequestOutDTO[];
    inQueueCount: number;
    failed: EmailRequestOutDTO[];
    failedCount: number;
}

export interface AggregatedStageDTO {
    emailStageState: EmailStageStateEnum;
    count: number;
}

export interface EmailHistoryRecipientOutDTO {
    id: string;
    recipientEmail?: string;
    recipientName?: string;
    recipientPhone?: string;
    senderName?: string;
    senderEmail?: string;
    senderPhone?: string;
    cc?: string;
    subject?: string;
    applicationId?: string;
    emailCreatedAt?: string;
    emailLastRetryAt?: string;
    rfcMessageId?: string;
    queued: EmailStageDTO;
    sent: EmailStageDTO;
    delivered: EmailStageDTO;
    opened: EmailStageDTO;
    canResend: boolean;
    resentFromId?: string;
    resentById?: string;
    resentByName?: string;
    events: EmailFlowEventDTO[];
}

export interface EmailHistoryRequestOutDTO {
    id: string;
    ownerCompanyId: string;
    ownerCompanyName?: string;
    entityType: EntityTypeEnum;
    action: string;
    actionTitle?: string;
    applicationIds: string[];
    relatedEntities: RelatedEntityDTO[];
    createdById?: string;
    createdByName?: string;
    createdByCompanyId?: string;
    createdByCompanyName?: string;
    requestCreatedAt: string;
    emailHistoryAggStatus: EmailHistoryAggStatusEnum;
    queued: AggregatedStageDTO;
    sent: AggregatedStageDTO;
    delivered: AggregatedStageDTO;
    opened: AggregatedStageDTO;
    recipients: EmailHistoryRecipientOutDTO[];
}

export interface PageResponseEmailHistoryRequestOutDTO {
    data: EmailHistoryRequestOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ResolvedEmailHtmlOutDTO {
    fullHtml?: string;
    subject?: string;
}

export interface GetCompanyNotificationSettingResponseOutDTO {
    id: string;
    companyId: string;
    entityType?: EntityTypeEnum;
    actionName?: string;
    notificationChannels: NotificationChannelsEnum[];
    notifyUserWithRole?: string;
    notifyUsers: GetCompanyNotificationSettingUserOutDTO[];
}

export interface GetCompanyNotificationSettingUserOutDTO {
    userId: string;
    email: string;
    phone?: string;
    userName: string;
}

export interface ListCompanyFolderResponseOutDTO {
    folders: CompanyFolderOutDTO[];
    availableEntityTypes: AvailableEntityTypesEnum[];
}

export interface AdminCompanyLocationResponseOutDTO {
    id: string;
    name: string;
    rampNumber: number;
}

export interface PageResponseAdminCompanyLocationResponseOutDTO {
    data: AdminCompanyLocationResponseOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CargoTemplateFilter {
    code?: string;
}

export interface CargoTemplateListItemOutDTO {
    id: string;
    name: string;
    code: string;
    order?: number;
    stackable: boolean;
}

export interface PageResponseCargoTemplateListItemOutDTO {
    data: CargoTemplateListItemOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface NextOrderCargoTemplateOutDTO {
    nextOrder: number;
}

export interface AdminHTTPRequestSettingsResponse {
    enabled: boolean;
    ignoredUrls: string[];
    disabledHttpStatuses: number[];
    indexName: string;
}

export interface AdminGetUsersFilter {
    companyName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    companyId?: string;
}

export interface AdminUserOutDTO {
    id: string;
    companyId: string;
    email: string;
    firstName: string;
    lastName: string;
    companyName?: string;
    active?: boolean;
    registered?: boolean;
}

export interface PageResponseAdminUserOutDTO {
    data: AdminUserOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ListAdditionTermsOutDTO {
    id: string;
    name: string;
    isMandatory: boolean;
    isOnSinglePage: boolean;
    isForAllCompanies: boolean;
    companyCount: number;
    termsText: string;
}

export interface PageResponseListAdditionTermsOutDTO {
    data: ListAdditionTermsOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface GetAdditionalTermOutDTO {
    id: string;
    name: string;
    isMandatory: boolean;
    isOnSinglePage: boolean;
    isForAllCompanies: boolean;
    termText: string;
    companies: CompanyPreview[];
}

export interface ManageReportsAdminReportsResponse {
    reportName: string;
    reportImage: string;
    reportDefinitionId: string;
    reportDescription?: string;
    companySettings?: ReportDefinitionCompanySettingResponse;
}

export interface CMRPDF {
    fileName: string;
    mimeType: string;
    size: number;
    data: string;
}

export interface FindCarrierCarrierOrGroupResponseOutDTO {
    id: string;
    carrierOrGroup: CarrierOrGroupEnum;
    name: string;
    selectedItemType: SelectedItemTypeEnum;
    apiTypes?: ApiTypesEnum[];
    userIds?: string[];
    carrierIds?: string[];
}

export interface AuditFilter {
    entityType?: EntityTypeEnum;
    entityId?: string;
    action?: ActionEnum[];
    actorId?: string[];
    actorCompanyId?: string[];
    onBehalfOfUserId?: string[];
    onBehalfOfCompanyId?: string[];
    entityOwnerCompanyId?: string[];
    restrictedToCompanyId?: string[];
    category?: CategoryEnum[];
    source?: SourceEnum[];
    actionOutcome?: ActionOutcomeEnum[];
    correlationId?: string[];
    impersonated?: boolean;
    from?: string;
    to?: string;
}

export interface AuditActorOutDTO {
    name?: string;
    email?: string;
}

export interface AuditEntryOutDTO {
    id: string;
    auditEntityType: AuditEntityTypeEnum;
    entityId: string;
    entityApplicationId?: string;
    entityName?: string;
    auditAction: AuditActionEnum;
    activityKey: string;
    actor?: AuditActorOutDTO;
    actorId?: string;
    actorCompanyId?: string;
    actorCompanyName?: string;
    onBehalfOfUser?: AuditActorOutDTO;
    onBehalfOfUserId?: string;
    onBehalfOfCompanyId?: string;
    onBehalfOfCompanyName?: string;
    entityOwnerCompanyId?: string;
    entityOwnerCompanyName?: string;
    atUtc: string;
    restrictedToCompanyId?: string;
    auditCategory: AuditCategoryEnum;
    source: SourceEnum;
    actionOutcome: ActionOutcomeEnum;
    correlationId?: string;
    description?: string;
    descriptionKey?: string;
    params: AuditParamOutDTO[];
}

export interface AuditParamOutDTO {
    kind: KindEnum;
    position: number;
    name?: string;
    oldValue?: string;
    value?: string;
}

export interface PageResponseAuditEntryOutDTO {
    data: AuditEntryOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface AuditActionLovDTO {
    auditEntityType: AuditEntityTypeEnum;
    auditAction: AuditActionEnum;
    activityKey: string;
    descriptionKey?: string;
}

export interface AuditEnumCatalogOutDTO {
    entityTypes: EnumLovDTO[];
    actions: AuditActionLovDTO[];
    categories: EnumLovDTO[];
    sources: EnumLovDTO[];
    actionOutcomes: EnumLovDTO[];
    paramKinds: EnumLovDTO[];
}

export interface EnumLovDTO {
    id: string;
    i18nKey: string;
}

export interface AresResponse {
    ico?: string;
    dic?: string;
    name?: string;
    street?: string;
    city?: string;
    zipCode?: string;
    streetNumber1?: string;
    streetNumber2?: string;
}

export interface GroupMessagesPreviewOutV3DTO {
    counterPartyId: string;
    counterPartyName: string;
    lastMessage: string;
    lastInteracted: string;
    isNewMessage: boolean;
}

export interface ListGroupsMessagesOutV3DTO {
    groups: GroupMessagesPreviewOutV3DTO[];
}

export interface LoVCarriesToSendMessageOutV3DTO {
    carriers: LovDTO[];
}

export interface CountMessagesCarrierOutV3DTO {
    countUnread: number;
    countAll: number;
}

export interface FileOutDTO {
    id: string;
    mimeType: string;
    fileName: string;
    companyName: string;
    data?: string;
    size: number;
    canBeDeleted: boolean;
    createdAt: string;
    documentType: DocumentTypeEnum;
    accessType: AccessTypeEnum;
}

export interface CatalogCarrierFilter {
    carrierName?: string;
    headquarters?: string[];
    exportCountries?: string[];
    importCountries?: string[];
    trucks?: string[];
}

export interface CatalogCarPreviewOutDTO {
    name: string;
    count: number;
}

export interface CatalogCarrierPreviewOutDTO {
    carrierId: string;
    name: string;
    countryRegion?: string;
    country: string;
    zipCode?: string;
    city?: string;
    timezoneId?: string;
    exportCountries: string[];
    exportNote?: string;
    importCountries: string[];
    importNote?: string;
    cars: CatalogCarPreviewOutDTO[];
    isAlreadyAdded: boolean;
}

export interface PageResponseCatalogCarrierPreviewOutDTO {
    data: CatalogCarrierPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ProfileSettingsOutDTO {
    key: KeyEnum;
    value: any;
}

export interface UserProfileInfoOutDTO {
    id: string;
    firstName: string;
    surname: string;
    email: string;
    phone: string;
    company: string;
}

export interface UserProfileOutDTO {
    information: UserProfileInfoOutDTO;
    settings: ProfileSettingsOutDTO[];
}

export interface CompanyPreviewOutDTO {
    companyId: string;
    companyName: string;
    companyCode?: string;
}

export interface ModuleSettingsOutDTO {
    companyModule: CompanyModuleEnum;
    inheritingModule: boolean;
    owner?: CompanyPreviewOutDTO;
}

export interface UserInfoOutDTO {
    id: string;
    avatar?: string;
    firstName: string;
    lastName: string;
    initial: string;
    email: string;
    phone: string;
    companyId: string;
    company: string;
    companyType: CompanyTypeEnum;
    /**
     * @deprecated Use defaultTimezoneId instead
     */
    companyTimeZone: string;
    language: string;
    permissionTypes: PermissionTypesEnum[];
    modules: ModuleSettingsOutDTO[];
    companyCode?: string;
    features?: FeaturesEnum[];
    betaFeatures: any;
    securityGroups: string[];
    securityRoles: string[];
    /**
     * @deprecated Legacy LogsteoUser.roles (dead-write); use securityRoles instead
     */
    roles?: RolesEnum[];
    reports?: GetPowerBIReportServiceReport[];
    defaultCurrencyIsoCode: string;
    priceDisplayType: PriceDisplayTypeEnum;
    defaultTimezoneId?: string;
}

export interface TruckTypeWithoutIdDTO {
    name: string;
    width?: number;
    length?: number;
    height?: number;
    loadingCapacity?: number;
    loadingUnit?: string;
    icon?: string;
    code: string;
}

export interface LovTransportationTypeOutDTO {
    name: string;
    transportationType: TransportationTypeEnum;
}

export interface LovSecurityRolesDTO {
    id: string;
    name: string;
    translateKey?: string;
    descriptionKey?: string;
    isPrivate: boolean;
    isOnlyInternal: boolean;
    companyModules: CompanyModulesEnum[];
}

export interface SchenkerLovForAddonTypeInnerOutDTO {
    name: string;
    code: string;
}

export interface SchenkerLovForAddonTypeOutDTO {
    group: number;
    schenkerAddonTypeSelector: SchenkerAddonTypeSelectorEnum;
    values: SchenkerLovForAddonTypeInnerOutDTO[];
}

export interface NotificationListFilter {
    messageTypeFilter: MessageTypeFilterEnum;
    onlyMessage: boolean;
    notificationType?: string;
}

export interface NotificationPreviewListOutDTO {
    id: string;
    applicationId: string;
    companyId: string;
    name: string;
    read: boolean;
    type: TypeEnum;
    createAt: string;
    createdBy: string;
    toLoadAt: string;
    timezoneId?: string;
    locationNames: string[];
    entityId: string;
    entityType: EntityTypeEnum;
    isMessage: boolean;
    selectedCarrierId?: string;
    expeditionCoordinate?: ExpeditionCoordinate;
}

export interface PageResponseNotificationPreviewListOutDTO {
    data: NotificationPreviewListOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CountNotificationOutDTO {
    count: number;
    messageCount: number;
}

export interface AddressBookTemplateOutDTO {
    id: string;
    name: string;
    addressTemplate: AddressBookAddressOutDTO;
    defaultContact: AddressBookDefaultContactOutDTO;
    openingHourDefinitions: OpeningHourDefinitionsDTO;
    contactPersons: BasicContactPerson[];
    enabledEmailNotificationForContactPerson: boolean;
}

export interface ListAddressBooksOutDTO {
    addressBooks: AddressBookTemplateOutDTO[];
}

export interface ExpeditionDetailTabPlanOutDTO {
    id: string;
    applicationId?: string;
    companyId: string;
    expeditionStatus: ExpeditionStatusEnum;
    expeditionType?: ExpeditionTypeEnum;
    distance: number;
    locations: LocationPreviewOutDTO[];
    requirements: LovWithoutIdDTO[];
    distributionType?: DistributionTypeEnum;
    nextLocationUnloadingAction?: ShipmentDetailNextAction;
    customerName: string;
    isManualExpedition: boolean;
    isDistributionCreated: boolean;
    isCarrierAssigned: boolean;
    expeditionToId?: string;
    expeditionFromId?: string;
    sumPrice?: SumPriceExpeditionPreviewOutDTO;
    expeditionCurrency?: string;
    lastExpeditionStatus: LastExpeditionStatusEnum;
    isPublished: boolean;
    publishedAt?: string;
    publishedByName?: string;
    isDriverCurrentlyActive: boolean;
    labels: LabelPreview[];
    cancellationReasonCode?: string;
    carrierDispatcherEmail?: string;
    carrierDispatcherName?: string;
    isArchived: boolean;
    supplierNotificationLink?: SupplierNotificationPreviewOutDTO;
    handlingUnitCount?: number;
    systemLabels?: SystemLabel[];
    adrWeight?: number;
    customsLoadingNumber?: string;
    transportationType?: TransportationTypeEnum;
    incoterms?: IncotermsResponseOutDTO;
    childExpeditions?: LadenFactorExpeditionPreviewOutDTO[];
    parentExpedition?: LadenFactorExpeditionPreviewOutDTO;
    polandSent?: PolandSentOutDTO;
    huEkaerNumber?: string;
    roUitNumber?: string;
    utnCode?: string;
    trackingNumber?: string;
    volumeOfOrderEnabled: boolean;
    disableCarrierProgressTimeslots: boolean;
}

export interface LadenFactorExpeditionPreviewOutDTO {
    applicationId: string;
    expeditionId: string;
    customerId: string;
    expeditionStatus: ExpeditionStatusEnum;
    sumManipulationUnits: number;
    price?: number;
    currency?: string;
}

export interface ShipmentDetailNextAction {
    nextActionType: NextActionTypeEnum;
    loadingActionIsFinished?: boolean;
    unloadingActionIsFinished?: boolean;
    zipCode: string;
    country: string;
    locationId: string;
}

export interface SubscriberInfoOutDTO {
    subscriberUsers: SubscriberPersonOutDTO[];
    amISubscribed: boolean;
}

export interface SubscriberPersonOutDTO {
    id: string;
    name: string;
    initials: string;
}

export interface AddressDetailPlanOutDTO {
    city: string;
    streetNr: string;
    zipCode: string;
    country: string;
}

export interface ExpeditionDetailOutDTO {
    expeditionHeaderPreview: ExpeditionDetailTabPlanOutDTO;
    truckType?: TruckDetailPlanOutDTO;
    loadingTypes: LovWithoutIdDTO[];
    cargoType?: PreviewPlanOutLoV;
    adrWeight?: number;
    requirements: PreviewPlanOutLoV[];
    carrierNote?: string;
    locations: LocationDetailPlanOutDTO[];
    responsiblePerson: ResponsiblePersonPreviewOutDTO;
    nextLocationUnloadingAction?: ShipmentDetailNextAction;
    internalNote?: string;
}

export interface LocationDetailPlanOutDTO {
    id: string;
    name: string;
    address: AddressDetailPlanOutDTO;
    pickupCode?: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    loadedOrders: OrderDetailPlanOutDTO[];
    unloadedOrders: OrderDetailPlanOutDTO[];
    timeslots: GlobalTimeslots;
    enabledEmailNotificationForContactPerson: boolean;
    additionalNotificationContacts: BasicContactPerson[];
    contactType: ContactTypeEnum;
    locationId?: string;
    requirementCodes: string[];
    timezoneId?: string;
}

export interface PreviewPlanOutLoV {
    name: string;
    code: string;
}

export interface ResponsiblePersonPreviewOutDTO {
    id: string;
    name: string;
}

export interface TruckDetailPlanOutDTO {
    name: string;
    code: string;
    loadingCapacity?: number;
    loadingUnit?: string;
    length?: number;
    height?: number;
    width?: number;
    iconPath?: string;
}

export interface ExpeditionInternalInformationOutDTO {
    expeditionHeaderPreview: ExpeditionDetailTabPlanOutDTO;
    responsiblePerson: InternalInformationPersonOutDTO;
    subscribers: InternalInformationPersonOutDTO[];
    invoiceDetail: InternalInvoiceDetailOutDTO;
    internalNote?: string;
    pairingSymbol?: string;
}

export interface InternalInformationCompanyPartnerOutDTO {
    id: string;
    name: string;
}

export interface InternalInformationPersonOutDTO {
    id: string;
    name: string;
}

export interface InternalInvoiceDetailOutDTO {
    invoiceUser?: InternalInformationPersonOutDTO;
    invoiceState?: InvoiceStateEnum;
    invoiceRebillingType?: InvoiceRebillingTypeEnum;
    invoiceDepartment?: string;
    invoicePartner?: InternalInformationCompanyPartnerOutDTO;
    changedAt?: string;
    changedBy?: InternalInformationPersonOutDTO;
}

export interface AddMoreCarrierOutDTO {
    carriers: CarrierOrGroupOutDTO[];
}

export interface CarrierPageOutDTO {
    expeditionHeaderPreview: ExpeditionDetailTabPlanOutDTO;
    distributionType: DistributionTypeEnum;
    distributionCreatedAt: string;
    distributionCreatedByFullName: string;
    isDistributionExpired: boolean;
    assigning: ExpeditionDetailCarrierOutDTO;
}

export interface ExpeditionDetailCarrierOutDTO {
    /**
     * @deprecated Use utcEnd  and timezoneId instead
     */
    validTill: string;
    remainingTimeInHours: number;
    price?: number;
    currency?: string;
    createdByName: string;
    createdAt: string;
    quotes: QuotesPreviewOutDTO[];
    utcEnd?: string;
    timezoneId?: string;
}

export interface ExpeditionDetailCarrierQuotesFilter {
    carrierIds?: string[];
    emailStatuses?: EmailStatusesEnum[];
    demandPseudoStates?: DemandPseudoStatesEnum[];
}

export interface ExpeditionDetailCarrierQuotesResponseOutDTO {
    quotes: QuotesPreviewOutDTO[];
}

export interface AssignedCarrierLocationOutDTO {
    name: string;
    city: string;
    isComplete: boolean;
    completedAt?: string;
    loadingActionIsFinished?: boolean;
    loadingActionFinishedAt?: string;
    loadingActionFinishedAtUtc?: string;
    unloadingActionIsFinished?: boolean;
    unloadingActionFinishedAt?: string;
    unloadingActionFinishedAtUtc?: string;
    actionType: ActionTypeEnum;
    inTime: boolean;
    selectedTimeslot?: TimeSlotExpeditionDetailCarrierAssignedDTO;
}

export interface CarInfoOutDTO {
    carPlate?: string;
    driverName?: string;
}

export interface CarrierAssignedInfoOutDTO {
    id: string;
    name: string;
    phone?: string;
    carInfo?: CarInfoOutDTO;
    price: number;
    driverIsActiveOnExpedition: boolean;
    currency: string;
}

export interface CarrierPageAssignedOutDTO {
    expeditionHeaderPreview: ExpeditionDetailTabPlanOutDTO;
    distributionType: DistributionTypeEnum;
    distributionCreatedAt: string;
    distributionCreatedByFullName: string;
    isDistributionExpired: boolean;
    assigned: ExpeditionDetailCarrierAssignedOutDTO;
}

export interface ExpeditionDetailCarrierAssignedOutDTO {
    locations: AssignedCarrierLocationOutDTO[];
    assignedCarrierInfo: CarrierAssignedInfoOutDTO;
    quotes?: QuotesPreviewOutDTO[];
    extraCosts: ExtraCostsPreviewOutDTO[];
}

export interface TimeSlotExpeditionDetailCarrierAssignedDTO {
    id: string;
    isCarrier: boolean;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceInUTC: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    tillInUTC?: string;
    isNotSpecifiedTime: boolean;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface DistributionTemplateOutDTO {
    distributionId: string;
    name: string;
    distributionType: DistributionTypeEnum;
    intervalHour: number;
    price?: number;
    currency?: string;
    carriersAndGroups: CarrierOrGroupOutDTO[];
    shouldExpeditionAutomaticallyPublished?: boolean;
}

export interface TemplateCargoOutDTO {
    name?: string;
    width: number;
    height: number;
    length: number;
    weight: number;
    amount: number;
    quantityUnit: string;
    stackable: boolean;
    weightMode: WeightModeEnum;
    cargoTemplate?: CargoTemplateWithoutIdDTO;
    itemNote?: string;
}

export interface TemplateExpeditionOutDTO {
    templateName?: string;
    maxWeight: number;
    distance: number;
    expeditionType?: ExpeditionTypeEnum;
    truckType?: TruckTypeWithoutIdDTO;
    locations: TemplateLocationOutDTO[];
    note?: string;
    loadingTypes: LovWithoutIdDTO[];
    cargoType?: LovWithoutIdDTO;
    requirements?: LovWithoutIdDTO[];
    duplicatedFromExpeditionId?: string;
    templateExpeditionId?: string;
    responsiblePerson?: UserLovOutDTO;
    distributionTemplate?: DistributionTemplateOutDTO;
    subscribersList: LovDTO[];
    internalCustomerNote?: string;
    labels: LabelPreview[];
    fromSupplierNotificationId?: string;
    adrWeight?: number;
}

export interface TemplateLocationOrderOutDTO {
    id: string;
    orderName: string;
    loadingLocationId: string;
    loadingLocationIndex: number;
    unloadingLocationId: string;
    unloadingLocationIndex: number;
    items: TemplateCargoOutDTO[];
}

export interface TemplateLocationOutDTO {
    id: string;
    locationIndex: number;
    applicationId: string;
    name: string;
    country: string;
    postalCode: string;
    city: string;
    streetNr: string;
    timezoneId?: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    pickupCode?: string;
    loadedOrders?: TemplateLocationOrderOutDTO[];
    openingHourDefinitions?: OpeningHourDefinitionsDTO;
    fromAddressBookId?: string;
    companyLocationId?: string;
    locationNote?: string;
}

export interface EditDataTemplateNameOuDTO {
    templateName: string;
}

export interface EditDataLocationAndOrderOutDTO {
    locationId: string;
    templateExpeditionId: string;
    locationName: string;
    contactName?: string;
    contactEmail?: string;
    contactPhone?: string;
    pickupCode?: string;
    streetNr: string;
    country: string;
    zipCode: string;
    city: string;
    timezoneId?: string;
    orders?: EditTemplateLocationOrderOutDTO[];
    fromAddressBookId?: string;
    openingHourDefinitions?: OpeningHourDefinitionsDTO;
}

export interface EditTemplateLocationOrderOutDTO {
    id: string;
    orderName: string;
    items: TemplateCargoOutDTO[];
}

export interface EditTemplateInternalInformationOutDTO {
    subscribers?: UserPreview[];
    responsiblePerson?: UserPreview;
    internalNote?: string;
}

export interface UserPreview {
    userId: string;
    userFullName: string;
    companyId: string;
    companyName: string;
    initials: string;
    userEmail: string;
    userPhone: string;
}

export interface EditDataTemplateCarrierRequirementOutDTO {
    templateExpeditionId: string;
    expeditionType?: ExpeditionTypeEnum;
    truckType?: TruckDetailPlanOutDTO;
    loadingTypes: LoadingTypesEnum[];
    requirements?: PreviewPlanOutLoV[];
    cargoType?: PreviewPlanOutLoV;
    carrierNote?: string;
}

export interface CreatedByTemplateFiler {
    createdBy?: string;
    locationZipCode?: string;
    locationName?: string;
    templateName?: string;
}

export interface PageResponseTemplatePreviewOutDTO {
    data: TemplatePreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface TemplatePreviewOutDTO {
    id: string;
    name: string;
    createdAt: string;
    createdBy: string;
    expeditionType?: ExpeditionTypeEnum;
    cargoType?: string;
    truckType?: string;
    maxWeight?: number;
    isExpeditionTemplate: boolean;
    isDistributionTemplate: boolean;
    locations: string[];
    timezoneIds: string[];
}

export interface AddressOutDTO {
    streetNr: string;
    country: string;
    zipCode: string;
    city: string;
    timezoneId?: string;
}

export interface PageResponsePartnerPreviewOutDTO {
    data: PartnerPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface PartnerPreviewOutDTO {
    partnerId: string;
    name: string;
    address: AddressOutDTO;
    contactEmail?: string;
    crn?: string;
    createdAt: string;
}

export interface PartnerDetailOutDTO {
    partnerId: string;
    name: string;
    crn?: string;
    address: AddressOutDTO;
    contactPerson?: string;
    contactPhone?: string;
    contactEmail?: string;
    locations: PartnerLocationOutDTO[];
    isAllMigrated: boolean;
}

export interface PartnerLocationOutDTO {
    partnerLocationId: string;
    name: string;
    address: AddressOutDTO;
    contactEmail?: string;
    contactPhone?: string;
    contactName?: string;
    isTimeslotExists: boolean;
    migrateToCompanyLocationId?: string;
    timezoneId?: string;
}

export interface PartnerLocationDetailOutDTO {
    locationId: string;
    partnerId: string;
    name: string;
    streetNr: string;
    country: string;
    zipCode: string;
    city: string;
    timezoneId?: string;
    contactEmail?: string;
    contactPhone?: string;
    contactName?: string;
    openingHourDefinitions: OpeningHourDefinitionsDTO;
    contacts: BasicContactPerson[];
    migrateToCompanyLocationId?: string;
    locationNote?: string;
}

export interface CarrierListOutDTO {
    carrierId: string;
    name: string;
    address: AddressNullableOutDTO;
    crn: string;
    mainContact: string;
    createdAt: string;
}

export interface PageResponseCarrierListOutDTO {
    data: CarrierListOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CarrierContactPersonOutDTO {
    id: string;
    name?: string;
    phone?: string;
    email: string;
    isBlacklisted: boolean;
    carrierGroups: CatalogCarrierGroupNameOutDTO[];
}

export interface CatalogCarrierDetailOutDTO {
    carrierId: string;
    name: string;
    originalName?: string;
    crn: string;
    streetNr?: string;
    country: string;
    zipCode?: string;
    city?: string;
    timezoneId?: string;
    wwwPage?: string;
    contactPersons: CarrierContactPersonOutDTO[];
    exportCountries: string[];
    exportNote?: string;
    importCountries: string[];
    importNote?: string;
    cars: CatalogCarPreviewOutDTO[];
    isAlreadyAdded: boolean;
    hqLng?: number;
    hqLat?: number;
    contactPerson?: string;
    contactPhone?: string;
    contactEmail: string;
    isRegistered: boolean;
    isMyCarrier: boolean;
    labels: LabelPreview[];
    additionalInfo: CarrierDetailAdditionalInfoOutDTO[];
    companyModules: CompanyModuleForCarrierOutDTO[];
}

export interface CatalogCarrierGroupNameOutDTO {
    groupName: string;
}

export interface CarrierDetailGroupsOutDTO {
    carrierId: string;
    carrierGroupId: string;
    name: string;
    count: number;
    createdBy: string;
    createdAt: string;
}

export interface PageResponseCarrierDetailGroupsOutDTO {
    data: CarrierDetailGroupsOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CarrierCarrierGroupLov {
    groups: LovDTO[];
}

export interface CarrierSearchOutDTO {
    carrierId: string;
    name: string;
    streetNr?: string;
    country: string;
    zipCode?: string;
    city?: string;
    timezoneId?: string;
    contactEmail: string;
    crn: string;
    tin?: string;
    contactPerson?: string;
    contactPhone?: string;
    version: number;
}

export interface CarrierGroupListOutDTO {
    carrierGroupId: string;
    name: string;
    carriersCount: number;
    createdBy: string;
    createdAt: string;
}

export interface PageResponseCarrierGroupListOutDTO {
    data: CarrierGroupListOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CarrierGroupDetailOutDTO {
    carrierGroupId: string;
    carrierGroupName: string;
}

export interface CarrierCarrierGroupPreviewOutDTO {
    carrierGroupId: string;
    carrierId: string;
    carrierName: string;
    addAt: string;
    addBy: string;
}

export interface PageResponseCarrierCarrierGroupPreviewOutDTO {
    data: CarrierCarrierGroupPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CarriersForGroupLov {
    carriers: LovDTO[];
}

export interface UserCompanyOutDTO {
    id: string;
    companyName: string;
    crn: string;
    country: string;
    zipCode: string;
    city: string;
    streetNr: string;
    issueOrder: boolean;
    quickLinkEnabled: boolean;
    customerNamesWithSpecificUserIds?: string[];
    defaultTimezoneId: string;
}

export interface CompanyUsersFilter {
    firstName?: string;
    lastName?: string;
    email?: string;
    securityRoleIds?: string[];
    isRegistered?: boolean;
    isActive?: boolean;
}

export interface PageResponseUserCompanyUserPreviewOutDTO {
    data: UserCompanyUserPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface UserCompanyUserPreviewOutDTO {
    userId: string;
    fullName: string;
    email: string;
    phone: string;
    securityRoles: SecurityRoleOutDTO[];
    /**
     * @deprecated Legacy LogsteoUser.roles (dead-write); use securityRoles instead
     */
    roles: string[];
    isRegistered: boolean;
    isActive: boolean;
    isItMe: boolean;
    isVirtual: boolean;
    hasToken: boolean;
    departmentNames?: string[];
}

export interface SecurityUsageFilterInDTO {
    userId?: string;
    email?: string;
}

export interface GroupRefOutDTO {
    id: string;
    name: string;
}

export interface PermissionUsageOutDTO {
    permission: PermissionEnum;
    translateKeyName?: string;
    deprecated: boolean;
    roles: RoleRefOutDTO[];
    groups: GroupRefOutDTO[];
    userCount?: number;
}

export interface RoleRefOutDTO {
    id: string;
    name: string;
}

export interface RoleUsageOutDTO {
    id: string;
    name: string;
    groups: GroupRefOutDTO[];
}

export interface SecurityUsageOutDTO {
    permissions: PermissionUsageOutDTO[];
    roles: RoleUsageOutDTO[];
    groups: GroupRefOutDTO[];
}

export interface SecurityUsageUserFilterInDTO {
    permission?: PermissionEnum;
    roleId?: string;
    groupId?: string;
    email?: string;
    name?: string;
    active?: boolean;
    companyId?: string;
}

export interface PageResponseSecurityUsageUserOutDTO {
    data: SecurityUsageUserOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface SecurityUsageUserOutDTO {
    id: string;
    fullName?: string;
    email?: string;
    active: boolean;
    companyName?: string;
}

export interface CompanySecurityRolePreviewOutDTO {
    id: string;
    isGlobal: boolean;
    name: string;
    translateKey?: string;
    descriptionKey?: string;
    isPrivate: boolean;
    isOnlyInternal: boolean;
    permissionTypes: PermissionTypesEnum[];
    userCount: number;
    companyModules: CompanyModulesEnum[];
}

export interface CompanySecurityGroupPreviewOutDTO {
    id: string;
    isGlobal: boolean;
    name: string;
    roles: string[];
}

export interface AllQuoteStateFilter {
    pseudoState?: PseudoStateEnum;
    pseudoStates?: PseudoStatesEnum[];
    loadingDateFromISO?: string;
    loadingDateToISO?: string;
    unloadingDateFromISO?: string;
    unloadingDateToISO?: string;
    allTimeDateFromISO?: string;
    allTimeDateToISO?: string;
    locationName?: string;
    applicationId?: string;
    userTimezoneId: string;
}

export interface CarrierExpeditionStartOutDTO {
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    till?: string;
    showDates: boolean;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface LocationQuoteCarrierPreviewOutDTO {
    zipCode: string;
    country: string;
    city: string;
    locationName: string;
    timezoneId?: string;
}

export interface PageResponseQuotePreviewOutDTO {
    data: QuotePreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface QuotePreviewOutDTO {
    expeditionId: string;
    applicationId?: string;
    companyId: string;
    quoteId: string;
    price?: number;
    currency?: string;
    priceType: PriceTypeEnum;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    distributionValidTill?: string;
    utcEnd?: string;
    timezoneId?: string;
    isExpiredDistribution: boolean;
    distance: number;
    customerCompanyName: string;
    expeditionStatus: ExpeditionStatusEnum;
    lastExpeditionStatus: LastExpeditionStatusEnum;
    isManualExpedition: boolean;
    distributionType: DistributionTypeEnum;
    truckType?: string;
    maxWeight?: number;
    cargoType?: string;
    locations: LocationQuoteCarrierPreviewOutDTO[];
    expeditionType?: ExpeditionTypeEnum;
    carrierQuoteState?: CarrierQuoteStateEnum;
    customerQuoteState?: CustomerQuoteStateEnum;
    pseudoState: PseudoStateEnum;
    expeditionStart?: CarrierExpeditionStartOutDTO;
    extraCosts?: ExtraCostsListPreview[];
    note?: string;
}

export interface AllJobCarrierFilter {
    carrierExpeditionStatus?: CarrierExpeditionStatusEnum;
    applicationId?: string;
    carrierDispatcherIds?: string[];
    loadingDateFromISO?: string;
    loadingDateToISO?: string;
    unloadingDateFromISO?: string;
    unloadingDateToISO?: string;
    allTimeDateFromISO?: string;
    allTimeDateToISO?: string;
    locationName?: string;
    orderName?: string;
    driverIds?: string[];
    loadingCountryCode?: string;
    unloadingCountryCode?: string;
    customerCompanyId?: string;
    userTimezoneId: string;
    attachmentName?: string;
}

export interface JobAlertsOutDTO {
    hasSelectedTimeslots: boolean;
    hasSelectedTimeslotsOnStops: boolean;
    hasRequiredReservations: boolean;
}

export interface JobPreviewOutDTO {
    id: string;
    applicationId?: string;
    companyId: string;
    price: number;
    currency: string;
    expeditionStatus: ExpeditionStatusEnum;
    isManualExpedition: boolean;
    distributionType: DistributionTypeEnum;
    customerCompanyName: string;
    locations: LocationJobPreviewOutDTO[];
    expeditionType?: ExpeditionTypeEnum;
    carPlate?: string;
    dispatcherFullName?: string;
    lastExpeditionStatus: LastExpeditionStatusEnum;
    expeditionStart?: CarrierExpeditionStartOutDTO;
    isDriverCurrentlyActive: boolean;
    extraCosts?: ExtraCostsListPreview[];
    note?: string;
    carrierName?: string;
    labels: LabelPreview[];
    assignedDriver?: string;
    routes: JobRouteResponse[];
    isInvoiced: boolean;
    attachmentInfo?: ListAttachmentInfoOutDTO;
    createdDate?: string;
    lastModifiedDate?: string;
    jobAlerts: JobAlertsOutDTO;
    orders: OrderPreviewExpeditionListOutDTO[];
}

export interface JobRouteResponse {
    linkedReservation?: ReservationCoordinates;
}

export interface LocationJobPreviewOutDTO {
    zipCode: string;
    country: string;
    city: string;
    isCompleted: boolean;
    actionType: ActionTypeEnum;
    timeslots: TimeSlotDTO[];
    globalTimeslots: GlobalTimeslots;
    locationName: string;
    timezoneId?: string;
    /**
     * @deprecated Use completedAtUtc instead
     */
    completedAt?: string;
    completedAtUtc?: string;
}

export interface PageResponseJobPreviewOutDTO {
    data: JobPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface TimeSlotDTO {
    /**
     * @deprecated Use utcStart instead
     */
    sinceInUTC: string;
    /**
     * @deprecated Use utcEnd instead
     */
    tillInUTC?: string;
    isNotSpecifiedTime: boolean;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface CargoDetailQuoteDemandOutDTO {
    name: string;
    width?: number;
    height?: number;
    length?: number;
    weight?: number;
    amount: number;
    quantityUnit: string;
    stackable: boolean;
    itemNote?: string;
    manipulationUnitInfo?: GlobalOrderItemInfoDetailOutDTO[];
}

export interface CargoQuoteDemandOutDTO {
    name: string;
    amount: number;
    quantityUnit: string;
    weight?: number;
    stackable: boolean;
    itemNote?: string;
}

export interface CarrierQuoteSettingsOutDTO {
    enforcePhoneNumber: boolean;
    quoteValidTillReadOnly: boolean;
    carrierQuoteValidTillDefaultInHours?: number;
    volumeOfOrderEnabled: boolean;
    quoteValidTillVisible: boolean;
    disableCarrierQuoteTimeslots: boolean;
}

export interface CustomerQuoteDetailOutDTO {
    name: string;
    streetNr: string;
    zipCode: string;
    country: string;
    city: string;
    tin: string;
    crn: string;
}

export interface LoadedOrderQuoteDemandOutDTO {
    orderName: string;
    totalWeight: number;
    totalVolume: number;
    items: CargoDetailQuoteDemandOutDTO[];
}

export interface LocationQuoteDemandOutDTO {
    locationName: string;
    streetNr: string;
    zipCode: string;
    city: string;
    country: string;
    loadedOrderCargo: CargoDetailQuoteDemandOutDTO[];
    unloadedOrderCargo: CargoDetailQuoteDemandOutDTO[];
    loadingActionIsFinished?: boolean;
    unloadingActionIsFinished?: boolean;
    loadedOrders: LoadedOrderQuoteDemandOutDTO[];
    unloadedOrders: LoadedOrderQuoteDemandOutDTO[];
    requirementCodes: string[];
    timezoneId?: string;
}

export interface LocationTimeslotQuoteDemandOutDTO {
    locationId: string;
    locationName: string;
    streetNr: string;
    zipCode: string;
    city: string;
    country: string;
    timeslots: TimeSlotQuoteDemandOutDTO[];
}

export interface MyQuoteInfoOutDTO {
    myQuotePrice?: number;
    myQuoteCurrency?: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    myQuoteValidTill?: string;
    utcEnd?: string;
    timezoneId?: string;
    myQuoteIsExpired: boolean;
    /**
     * @deprecated Use rejectedAtUtcByCustomer and timezoneId instead
     */
    rejectedAtByCustomer?: string;
    rejectedAtUtcByCustomer?: string;
    rejectedByByCustomerFullName?: string;
    rejectedMessageByCustomer?: string;
    myQuoteManipulationUnits?: number;
}

export interface QuoteDetailOutDTO {
    quoteId: string;
    companyId: string;
    applicationId: string;
    expeditionId: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    distributionValidTill: string;
    utcEnd?: string;
    timezoneId?: string;
    userTimezoneId?: string;
    distance: number;
    expeditionType?: ExpeditionTypeEnum;
    distributionType: DistributionTypeEnum;
    carrierQuoteState?: CarrierQuoteStateEnum;
    customerQuoteState?: CustomerQuoteStateEnum;
    isDistributionExpired: boolean;
    isExpeditionCanceled: boolean;
    cargoType?: string;
    truckType?: string;
    maxWeight: number;
    carrierNote?: string;
    price?: number;
    currency?: string;
    loadingTypes: LoadingTypesEnum[];
    timeslots: LocationTimeslotQuoteDemandOutDTO[];
    requirements: string[];
    customer: CustomerQuoteDetailOutDTO;
    items: CargoQuoteDemandOutDTO[];
    locations: LocationQuoteDemandOutDTO[];
    responsiblePerson: ResponsiblePersonQuoteDemandOutDTO;
    messages: CountMessagesCarrierOutV3DTO;
    myQuoteInfo: MyQuoteInfoOutDTO;
    isAssignedToAnotherCarrier: boolean;
    isManualExpedition: boolean;
    lastExpeditionStatus: LastExpeditionStatusEnum;
    /**
     * @deprecated Use reconfirmedAtUtc and timezoneId instead
     */
    reconfirmedAt?: string;
    reconfirmedAtUtc?: string;
    isReconfirmedByCarrier?: boolean;
    handlingUnitCount?: number;
    ladenFactor?: number;
    allowPartialDelivery: boolean;
    currencyLockType: CurrencyLockTypeEnum;
    transportationType?: TransportationTypeEnum;
    incoterms?: IncotermsResponseOutDTO;
    note?: string;
    transportLegs: QuoteDemandTransportLegOutDTO[];
    distributionCreatedAt: string;
    adrWeight?: number;
    childExpeditions?: LadenFactorExpeditionPreviewOutDTO[];
    parentExpedition?: LadenFactorExpeditionPreviewOutDTO;
    remainingManipulationUnits?: number;
    /**
     * @deprecated Use carrierQuoteSettings.enforcePhoneNumber instead. Kept for backward compatibility can be removed in upcoming releases.
     */
    enforcePhoneNumber?: boolean;
    tiebreaker?: TiebreakerInfoOutDTO;
    carrierQuoteSettings: CarrierQuoteSettingsOutDTO;
}

export interface ResponsiblePersonQuoteDemandOutDTO {
    id: string;
    fullName: string;
}

export interface TimeSlotQuoteDemandOutDTO {
    id: string;
    isCarrier: boolean;
    isSelected: boolean;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceInUTC: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    tillInUTC?: string;
    isNotSpecifiedTime: boolean;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
    selected?: boolean;
}

export interface CustomerDetailJobProgressOutDTO {
    id: string;
    zipCode: string;
    city: string;
    name: string;
    country: string;
    streetNr: string;
    crn: string;
    tin: string;
}

export interface JobProgressFormDataOutDTO {
    expeditionHeaderPreview: ExpeditionDetailTabPlanOutDTO;
    locations: LocationsJobProgressOutDTO[];
    customerDetail: CustomerDetailJobProgressOutDTO;
    responsiblePersonName: string;
    agreedPrice: number;
    currency: string;
    extraCosts: ExtraCostsPreviewOutDTO[];
    isReconfirmedNeeded: boolean;
    /**
     * @deprecated Use reconfirmedAtUtc and timezoneId instead
     */
    reconfirmedAt?: string;
    reconfirmedAtUtc?: string;
    timezoneId?: string;
    isReconfirmedByCarrier?: boolean;
    carrierNote?: string;
    carPlate?: string;
    dispatcherId?: string;
    driverId?: string;
}

export interface LocationsJobProgressOutDTO {
    id: string;
    zipCode: string;
    city: string;
    name: string;
    country: string;
    isCompleted: boolean;
    timeslots: TimeSlotProgressTabDTO[];
    linkedReservation?: ReservationCoordinates;
    companyLocationId?: string;
    companyLocationCustomerId?: string;
    timezoneId?: string;
}

export interface TimeSlotProgressTabDTO {
    id: string;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceInUTC: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    tillInUTC?: string;
    isNotSpecifiedTime: boolean;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface EditTimeslotCarrierOutDTO {
    locations: LocationsEditJobProgressOutDTO[];
}

export interface LocationsEditJobProgressOutDTO {
    id: string;
    zipCode: string;
    city: string;
    name: string;
    country: string;
    isCompleted: boolean;
    timeslots: TimeSlotExpeditionShipmentPageR2SDTO[];
    timezoneId?: string;
}

export interface TimeSlotExpeditionShipmentPageR2SDTO {
    id: string;
    isCarrier: boolean;
    isSelected: boolean;
    /**
     * @deprecated Use utcStart and timezoneId instead
     */
    sinceInUTC: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    tillInUTC?: string;
    isNotSpecifiedTime: boolean;
    utcStart?: string;
    utcEnd?: string;
    timezoneId?: string;
    selected?: boolean;
}

export interface CarInfoShipmentPageR2SOutDTO {
    carPlate?: string;
    driverName?: string;
    driverId?: string;
    dispatcherId?: string;
    dispatcherName?: string;
}

export interface CustomerShipmentPageR2SOutDTO {
    id: string;
    name: string;
    streetNr: string;
    country: string;
    city: string;
    zipCode: string;
    phone: string;
    price: number;
    currency: string;
    responsiblePersonFullName: string;
}

export interface ShipmentPageR2SLocationOutDTO {
    locationId: string;
    name: string;
    city: string;
    country: string;
    zipCode: string;
    isComplete: boolean;
    completedAt?: string;
    loadingActionIsFinished?: boolean;
    loadingActionFinishedAt?: string;
    loadingActionFinishedAtUtc?: string;
    unloadingActionIsFinished?: boolean;
    unloadingActionFinishedAt?: string;
    unloadingActionFinishedAtUtc?: string;
    actionType: ActionTypeEnum;
    inTime: boolean;
    selectedTimeslots: TimeSlotExpeditionShipmentPageR2SDTO[];
    linkedReservation?: ReservationCoordinates;
    companyLocationId?: string;
    companyLocationCustomerId?: string;
    timezoneId?: string;
}

export interface ShipmentPageR2SOutDTO {
    expeditionHeaderPreview: ExpeditionDetailTabPlanOutDTO;
    distributionType: DistributionTypeEnum;
    distributionCreatedAt: string;
    distributionCreatedByFullName: string;
    isDistributionExpired: boolean;
    locations: ShipmentPageR2SLocationOutDTO[];
    customerInfo: CustomerShipmentPageR2SOutDTO;
    carInfo?: CarInfoShipmentPageR2SOutDTO;
    extraCosts: ExtraCostsPreviewOutDTO[];
    carrierQuoteState?: CarrierQuoteStateEnum;
    customerQuoteState?: CustomerQuoteStateEnum;
    /**
     * @deprecated Use reconfirmedAtUtc instead
     */
    reconfirmedAt?: string;
    reconfirmedAtUtc?: string;
    isReconfirmedByCarrier?: boolean;
    driverIsActiveOnExpedition: boolean;
    carrierNote?: string;
}

export interface JobDetailOutDTO {
    expeditionHeaderPreview: ExpeditionDetailTabPlanOutDTO;
    truckType?: TruckDetailPlanOutDTO;
    loadingTypes: LoadingTypesEnum[];
    cargoType?: PreviewPlanOutLoV;
    requirements: PreviewPlanOutLoV[];
    maxWeight: number;
    carrierNote?: string;
    locations: LocationDetailPlanOutDTO[];
}

export interface LovWithoutIdWithFillingDataDTO {
    name: string;
    code: string;
    isSelected: boolean;
    isDisabled: boolean;
}

export interface AdminModuleAllNotInheritedPreviewOutDTO {
    companyModule: CompanyModuleEnum;
    isActive: boolean;
}

export interface InheritedModuleOutDTO {
    companyId: string;
    companyName: string;
    inheritedFromCompanyId: string;
    inheritedFromCompanyName: string;
    moduleName: string;
}

export interface AdminModuleInheritingPreviewDTO {
    companyId: string;
    companyName: string;
    companyModule: CompanyModuleEnum;
}

export interface AdminModuleAllInheritedPreviewOutDTO {
    parentCompanyId: string;
    inheritedCompanyId: string;
    companyModule: CompanyModuleEnum;
    isActive: boolean;
}

export interface LovCompanyDTO {
    id: string;
    name: string;
}

export interface DashboardBuildMetaDTO {
    status?: string;
    startedAt?: string;
    finishedAt?: string;
    durationMs?: number;
    lastBuildAt?: string;
    shipmentRows?: number;
    savingsRows?: number;
    reservationRows?: number;
    supplierNotificationRows?: number;
    rampDayRows?: number;
}

export interface AdminCompanyNotificationEnablingOutDTO {
    emailType: EmailTypeEnum;
    isEnabled: boolean;
}

export interface WorkflowPossibleTransitionOutDTO {
    workflowId: string;
    workflowName: string;
    currentState: string;
    possibleTransitions: WorkflowTransitionOutDTO[];
}

export interface WorkflowTransitionOutDTO {
    to: State;
    actionName: string;
}

export interface WorkflowEntityIsManagedOutDTO {
    isManagedByWF: boolean;
}

export interface ArrivalDepartureListResponseOutDTO {
    date?: string;
    time?: string;
    expected: boolean;
}

export interface PageResponseVisitorRecordListInnerResponseOutDTO {
    data: VisitorRecordListInnerResponseOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface VisitorGuestResponseOutDTO {
    id: string;
    name?: string;
    visitorId?: string;
}

export interface VisitorRecordGroupedFilterDTO {
    locations: LovDTO[];
    responsiblePersons: LovDTO[];
    statuses: string[];
}

export interface VisitorRecordListInnerResponseOutDTO {
    id: string;
    applicationId: string;
    visitorId?: string;
    visitorName?: string;
    visitorCompany?: string;
    locationName?: string;
    responsiblePersonName?: string;
    status?: State;
    note?: string;
    carPlate?: string;
    arrival?: ArrivalDepartureListResponseOutDTO;
    departure?: ArrivalDepartureListResponseOutDTO;
    labels: LabelPreview[];
    additionalContacts?: VisitorGuestResponseOutDTO[];
}

export interface VisitorRecordListResponseOutDTO {
    page: PageResponseVisitorRecordListInnerResponseOutDTO;
    archivedCount: number;
    groupedFilters: VisitorRecordGroupedFilterDTO;
}

export interface VisitorCarResponseOutDTO {
    carPlate?: string;
    expectedArrivalDate?: string;
    expectedArrivalTime?: string;
    durationMinutes?: number;
}

export interface VisitorRecordDetailOutDTO {
    id: string;
    applicationId: string;
    locationId?: string;
    locationName?: string;
    responsiblePersonId?: string;
    responsiblePersonName?: string;
    visitorName?: string;
    visitorId?: string;
    visitorCompany?: string;
    car?: VisitorCarResponseOutDTO;
    note?: string;
    otherGuests?: VisitorGuestResponseOutDTO[];
    actualArrivalDate?: string;
    actualDepartureDate?: string;
    isArchived: boolean;
    createdBy: string;
    createdDate: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    labels: LabelPreview[];
    state?: State;
}

export interface GroupDemandPreviewOutDTO {
    groupDemandName: string;
    groupDemandId: string;
    state: StateEnum;
    isValid?: boolean;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill?: string;
    assignedCarriersCount?: number;
    repliedCarriersCount?: number;
    utcEnd?: string;
    timezoneId?: string;
}

export interface ListSnCargoPreviewOutDTO {
    name: string;
    code: string;
    amount: number;
}

export interface ListSupplierNotificationPreviewOutDTO {
    id: string;
    version: number;
    applicationId: string;
    customerName: string;
    supplierName: string;
    supplierCompanyId: string;
    customerLocationName: string;
    customerLocationCity: string;
    customerLocationCountry: string;
    supplierLocationName: string;
    supplierLocationCountry: string;
    supplierLocationCity: string;
    expeditionCreated?: SNExpeditionCreatedPreviewOutDTO;
    mergedToExpedition?: SNExpeditionCreatedPreviewOutDTO;
    groupDemandCreated?: GroupDemandPreviewOutDTO;
    customerDeliverySlots: GlobalTimeslots;
    supplierDeliverySlots: GlobalTimeslots;
    responsiblePersonName?: string;
    isArchived: boolean;
    shipmentStateCode?: ShipmentStateCodeEnum;
    shipmentStateName?: string;
    distance: number;
    labels: LabelPreview[];
    entityOwnerCompanyId: string;
    internalNote?: string;
    supplierNotificationType: SupplierNotificationTypeEnum;
    shipmentNumber?: string;
    supplierNotificationStatus: SupplierNotificationStatusEnum;
    partnerCompanyNote?: string;
    attachmentInfo: ListAttachmentInfoOutDTO;
    cargo: ListSnCargoPreviewOutDTO[];
}

export interface SNExpeditionCreatedPreviewOutDTO {
    expeditionId: string;
    expeditionApplicationId: string;
}

export interface SupplierNotificationGroupedFilterDTO {
    supplierLocationCountries: LovWithoutIdDTO[];
    responsiblePersons: LovDTO[];
    customers: LovDTO[];
    suppliers: LovDTO[];
    labels: LabelPreviewWithTypeOutDTO[];
    folders: LovDTO[];
    supplierNotificationType: SupplierNotificationTypeEnum[];
}

export interface SupplierNotificationListOutDTO {
    data: ListSupplierNotificationPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
    groupedFilter: SupplierNotificationGroupedFilterDTO;
}

export interface CargoTypeInnerOutLoV {
    cargoTypeName: string;
    cargoTypeCode: string;
}

export interface CargoTypeOutDTO {
    cargoType: CargoTypeInnerOutLoV;
    adrWeight?: number;
}

export interface ContainerInfoOutDTO {
    containerInfoCode: ContainerInfoCodeEnum;
    containerInfoName: string;
    containerId: string;
}

export interface DetailSupplierNotificationOutDTO {
    id: string;
    version: number;
    applicationId: string;
    createdBy: UserLovOutDTO;
    customerCompany: LovDTO;
    carrierCompany: LovDTO;
    createdAt: string;
    updatedAt: string;
    updatedBy: UserLovOutDTO;
    cargoType?: CargoTypeOutDTO;
    containerInfo?: ContainerInfoOutDTO;
    shipmentStateCode?: ShipmentStateCodeEnum;
    shipmentStateName?: string;
    customsTypeCode?: CustomsTypeCodeEnum;
    customsTypeName?: string;
    referralCode?: string;
    /**
     * @deprecated mirrored from the active CMR/BL/AWB number
     */
    shipmentId?: string;
    cmrNumber?: string;
    blNumber?: string;
    awbNumber?: string;
    internalInvoiceNumber?: string;
    invoiceDueDate?: string;
    deliveryConditionsIncotermCode?: string;
    orders: GlobalOrderResponse[];
    customerLocation: SupplierNotificationLocationInfoOutDTO;
    supplierLocation: SupplierNotificationLocationInfoOutDTO;
    specialRequirements: PreviewPlanOutLoV[];
    attachments: AttachmentUploadedOutDTO[];
    notifyData: NotificationEntityInfoOutDTO;
    previousShipment?: SNPreviousShipmentOutDTO;
    expeditionCreated?: SNExpeditionCreatedPreviewOutDTO;
    mergedToExpedition?: SNExpeditionCreatedPreviewOutDTO;
    groupDemandCreated?: GroupDemandPreviewOutDTO;
    totalWeight: number;
    transportationTypeCode: LovTransportationTypeOutDTO;
    isArchived: boolean;
    distance: number;
    orderValue: CurrencyOrderValue;
    entityOwnerCompanyId: string;
    internalNote?: string;
    customerOpeningHourDefinitions: OpeningHourDefinitionsDTO;
    supplierOpeningHourDefinitions: OpeningHourDefinitionsDTO;
    note?: string;
    customerDeliverySlots: GlobalTimeslots;
    supplierDeliverySlots: GlobalTimeslots;
    supplierNotificationStatus: SupplierNotificationStatusEnum;
    counterPartyNotifyPersons: LovDTO[];
    folders: DetailExpeditionFolderResponseOutDTO[];
}

export interface NotificationEntityInfoOutDTO {
    responsiblePerson?: LovDTO;
    usersToNotify: LovDTO[];
    notifyUsersDependsOnRole: boolean;
}

export interface SNPreviousShipmentOutDTO {
    id: string;
    shipmentApplicationId: string;
    shipmentTransportationTypeCode: string;
    shipmentAWBId?: string;
    arrivalAt: string;
    departureAt: string;
    shipmentCustomerCompany: LovDTO;
    shipmentSupplierCompany: LovDTO;
    customerLocation: SupplierNotificationLocationInfoOutDTO;
    supplierLocation: SupplierNotificationLocationInfoOutDTO;
}

export interface SupplierNotificationLocationInfoOutDTO {
    country: string;
    locationId?: string;
    zipCode: string;
    city: string;
    streetNr: string;
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
    locationName?: string;
    timezoneId?: string;
}

export interface InternalInfoData {
    internalInvoiceNumber?: string;
    invoiceDueDate?: string;
    deliveryConditionsIncotermCode?: string;
}

export interface LabelPreviewWithoutTypeOutDTO {
    labelValue: string;
    labelColor: string;
    labelId: string;
}

export interface LovCompanyLocationWithOpeningHours {
    id: string;
    name: string;
    isInherited: boolean;
    inheritedFromCompanyId: string;
    inheritedFromCompanyName: string;
    openingHourDefinitions: OpeningHourDefinitionsDTO;
    countryCode3: string;
    timezoneId?: string;
    isDeleted: boolean;
}

export interface SupplierNotificationDataForSNOutDTO {
    attachmentsData: AttachmentUploadedOutDTO[];
    transportationType: TransportationTypeEnum;
    cargoType: CargoTypeOutDTO;
    containerInfo?: ContainerInfoInDTO;
    customsTypeCode?: string;
    referralCode?: string;
    orders: GlobalOrderResponse[];
    specialRequirementCodes: string[];
    internalNote?: string;
    customerId: string;
    supplierId: string;
    customerLocationId: string;
    supplierLocationId: string;
    notifyData: NotificationEntityInfoOutDTO;
    internalInfoData?: InternalInfoData;
    shipmentId?: string;
    cmrNumber?: string;
    blNumber?: string;
    awbNumber?: string;
    customerLocation?: LovCompanyLocationWithOpeningHours;
    supplierLocation?: LovCompanyLocationWithOpeningHours;
    shipmentStateCode?: ShipmentStateCodeEnum;
    labels: LabelPreviewWithoutTypeOutDTO[];
}

export interface ShipmentListFilter {
    arrivalAt?: string;
    departureAt?: string;
    showArchived?: boolean;
    awbNumber?: string;
    userTimezoneId: string;
}

export interface GroupDemandCreatedPreviewOutDTO {
    groupDemandId: string;
    groupDemandName: string;
}

export interface ListShipmentPreviewOutDTO {
    id: string;
    version: number;
    applicationId: string;
    unloadingCompanyName: string;
    loadingCompanyName: string;
    unloadingLocationName: string;
    loadingLocationName: string;
    arrivalAt: string;
    departureAt: string;
    arrivalAtUtc?: string;
    departureAtUtc?: string;
    loadingTimezoneId?: string;
    unloadingTimezoneId?: string;
    supplierNotificationCreated?: SupplierNotificationCreatedPreviewOutDTO;
    groupDemandCreated?: GroupDemandCreatedPreviewOutDTO;
    isArchived: boolean;
    labels: LabelPreview[];
    entityOwnerCompanyId: string;
    awbNumber?: string;
}

export interface PageResponseListShipmentPreviewOutDTO {
    data: ListShipmentPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface SupplierNotificationCreatedPreviewOutDTO {
    supplierNotificationId: string;
    supplierNotificationApplicationId: string;
}

export interface CargoItemType {
    code: string;
    name: string;
}

export interface DetailShipmentOutDTO {
    id: string;
    version: number;
    applicationId: string;
    createdBy: UserLovOutDTO;
    unloadingCompany: LovDTO;
    loadingCompany: LovDTO;
    createdAt: string;
    updatedAt: string;
    updatedBy: UserLovOutDTO;
    cargoType?: CargoTypeOutDTO;
    containerInfo?: ContainerInfoOutDTO;
    customsTypeCode: CustomsTypeCodeEnum;
    customsTypeName: string;
    referralCode?: string;
    shipmentId?: string;
    orders: ShipmentOrderOutDTO[];
    unloadingAddress: SupplierNotificationLocationInfoOutDTO;
    loadingAddress: SupplierNotificationLocationInfoOutDTO;
    specialRequirements: PreviewPlanOutLoV[];
    attachments: AttachmentUploadedOutDTO[];
    notifyData: NotificationEntityInfoOutDTO;
    supplierNotificationCreated?: SupplierNotificationCreatedPreviewOutDTO;
    totalWeight: number;
    transportationTypeCode: LovTransportationTypeOutDTO;
    /**
     * @deprecated Use departureAtUtc instead
     */
    departureAt: string;
    /**
     * @deprecated Use arrivalAtUtc instead
     */
    arrivalAt: string;
    departureAtUtc?: string;
    arrivalAtUtc?: string;
    isArchived: boolean;
    orderValue: CurrencyOrderValue;
    entityOwnerCompanyId: string;
}

export interface ShipmentItemOutDTO {
    cargoItemType: CargoItemType;
    height?: number;
    length?: number;
    weight?: number;
    width?: number;
    amount: number;
    quantityUnitCode: string;
}

export interface ShipmentOrderOutDTO {
    id: string;
    items: ShipmentItemOutDTO[];
    orderName: string;
    orderValue?: CurrencyOrderValue;
    weight: WeightOutDTO;
    orderAmount?: number;
    orderDescription?: string;
}

export interface ShipmentDataForSNOrderInDTO {
    orderName: string;
    items: SupplierNotificationItemInDTO[];
    orderValue?: CurrencyOrderValueInDTO;
    weight: WeightOutDTO;
    orderAmount?: number;
    orderDescription?: string;
}

export interface ShipmentDataForSNOutDTO {
    attachmentsData: AttachmentUploadedOutDTO[];
    transportationType: TransportationTypeEnum;
    cargoType: CargoTypeOutDTO;
    containerInfo?: ContainerInfoInDTO;
    customsTypeCode: string;
    referralCode?: string;
    orders: ShipmentDataForSNOrderInDTO[];
    specialRequirementIds: string[];
    fromShipmentId: string;
    shipmentApplicationId: string;
    shipmentId?: string;
}

export interface SupplierNotificationItemInDTO {
    stackable?: boolean;
    cargoItemTypeCode: string;
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
    amount: number;
    quantityUnitCode: string;
}

export interface CoordinatesMapDTO {
    lat: number;
    lng: number;
}

export interface MapDataOutDTO {
    mapRoutePolyline: string[];
    coordinates: CoordinatesMapDTO[];
}

export interface CoordinatesMapWithTimeDTO {
    lat: number;
    lng: number;
    createdAt: string;
}

export interface MapDataLastTruckPosition {
    driverId?: string;
    driverFullName?: string;
    lastPosition?: CoordinatesMapWithTimeDTO;
}

export interface CustomerGroupDemandFilter {
    applicationId?: string;
    groupDemandName?: string;
    groupDemandState?: GroupDemandStateEnum[];
    createdByUserName?: string;
    supplierNotificationApplicationId?: string;
    supplierIds?: string[];
    supplierLocationCountry?: string;
}

export interface GroupDemandListPreviewOutDTO {
    groupDemandId: string;
    groupDemandName: string;
    groupDemandApplicationId: string;
    supplierNotifications: GroupDemandSupplierNotificationPreviewOutDTO[];
    state: StateEnum;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill?: string;
    createdByUserName: string;
    isValid?: boolean;
    sumFinalPrice?: Price;
    percentOfOrder?: number;
    assignedCarriersCount?: number;
    repliedCarriersCount?: number;
    goodsTotalValue: CurrencyOrderValue;
    utcEnd?: string;
    timezoneId?: string;
}

export interface GroupDemandSupplierNotificationPreviewOutDTO {
    supplierNotificationId: string;
    supplierNotificationApplicationId: string;
    supplierId?: string;
    supplierName?: string;
    supplierLocationCountry?: string;
    handlingUnitsCount?: number;
    totalWeight?: number;
    internalNote?: string;
}

export interface PageResponseGroupDemandListPreviewOutDTO {
    data: GroupDemandListPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CarrierQuoteDemandOutDTO {
    quoteSnId?: string;
    offerId?: string;
    carrierId: string;
    carrierName: string;
    isNotInterested?: boolean;
    price?: PriceCurrencyDTO;
    referencePrice?: PriceCurrencyDTO;
    percentOfOrder?: number;
    isMin: boolean;
    additionalTerms: LovCompanyAdditionalTermsOutDTO[];
    min?: boolean;
}

export interface CarrierWithSumPriceTableHeaderOutDTO {
    carrierName: string;
    carrierSumPrice?: PriceDTO;
}

export interface GroupDemandDetailCompleteViewOutDTO {
    alwaysShowState: GroupDemandDetailOutDTO;
    finishedState?: GroupDemandDetailFinishedStateOutDTO;
}

export interface GroupDemandDetailFinishedStateOutDTO {
    groupDemandId: string;
    groupDemandName: string;
    groupDemandApplicationId: string;
    supplierNotificationRowsWithDemands: SupplierNotificationFinishedStateRowOutDTO[];
    sumPrice: PriceDTO;
    sumPercentOfOrder?: number;
    carrierAmount: number;
    state: StateEnum;
}

export interface GroupDemandDetailOutDTO {
    groupDemandId: string;
    groupDemandName: string;
    groupDemandApplicationId: string;
    supplierNotificationRowsWithDemands: SupplierNotificationRowOutDTO[];
    isDistributionExists: boolean;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill?: string;
    carriersHeader?: string[];
    carriersHeaderWithSumPrice?: CarrierWithSumPriceTableHeaderOutDTO[];
    state: StateEnum;
    sumPrice?: PriceDTO;
    sumPercentOfOrder?: number;
    utcEnd?: string;
    timezoneId?: string;
}

export interface LovCompanyAdditionalTermsOutDTO {
    id: string;
    name: string;
    isMandatory: boolean;
}

export interface PriceCurrencyDTO {
    price?: number;
    currency?: string;
}

export interface SupplierNotificationFinishedStateRowOutDTO {
    snId: string;
    snApplicationId: string;
    specialRequirements: PreviewPlanOutLoV[];
    snCompanyName: string;
    loadingFromTime?: string;
    loadingToTime?: string;
    loadingPlaceName?: string;
    carrierId: string;
    carrierName: string;
    price: PriceCurrencyDTO;
    originalPrice: PriceCurrencyDTO;
    percentOfOrder?: number;
    expeditionId: string;
    expeditionApplicationId: string;
    loadingTimezoneId?: string;
}

export interface SupplierNotificationRowOutDTO {
    snId: string;
    snApplicationId: string;
    snCompanyName: string;
    loadingFromTime?: string;
    loadingToTime?: string;
    loadingPlaceName?: string;
    carriersQuotes: CarrierQuoteDemandOutDTO[];
    specialRequirements: PreviewPlanOutLoV[];
    orderValue: CurrencyOrderValue;
    loadingTimezoneId?: string;
}

export interface AttachmentSendDataEmailOutDTO {
    attachments: AttachmentSendDataInnerOutDTO[];
    titleName: string;
    messageBody: string;
}

export interface AttachmentSendDataInnerOutDTO {
    attachmentId: string;
    name: string;
    accessType: AccessTypeEnum;
}

export interface PropertyWithSubProperties {
    name: string;
    type: string;
    classMapper?: string;
    multiple: boolean;
    valuesFunction?: string;
    i18n: boolean;
    aspects: string[];
    innerProperty: PropertyWithSubProperties[];
    definedInModel: string;
    required: boolean;
    additionalPrefix?: string;
}

export interface ConsigneeTasksDTO {
    hasExpeditionModule: boolean;
    hasReservationModule: boolean;
    hasSupplierNotificationModule: boolean;
    expeditions?: ExpeditionTaskCounts;
    reservations?: ReservationTaskCounts;
    notificationsWithoutExpedition?: number;
}

export interface ExpeditionTaskCounts {
    new: number;
    assigned: number;
    assigning: number;
    waitingForDocuments: number;
    inProgress: number;
    active: number;
}

export interface ReservationTaskCounts {
    openYesterday: number;
    openToday: number;
    openTomorrow: number;
}

export interface CarrierTasksDTO {
    visible: boolean;
    openSingleDemands: number;
    openGroupDemands: number;
    expeditionsWaitingForDocuments: number;
    expeditionsInProgress: number;
    expeditionsActive: number;
}

export interface CountTimeBucketDTO {
    bucket: string;
    count: number;
}

export interface DistributionBucketDTO {
    label: string;
    count: number;
}

export interface KpiDTO {
    current?: number;
    previous?: number;
    changePct?: number;
}

export interface SupplierNotificationStatisticsDTO {
    currency: string;
    totalNotifications: KpiDTO;
    timeToExpeditionMinutes?: KpiDTO;
    relatedPrice?: KpiDTO;
    overTime: CountTimeBucketDTO[];
    timeToExpeditionDistribution?: DistributionBucketDTO[];
}

export interface NotificationPartnerRowDTO {
    partnerId?: string;
    partnerName?: string;
    notifications: number;
    totalRelatedPrice: number;
}

export interface MoneyTimeBucketDTO {
    bucket: string;
    originalCost: number;
    extraCost: number;
    count: number;
}

export interface ShipmentStatisticsDTO {
    currency: string;
    totalShipments: KpiDTO;
    totalCosts: KpiDTO;
    extraCosts: KpiDTO;
    savings?: KpiDTO;
    overTime: MoneyTimeBucketDTO[];
}

export interface ShipmentTopRowDTO {
    companyId?: string;
    companyName?: string;
    shipments: number;
    totalCosts: number;
    extraCosts: number;
    pricePerKm?: number;
    pricePerUnit?: number;
}

export interface ReservationStatisticsDTO {
    totalReservations: KpiDTO;
    scheduledTimeMinutes: KpiDTO;
    actualHandlingTimeMinutes?: KpiDTO;
    rampUtilization?: KpiDTO;
    finishedPct?: KpiDTO;
    overTime: ReservationTimeBucketDTO[];
    scheduledTimeDistribution: DistributionBucketDTO[];
    actualTimeDistribution?: DistributionBucketDTO[];
}

export interface ReservationTimeBucketDTO {
    bucket: string;
    count: number;
    avgScheduledMinutes?: number;
    avgActualMinutes?: number;
}

export interface ReservationLocationRowDTO {
    locationId?: string;
    locationName?: string;
    rampId?: string;
    rampName?: string;
    reservations: number;
    avgScheduledMinutes?: number;
    avgActualMinutes?: number;
}

export interface CustomsDeclarationStatisticsDTO {
    totalShipments: KpiDTO;
    overTime: CountTimeBucketDTO[];
}

export interface CustomsDeclarationTopPartnerRowDTO {
    companyId?: string;
    companyName?: string;
    shipments: number;
}

export interface CustomsDeclarationsAvailabilityDTO {
    available: boolean;
}

export interface DashboardAvailabilityDTO {
    tasks: TasksAvailabilityDTO;
    statistics: StatisticsAvailabilityDTO;
}

export interface PartnerRolesAvailabilityDTO {
    myCompany: boolean;
    asPartner: boolean;
    currentCompanyHasReporting: boolean;
    currentUserHasReporting: boolean;
}

export interface ShipmentRolesAvailabilityDTO {
    asConsignee: boolean;
    asCarrier: boolean;
    currentCompanyHasReporting: boolean;
    currentUserHasReporting: boolean;
}

export interface StatisticsAvailabilityDTO {
    shipments: ShipmentRolesAvailabilityDTO;
    reservations: PartnerRolesAvailabilityDTO;
    supplierNotifications: PartnerRolesAvailabilityDTO;
    customsDeclarations: CustomsDeclarationsAvailabilityDTO;
}

export interface TaskSectionAvailabilityDTO {
    expedition: boolean;
    reservation: boolean;
    supplierNotification: boolean;
}

export interface TasksAvailabilityDTO {
    consignee: TaskSectionAvailabilityDTO;
    carrier: TaskSectionAvailabilityDTO;
}

export interface PageResponseInternalCommentOutDTO {
    data: InternalCommentOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ExpeditionUnpublishedCountOutDTO {
    unpublishedExpeditionCount: number;
}

export interface DataOutDTO {
    data?: any;
}

export interface CompanySettingsIdInDTO {
    identifier: string;
}

export interface CargoItemReservationListPreviewOutDTO {
    cargoName?: string;
    cargoQuantity?: number;
}

export interface PageResponseReservationListPreviewOutDTO {
    data: ReservationListPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface ReservationListPreviewOutDTO {
    id: string;
    applicationId: string;
    version: number;
    customerName: string;
    customerCode?: string;
    customerId: string;
    carrierName?: string;
    locationName: string;
    locationCity: string;
    timeslot?: TimeslotCalendarDTO;
    orderId?: string;
    labels: LabelPreview[];
    cargoItems?: CargoItemReservationListPreviewOutDTO[];
    state?: State;
    carPlate?: string;
    driverInfo?: ReservationDriverInfoOutDTO;
    reservationName?: string;
    orders: GlobalOrderResponse[];
    hasETransportRO: boolean;
    rampName?: string;
    preferredDate?: string;
    attachmentInfo: ListAttachmentInfoOutDTO;
    flags: ReservationFlagDTO[];
    timezoneId?: string;
    onBehalfOf?: LovCompanyCodeListDTO;
}

export interface ReservationDetailOutDTO {
    id: string;
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    applicationId: string;
    version: number;
    customerId: string;
    customerName: string;
    customerCode?: string;
    carrierId?: string;
    carrierName?: string;
    locationId: string;
    locationName: string;
    locationCity: string;
    locationCountry: string;
    locationStreetNr: string;
    locationPostalCode: string;
    calendarId?: string;
    rampId?: string;
    rampName?: string;
    /**
     * @deprecated User slot instead
     */
    timeslot?: TimeslotCalendarDTO;
    slot?: TimeSlotResponse;
    orders: GlobalOrderResponse[];
    reservationName?: string;
    reservationNote?: string;
    carPlate?: string;
    carrierNote?: string;
    internalNote?: string;
    driverInfo?: ReservationDriverInfoOutDTO;
    labels: LabelPreview[];
    state?: State;
    isPinnedOnLocRampTable: boolean;
    hasTable: boolean;
    reservationActionTypes?: ReservationActionTypesEnum[];
    linkedToExpCoords?: ExpeditionCoordinate;
    linkedToExpOrder: boolean;
    linkedToExpeditionLocationId?: string;
    isBlockedToEdit: boolean;
    truck?: TruckTypeV4OutDTO;
    preferredDate?: string;
    isArchived: boolean;
    flags: ReservationFlagDTO[];
    notSpecifiedOrders: boolean;
    onBehalfOf?: LovCompanyCodeListDTO;
    folders: DetailExpeditionFolderResponseOutDTO[];
}

export interface ReservationRampDashboardDataOutDTO {
    reservationId: string;
    reservationApplicationId: string;
    customerId: string;
    customerName: string;
    carrierId?: string;
    carrierName?: string;
    calendarId?: string;
    rampId?: string;
    timeslot?: TimeslotCalendarDTO;
    carPlate?: string;
    createdAt: string;
    isPinnedOnLocRampTable: boolean;
    orderId?: string;
    orderIds: string[];
    reservationName?: string;
    flags: ReservationFlagDTO[];
}

export interface ReservationRampDashboardOutDTO {
    rampId: string;
    calendarId: string;
    name: string;
    tvDashboard: TvDashboardSettingsDTO;
    reservations: ReservationRampDashboardDataOutDTO[];
}

export interface CarrierModuleOutDTO {
    isActive: boolean;
    waitingForQuote?: number;
    waitingForCarPlate?: number;
    waitingGroupDemands?: number;
}

export interface ExpeditionModuleOutDTO {
    isActive: boolean;
    activeExpeditionCount?: number;
    choosingCarrierExpeditionCount?: number;
    w4dExpeditionCount?: number;
    workInProgressExpeditionCount?: number;
    inProgressExpeditionCount?: number;
}

export interface ModulesPreviewDataOutDTO {
    expeditionModule: ExpeditionModuleOutDTO;
    timeslotsModule: TimeslotsModuleOutDTO;
    supplierManifestModule: SupplierManifestModuleOutDTO;
    carrierModule: CarrierModuleOutDTO;
    shipmentModule: ShipmentModuleOutDTO;
    newSMModule: NewSMModuleOutDTO;
}

export interface NewSMModuleOutDTO {
    isActive: boolean;
}

export interface ShipmentModuleOutDTO {
    isActive: boolean;
}

export interface SupplierManifestModuleOutDTO {
    isActive: boolean;
    allSupplierManifestCount?: number;
    mySupplierManifestCount?: number;
    noResponsiblePersonSupplierManifestCount?: number;
}

export interface TimeslotsModuleOutDTO {
    isActive: boolean;
    in7DaysTimeslotsCount?: number;
    todayTimeslotsCount?: number;
    tomorrowTimeslotsCount?: number;
}

export interface ACLOutDTO {
    visibility: VisibilityEnum;
    visibleToCompanies: LovDTO[];
}

export interface CompanyLocationRampOutDTO {
    rampId: string;
    name: string;
    calendarId: string;
    timezoneId?: string;
    orderIndex?: number;
}

export interface CompanyLocationsListPreviewOutDTO {
    locationId: string;
    version: number;
    name: string;
    city: string;
    postalCode: string;
    streetNr: string;
    country: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    loadingType: LoadingTypeEnum;
    ramps: CompanyLocationRampOutDTO[];
    acl: ACLOutDTO;
    isExternal: boolean;
    externalName?: string;
    isPartnerLocation: boolean;
    enableVisitor: boolean;
    isDeleted: boolean;
    supersededBy?: SupersededByLocationOutDTO;
    externalId?: string;
    timezoneId?: string;
    isSharedWithMe: boolean;
    isInheritedFromCustomer: boolean;
    companyId: string;
}

export interface CMRSigningDataOutDTO {
    textEnabled: boolean;
    text?: string;
    imageEnabled: boolean;
    imageDataFileName?: string;
    userEnabled: boolean;
}

export interface CompanyLocationContactPersonOutDTO {
    id: string;
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
    automaticPrefillToNotify: boolean;
}

export interface CompanyLocationRampWithOpeningHoursOutDTO {
    rampId: string;
    name: string;
    isPrivate: boolean;
    isShowOnRampDashboard: boolean;
    calendarId: string;
    openingHourDefinitions: OpeningHourDefinitionsDTO;
    isTemporaryClosed: boolean;
    isSoftDeleted: boolean;
    timezoneId?: string;
    orderIndex?: number;
}

export interface CompanyLocationsDetailOutDTO {
    id: string;
    version: number;
    name: string;
    city: string;
    postalCode: string;
    streetNr: string;
    country: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    contactAutomaticPrefillToNotify: boolean;
    loadingType: LoadingTypeEnum;
    ramps: CompanyLocationRampWithOpeningHoursOutDTO[];
    concurrentlyActiveEventsCount: number;
    /**
     * @deprecated Misnamed straight copy of entity isNotIncludedPrivateRamps; use excludePrivateRampsFromCapacity
     */
    isIncludedPrivateRamps: boolean;
    excludePrivateRampsFromCapacity: boolean;
    openingHourDefinitions: OpeningHourDefinitionsDTO;
    contacts?: CompanyLocationContactPersonOutDTO[];
    acl: ACLOutDTO;
    isExternal: boolean;
    externalName?: string;
    externalId?: string;
    externalIds: string[];
    tvDashboard: TvDashboardSettingsDTO;
    tvMaxColumns: number;
    isPartnerLocation: boolean;
    enableVisitor: boolean;
    isDeleted: boolean;
    supersededBy?: SupersededByLocationOutDTO;
    dachserBranch?: string;
    dachserToken?: string;
    dachserCustomerNumber?: string;
    schenkerReferenceNumber?: string;
    dhlAccountNumberExport?: string;
    dhlAccountNumberImport?: string;
    fedexAccountIds: string[];
    senderSigningEnabled: boolean;
    senderSigningData?: CMRSigningDataOutDTO;
    receiverSigningEnabled: boolean;
    receiverSigningData?: CMRSigningDataOutDTO;
    timezoneId?: string;
    sharing: LocationSharingOutDTO[];
    locationNote?: string;
    latitude?: number;
    longitude?: number;
}

export interface LocationSharingOutDTO {
    companyId: string;
    companyName: string;
    locationSharingPrivilege: LocationSharingPrivilegeEnum;
}

export interface CompanyLocationRampDetailOutDTO {
    locationId: string;
    rampId: string;
    isPrivate: boolean;
    isShowOnRampDashboard: boolean;
    name: string;
    calendarId: string;
    openingHourDefinitions: OpeningHourDefinitionsDTO;
    maxSkuAmount?: number;
    maxReservationCount?: number;
    weeklyMaxSkuAmount?: number;
    weeklyMaxReservationCount?: number;
    isTemporaryClosed: boolean;
    timezoneId?: string;
    orderIndex?: number;
}

export interface CompanyLocationFutureReservationsOutDTO {
    futureReservationsCount: number;
}

export interface CompanyLocationExceptionPreviewOutDTO {
    locationExceptionId: string;
    /**
     * @deprecated Use localDates instead
     */
    dates: string[];
    openHourExceptionType: OpenHourExceptionTypeEnum;
    exceptionName: string;
    closed: boolean;
    locationSelectMode: LocationSelectModeEnum;
    localities: LocationListPreviewOutDTO[];
    createdAt: string;
    createdBy: string;
    openingHours?: ExceptionTimeIntervalOutDTO[];
    isOnlyForExternalPartners: boolean;
    localDates?: string[];
}

export interface ExceptionTimeIntervalOutDTO {
    /**
     * @deprecated Use localStartTime and timezoneId instead
     */
    since: string;
    /**
     * @deprecated Use localEndTime and timezoneId instead
     */
    till: string;
    localStartTime?: string;
    localEndTime?: string;
}

export interface LocationListPreviewOutDTO {
    localityName: string;
    rampsNames: string[];
}

export interface LocationContactOutDTO {
    contactId: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
    automaticPrefillToNotify: boolean;
}

export interface PageResponseLocationContactOutDTO {
    data: LocationContactOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CmrSigningImageOutDTO {
    fileName: string;
    mimeType: string;
    size: number;
    data: string;
}

export interface RampsOpeningHoursDateRangeRequestInDTO {
    rampIds: string[];
    dateFrom: string;
    dateTo: string;
    /**
     * @deprecated We will use location timezone anyway and legacy code is not using it
     */
    timezoneId?: string;
    showTemporaryClosed: boolean;
}

export interface RampOpeningHoursByDateRangeOutDTO {
    rampId: string;
    name: string;
    calendarId: string;
    isPrivate: boolean;
    isShowOnRampDashboard: boolean;
    dailyOpeningHours: RampsOpeningHoursDateRangeDailyOpeningHoursOutDTO[];
    dailyInverseOpeningHours: RampsOpeningHoursDateRangeDailyOpeningHoursOutDTO[];
    staticOpeningHourDefinitions: OpeningHourDefinitionsDTO;
    isTemporaryClosed: boolean;
    isSoftDeleted: boolean;
    timezoneId?: string;
    timezoneOffset: number;
    locationId?: string;
}

export interface RampsOpeningHoursDateRangeDailyOpeningHoursOutDTO {
    date: string;
    openingMode: OpeningModeEnum;
    intervals: RampsOpeningHoursDateRangeOpeningHoursIntervalOutDTO[];
}

export interface RampsOpeningHoursDateRangeOpeningHoursIntervalOutDTO {
    since: string;
    till: string;
}

export interface PageResponseCompanyLocationsListPreviewOutDTO {
    data: CompanyLocationsListPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CompanyLocationWithOpeningHours {
    id: string;
    name: string;
    openingHourDefinitions: OpeningHourDefinitionsDTO;
    timezoneId?: string;
}

export interface RequestParamsForMultipleLocationsInDTO {
    locationIds: string[];
    showTemporaryClosed: boolean;
}

export interface CompanyLocationExceptionFilterDTO {
    dateFrom?: string;
    dateTo?: string;
    locationIds?: string[];
    locationSelectMode?: LocationSelectModeEnum;
    createdByName?: string;
}

export interface PageResponseCompanyLocationExceptionPreviewOutDTO {
    data: CompanyLocationExceptionPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface GetListLabelsPreviewOutDTO {
    entityType: EntityTypeEnum;
    labels: LabelPreviewWithTypeOutDTO[];
}

export interface CompanyCustomDataPreviewOutDTO {
    id: string;
    createdByFullName: string;
    type: string;
    name: string;
    payload: any;
}

export interface PageResponseLovDTO {
    data: LovDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CMRItemResponse {
    id: string;
    signoNumber?: string;
    count: number;
    packagingName: string;
    name?: string;
    statisticsNumber?: string;
    completeWeight: number;
    volume?: number;
    position: number;
}

export interface CompanyResponse {
    id: string;
    name: string;
    streetNr: string;
    city: string;
    zipCode: string;
    countryCode3: string;
}

export interface GetCMRDetailDocResponse {
    applicationId: string;
    id: string;
    createdByFullName: string;
    createdByCompanyName: string;
    createdDate: string;
    updatedAt?: string;
    updatedBy?: string;
    /**
     * @deprecated completeSender
     */
    senderStreetNr?: string;
    /**
     * @deprecated completeSender
     */
    senderCity?: string;
    /**
     * @deprecated completeSender
     */
    senderName?: string;
    /**
     * @deprecated completeSender
     */
    senderId?: string;
    /**
     * @deprecated completeSender
     */
    senderCountryCode3?: string;
    /**
     * @deprecated completeSender
     */
    senderZipCode?: string;
    /**
     * @deprecated completeConsignee
     */
    consigneeStreetNr?: string;
    /**
     * @deprecated completeConsignee
     */
    consigneeCity?: string;
    /**
     * @deprecated completeConsignee
     */
    consigneeName?: string;
    /**
     * @deprecated completeConsignee
     */
    consigneeId?: string;
    /**
     * @deprecated completeConsignee
     */
    consigneeCountryCode3?: string;
    /**
     * @deprecated completeConsignee
     */
    consigneeZipCode?: string;
    loadDateAndPlace?: string;
    unloadingDateAndPlace?: string;
    attachedDocumentTypes?: string;
    successiveCarriers?: string;
    commentsOfTheCarrier?: string;
    ordersNumbers?: string;
    items: CMRItemResponse[];
    doNotStack?: boolean;
    disableTranshipment?: boolean;
    sendersInstructions?: string;
    instrPaymentForCarriage?: string;
    codCurrenyCode?: string;
    codAmount?: number;
    carrier?: CompanyResponse;
    succesiveCarrier?: string;
    carrierReservationsAndObservations?: string;
    specialAgreements?: string;
    extraCosts?: string;
    establishedIn?: string;
    establishedAt?: string;
    carPlates?: string;
    weight?: number;
    dzvvNumber?: string;
    rideNumber?: string;
    borderCrossings?: string;
    accompanyingDocuments?: string;
    variousNote?: string;
    completeSender?: string;
    completeConsignee?: string;
    toBePaidBy?: string;
    cashOnDelivery?: string;
    others?: string;
    confirmationOfCustomsPapers?: string;
    unClass?: string;
}

export interface GetCMRDetailResponse {
    entityType: EntityTypeEnum;
    entityId: string;
    entityApplicationId: string;
    documents: GetCMRDetailDocResponse[];
}

export interface GroupDemandFilter {
    validTill?: string;
    groupDemandState?: GroupDemandStateEnum[];
    applicationId?: string;
    customerName?: string;
    userTimezoneId: string;
}

export interface GroupDemandCarrierListPreviewOutDTO {
    groupDemandId: string;
    groupDemandName: string;
    groupDemandApplicationId: string;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: string;
    groupDemandStart: CarrierExpeditionStartOutDTO;
    createdByCompany: string;
    state: StateEnum;
    isValid: boolean;
    utcEnd?: string;
    timezoneId?: string;
}

export interface PageResponseGroupDemandCarrierListPreviewOutDTO {
    data: GroupDemandCarrierListPreviewOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface CarrierGroupDemandDetailOutDTO {
    groupDemandId: string;
    groupDemandName: string;
    groupDemandApplicationId: string;
    supplierNotificationRowsWithDemands: CarrierSupplierNotificationRowOutDTO[];
    isDifferentPriceForAll: boolean;
    differentPrice?: Price;
    sumPrice?: Price;
    /**
     * @deprecated Use utcEnd and timezoneId instead
     */
    validTill: string;
    createdByInfo: CreatedByInfoOutDTO;
    state: StateEnum;
    isValid: boolean;
    customerId: string;
    customerName: string;
    utcEnd?: string;
    timezoneId?: string;
}

export interface CarrierSNListOrderOutDTO {
    manipulationUnitName: string;
    quantity: number;
    height?: number;
    width?: number;
    length?: number;
    weight?: number;
    stackable?: boolean;
}

export interface CarrierSupplierNotificationRowAddressOutDTO {
    zipCode: string;
    country: string;
    city: string;
    streetNr: string;
    locationName?: string;
}

export interface CarrierSupplierNotificationRowOutDTO {
    snId: string;
    snApplicationId: string;
    specialRequirements: PreviewPlanOutLoV[];
    snCompanyName: string;
    loadingFromTime?: string;
    loadingToTime?: string;
    loadingTimeslots?: TimeslotOutDTO;
    unloadingTimeslots?: TimeslotOutDTO;
    loadingPlace: CarrierSupplierNotificationRowAddressOutDTO;
    unloadingPlace: CarrierSupplierNotificationRowAddressOutDTO;
    distance?: number;
    weight: number;
    transportCode: LovWithoutIdDTO;
    cargoType: LovWithoutIdDTO;
    orders: CarrierSNListOrderOutDTO[];
    myPrice?: Price;
    isNotInterested: boolean;
    percentOfOrder?: number;
    expeditionId?: string;
    expeditionApplicationId?: string;
    expeditionCustomerId?: string;
    totalWeight: number;
    orderValue: CurrencyOrderValue;
    sumCargoAmount: number;
    cargoTypeOut: CargoTypeOutDTO;
    carrierNote?: string;
}

export interface CreatedByInfoOutDTO {
    customerId: string;
    companyName: string;
    streetNr: string;
    zipCode: string;
    city: string;
    country: string;
    crn: string;
    tin: string;
    responsiblePersonName: string;
}

export interface DaysWithIntervalsDTO {
    day: string;
    intervals: IntervalsDTO[];
}

export interface IntervalsDTO {
    till: string;
    since: string;
}

export interface TimeslotOutDTO {
    timezoneId: string;
    daysWithIntervals: DaysWithIntervalsDTO[];
}

export interface AttachmentDownloadOutDTO {
    attachmentId: string;
    mimeType: string;
    fileName: string;
    size: number;
    data: string;
}

export interface LovDocumentTypeOutDTO {
    name: string;
    documentType: DocumentTypeEnum;
}

export interface ListShippingCompaniesFilter {
    name?: string;
    showDeleted?: boolean;
}

export interface ListShippingCompaniesItemResponseOutDTO {
    id: string;
    name: string;
    position: number;
    deleted: boolean;
}

export interface PageResponseListShippingCompaniesItemResponseOutDTO {
    data: ListShippingCompaniesItemResponseOutDTO[];
    total: number;
    page: number;
    size: number;
}

export interface AdminCompanyDetailOutDTO {
    name: string;
    companyId: string;
    features: FeaturesEnum[];
    contentPrefix?: string;
    code?: string;
    modules: ModuleSettingsOutDTO[];
    dachserLastExportId?: string;
    enabledExpRequirementCodes?: string[];
    prefillRequirementCodes?: string[];
    customerReportingId?: string;
    streetAndNr: string;
    zipCode: string;
    city: string;
    country: string;
    crn: string;
    tin: string;
    defaultCurrencyIsoCode: string;
    defaultDistributionIntervalInHours: number;
    aiPriceAlertsMinimalSeverity: AiPriceAlertsMinimalSeverityEnum;
    invoicePublishServiceType: InvoicePublishServiceTypeEnum;
    prefixManualAppId?: string;
    entityPrefixes: EntityPrefixDTO[];
    autoAcceptModules?: boolean;
    availableCurrencies: string[];
    priceDisplayType: PriceDisplayTypeEnum;
    defaultTimezoneId?: string;
    cargoTemplateIds: string[];
    externalIdType: ExternalIdTypeEnum[];
    carrierQuoteValidTillDefaultInHours?: number;
    responseDeadlineMode: ResponseDeadlineModeEnum;
}

export interface AdminCatalogListOutDTO {
    carrierId: string;
    name: string;
    countryRegion?: LovDTO;
    streetNr?: string;
    country: string;
    crn: string;
    tin?: string;
    zipCode?: string;
    city?: string;
    exportCountries: string[];
    exportNote?: string;
    importCountries: string[];
    importNote?: string;
    cars: AdminTruckCarCountDTO[];
    createdAt: string;
    updatedAt: string;
    hqLat?: number;
    hqLng?: number;
    wwwPage?: string;
    contactName?: string;
    contactPhone?: string;
    contactEmail?: string;
}

export interface AdminTruckCarCountDTO {
    code: string;
    name: string;
    count: number;
}

export interface DeleteCompanyCarPlateResponseDTO {
    id: string;
    deleted: boolean;
}

export interface DeleteCompanyUserDepartmentResponseDTO {
    id: string;
    deleted: boolean;
}

export interface DeleteCalendarLayoutModelsInDTO {
    modelIds: string[];
}

export interface DeleteCalendarLayoutModelResultOutDTO {
    modelId: string;
    modelName: string;
    removedAssignmentCount: number;
    impact: CalendarLayoutImpactOutDTO;
}

export interface DeleteCalendarLayoutModelsOutDTO {
    results: DeleteCalendarLayoutModelResultOutDTO[];
}

export interface ActionNeededDataOutDTO {
    action: ActionEnum;
    className: string;
    data: any;
}

export interface LocationForceNeededDataExceptionOutDTO {
    count: number;
    localizedMessage: string;
}

export enum ScopeEnum { FIELD='FIELD',COMPONENT='COMPONENT',GLOBAL='GLOBAL' }
export enum ErrorTypeEnum { ERROR='ERROR',VALIDATION='VALIDATION',CONFLICT='CONFLICT',ADDITIONAL_ACTION='ADDITIONAL_ACTION' }
export enum ViewVisibilityEnum { PRIVATE='PRIVATE',COMPANY='COMPANY' }
export enum TableKeyEnum { EXPEDITION_LIST='EXPEDITION_LIST',SUPPLIER_NOTIFICATION_LIST='SUPPLIER_NOTIFICATION_LIST',RESERVATION_LIST='RESERVATION_LIST' }
export enum ReservationFlagTypeEnum { RETURNABLE_PACKAGE='RETURNABLE_PACKAGE',CUSTOMS='CUSTOMS',CROSS_DOCK='CROSS_DOCK' }
export enum ReferenceSourceEnum { APPLICATION_ID='APPLICATION_ID',PICKUP_CODES='PICKUP_CODES' }
export enum OpeningHourStateEnum { OK='OK',COLLISION='COLLISION',NO_DATA='NO_DATA',CLOSED_EXCEPTION='CLOSED_EXCEPTION',OPEN_EXCEPTION='OPEN_EXCEPTION' }
export enum ReservationStateEnum { FREE='FREE',FULL='FULL',FREE_NOSLOT='FREE_NOSLOT',LOCATION_SUPERSEDED='LOCATION_SUPERSEDED' }
export enum FolderVisibilityEnum { ALL='ALL',RESTRICTED='RESTRICTED' }
export enum DiagnosticSeverityEnum { ERROR='ERROR',WARNING='WARNING' }
export enum DiagnosticCodeEnum { UNEXPECTED_CHARACTER='UNEXPECTED_CHARACTER',RESERVED_WORD='RESERVED_WORD',ASSIGNMENT_NOT_COMPARISON='ASSIGNMENT_NOT_COMPARISON',UNTERMINATED_TEXT='UNTERMINATED_TEXT',TEXT_PAST_END_OF_LINE='TEXT_PAST_END_OF_LINE',EXPECTED_BUT_FOUND='EXPECTED_BUT_FOUND',EXPECTED_COMPARISON='EXPECTED_COMPARISON',NOT_A_UNIT='NOT_A_UNIT',KEYWORD_AS_NAME='KEYWORD_AS_NAME',PARAMETER_GIVEN_TWICE='PARAMETER_GIVEN_TWICE',PRIORITY_NOT_A_NUMBER='PRIORITY_NOT_A_NUMBER',MISSING_THEN='MISSING_THEN',EXPECTED_ACTION='EXPECTED_ACTION',TRAILING_INPUT='TRAILING_INPUT',UNKNOWN_FACT='UNKNOWN_FACT',UNKNOWN_ACTION='UNKNOWN_ACTION',UNKNOWN_TRIGGER='UNKNOWN_TRIGGER',DID_YOU_MEAN='DID_YOU_MEAN',TRIGGER_CANNOT_BE_DELAYED='TRIGGER_CANNOT_BE_DELAYED',DELAY_ONLY_ON_CHANGE_TRIGGERS='DELAY_ONLY_ON_CHANGE_TRIGGERS',FACT_WRONG_ENTITY='FACT_WRONG_ENTITY',FACT_NOT_ON_TRIGGER='FACT_NOT_ON_TRIGGER',FACT_AVAILABLE_ON='FACT_AVAILABLE_ON',FACT_HAS_NO_PARAMETER='FACT_HAS_NO_PARAMETER',FACT_TAKES_PARAMETERS='FACT_TAKES_PARAMETERS',FACT_TAKES_NO_PARAMETERS='FACT_TAKES_NO_PARAMETERS',OPERATOR_NOT_VALID_FOR_TYPE='OPERATOR_NOT_VALID_FOR_TYPE',FACT_SUPPORTS_OPERATORS='FACT_SUPPORTS_OPERATORS',OPERATOR_TAKES_NO_VALUE='OPERATOR_TAKES_NO_VALUE',OPERATOR_NEEDS_LIST='OPERATOR_NEEDS_LIST',OPERATOR_NEEDS_VALUE='OPERATOR_NEEDS_VALUE',OPERATOR_NEEDS_SINGLE_VALUE='OPERATOR_NEEDS_SINGLE_VALUE',BETWEEN_NEEDS_TWO_BOUNDS='BETWEEN_NEEDS_TWO_BOUNDS',EMPTY_LIST_NEVER_MATCHES='EMPTY_LIST_NEVER_MATCHES',EXAMPLE='EXAMPLE',USE_IN_FOR_SEVERAL='USE_IN_FOR_SEVERAL',USE_IS_NULL_FOR_MISSING='USE_IS_NULL_FOR_MISSING',FACT_IS_BOOLEAN='FACT_IS_BOOLEAN',FACT_IS_NUMBER='FACT_IS_NUMBER',FACT_IS_MONEY='FACT_IS_MONEY',FACT_IS_NOT_MONEY='FACT_IS_NOT_MONEY',FACT_IS_DURATION='FACT_IS_DURATION',BOOLEAN_HINT='BOOLEAN_HINT',DURATION_HINT='DURATION_HINT',NOT_AN_ENUM_VALUE='NOT_AN_ENUM_VALUE',ALLOWED_VALUES='ALLOWED_VALUES',UNKNOWN_COUNTRY_GROUP='UNKNOWN_COUNTRY_GROUP',NOT_A_DATETIME='NOT_A_DATETIME',NOW_ONLY_FOR_DATETIME='NOW_ONLY_FOR_DATETIME',NOW_OFFSET_NOT_A_DURATION='NOW_OFFSET_NOT_A_DURATION',DATETIME_HINT='DATETIME_HINT',UNIT_NOT_COMPARABLE='UNIT_NOT_COMPARABLE',FACT_HAS_NO_UNIT='FACT_HAS_NO_UNIT',NO_CURRENCY_GIVEN='NO_CURRENCY_GIVEN',WILL_BE_READ_AS='WILL_BE_READ_AS',NOT_A_CURRENCY='NOT_A_CURRENCY',CURRENCY_HINT='CURRENCY_HINT',CURRENCY_MISMATCH='CURRENCY_MISMATCH',CONVERT_TO_CURRENCY='CONVERT_TO_CURRENCY',ACTION_WRONG_ENTITY='ACTION_WRONG_ENTITY',ACTION_NEEDS_PARAMETER='ACTION_NEEDS_PARAMETER',ACTION_HAS_NO_PARAMETER='ACTION_HAS_NO_PARAMETER',ACTION_TAKES_PARAMETERS='ACTION_TAKES_PARAMETERS',PARAMETER_IS_BOOLEAN='PARAMETER_IS_BOOLEAN',PARAMETER_IS_NUMBER='PARAMETER_IS_NUMBER',PARAMETER_IS_MONEY='PARAMETER_IS_MONEY',PARAMETER_IS_DURATION='PARAMETER_IS_DURATION',PARAMETER_IS_LIST='PARAMETER_IS_LIST',NOT_A_PARAMETER_VALUE='NOT_A_PARAMETER_VALUE',RULE_NEEDS_AN_ACTION='RULE_NEEDS_AN_ACTION',DRY_RUN_NEEDS_A_RULE='DRY_RUN_NEEDS_A_RULE' }
export enum IdEntityTypeEnum { RESERVATION='RESERVATION',EXPEDITION='EXPEDITION',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',GROUP_DEMAND='GROUP_DEMAND',VISITOR_RECORD='VISITOR_RECORD',ASYNC_JOB='ASYNC_JOB' }
export enum TagEnum { STATUS='STATUS',TRANSPORTATION_TYPE='TRANSPORTATION_TYPE',CARGO='CARGO',CUSTOMS_REGIME='CUSTOMS_REGIME',CMR_NUMBER='CMR_NUMBER',BL_NUMBER='BL_NUMBER',AWB_NUMBER='AWB_NUMBER',CONTAINER='CONTAINER',LOADING_REFERENCE='LOADING_REFERENCE',CARRIER_REQUIREMENTS='CARRIER_REQUIREMENTS',CARRIER_NOTE='CARRIER_NOTE' }
export enum DefaultVersionEnum { ORIGINAL='ORIGINAL',NEW='NEW' }
export enum FindCarrierTypeEnum { GROUP='GROUP',CARRIER='CARRIER',CARRIER_USER='CARRIER_USER',API='API' }
export enum SeverityEnum { DEBUG='DEBUG',INFO='INFO',WARNING='WARNING',ERROR='ERROR' }
export enum SourceTypeEnum { AI_PARSED='AI_PARSED',ISDOC_XML='ISDOC_XML',DACHSER_XML='DACHSER_XML',DHL_XML='DHL_XML' }
export enum ModeEnum { HIDDEN='HIDDEN',FULL='FULL',TRUNCATED='TRUNCATED' }
export enum StatusEnum { UNKNOWN='UNKNOWN',NEW='NEW',PROCESSING='PROCESSING',SKIPPED_DUE_TO_OTHER_DOCUMENT='SKIPPED_DUE_TO_OTHER_DOCUMENT',PUBLISH_SKIPPED_DUE_TO_DISABLED_FEATURE_FLAG='PUBLISH_SKIPPED_DUE_TO_DISABLED_FEATURE_FLAG',PROCESSED_WITH_ERRORS='PROCESSED_WITH_ERRORS',PROCESSING_FAILED='PROCESSING_FAILED',ERP_UPLOAD_SUCCESS='ERP_UPLOAD_SUCCESS',ERP_UPLOAD_FAILED='ERP_UPLOAD_FAILED',FINISHED='FINISHED',USER_EDITED='USER_EDITED',ERP_FILE_UPLOAD_SUCCESS='ERP_FILE_UPLOAD_SUCCESS',ERP_FILE_UPLOAD_FAILED='ERP_FILE_UPLOAD_FAILED',MISSING_PDF_ATTACHMENT='MISSING_PDF_ATTACHMENT',NO_OPS='NO_OPS' }
export enum InvoiceSeverityEnum { DEBUG='DEBUG',INFO='INFO',WARNING='WARNING',ERROR='ERROR' }
export enum ReservationActionTypeEnum { LOADING='LOADING',UNLOADING='UNLOADING' }
export enum ResultStatesEnum { ERROR='ERROR',DONE_WITH_ERRORS='DONE_WITH_ERRORS',RUNNING='RUNNING',DRAFT='DRAFT',DONE='DONE',CANCELLED='CANCELLED' }
export enum ValidDistributionEnum { VALID_ALL='VALID_ALL',VALID_12H='VALID_12H',VALID_24H='VALID_24H',VALID_48H='VALID_48H',EXPIRED='EXPIRED' }
export enum PagingModeEnum { SCROLL='SCROLL' }
export enum ActionTypesEnum { LOADING='LOADING',UNLOADING='UNLOADING' }
export enum ReservationRejectionReasonEnum { NOT_FOUND='NOT_FOUND',ALREADY_ARCHIVED='ALREADY_ARCHIVED',EDIT_BLOCKED_BEFORE_START='EDIT_BLOCKED_BEFORE_START',DELETE_NOT_ALLOWED='DELETE_NOT_ALLOWED' }
export enum TargetEnum { BROADCAST='BROADCAST',PERSONAL='PERSONAL',COMPANY='COMPANY' }
export enum FedexRegistrationStatusEnum { REGISTERED='REGISTERED',MFA_REQUIRED='MFA_REQUIRED' }
export enum FilterFieldTypeEnum { STRING='STRING',DATE='DATE',LIST_STRING='LIST_STRING',BOOLEAN='BOOLEAN' }
export enum FilterComparisonTypeEnum { GREATER_THAN='GREATER_THAN',LOWER_THAN='LOWER_THAN',CONTAINS='CONTAINS' }
export enum IntentEnum { UNKNOWN='UNKNOWN',CONFIRMATION='CONFIRMATION',ISSUE='ISSUE',QUESTION_OR_REQUEST='QUESTION_OR_REQUEST' }
export enum TopicEnum { UNKNOWN='UNKNOWN',TRANSPORT_DETAILS='TRANSPORT_DETAILS',SCHEDULE='SCHEDULE',COST='COST' }
export enum StatusEnumsEnum { IMPORTED='IMPORTED',NEW='NEW',ASSIGNING='ASSIGNING',ASSIGNED='ASSIGNED',READY_TO_SHIPMENT='READY_TO_SHIPMENT',ACTIVE='ACTIVE',WAITING_FOR_DOCS='WAITING_FOR_DOCS',CANCELED='CANCELED',FINISHED='FINISHED' }
export enum ExpeditionTypesEnum { LESS_TRUCK_LOAD='LESS_TRUCK_LOAD',FULL_TRUCK_LOAD='FULL_TRUCK_LOAD',SBERKA='SBERKA',FCL='FCL',LCL='LCL',TAXI='TAXI',CHARTER='CHARTER',EXPEDITED='EXPEDITED',CUSTOM_CLEARANCE='CUSTOM_CLEARANCE' }
export enum ReasonEnum { NOT_FOUND='NOT_FOUND',NOT_EMAIL_CHANNEL='NOT_EMAIL_CHANNEL',ALREADY_RESENT='ALREADY_RESENT' }
export enum ProductCodeEnum { EXPRESS_DOMESTIC='EXPRESS_DOMESTIC',ECONOMY_SELECT_EU='ECONOMY_SELECT_EU',ECONOMY_SELECT_NON_EU='ECONOMY_SELECT_NON_EU',EXPRESS_WORLDWIDE_EU='EXPRESS_WORLDWIDE_EU',EXPRESS_WORLDWIDE_NON_EU='EXPRESS_WORLDWIDE_NON_EU',EXPRESS_WORLDWIDE_DOC='EXPRESS_WORLDWIDE_DOC',EXPRESS_9_EU='EXPRESS_9_EU',EXPRESS_9_NON_EU='EXPRESS_9_NON_EU',EXPRESS_10_30_EU='EXPRESS_10_30_EU',EXPRESS_10_30_NON_EU='EXPRESS_10_30_NON_EU',EXPRESS_12_EU='EXPRESS_12_EU',EXPRESS_12_NON_EU='EXPRESS_12_NON_EU',EXPRESS_DOMESTIC_9='EXPRESS_DOMESTIC_9',EXPRESS_DOMESTIC_10_30='EXPRESS_DOMESTIC_10_30',EXPRESS_DOMESTIC_12='EXPRESS_DOMESTIC_12',EXPRESS_BREAKBULK='EXPRESS_BREAKBULK',EXPRESS_EASY_EU='EXPRESS_EASY_EU',EXPRESS_EASY_NON_EU='EXPRESS_EASY_NON_EU',MEDICAL_EXPRESS_EU='MEDICAL_EXPRESS_EU',MEDICAL_EXPRESS_NON_EU='MEDICAL_EXPRESS_NON_EU' }
export enum CalendarLayoutActionEnum { ASSIGN='ASSIGN',REMOVE='REMOVE' }
export enum CalendarLayoutOutcomeEnum { CREATED='CREATED',REPLACED='REPLACED',REMOVED='REMOVED',SKIPPED='SKIPPED' }
export enum WebhookTypeEnum { UPLOAD_ATTACHMENT='UPLOAD_ATTACHMENT',CHANGE_RESERVATION_TIMESLOT='CHANGE_RESERVATION_TIMESLOT',RESERVATION_CHANGED='RESERVATION_CHANGED',RESERVATION_CHANGED_ORDERS='RESERVATION_CHANGED_ORDERS',RESERVATION_UPDATE_LOADED_EANS='RESERVATION_UPDATE_LOADED_EANS',EXPEDITION_CHANGED='EXPEDITION_CHANGED',EXPEDITION_STATUS_CHANGE='EXPEDITION_STATUS_CHANGE',ETRANSPORT_CREATED='ETRANSPORT_CREATED',SEND_ETRANSPORT_DATA='SEND_ETRANSPORT_DATA',RESERVATION_OPEN_GATE_MESSAGE='RESERVATION_OPEN_GATE_MESSAGE' }
export enum WebhookActionTypeEnum { EXPEDITION_CREATED='EXPEDITION_CREATED',EXPEDITION_CAR_PLATE_CHANGE='EXPEDITION_CAR_PLATE_CHANGE',EXPEDITION_STATUS_CHANGE='EXPEDITION_STATUS_CHANGE',EXPEDITION_CARRIER_TIMESLOT_CHANGE='EXPEDITION_CARRIER_TIMESLOT_CHANGE',EXPEDITION_LOCATION_CHANGE='EXPEDITION_LOCATION_CHANGE',RESERVATION_CREATED='RESERVATION_CREATED',RESERVATION_CAR_PLATE_CHANGE='RESERVATION_CAR_PLATE_CHANGE',RESERVATION_DRIVER_NAME_CHANGE='RESERVATION_DRIVER_NAME_CHANGE',RESERVATION_DRIVER_PHONE_CHANGE='RESERVATION_DRIVER_PHONE_CHANGE',RESERVATION_NAME_CHANGE='RESERVATION_NAME_CHANGE',RESERVATION_STATE_CHANGE='RESERVATION_STATE_CHANGE',RESERVATION_TIME_CHANGE='RESERVATION_TIME_CHANGE',RESERVATION_ORDERS_CHANGE='RESERVATION_ORDERS_CHANGE',RESERVATION_ARCHIVED='RESERVATION_ARCHIVED',RESERVATION_UNARCHIVED='RESERVATION_UNARCHIVED',MANUAL_ACTION='MANUAL_ACTION' }
export enum CompanyUserTypeEnum { DRIVER='DRIVER' }
export enum CargoTypeCodeEnum { COMMON_GOODS='COMMON_GOODS',COOLED_GOODS='COOLED_GOODS',FROZEN_GOODS='FROZEN_GOODS',OVERSIZED_LOADS='OVERSIZED_LOADS',BULK_GOODS='BULK_GOODS',FLUID='FLUID',COIL='COIL',CARS='CARS',ADR_1='ADR_1',ADR_2_1='ADR_2.1',ADR_2_2='ADR_2.2',ADR_2_3='ADR_2.3',ADR_3='ADR_3',ADR_4_1='ADR_4.1',ADR_4_2='ADR_4.2',ADR_4_3='ADR_4.3',ADR_5_1='ADR_5.1',ADR_5_2='ADR_5.2',ADR_6_1='ADR_6.1',ADR_6_2='ADR_6.2',ADR_7='ADR_7',ADR_8='ADR_8',ADR_9='ADR_9',DRY_FOODS_PALLET='DRY_FOODS_PALLET',COOLED_FOODS_PALLET='COOLED_FOODS_PALLET',FROZEN_FOODS_PALLET='FROZEN_FOODS_PALLET',TECHNICAL_MATERIAL_PALLET='TECHNICAL_MATERIAL_PALLET',ADR='ADR',PALLET_125_X_105='PALLET_125_X_105',PALLET_125_X_85='PALLET_125_X_85',EURO_PALLET_HALF='EURO_PALLET_HALF',ADR_LQ='ADR_LQ' }
export enum UnavailabilityReasonEnum { NEXT_DAY_DEADLINE='NEXT_DAY_DEADLINE',SLOT_IN_PAST='SLOT_IN_PAST',LOCATION_CLOSED='LOCATION_CLOSED',NO_OPENING_HOURS='NO_OPENING_HOURS',OUTSIDE_OPENING_HOURS='OUTSIDE_OPENING_HOURS',OUTSIDE_EXPEDITION_OPENING_HOURS='OUTSIDE_EXPEDITION_OPENING_HOURS',SLOT_OCCUPIED='SLOT_OCCUPIED',DAILY_RESERVATION_LIMIT='DAILY_RESERVATION_LIMIT',DAILY_SKU_LIMIT='DAILY_SKU_LIMIT',WEEKLY_RESERVATION_LIMIT='WEEKLY_RESERVATION_LIMIT',WEEKLY_SKU_LIMIT='WEEKLY_SKU_LIMIT' }
export enum AdditionalFieldTypeEnum { LIST_ENUMS='LIST_ENUMS',STRING='STRING',MULTI_LIST_ENUMS='MULTI_LIST_ENUMS' }
export enum DachserDeliveryTermEnum { EX_WORKS='EX_WORKS',FREE_DELIVERED='FREE_DELIVERED',FREE_DELIVERED_AT_PLACE='FREE_DELIVERED_AT_PLACE',FREE_DELIVERED_AT_TERMINAL='FREE_DELIVERED_AT_TERMINAL',EX_WORKS_WITH_INVOICE='EX_WORKS_WITH_INVOICE',FREE_BORDER_UNCLEARED='FREE_BORDER_UNCLEARED',FREE_DELIVERED_UNCLEARED='FREE_DELIVERED_UNCLEARED',FREE_DELIVERED_CLEARED_NO_TAX='FREE_DELIVERED_CLEARED_NO_TAX',FREE_DELIVERED_CLEARED_DUTY_ONLY='FREE_DELIVERED_CLEARED_DUTY_ONLY',FREE_DELIVERED_CLEARED_ALL='FREE_DELIVERED_CLEARED_ALL',FREE_DELIVERED_INSURED_UNCLEARED='FREE_DELIVERED_INSURED_UNCLEARED',SERVICE_GOODS_INSURED='SERVICE_GOODS_INSURED' }
export enum IncotermsValueEnum { EXW='EXW',FCA='FCA',CPT='CPT',CIP='CIP',DAP='DAP',DPU='DPU',DDP='DDP',FAS='FAS',FOB='FOB',CFR='CFR',CIF='CIF' }
export enum LocationContactTypeEnum { OUR_LOCATION='OUR_LOCATION',PARTNER_LOCATION='PARTNER_LOCATION',OUR_EXTERNAL_LOCATION='OUR_EXTERNAL_LOCATION',OUR_PARTNER_LOCATION='OUR_PARTNER_LOCATION' }
export enum AiPriceAlertTypeEnum { UNDEFINED='UNDEFINED',PRICE_DEVIATION_FROM_HISTORY='PRICE_DEVIATION_FROM_HISTORY' }
export enum AiPriceAlertSeverityEnum { SEVERITY_UNDEFINED='SEVERITY_UNDEFINED',SEVERITY_0='SEVERITY_0',SEVERITY_1='SEVERITY_1',SEVERITY_2='SEVERITY_2',SEVERITY_3='SEVERITY_3',SEVERITY_4='SEVERITY_4' }
export enum ApiTypeEnum { DACHSER='DACHSER',SCHENKER='SCHENKER',DHL='DHL',FEDEX='FEDEX' }
export enum EmailStatusEnum { FAILED='FAILED',SEND='SEND',ACCEPTED='ACCEPTED',DELIVERED='DELIVERED',READ_EMAIL='READ_EMAIL',READ_IN_APP='READ_IN_APP',DACHSER_FAILED='DACHSER_FAILED',DACHSER_IMPORTED='DACHSER_IMPORTED',EXTERNAL_API_FAILED='EXTERNAL_API_FAILED',EXTERNAL_API_IMPORTED='EXTERNAL_API_IMPORTED',UNDEFINED='UNDEFINED' }
export enum QuoteGroupEnum { EW='EW',RINGIL='RINGIL',DACHSER='DACHSER' }
export enum DachserProductTypeEnum { TARGOSPEED='TARGOSPEED',TARGOSPEED_10='TARGOSPEED_10',TARGOSPEED_12='TARGOSPEED_12',TARGOSPEED_PLUS='TARGOSPEED_PLUS',TARGOFIX='TARGOFIX',TARGOFIX_10='TARGOFIX_10',TARGOFIX_12='TARGOFIX_12',TARGOFLEX='TARGOFLEX',TARGO_ON_SITE='TARGO_ON_SITE',TARGO_ON_SITE_PLUS='TARGO_ON_SITE_PLUS',TARGO_ON_SITE_PREMIUM='TARGO_ON_SITE_PREMIUM',CLASSICLINE='CLASSICLINE',TARGO_ON_SITE_FIX='TARGO_ON_SITE_FIX' }
export enum SchenkerProductTypeEnum { PRODUCT_SYSTEM='PRODUCT_SYSTEM',PRODUCT_SYSTEM_FIXED='PRODUCT_SYSTEM_FIXED',PRODUCT_SYSTEM_FIXED_10='PRODUCT_SYSTEM_FIXED_10',PRODUCT_SYSTEM_FIXED_13='PRODUCT_SYSTEM_FIXED_13',PRODUCT_SYSTEM_PREMIUM='PRODUCT_SYSTEM_PREMIUM',PRODUCT_SYSTEM_PREMIUM_10='PRODUCT_SYSTEM_PREMIUM_10',PRODUCT_SYSTEM_PREMIUM_13='PRODUCT_SYSTEM_PREMIUM_13' }
export enum SchenkerAddonsTypeEnum { AUTO_FIX_TBA='AUTO_FIX_TBA',AVIZORSMS='AVIZORSMS',CUSTOMS_SHIPMENT='CUSTOMS_SHIPMENT',CUSTOMS_SHIPMENT_NOT_REQUIRED='CUSTOMS_SHIPMENT_NOT_REQUIRED',CUSTOMS_SHIPMENT_OTHERS='CUSTOMS_SHIPMENT_OTHERS',OVER_1='OVER_1',OVER_2='OVER_2',PRE_NOTICE_DLV_MAIL='PRE_NOTICE_DLV_MAIL' }
export enum DhlProductTypeEnum { EXPRESS_DOMESTIC='EXPRESS_DOMESTIC',ECONOMY_SELECT_EU='ECONOMY_SELECT_EU',ECONOMY_SELECT_NON_EU='ECONOMY_SELECT_NON_EU',EXPRESS_WORLDWIDE_EU='EXPRESS_WORLDWIDE_EU',EXPRESS_WORLDWIDE_NON_EU='EXPRESS_WORLDWIDE_NON_EU',EXPRESS_WORLDWIDE_DOC='EXPRESS_WORLDWIDE_DOC',EXPRESS_9_EU='EXPRESS_9_EU',EXPRESS_9_NON_EU='EXPRESS_9_NON_EU',EXPRESS_10_30_EU='EXPRESS_10_30_EU',EXPRESS_10_30_NON_EU='EXPRESS_10_30_NON_EU',EXPRESS_12_EU='EXPRESS_12_EU',EXPRESS_12_NON_EU='EXPRESS_12_NON_EU',EXPRESS_DOMESTIC_9='EXPRESS_DOMESTIC_9',EXPRESS_DOMESTIC_10_30='EXPRESS_DOMESTIC_10_30',EXPRESS_DOMESTIC_12='EXPRESS_DOMESTIC_12',EXPRESS_BREAKBULK='EXPRESS_BREAKBULK',EXPRESS_EASY_EU='EXPRESS_EASY_EU',EXPRESS_EASY_NON_EU='EXPRESS_EASY_NON_EU',MEDICAL_EXPRESS_EU='MEDICAL_EXPRESS_EU',MEDICAL_EXPRESS_NON_EU='MEDICAL_EXPRESS_NON_EU' }
export enum ExternalOrdersApiTypeEnum { NOTINO_PAP='NOTINO_PAP' }
export enum OwnerDefaultActionTypeEnum { NONE='NONE',LOADING='LOADING',UNLOADING='UNLOADING',BOTH='BOTH' }
export enum CounterPartyDefaultActionTypeEnum { NONE='NONE',LOADING='LOADING',UNLOADING='UNLOADING',BOTH='BOTH' }
export enum NameEnum { PERMISSION_COMPANY_DETAIL='PERMISSION_COMPANY_DETAIL',PERMISSION_COMPANY_PERMISSIONS='PERMISSION_COMPANY_PERMISSIONS',PERMISSION_MODULE_DASHBOARD='PERMISSION_MODULE_DASHBOARD',PERMISSION_EXPEDITION='PERMISSION_EXPEDITION',PERMISSION_TEMPLATE='PERMISSION_TEMPLATE',PERMISSION_MY_CARRIERS='PERMISSION_MY_CARRIERS',PERMISSION_MY_CARRIERS_READ='PERMISSION_MY_CARRIERS_READ',PERMISSION_MY_CARRIERS_RW='PERMISSION_MY_CARRIERS_RW',PERMISSION_CARRIER_GROUP='PERMISSION_CARRIER_GROUP',PERMISSION_CARRIER_GROUP_READ='PERMISSION_CARRIER_GROUP_READ',PERMISSION_CARRIER_GROUP_RW='PERMISSION_CARRIER_GROUP_RW',PERMISSION_PARTNERS='PERMISSION_PARTNERS',PERMISSION_CARRIER_CATALOGUE='PERMISSION_CARRIER_CATALOGUE',PERMISSION_SUPPLIER_MANIFEST='PERMISSION_SUPPLIER_MANIFEST',PERMISSION_RESERVATION='PERMISSION_RESERVATION',PERMISSION_EXCEPTIONS='PERMISSION_EXCEPTIONS',PERMISSION_DEMANDS='PERMISSION_DEMANDS',PERMISSION_SHIPMENTS='PERMISSION_SHIPMENTS',PERMISSION_MOBILE_APP='PERMISSION_MOBILE_APP',PERMISSION_ADMIN='PERMISSION_ADMIN',PERMISSION_LOCATIONS='PERMISSION_LOCATIONS',PERMISSION_LOCATIONS_LOV='PERMISSION_LOCATIONS_LOV',PERMISSION_TIMESLOTS='PERMISSION_TIMESLOTS',PERMISSION_TIMESLOT_READ='PERMISSION_TIMESLOT_READ',PERMISSION_TIMESLOT_FULLREAD='PERMISSION_TIMESLOT_FULLREAD',PERMISSION_TIMESLOT_CREATE='PERMISSION_TIMESLOT_CREATE',PERMISSION_TIMESLOT_DELETE='PERMISSION_TIMESLOT_DELETE',PERMISSION_TIMESLOT_CHANGE_WORKFLOW='PERMISSION_TIMESLOT_CHANGE_WORKFLOW',PERMISSION_TIMESLOT_CHANGE_ORDER='PERMISSION_TIMESLOT_CHANGE_ORDER',PERMISSION_TIMESLOT_CHANGE_SLOT='PERMISSION_TIMESLOT_CHANGE_SLOT',PERMISSION_TIMESLOT_CHANGE_CARRIER='PERMISSION_TIMESLOT_CHANGE_CARRIER',PERMISSION_TIMESLOT_CHANGE_CARRIER_INFO='PERMISSION_TIMESLOT_CHANGE_CARRIER_INFO',PERMISSION_TIMESLOT_DUPLICATE='PERMISSION_TIMESLOT_DUPLICATE',PERMISSION_TIMESLOT_CALENDAR='PERMISSION_TIMESLOT_CALENDAR',PERMISSION_TIMESLOT_PUT2TABLE='PERMISSION_TIMESLOT_PUT2TABLE',PERMISSION_TIMESLOT_CHANGE_LABELS='PERMISSION_TIMESLOT_CHANGE_LABELS',PERMISSION_TIMESLOT_CHANGE_PARTIES='PERMISSION_TIMESLOT_CHANGE_PARTIES',PERMISSION_TIMESLOT_CHANGE_STATUS='PERMISSION_TIMESLOT_CHANGE_STATUS',PERMISSION_TIMESLOT_CHANGE_INFO='PERMISSION_TIMESLOT_CHANGE_INFO',PERMISSION_TIMESLOT_DETAIL_READ='PERMISSION_TIMESLOT_DETAIL_READ',PERMISSION_TIMESLOT_DETAIL_RW='PERMISSION_TIMESLOT_DETAIL_RW',PERMISSION_TIMESLOT_DETAIL_AUDITLOG_READ='PERMISSION_TIMESLOT_DETAIL_AUDITLOG_READ',PERMISSION_TIMESLOT_DASHBOARD_READ='PERMISSION_TIMESLOT_DASHBOARD_READ',PERMISSION_TIMESLOT_DASHBOARD_RW='PERMISSION_TIMESLOT_DASHBOARD_RW',PERMISSION_TIMESLOT_DASHBOARDMULTI_READ='PERMISSION_TIMESLOT_DASHBOARDMULTI_READ',PERMISSION_TIMESLOT_DASHBOARDMULTI_RW='PERMISSION_TIMESLOT_DASHBOARDMULTI_RW',PERMISSION_TIMESLOT_LIST_READ='PERMISSION_TIMESLOT_LIST_READ',PERMISSION_TIMESLOT_LIST_RW='PERMISSION_TIMESLOT_LIST_RW',PERMISSION_READ_LOCATIONS='PERMISSION_READ_LOCATIONS',PERMISSION_CREATE_LOCATIONS='PERMISSION_CREATE_LOCATIONS',PERMISSION_DELETE_LOCATIONS='PERMISSION_DELETE_LOCATIONS',PERMISSION_CREATE_RAMPS='PERMISSION_CREATE_RAMPS',PERMISSION_DELETE_RAMPS='PERMISSION_DELETE_RAMPS',PERMISSION_UPDATE_RAMPS='PERMISSION_UPDATE_RAMPS',PERMISSION_CREATE_EXCEPTIONS='PERMISSION_CREATE_EXCEPTIONS',PERMISSION_DELETE_EXCEPTIONS='PERMISSION_DELETE_EXCEPTIONS',PERMISSION_CAM_ENTRYLOG='PERMISSION_CAM_ENTRYLOG',PERMISSION_CAM_SETTINGS='PERMISSION_CAM_SETTINGS',PERMISSION_CAM_SETTINGS_REGISTERED_CAMS='PERMISSION_CAM_SETTINGS_REGISTERED_CAMS',PERMISSION_SN_FIX='PERMISSION_SN_FIX',PERMISSION_SN_CANCEL='PERMISSION_SN_CANCEL',PERMISSION_SUPP_NOTIFICATION_RW='PERMISSION_SUPP_NOTIFICATION_RW',PERMISSION_SN_DETAIL_AUDITLOG_READ='PERMISSION_SN_DETAIL_AUDITLOG_READ',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_RW='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_RW',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ_WITHOUTPRICE='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ_WITHOUTPRICE',PERMISSION_EXPEDITION_LIST_READ='PERMISSION_EXPEDITION_LIST_READ',PERMISSION_EXPEDITION_LIST_RW='PERMISSION_EXPEDITION_LIST_RW',PERMISSION_EXPEDITION_LIST_READ_WITHOUTPRICE='PERMISSION_EXPEDITION_LIST_READ_WITHOUTPRICE',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_READ='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_READ',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_RW',PERMISSION_EXPEDITION_MESSAGES_READ='PERMISSION_EXPEDITION_MESSAGES_READ',PERMISSION_EXPEDITION_MESSAGES_RW='PERMISSION_EXPEDITION_MESSAGES_RW',PERMISSION_EXPEDITION_CREATE='PERMISSION_EXPEDITION_CREATE',PERMISSION_PARTNER_LOCATION_MIGRATION='PERMISSION_PARTNER_LOCATION_MIGRATION',PERMISSION_CARRIER_EXPEDITION_RW='PERMISSION_CARRIER_EXPEDITION_RW',PERMISSION_SUPP_SHIPMENT_RW='PERMISSION_SUPP_SHIPMENT_RW',PERMISSION_COMPANY_NOTIFICATIONS='PERMISSION_COMPANY_NOTIFICATIONS',PERMISSION_COMPANY_INHERITED_COMPANIES='PERMISSION_COMPANY_INHERITED_COMPANIES',PERMISSION_SETTINGS_MAIL='PERMISSION_SETTINGS_MAIL',RESTRICT_NO_EXP='RESTRICT_NO_EXP',RESTRICT_NO_EXP_NO_TIMESLOT='RESTRICT_NO_EXP_NO_TIMESLOT',RESTRICT_NO_SUPPNOTIFICATION='RESTRICT_NO_SUPPNOTIFICATION',RESTRICT_NO_SETTINGS='RESTRICT_NO_SETTINGS',PERMISSION_SETTINGS_PARTNERS_READ='PERMISSION_SETTINGS_PARTNERS_READ',PERMISSION_SETTINGS_PARTNERS_RW='PERMISSION_SETTINGS_PARTNERS_RW',PERMISSION_REPORT='PERMISSION_REPORT',PERMISSION_SHIPMENT_MANUALIMPORT='PERMISSION_SHIPMENT_MANUALIMPORT',PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_READ='PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_READ',PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW='PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW',PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_READ='PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_READ',PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_RW='PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CMR_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CMR_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CMR_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CMR_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_RW',PERMISSION_EXPEDITION_DETAIL_AUDITLOG_READ='PERMISSION_EXPEDITION_DETAIL_AUDITLOG_READ',PERMISSION_EXPEDITION_PRICE='PERMISSION_EXPEDITION_PRICE',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_ORDERS_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_ORDERS_RW',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_INVOICES_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_INVOICES_RW',PERMISSION_EXPEDITION_CREATE_DISTRIBUTION_RW='PERMISSION_EXPEDITION_CREATE_DISTRIBUTION_RW',PERMISSION_SETTINGS_COMPANY_PROFILE='PERMISSION_SETTINGS_COMPANY_PROFILE',PERMISSION_SETTINGS_COMPANY_NOTIFICATIONS='PERMISSION_SETTINGS_COMPANY_NOTIFICATIONS',PERMISSION_SETTINGS_INHERITED_COMPANIES_READ='PERMISSION_SETTINGS_INHERITED_COMPANIES_READ',PERMISSION_TIMESLOT_VISITORS_WRITE='PERMISSION_TIMESLOT_VISITORS_WRITE',PERMISSION_TIMESLOT_VISITORS_READ='PERMISSION_TIMESLOT_VISITORS_READ',PERMISSION_TIMESLOT_VISITORS_HOST='PERMISSION_TIMESLOT_VISITORS_HOST',PERMISSION_ADMIN_CODELISTS='PERMISSION_ADMIN_CODELISTS',PERMISSION_RINGIL_ALLOW_RUN_TEST='PERMISSION_RINGIL_ALLOW_RUN_TEST',PERMISSION_SETTINGS_COMPANY_CREATE_USER='PERMISSION_SETTINGS_COMPANY_CREATE_USER',PERMISSION_ORDER_DISCREPANCY_RW='PERMISSION_ORDER_DISCREPANCY_RW',PERMISSION_TIMESLOT_INTERNALNOTE_RW='PERMISSION_TIMESLOT_INTERNALNOTE_RW',PERMISSION_EXPEDITION_EXPORT='PERMISSION_EXPEDITION_EXPORT',PERMISSION_TIMESLOT_EXPORT='PERMISSION_TIMESLOT_EXPORT',PERMISSION_SUPP_NOTIFICATION_EXPORT='PERMISSION_SUPP_NOTIFICATION_EXPORT',PERMISSION_CAM_LOG_EXPORT='PERMISSION_CAM_LOG_EXPORT',PERMISSION_NOTIFICATION_EXPORT='PERMISSION_NOTIFICATION_EXPORT',PERMISSION_EXPEDITION_FULL_CHANGE_PRICE='PERMISSION_EXPEDITION_FULL_CHANGE_PRICE',PERMISSION_EXPEDITION_INTERNAL_COMMENT_READ='PERMISSION_EXPEDITION_INTERNAL_COMMENT_READ',PERMISSION_EXPEDITION_INTERNAL_COMMENT_RW='PERMISSION_EXPEDITION_INTERNAL_COMMENT_RW',PERMISSION_DASHBOARD_TMS_TASKS='PERMISSION_DASHBOARD_TMS_TASKS',PERMISSION_DASHBOARD_TMS_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_TMS_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_TMS_GRAPHS_PARTNER='PERMISSION_DASHBOARD_TMS_GRAPHS_PARTNER',PERMISSION_DASHBOARD_TS_TASKS='PERMISSION_DASHBOARD_TS_TASKS',PERMISSION_DASHBOARD_TS_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_TS_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_TS_GRAPHS_PARTNER='PERMISSION_DASHBOARD_TS_GRAPHS_PARTNER',PERMISSION_DASHBOARD_SN_TASKS='PERMISSION_DASHBOARD_SN_TASKS',PERMISSION_DASHBOARD_SN_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_SN_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_SN_GRAPHS_PARTNER='PERMISSION_DASHBOARD_SN_GRAPHS_PARTNER',PERMISSION_DASHBOARD_CD_GRAPHS='PERMISSION_DASHBOARD_CD_GRAPHS',PERMISSION_SN_LIST_RW='PERMISSION_SN_LIST_RW',PERMISSION_SN_LIST_READ='PERMISSION_SN_LIST_READ',PERMISSION_SN_EFXX_CREATE='PERMISSION_SN_EFXX_CREATE',PERMISSION_SN_EFXX_DETAIL_TAB_SN_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_READ',PERMISSION_SN_DXX_CREATE='PERMISSION_SN_DXX_CREATE',PERMISSION_SN_DXX_DETAIL_TAB_SN_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_READ',PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_RW='PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_RW',PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_READ='PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_READ',PERMISSION_CALENDAR_LAYOUT_READ='PERMISSION_CALENDAR_LAYOUT_READ',PERMISSION_CALENDAR_LAYOUT_RW='PERMISSION_CALENDAR_LAYOUT_RW',PERMISSION_VISITOR_RECORD_DETAIL_AUDITLOG_READ='PERMISSION_VISITOR_RECORD_DETAIL_AUDITLOG_READ',PERMISSION_LOCATION_DETAIL_AUDITLOG_READ='PERMISSION_LOCATION_DETAIL_AUDITLOG_READ',PERMISSION_EMAIL_HISTORY_EXPORT='PERMISSION_EMAIL_HISTORY_EXPORT',PERMISSION_EMAIL_HISTORY_READ='PERMISSION_EMAIL_HISTORY_READ',PERMISSION_EMAIL_HISTORY_RW='PERMISSION_EMAIL_HISTORY_RW',PERMISSION_JOBS_READ='PERMISSION_JOBS_READ',PERMISSION_JOBS_RW='PERMISSION_JOBS_RW',PERMISSION_MULTIDUPLICATION_V3='PERMISSION_MULTIDUPLICATION_V3',PERMISSION_AI_PRICECHECK='PERMISSION_AI_PRICECHECK',PERMISSION_AI_DISPATCHER_READ='PERMISSION_AI_DISPATCHER_READ',PERMISSION_AI_DISPATCHER_RW='PERMISSION_AI_DISPATCHER_RW',PERMISSION_AI_ASSISTANT='PERMISSION_AI_ASSISTANT',PERMISSION_COMPANY_FOLDERS_RW='PERMISSION_COMPANY_FOLDERS_RW' }
export enum OpeningEntityTypeEnum { RAMP='RAMP',LOCATION='LOCATION',PARTNER_LOCATION='PARTNER_LOCATION',TEMPLATE_LOCATION='TEMPLATE_LOCATION' }
export enum DayEnum { MONDAY='MONDAY',TUESDAY='TUESDAY',WEDNESDAY='WEDNESDAY',THURSDAY='THURSDAY',FRIDAY='FRIDAY',SATURDAY='SATURDAY',SUNDAY='SUNDAY' }
export enum ProposedCurrencyEnum { eur='eur' }
export enum CodeTypeEnum { ACCOUNT='ACCOUNT',COST_CENTER='COST_CENTER',COST_UNIT='COST_UNIT',PROJECT='PROJECT',ON_BEHALF_OF='ON_BEHALF_OF' }
export enum ActiveCompanyModuleEnum { EXPEDITION='EXPEDITION',CARRIER='CARRIER',TIMESLOTS='TIMESLOTS',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',CUSTOMS_DECLARATION='CUSTOMS_DECLARATION' }
export enum AskedCompanyModuleEnum { EXPEDITION='EXPEDITION',CARRIER='CARRIER',TIMESLOTS='TIMESLOTS',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',CUSTOMS_DECLARATION='CUSTOMS_DECLARATION' }
export enum ModuleTypeEnum { EXPEDITION='EXPEDITION',CARRIER='CARRIER',TIMESLOTS='TIMESLOTS',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',CUSTOMS_DECLARATION='CUSTOMS_DECLARATION' }
export enum ModulesEnum { EXPEDITION='EXPEDITION',CARRIER='CARRIER',TIMESLOTS='TIMESLOTS',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',CUSTOMS_DECLARATION='CUSTOMS_DECLARATION' }
export enum JobStatusEnum { DRAFT='DRAFT',PENDING='PENDING',RUNNING='RUNNING',DONE='DONE',ERROR='ERROR',CANCELLED='CANCELLED' }
export enum ExportEntityTypeEnum { EXPEDITION='EXPEDITION',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',TIMESLOT='TIMESLOT',TIMESLOT_CALENDAR='TIMESLOT_CALENDAR',EXPEDITION_TEMPLATE='EXPEDITION_TEMPLATE',GROUP_DEMAND='GROUP_DEMAND',ATTACHMENTS='ATTACHMENTS',CMR_DOCUMENT='CMR_DOCUMENT',CUSTOMER_NOTIFICATION='CUSTOMER_NOTIFICATION',VISITOR_RECORD='VISITOR_RECORD',CARRIER_COMPANY='CARRIER_COMPANY',INVOICE_CARRIER='INVOICE_CARRIER',CAMERA_LOG='CAMERA_LOG',USER='USER',NOTIFICATION='NOTIFICATION',EMAIL_HISTORY='EMAIL_HISTORY',ASYNC_JOB='ASYNC_JOB' }
export enum JobTypeEnum { EXPEDITION_MULTI_DUPLICATION='EXPEDITION_MULTI_DUPLICATION',MULTIDUPLICATION_V3='MULTIDUPLICATION_V3',EXPORT='EXPORT',RESERVATION_MULTI_DUPLICATION='RESERVATION_MULTI_DUPLICATION',EXPEDITION_BULK_DISTRIBUTION='EXPEDITION_BULK_DISTRIBUTION' }
export enum JobStatusesEnum { DRAFT='DRAFT',PENDING='PENDING',RUNNING='RUNNING',DONE='DONE',ERROR='ERROR',CANCELLED='CANCELLED' }
export enum CategoriesEnum { EXPEDITION='EXPEDITION',RESERVATION='RESERVATION',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',COMMUNICATION='COMMUNICATION',OTHER='OTHER' }
export enum WeightModeTypeOrderEnum { SUMMED='SUMMED',CUSTOM='CUSTOM' }
export enum NotificationTypeEnum { SMS='SMS',EMAIL='EMAIL',NOTIFICATION_CENTER='NOTIFICATION_CENTER' }
export enum ExportFormatEnum { XLSX='XLSX',CSV='CSV' }
export enum ExportJobStatusEnum { PENDING='PENDING',RUNNING='RUNNING',DONE='DONE',ERROR='ERROR',CANCELLED='CANCELLED' }
export enum JobCategoryEnum { EXPEDITION='EXPEDITION',RESERVATION='RESERVATION',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',COMMUNICATION='COMMUNICATION',OTHER='OTHER' }
export enum PhaseEnum { VALIDATE='VALIDATE',EXECUTE='EXECUTE' }
export enum DistributionKindEnum { SPOT='SPOT',FIXED='FIXED',ASSIGN='ASSIGN' }
export enum StateFilterEnum { WITH_ERROR='WITH_ERROR',OK='OK' }
export enum ItemStatusEnum { PENDING='PENDING',RUNNING='RUNNING',DONE='DONE',ERROR='ERROR',SKIPPED='SKIPPED' }
export enum SnTypeEnum { FCA='FCA',DAP='DAP',EFXX='EFXX',DXX='DXX' }
export enum CustomsStatusEnum { CLEARED='CLEARED',WAITING4INVOICE='WAITING4INVOICE',WAITING4DELIVERY='WAITING4DELIVERY',SUBMITTED='SUBMITTED',ISSUED='ISSUED',FINISHED='FINISHED',WAITING4LRN='WAITING4LRN',LRN_ISSUED='LRN_ISSUED',WAITING4CLEARANCE_MISSING_INFO='WAITING4CLEARANCE_MISSING_INFO',WAITING4VDD='WAITING4VDD',VDD_ISSUED='VDD_ISSUED' }
export enum CustomsValueEnum { PAID='PAID',UNPAID='UNPAID' }
export enum CustomsAreaEnum { EU='EU',NONEU='NONEU' }
export enum CompanyNotificationValidityEnum { ALL='ALL',ACTIVE='ACTIVE' }
export enum NotifyTargetTypeEnum { DEPARTMENT='DEPARTMENT',USER='USER' }
export enum CreateReservationCheckEnum { NO_TIMESLOT_MODULE='NO_TIMESLOT_MODULE',NOT_VISIBLE_FOR_USER='NOT_VISIBLE_FOR_USER',CAN_CREATE_RESERVATION='CAN_CREATE_RESERVATION' }
export enum CameraTypeEnum { ENTRY='ENTRY',EXIT='EXIT' }
export enum CalendarLayoutStatusEnum { ACTIVE='ACTIVE',ARCHIVED='ARCHIVED' }
export enum CalendarLayoutSourceEnum { SYSTEM_DEFAULT='SYSTEM_DEFAULT',COMPANY='COMPANY',LOCATION='LOCATION' }
export enum CalendarLayoutScopeTypeEnum { SYSTEM_DEFAULT='SYSTEM_DEFAULT',COMPANY='COMPANY',LOCATION='LOCATION' }
export enum CalendarLayoutModelStatusEnum { ACTIVE='ACTIVE',ARCHIVED='ARCHIVED' }
export enum AllowedCarPlateMatchTypeEnum { EXACT='EXACT',CONTAINS='CONTAINS',STARTS_WITH='STARTS_WITH',ENDS_WITH='ENDS_WITH' }
export enum RuleEditModeEnum { TEXT='TEXT',BUILDER='BUILDER' }
export enum EventStateEnum { PENDING='PENDING',CLAIMED='CLAIMED',PROCESSED='PROCESSED',FAILED='FAILED' }
export enum EntityTypesEnum { EXPEDITION='EXPEDITION',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',TIMESLOT='TIMESLOT',TIMESLOT_CALENDAR='TIMESLOT_CALENDAR',EXPEDITION_TEMPLATE='EXPEDITION_TEMPLATE',GROUP_DEMAND='GROUP_DEMAND',ATTACHMENTS='ATTACHMENTS',CMR_DOCUMENT='CMR_DOCUMENT',CUSTOMER_NOTIFICATION='CUSTOMER_NOTIFICATION',VISITOR_RECORD='VISITOR_RECORD',CARRIER_COMPANY='CARRIER_COMPANY',INVOICE_CARRIER='INVOICE_CARRIER',CAMERA_LOG='CAMERA_LOG',USER='USER',NOTIFICATION='NOTIFICATION',EMAIL_HISTORY='EMAIL_HISTORY',ASYNC_JOB='ASYNC_JOB' }
export enum ParamTypeEnum { STRING='STRING',NUMBER='NUMBER',MONEY='MONEY',BOOLEAN='BOOLEAN',ENUM='ENUM',DATETIME='DATETIME',DURATION='DURATION',LIST='LIST',ENTITY_REF='ENTITY_REF' }
export enum FactTypeEnum { STRING='STRING',NUMBER='NUMBER',MONEY='MONEY',BOOLEAN='BOOLEAN',ENUM='ENUM',DATETIME='DATETIME',DURATION='DURATION',LIST='LIST',ENTITY_REF='ENTITY_REF' }
export enum FactCostEnum { CHEAP='CHEAP',EXPENSIVE='EXPENSIVE' }
export enum FactQuantifierEnum { SINGLE='SINGLE',ALL='ALL',ANY='ANY' }
export enum ExecutionStateEnum { PENDING='PENDING',EXECUTED='EXECUTED',SKIPPED='SKIPPED',FAILED='FAILED' }
export enum ActivityKindEnum { EVENT_QUEUED='EVENT_QUEUED',RULE_MATCHED='RULE_MATCHED',RULE_SKIPPED='RULE_SKIPPED',RULE_FAILED='RULE_FAILED',EVENT_FINISHED='EVENT_FINISHED',EVENT_FAILED='EVENT_FAILED' }
export enum WebhookDeliveryStatusEnum { PENDING='PENDING',IN_PROGRESS='IN_PROGRESS',SENT='SENT',FAILED='FAILED' }
export enum ReminderUnitEnum { HOURS='HOURS',DAYS='DAYS' }
export enum ReminderDirectionEnum { BEFORE='BEFORE',AFTER='AFTER' }
export enum EmailStageStateEnum { WAITING='WAITING',DONE='DONE',ERROR='ERROR' }
export enum EmailHistoryAggStatusEnum { ERROR='ERROR',IN_PROGRESS='IN_PROGRESS',DONE='DONE' }
export enum NotificationChannelsEnum { SMS='SMS',EMAIL='EMAIL',NOTIFICATION_CENTER='NOTIFICATION_CENTER' }
export enum AvailableEntityTypesEnum { EXPEDITION='EXPEDITION',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',TIMESLOT='TIMESLOT',TIMESLOT_CALENDAR='TIMESLOT_CALENDAR',EXPEDITION_TEMPLATE='EXPEDITION_TEMPLATE',GROUP_DEMAND='GROUP_DEMAND',ATTACHMENTS='ATTACHMENTS',CMR_DOCUMENT='CMR_DOCUMENT',CUSTOMER_NOTIFICATION='CUSTOMER_NOTIFICATION',VISITOR_RECORD='VISITOR_RECORD',CARRIER_COMPANY='CARRIER_COMPANY',INVOICE_CARRIER='INVOICE_CARRIER',CAMERA_LOG='CAMERA_LOG',USER='USER',NOTIFICATION='NOTIFICATION',EMAIL_HISTORY='EMAIL_HISTORY',ASYNC_JOB='ASYNC_JOB' }
export enum CarrierOrGroupEnum { CARRIER='CARRIER',GROUP='GROUP' }
export enum SelectedItemTypeEnum { CARRIER='CARRIER',GROUP='GROUP',API='API' }
export enum ApiTypesEnum { DACHSER='DACHSER',SCHENKER='SCHENKER',DHL='DHL',FEDEX='FEDEX' }
export enum CategoryEnum { USER_ACTION='USER_ACTION',INTEGRATION='INTEGRATION' }
export enum AuditCategoryEnum { USER_ACTION='USER_ACTION',INTEGRATION='INTEGRATION' }
export enum SourceEnum { USER='USER',AOP='AOP',CDC='CDC' }
export enum ActionOutcomeEnum { INFO='INFO',OK='OK',ERROR='ERROR' }
export enum KindEnum { DESCRIPTION='DESCRIPTION',DATA_CHANGE='DATA_CHANGE',SNAPSHOT='SNAPSHOT',DATA_CHANGE_KEY='DATA_CHANGE_KEY' }
export enum AuditEntityTypeEnum { PARTNER='PARTNER',EXPEDITION='EXPEDITION',TIMESLOT='TIMESLOT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',SHIPMENT='SHIPMENT',VISITOR_RECORD='VISITOR_RECORD',ATTACHMENT='ATTACHMENT',CARRIER='CARRIER',LOCATION='LOCATION',RAMP='RAMP' }
export enum AuditActionEnum { EXTERNAL_ID_UPDATED='EXTERNAL_ID_UPDATED',MODULE_ENABLED='MODULE_ENABLED',MODULE_DISABLED='MODULE_DISABLED',CREATE_PARTNER='CREATE_PARTNER',UPDATE_PARTNER='UPDATE_PARTNER',RESERVATION_CREATED='RESERVATION_CREATED',RESERVATION_UPDATE_CARGO='RESERVATION_UPDATE_CARGO',RESERVATION_UPDATE_CARRIER_INFO='RESERVATION_UPDATE_CARRIER_INFO',RESERVATION_UPDATE_TIMESLOT='RESERVATION_UPDATE_TIMESLOT',RESERVATION_UPDATE_CARRIER_ENTITY='RESERVATION_UPDATE_CARRIER_ENTITY',RESERVATION_UPDATE_LABELS='RESERVATION_UPDATE_LABELS',RESERVATION_UPDATED='RESERVATION_UPDATED',RESERVATION_UPDATE_NAME='RESERVATION_UPDATE_NAME',RESERVATION_UPDATE_STATE='RESERVATION_UPDATE_STATE',RESERVATION_UPDATE_NOTE='RESERVATION_UPDATE_NOTE',RESERVATION_UPDATE_CARRIER_NOTE='RESERVATION_UPDATE_CARRIER_NOTE',RESERVATION_UPDATE_INTERNAL_NOTE='RESERVATION_UPDATE_INTERNAL_NOTE',RESERVATION_UPDATE_CAR_PLATE='RESERVATION_UPDATE_CAR_PLATE',RESERVATION_UPDATE_DRIVER_PHONE='RESERVATION_UPDATE_DRIVER_PHONE',RESERVATION_UPDATE_DRIVER_NAME='RESERVATION_UPDATE_DRIVER_NAME',RESERVATION_ADD_ATTACHMENT='RESERVATION_ADD_ATTACHMENT',RESERVATION_DELETE_ATTACHMENT='RESERVATION_DELETE_ATTACHMENT',RESERVATION_ADD_INTERNAL_ATTACHMENT='RESERVATION_ADD_INTERNAL_ATTACHMENT',RESERVATION_DELETE_INTERNAL_ATTACHMENT='RESERVATION_DELETE_INTERNAL_ATTACHMENT',RESERVATION_UPDATE_TRUCK='RESERVATION_UPDATE_TRUCK',RESERVATION_ARCHIVED='RESERVATION_ARCHIVED',RESERVATION_UNARCHIVED='RESERVATION_UNARCHIVED',RESERVATION_UNITS_DISCREPANCY='RESERVATION_UNITS_DISCREPANCY',CREATE_RESERVATION='CREATE_RESERVATION',UPDATE_ORDER_RESERVATION='UPDATE_ORDER_RESERVATION',ARCHIVE_RESERVATION='ARCHIVE_RESERVATION',UNARCHIVE_RESERVATION='UNARCHIVE_RESERVATION',INCOMING_DATA_COMMUNICATION='INCOMING_DATA_COMMUNICATION',OUTGOING_DATA_COMMUNICATION='OUTGOING_DATA_COMMUNICATION',WEBHOOK_SENT='WEBHOOK_SENT',WHATSAPP_TIMESLOT_GO_TO_RAMP='WHATSAPP_TIMESLOT_GO_TO_RAMP',WHATSAPP_TIMESLOT_GO_TO_RAMP_SENT='WHATSAPP_TIMESLOT_GO_TO_RAMP_SENT',WHATSAPP_TIMESLOT_ON_TIME_CHECK='WHATSAPP_TIMESLOT_ON_TIME_CHECK',WHATSAPP_TIMESLOT_ON_TIME_CHECK_SENT='WHATSAPP_TIMESLOT_ON_TIME_CHECK_SENT',WHATSAPP_TIMESLOT_ON_TIME_CHECK_REPLY='WHATSAPP_TIMESLOT_ON_TIME_CHECK_REPLY',CUSTOMER_SENT_ATTACHMENT='CUSTOMER_SENT_ATTACHMENT',CUSTOMER_SENT_INTERNAL_ATTACHMENT='CUSTOMER_SENT_INTERNAL_ATTACHMENT',CHANGE_WF_STATE='CHANGE_WF_STATE',EXPEDITION_MERGED='EXPEDITION_MERGED',EXPEDITION_CHANGED='EXPEDITION_CHANGED',CREATE_EXPEDITION='CREATE_EXPEDITION',UPDATE_EXPEDITION='UPDATE_EXPEDITION',CANCEL_EXPEDITION='CANCEL_EXPEDITION',MANUAL_EXPEDITION='MANUAL_EXPEDITION',EXPEDITION_MERGED_FROM='EXPEDITION_MERGED_FROM',EXPEDITION_MERGED_TO='EXPEDITION_MERGED_TO',EXPEDITION_DUPLICATED_FROM='EXPEDITION_DUPLICATED_FROM',EXPEDITION_MULTI_DUPLICATED_FROM='EXPEDITION_MULTI_DUPLICATED_FROM',EXPEDITION_PREFILLED_FROM='EXPEDITION_PREFILLED_FROM',EXPEDITION_INVOICE_STATUS_CHANGED='EXPEDITION_INVOICE_STATUS_CHANGED',CHANGE_RESPONSIBLE_PERSON='CHANGE_RESPONSIBLE_PERSON',DISTRIBUTION_CREATED='DISTRIBUTION_CREATED',DISTRIBUTION_UPDATED='DISTRIBUTION_UPDATED',DISTRIBUTION_CARRIERS_ADDED='DISTRIBUTION_CARRIERS_ADDED',QUOTE_PRICE_OFFERED='QUOTE_PRICE_OFFERED',QUOTE_PRICE_UPDATED='QUOTE_PRICE_UPDATED',QUOTE_ACCEPTED_BY_CUSTOMER='QUOTE_ACCEPTED_BY_CUSTOMER',QUOTE_ACCEPTED_NEED_RECONFIRM='QUOTE_ACCEPTED_NEED_RECONFIRM',QUOTE_RECONFIRMED='QUOTE_RECONFIRMED',QUOTE_REJECTED_BY_CARRIER='QUOTE_REJECTED_BY_CARRIER',QUOTE_REJECTED_BY_CUSTOMER='QUOTE_REJECTED_BY_CUSTOMER',CREATE_QUOTE='CREATE_QUOTE',CREATE_NEW_QUOTE='CREATE_NEW_QUOTE',CREATE_ANOTHER_QUOTE='CREATE_ANOTHER_QUOTE',REJECT_QUOTE='REJECT_QUOTE',REJECT_QUOTE_BY_CUSTOMER='REJECT_QUOTE_BY_CUSTOMER',CANCEL_QUOTE_BY_CARRIER='CANCEL_QUOTE_BY_CARRIER',ACCEPT_FIXED_PRICE='ACCEPT_FIXED_PRICE',REJECT_FIXED_PRICE='REJECT_FIXED_PRICE',ACCEPT_DEMAND_BY_CUSTOMER='ACCEPT_DEMAND_BY_CUSTOMER',CREATE_DEMAND_AUCTION='CREATE_DEMAND_AUCTION',CREATE_SPOT_DEMAND_AUCTION='CREATE_SPOT_DEMAND_AUCTION',ADD_CARRIERS_TO_AUCTION='ADD_CARRIERS_TO_AUCTION',CHANGE_VALIDITY_DEMAND_AUCTION='CHANGE_VALIDITY_DEMAND_AUCTION',CHANGE_VALIDITY_SPOT_DEMAND_AUCTION='CHANGE_VALIDITY_SPOT_DEMAND_AUCTION',CHANGE_VALIDITY_ASSIGNMENT='CHANGE_VALIDITY_ASSIGNMENT',NEW_TIEBREAK='NEW_TIEBREAK',CARRIER_RECONFIRM_SPOT='CARRIER_RECONFIRM_SPOT',CUSTOMER_RECONFIRM_SPOT='CUSTOMER_RECONFIRM_SPOT',RECONFIRMED_EXPEDITION='RECONFIRMED_EXPEDITION',ACCEPT_ASSIGNMENT='ACCEPT_ASSIGNMENT',DENY_ASSIGNMENT='DENY_ASSIGNMENT',CREATE_ASSIGNMENT='CREATE_ASSIGNMENT',DIRECT_CARRIER_ASSIGNMENT='DIRECT_CARRIER_ASSIGNMENT',SAVE_CARRIER_ASSIGNED_FORM='SAVE_CARRIER_ASSIGNED_FORM',ASSIGN_CAR='ASSIGN_CAR',ASSIGN_DRIVER='ASSIGN_DRIVER',ASSIGN_CARRIER_DISPATCHER='ASSIGN_CARRIER_DISPATCHER',CREATE_ONE_TIME_CAR='CREATE_ONE_TIME_CAR',CREATE_GPS_COORDINATION='CREATE_GPS_COORDINATION',CREATE_CARRIER='CREATE_CARRIER',UPDATE_CARRIER='UPDATE_CARRIER',ADD_CARRIER_CARRIER_AND_GROUPS='ADD_CARRIER_CARRIER_AND_GROUPS',DELETE_CARRIER_CARRIER_AND_GROUPS='DELETE_CARRIER_CARRIER_AND_GROUPS',CHANGE_STATUS_CARRIER='CHANGE_STATUS_CARRIER',CHANGE_STATUS_CARRIER_AND_GROUPS='CHANGE_STATUS_CARRIER_AND_GROUPS',CREATE_GROUP_CARRIER_AND_GROUPS='CREATE_GROUP_CARRIER_AND_GROUPS',ADD_TO_GROUP_CARRIER='ADD_TO_GROUP_CARRIER',UPLOAD_DOCUMENT='UPLOAD_DOCUMENT',UPLOAD_DOCUMENT_MOBILE_APP='UPLOAD_DOCUMENT_MOBILE_APP',DELETE_DOCUMENT='DELETE_DOCUMENT',RE_PROCESS_ATTACHMENT='RE_PROCESS_ATTACHMENT',MISSING_PDF_ATTACHMENT='MISSING_PDF_ATTACHMENT',DELETED_CARRIER_INVOICE_ATTACHMENT='DELETED_CARRIER_INVOICE_ATTACHMENT',EXPEDITION_ADD_INTERNAL_DOCUMENT='EXPEDITION_ADD_INTERNAL_DOCUMENT',EXPEDITION_DELETE_INTERNAL_DOCUMENT='EXPEDITION_DELETE_INTERNAL_DOCUMENT',START_INVOICE_CARRIER_WORKFLOW='START_INVOICE_CARRIER_WORKFLOW',CARRIER_INVOICE_EDITED_BY_USER='CARRIER_INVOICE_EDITED_BY_USER',INVOICE_PROCESSING_BLOCKED_DUPLICATE='INVOICE_PROCESSING_BLOCKED_DUPLICATE',FAILED_CARRIER_INVOICE_ITAB_API_CALL='FAILED_CARRIER_INVOICE_ITAB_API_CALL',FAILED_CARRIER_INVOICE_ITAB_FILE_API_CALL='FAILED_CARRIER_INVOICE_ITAB_FILE_API_CALL',SUCCESSFUL_CARRIER_INVOICE_ITAB_API_CALL='SUCCESSFUL_CARRIER_INVOICE_ITAB_API_CALL',SUCCESSFUL_CARRIER_INVOICE_ITAB_FILE_API_CALL='SUCCESSFUL_CARRIER_INVOICE_ITAB_FILE_API_CALL',SKIPPED_CARRIER_INVOICE_ITAB_API_CALL_DUE_TO_OTHER_DOCUMENT='SKIPPED_CARRIER_INVOICE_ITAB_API_CALL_DUE_TO_OTHER_DOCUMENT',SKIPPED_CARRIER_INVOICE_MULTIPLE_PRIMARIES='SKIPPED_CARRIER_INVOICE_MULTIPLE_PRIMARIES',SKIPPED_CARRIER_INVOICE_REPROCESS_ALREADY_PUBLISHED='SKIPPED_CARRIER_INVOICE_REPROCESS_ALREADY_PUBLISHED',CREATE_INTERNAL_COMMENT='CREATE_INTERNAL_COMMENT',UPDATE_INTERNAL_COMMENT='UPDATE_INTERNAL_COMMENT',DELETE_INTERNAL_COMMENT='DELETE_INTERNAL_COMMENT',NEW_INTERNAL_CHAT='NEW_INTERNAL_CHAT',NEW_COMMENT='NEW_COMMENT',NEW_MESSAGE='NEW_MESSAGE',LABEL_CHANGED='LABEL_CHANGED',READ_NOTIFICATION='READ_NOTIFICATION',ADD_SUBSCRIBER='ADD_SUBSCRIBER',FINISH_JOB='FINISH_JOB',FINISH_LOCATION='FINISH_LOCATION',FINISH_LOCATION_MOBILE_APP='FINISH_LOCATION_MOBILE_APP',FINISH_UPDATE_LOCATION_CUSTOMER='FINISH_UPDATE_LOCATION_CUSTOMER',SN_ADD_ATTACHMENT='SN_ADD_ATTACHMENT',SN_ADD_INTERNAL_ATTACHMENT='SN_ADD_INTERNAL_ATTACHMENT',SN_ARCHIVE='SN_ARCHIVE',SN_CHANGED_RESPONSIBLE_PERSON='SN_CHANGED_RESPONSIBLE_PERSON',SN_CHANGED_SHIPMENT_STATE_CODE='SN_CHANGED_SHIPMENT_STATE_CODE',SN_CHANGE_LOADING_SLOT='SN_CHANGE_LOADING_SLOT',SN_CHANGE_UNLOADING_SLOT='SN_CHANGE_UNLOADING_SLOT',SN_CREATED='SN_CREATED',SN_DELETE_ATTACHMENT='SN_DELETE_ATTACHMENT',SN_DELETE_INTERNAL_ATTACHMENT='SN_DELETE_INTERNAL_ATTACHMENT',SN_MERGED_TO_EXPEDITION='SN_MERGED_TO_EXPEDITION',SN_OVERWRITE_LABELS='SN_OVERWRITE_LABELS',SN_UPDATED='SN_UPDATED',SN_UPDATE_CARGO='SN_UPDATE_CARGO',SN_UPDATE_CARGO_INFO='SN_UPDATE_CARGO_INFO',SN_UPDATE_INTERNAL_INFO='SN_UPDATE_INTERNAL_INFO',SN_UPDATE_INTERNAL_NOTE='SN_UPDATE_INTERNAL_NOTE',SN_UPDATE_LABELS='SN_UPDATE_LABELS',SN_UPDATE_TIMESLOTS='SN_UPDATE_TIMESLOTS',SH_CREATE='SH_CREATE',SH_ADD_ATTACHMENT='SH_ADD_ATTACHMENT',SH_ADD_INTERNAL_ATTACHMENT='SH_ADD_INTERNAL_ATTACHMENT',SH_DELETE_ATTACHMENT='SH_DELETE_ATTACHMENT',SH_DELETE_INTERNAL_ATTACHMENT='SH_DELETE_INTERNAL_ATTACHMENT',SH_ARCHIVE='SH_ARCHIVE',SH_UPDATE_CARGO='SH_UPDATE_CARGO',SH_UPDATE_CARGO_INFO='SH_UPDATE_CARGO_INFO',SH_UPDATE_LABELS='SH_UPDATE_LABELS',SH_UPDATE_LOADING_DATE='SH_UPDATE_LOADING_DATE',SH_UPDATE_LOADING_PLACE='SH_UPDATE_LOADING_PLACE',SH_UPDATE_UNLOADING_DATE='SH_UPDATE_UNLOADING_DATE',SH_UPDATE_UNLOADING_PLACE='SH_UPDATE_UNLOADING_PLACE',VR_CREATED='VR_CREATED',VR_UPDATED='VR_UPDATED',VR_ARCHIVED='VR_ARCHIVED',VR_LABELS_UPDATED='VR_LABELS_UPDATED',VR_STATUS_CHANGED='VR_STATUS_CHANGED',LOCATION_CREATED='LOCATION_CREATED',LOCATION_UPDATED='LOCATION_UPDATED',LOCATION_UPDATED_BASIC_INFO='LOCATION_UPDATED_BASIC_INFO',LOCATION_UPDATED_RAMPS_CONFIG='LOCATION_UPDATED_RAMPS_CONFIG',LOCATION_UPDATED_CARRIERS_API='LOCATION_UPDATED_CARRIERS_API',LOCATION_UPDATED_CMR_SIGNING='LOCATION_UPDATED_CMR_SIGNING',LOCATION_UPDATED_OPENING_HOURS='LOCATION_UPDATED_OPENING_HOURS',LOCATION_ACL_CHANGED='LOCATION_ACL_CHANGED',LOCATION_ACTIVATED='LOCATION_ACTIVATED',LOCATION_DELETED='LOCATION_DELETED',LOCATION_SUPERSEDED='LOCATION_SUPERSEDED',RAMP_CREATED='RAMP_CREATED',RAMP_UPDATED='RAMP_UPDATED',RAMP_UPDATED_OPENING_HOURS='RAMP_UPDATED_OPENING_HOURS',RAMP_ACTIVATED='RAMP_ACTIVATED',RAMP_DELETED='RAMP_DELETED',RAMP_ORDER_CHANGED='RAMP_ORDER_CHANGED',INVOICE_BLOCKED_COVERED_BY_INVOICE='INVOICE_BLOCKED_COVERED_BY_INVOICE',INVOICE_BLOCKED_COVERED_BY_STRUCTURED_DOCUMENT='INVOICE_BLOCKED_COVERED_BY_STRUCTURED_DOCUMENT',CHANGE_DOCUMENT_TYPE='CHANGE_DOCUMENT_TYPE',CHANGE_INTERNAL_DOCUMENT_TYPE='CHANGE_INTERNAL_DOCUMENT_TYPE',AI_DISPATCHER_RULE_EXECUTED='AI_DISPATCHER_RULE_EXECUTED',AI_DISPATCHER_RULE_FAILED='AI_DISPATCHER_RULE_FAILED',SKIPPED_CARRIER_INVOICE_PROCESSING_IN_PROGRESS='SKIPPED_CARRIER_INVOICE_PROCESSING_IN_PROGRESS',SKIPPED_CARRIER_INVOICE_PUBLISH_DISABLED='SKIPPED_CARRIER_INVOICE_PUBLISH_DISABLED',FAILED_CARRIER_INVOICE_PDF_GENERATION='FAILED_CARRIER_INVOICE_PDF_GENERATION',FAILED_EXPEDITION_INVOICE_STATE_UPDATE='FAILED_EXPEDITION_INVOICE_STATE_UPDATE',EXPEDITION_FOLDERS_CHANGED='EXPEDITION_FOLDERS_CHANGED',RESERVATION_FOLDERS_CHANGED='RESERVATION_FOLDERS_CHANGED' }
export enum KeyEnum { EMAIL_NOTIFICATION='EMAIL_NOTIFICATION' }
export enum CompanyTypeEnum { CUSTOMER='CUSTOMER',CARRIER='CARRIER',COMPANY='COMPANY' }
export enum RolesEnum { ROLE_CARRIER='ROLE_CARRIER',ROLE_CUSTOMER='ROLE_CUSTOMER',ROLE_DRIVER='ROLE_DRIVER',ROLE_COMPANY='ROLE_COMPANY',ROLE_COMPANY_ADMIN='ROLE_COMPANY_ADMIN',ROLE_CUSTOMER_ADMIN='ROLE_CUSTOMER_ADMIN',ROLE_CARRIER_ADMIN='ROLE_CARRIER_ADMIN',ROLE_ADMIN='ROLE_ADMIN',ROLE_SM_NOTIFY='ROLE_SM_NOTIFY',ROLE_TS_NOTIFY='ROLE_TS_NOTIFY',ROLE_EXP_NOTIFY='ROLE_EXP_NOTIFY',ROLE_SH_NOTIFY='ROLE_SH_NOTIFY',ROLE_SN_NOTIFY='ROLE_SN_NOTIFY',ROLE_EXP_RW='ROLE_EXP_RW',ROLE_SN_RW='ROLE_SN_RW' }
export enum SchenkerAddonTypeSelectorEnum { RADIO_BOX='RADIO_BOX',CHECK_BOX='CHECK_BOX' }
export enum MessageTypeFilterEnum { READ='READ',UNREAD='UNREAD',BOTH='BOTH' }
export enum TypeEnum { ACCEPT_FIXED_PRICE='ACCEPT_FIXED_PRICE',DECLINED_FIXED_PRICE='DECLINED_FIXED_PRICE',NEW_DEMAND='NEW_DEMAND',CANCEL_DEMAND='CANCEL_DEMAND',NEW_MESSAGE='NEW_MESSAGE',SPOT_EXPIRED='SPOT_EXPIRED',FIXED_PRICE_EXPIRED='FIXED_PRICE_EXPIRED',CAR_PLATE_ASSIGN='CAR_PLATE_ASSIGN',CARGO_LOADED='CARGO_LOADED',CARGO_UNLOADED='CARGO_UNLOADED',CARGO_LOADED_UNLOADED='CARGO_LOADED_UNLOADED',LOCATION_ARRIVAL='LOCATION_ARRIVAL',FILE_UPLOADED='FILE_UPLOADED',CHANGE_TIMESLOTS='CHANGE_TIMESLOTS',RECONFIRMED_DEMAND='RECONFIRMED_DEMAND',RESPONSIBLE_PERSON_ASSIGNED='RESPONSIBLE_PERSON_ASSIGNED',SUBSCRIBER_ASSIGNED='SUBSCRIBER_ASSIGNED',CHANGE_CAR_INFO='CHANGE_CAR_INFO',NEW_MESSAGE_SN='NEW_MESSAGE_SN',NEW_MESSAGE_GD='NEW_MESSAGE_GD',NEW_DOCUMENT_SN='NEW_DOCUMENT_SN',AI_DISPATCHER_NOTIFICATION='AI_DISPATCHER_NOTIFICATION' }
export enum NextActionTypeEnum { CONFIRM_LOADING='CONFIRM_LOADING',CONFIRM_UNLOADING='CONFIRM_UNLOADING',CONFIRM_BOTH='CONFIRM_BOTH',CONFIRM_ARRIVAL='CONFIRM_ARRIVAL' }
export enum ContactTypeEnum { PARTNER_LOCATION='PARTNER_LOCATION',COMPANY_LOCATION='COMPANY_LOCATION' }
export enum InvoiceStateEnum { INVOICED='INVOICED',NON_INVOICED='NON_INVOICED' }
export enum InvoiceRebillingTypeEnum { NON_REBILLING='NON_REBILLING',INTERNAL_REBILLING='INTERNAL_REBILLING',EXTERNAL_REBILLING='EXTERNAL_REBILLING',OTHER='OTHER' }
export enum EmailStatusesEnum { FAILED='FAILED',SEND='SEND',ACCEPTED='ACCEPTED',DELIVERED='DELIVERED',READ_EMAIL='READ_EMAIL',READ_IN_APP='READ_IN_APP',DACHSER_FAILED='DACHSER_FAILED',DACHSER_IMPORTED='DACHSER_IMPORTED',EXTERNAL_API_FAILED='EXTERNAL_API_FAILED',EXTERNAL_API_IMPORTED='EXTERNAL_API_IMPORTED',UNDEFINED='UNDEFINED' }
export enum DemandPseudoStatesEnum { ACTIVE_OFFERS='ACTIVE_OFFERS',ALL_OFFERS='ALL_OFFERS',REJECTED_BY_CARRIER='REJECTED_BY_CARRIER',REJECTED_BY_CUSTOMER='REJECTED_BY_CUSTOMER',NO_OFFERS='NO_OFFERS' }
export enum WeightModeEnum { TOTAL_WEIGHT='TOTAL_WEIGHT',SKU_WEIGHT='SKU_WEIGHT' }
export enum PermissionEnum { PERMISSION_COMPANY_DETAIL='PERMISSION_COMPANY_DETAIL',PERMISSION_COMPANY_PERMISSIONS='PERMISSION_COMPANY_PERMISSIONS',PERMISSION_MODULE_DASHBOARD='PERMISSION_MODULE_DASHBOARD',PERMISSION_EXPEDITION='PERMISSION_EXPEDITION',PERMISSION_TEMPLATE='PERMISSION_TEMPLATE',PERMISSION_MY_CARRIERS='PERMISSION_MY_CARRIERS',PERMISSION_MY_CARRIERS_READ='PERMISSION_MY_CARRIERS_READ',PERMISSION_MY_CARRIERS_RW='PERMISSION_MY_CARRIERS_RW',PERMISSION_CARRIER_GROUP='PERMISSION_CARRIER_GROUP',PERMISSION_CARRIER_GROUP_READ='PERMISSION_CARRIER_GROUP_READ',PERMISSION_CARRIER_GROUP_RW='PERMISSION_CARRIER_GROUP_RW',PERMISSION_PARTNERS='PERMISSION_PARTNERS',PERMISSION_CARRIER_CATALOGUE='PERMISSION_CARRIER_CATALOGUE',PERMISSION_SUPPLIER_MANIFEST='PERMISSION_SUPPLIER_MANIFEST',PERMISSION_RESERVATION='PERMISSION_RESERVATION',PERMISSION_EXCEPTIONS='PERMISSION_EXCEPTIONS',PERMISSION_DEMANDS='PERMISSION_DEMANDS',PERMISSION_SHIPMENTS='PERMISSION_SHIPMENTS',PERMISSION_MOBILE_APP='PERMISSION_MOBILE_APP',PERMISSION_ADMIN='PERMISSION_ADMIN',PERMISSION_LOCATIONS='PERMISSION_LOCATIONS',PERMISSION_LOCATIONS_LOV='PERMISSION_LOCATIONS_LOV',PERMISSION_TIMESLOTS='PERMISSION_TIMESLOTS',PERMISSION_TIMESLOT_READ='PERMISSION_TIMESLOT_READ',PERMISSION_TIMESLOT_FULLREAD='PERMISSION_TIMESLOT_FULLREAD',PERMISSION_TIMESLOT_CREATE='PERMISSION_TIMESLOT_CREATE',PERMISSION_TIMESLOT_DELETE='PERMISSION_TIMESLOT_DELETE',PERMISSION_TIMESLOT_CHANGE_WORKFLOW='PERMISSION_TIMESLOT_CHANGE_WORKFLOW',PERMISSION_TIMESLOT_CHANGE_ORDER='PERMISSION_TIMESLOT_CHANGE_ORDER',PERMISSION_TIMESLOT_CHANGE_SLOT='PERMISSION_TIMESLOT_CHANGE_SLOT',PERMISSION_TIMESLOT_CHANGE_CARRIER='PERMISSION_TIMESLOT_CHANGE_CARRIER',PERMISSION_TIMESLOT_CHANGE_CARRIER_INFO='PERMISSION_TIMESLOT_CHANGE_CARRIER_INFO',PERMISSION_TIMESLOT_DUPLICATE='PERMISSION_TIMESLOT_DUPLICATE',PERMISSION_TIMESLOT_CALENDAR='PERMISSION_TIMESLOT_CALENDAR',PERMISSION_TIMESLOT_PUT2TABLE='PERMISSION_TIMESLOT_PUT2TABLE',PERMISSION_TIMESLOT_CHANGE_LABELS='PERMISSION_TIMESLOT_CHANGE_LABELS',PERMISSION_TIMESLOT_CHANGE_PARTIES='PERMISSION_TIMESLOT_CHANGE_PARTIES',PERMISSION_TIMESLOT_CHANGE_STATUS='PERMISSION_TIMESLOT_CHANGE_STATUS',PERMISSION_TIMESLOT_CHANGE_INFO='PERMISSION_TIMESLOT_CHANGE_INFO',PERMISSION_TIMESLOT_DETAIL_READ='PERMISSION_TIMESLOT_DETAIL_READ',PERMISSION_TIMESLOT_DETAIL_RW='PERMISSION_TIMESLOT_DETAIL_RW',PERMISSION_TIMESLOT_DETAIL_AUDITLOG_READ='PERMISSION_TIMESLOT_DETAIL_AUDITLOG_READ',PERMISSION_TIMESLOT_DASHBOARD_READ='PERMISSION_TIMESLOT_DASHBOARD_READ',PERMISSION_TIMESLOT_DASHBOARD_RW='PERMISSION_TIMESLOT_DASHBOARD_RW',PERMISSION_TIMESLOT_DASHBOARDMULTI_READ='PERMISSION_TIMESLOT_DASHBOARDMULTI_READ',PERMISSION_TIMESLOT_DASHBOARDMULTI_RW='PERMISSION_TIMESLOT_DASHBOARDMULTI_RW',PERMISSION_TIMESLOT_LIST_READ='PERMISSION_TIMESLOT_LIST_READ',PERMISSION_TIMESLOT_LIST_RW='PERMISSION_TIMESLOT_LIST_RW',PERMISSION_READ_LOCATIONS='PERMISSION_READ_LOCATIONS',PERMISSION_CREATE_LOCATIONS='PERMISSION_CREATE_LOCATIONS',PERMISSION_DELETE_LOCATIONS='PERMISSION_DELETE_LOCATIONS',PERMISSION_CREATE_RAMPS='PERMISSION_CREATE_RAMPS',PERMISSION_DELETE_RAMPS='PERMISSION_DELETE_RAMPS',PERMISSION_UPDATE_RAMPS='PERMISSION_UPDATE_RAMPS',PERMISSION_CREATE_EXCEPTIONS='PERMISSION_CREATE_EXCEPTIONS',PERMISSION_DELETE_EXCEPTIONS='PERMISSION_DELETE_EXCEPTIONS',PERMISSION_CAM_ENTRYLOG='PERMISSION_CAM_ENTRYLOG',PERMISSION_CAM_SETTINGS='PERMISSION_CAM_SETTINGS',PERMISSION_CAM_SETTINGS_REGISTERED_CAMS='PERMISSION_CAM_SETTINGS_REGISTERED_CAMS',PERMISSION_SN_FIX='PERMISSION_SN_FIX',PERMISSION_SN_CANCEL='PERMISSION_SN_CANCEL',PERMISSION_SUPP_NOTIFICATION_RW='PERMISSION_SUPP_NOTIFICATION_RW',PERMISSION_SN_DETAIL_AUDITLOG_READ='PERMISSION_SN_DETAIL_AUDITLOG_READ',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_RW='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_RW',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ_WITHOUTPRICE='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ_WITHOUTPRICE',PERMISSION_EXPEDITION_LIST_READ='PERMISSION_EXPEDITION_LIST_READ',PERMISSION_EXPEDITION_LIST_RW='PERMISSION_EXPEDITION_LIST_RW',PERMISSION_EXPEDITION_LIST_READ_WITHOUTPRICE='PERMISSION_EXPEDITION_LIST_READ_WITHOUTPRICE',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_READ='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_READ',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_RW',PERMISSION_EXPEDITION_MESSAGES_READ='PERMISSION_EXPEDITION_MESSAGES_READ',PERMISSION_EXPEDITION_MESSAGES_RW='PERMISSION_EXPEDITION_MESSAGES_RW',PERMISSION_EXPEDITION_CREATE='PERMISSION_EXPEDITION_CREATE',PERMISSION_PARTNER_LOCATION_MIGRATION='PERMISSION_PARTNER_LOCATION_MIGRATION',PERMISSION_CARRIER_EXPEDITION_RW='PERMISSION_CARRIER_EXPEDITION_RW',PERMISSION_SUPP_SHIPMENT_RW='PERMISSION_SUPP_SHIPMENT_RW',PERMISSION_COMPANY_NOTIFICATIONS='PERMISSION_COMPANY_NOTIFICATIONS',PERMISSION_COMPANY_INHERITED_COMPANIES='PERMISSION_COMPANY_INHERITED_COMPANIES',PERMISSION_SETTINGS_MAIL='PERMISSION_SETTINGS_MAIL',RESTRICT_NO_EXP='RESTRICT_NO_EXP',RESTRICT_NO_EXP_NO_TIMESLOT='RESTRICT_NO_EXP_NO_TIMESLOT',RESTRICT_NO_SUPPNOTIFICATION='RESTRICT_NO_SUPPNOTIFICATION',RESTRICT_NO_SETTINGS='RESTRICT_NO_SETTINGS',PERMISSION_SETTINGS_PARTNERS_READ='PERMISSION_SETTINGS_PARTNERS_READ',PERMISSION_SETTINGS_PARTNERS_RW='PERMISSION_SETTINGS_PARTNERS_RW',PERMISSION_REPORT='PERMISSION_REPORT',PERMISSION_SHIPMENT_MANUALIMPORT='PERMISSION_SHIPMENT_MANUALIMPORT',PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_READ='PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_READ',PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW='PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW',PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_READ='PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_READ',PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_RW='PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CMR_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CMR_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CMR_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CMR_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_RW',PERMISSION_EXPEDITION_DETAIL_AUDITLOG_READ='PERMISSION_EXPEDITION_DETAIL_AUDITLOG_READ',PERMISSION_EXPEDITION_PRICE='PERMISSION_EXPEDITION_PRICE',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_ORDERS_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_ORDERS_RW',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_INVOICES_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_INVOICES_RW',PERMISSION_EXPEDITION_CREATE_DISTRIBUTION_RW='PERMISSION_EXPEDITION_CREATE_DISTRIBUTION_RW',PERMISSION_SETTINGS_COMPANY_PROFILE='PERMISSION_SETTINGS_COMPANY_PROFILE',PERMISSION_SETTINGS_COMPANY_NOTIFICATIONS='PERMISSION_SETTINGS_COMPANY_NOTIFICATIONS',PERMISSION_SETTINGS_INHERITED_COMPANIES_READ='PERMISSION_SETTINGS_INHERITED_COMPANIES_READ',PERMISSION_TIMESLOT_VISITORS_WRITE='PERMISSION_TIMESLOT_VISITORS_WRITE',PERMISSION_TIMESLOT_VISITORS_READ='PERMISSION_TIMESLOT_VISITORS_READ',PERMISSION_TIMESLOT_VISITORS_HOST='PERMISSION_TIMESLOT_VISITORS_HOST',PERMISSION_ADMIN_CODELISTS='PERMISSION_ADMIN_CODELISTS',PERMISSION_RINGIL_ALLOW_RUN_TEST='PERMISSION_RINGIL_ALLOW_RUN_TEST',PERMISSION_SETTINGS_COMPANY_CREATE_USER='PERMISSION_SETTINGS_COMPANY_CREATE_USER',PERMISSION_ORDER_DISCREPANCY_RW='PERMISSION_ORDER_DISCREPANCY_RW',PERMISSION_TIMESLOT_INTERNALNOTE_RW='PERMISSION_TIMESLOT_INTERNALNOTE_RW',PERMISSION_EXPEDITION_EXPORT='PERMISSION_EXPEDITION_EXPORT',PERMISSION_TIMESLOT_EXPORT='PERMISSION_TIMESLOT_EXPORT',PERMISSION_SUPP_NOTIFICATION_EXPORT='PERMISSION_SUPP_NOTIFICATION_EXPORT',PERMISSION_CAM_LOG_EXPORT='PERMISSION_CAM_LOG_EXPORT',PERMISSION_NOTIFICATION_EXPORT='PERMISSION_NOTIFICATION_EXPORT',PERMISSION_EXPEDITION_FULL_CHANGE_PRICE='PERMISSION_EXPEDITION_FULL_CHANGE_PRICE',PERMISSION_EXPEDITION_INTERNAL_COMMENT_READ='PERMISSION_EXPEDITION_INTERNAL_COMMENT_READ',PERMISSION_EXPEDITION_INTERNAL_COMMENT_RW='PERMISSION_EXPEDITION_INTERNAL_COMMENT_RW',PERMISSION_DASHBOARD_TMS_TASKS='PERMISSION_DASHBOARD_TMS_TASKS',PERMISSION_DASHBOARD_TMS_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_TMS_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_TMS_GRAPHS_PARTNER='PERMISSION_DASHBOARD_TMS_GRAPHS_PARTNER',PERMISSION_DASHBOARD_TS_TASKS='PERMISSION_DASHBOARD_TS_TASKS',PERMISSION_DASHBOARD_TS_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_TS_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_TS_GRAPHS_PARTNER='PERMISSION_DASHBOARD_TS_GRAPHS_PARTNER',PERMISSION_DASHBOARD_SN_TASKS='PERMISSION_DASHBOARD_SN_TASKS',PERMISSION_DASHBOARD_SN_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_SN_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_SN_GRAPHS_PARTNER='PERMISSION_DASHBOARD_SN_GRAPHS_PARTNER',PERMISSION_DASHBOARD_CD_GRAPHS='PERMISSION_DASHBOARD_CD_GRAPHS',PERMISSION_SN_LIST_RW='PERMISSION_SN_LIST_RW',PERMISSION_SN_LIST_READ='PERMISSION_SN_LIST_READ',PERMISSION_SN_EFXX_CREATE='PERMISSION_SN_EFXX_CREATE',PERMISSION_SN_EFXX_DETAIL_TAB_SN_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_READ',PERMISSION_SN_DXX_CREATE='PERMISSION_SN_DXX_CREATE',PERMISSION_SN_DXX_DETAIL_TAB_SN_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_READ',PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_RW='PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_RW',PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_READ='PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_READ',PERMISSION_CALENDAR_LAYOUT_READ='PERMISSION_CALENDAR_LAYOUT_READ',PERMISSION_CALENDAR_LAYOUT_RW='PERMISSION_CALENDAR_LAYOUT_RW',PERMISSION_VISITOR_RECORD_DETAIL_AUDITLOG_READ='PERMISSION_VISITOR_RECORD_DETAIL_AUDITLOG_READ',PERMISSION_LOCATION_DETAIL_AUDITLOG_READ='PERMISSION_LOCATION_DETAIL_AUDITLOG_READ',PERMISSION_EMAIL_HISTORY_EXPORT='PERMISSION_EMAIL_HISTORY_EXPORT',PERMISSION_EMAIL_HISTORY_READ='PERMISSION_EMAIL_HISTORY_READ',PERMISSION_EMAIL_HISTORY_RW='PERMISSION_EMAIL_HISTORY_RW',PERMISSION_JOBS_READ='PERMISSION_JOBS_READ',PERMISSION_JOBS_RW='PERMISSION_JOBS_RW',PERMISSION_MULTIDUPLICATION_V3='PERMISSION_MULTIDUPLICATION_V3',PERMISSION_AI_PRICECHECK='PERMISSION_AI_PRICECHECK',PERMISSION_AI_DISPATCHER_READ='PERMISSION_AI_DISPATCHER_READ',PERMISSION_AI_DISPATCHER_RW='PERMISSION_AI_DISPATCHER_RW',PERMISSION_AI_ASSISTANT='PERMISSION_AI_ASSISTANT',PERMISSION_COMPANY_FOLDERS_RW='PERMISSION_COMPANY_FOLDERS_RW' }
export enum PermissionTypesEnum { PERMISSION_COMPANY_DETAIL='PERMISSION_COMPANY_DETAIL',PERMISSION_COMPANY_PERMISSIONS='PERMISSION_COMPANY_PERMISSIONS',PERMISSION_MODULE_DASHBOARD='PERMISSION_MODULE_DASHBOARD',PERMISSION_EXPEDITION='PERMISSION_EXPEDITION',PERMISSION_TEMPLATE='PERMISSION_TEMPLATE',PERMISSION_MY_CARRIERS='PERMISSION_MY_CARRIERS',PERMISSION_MY_CARRIERS_READ='PERMISSION_MY_CARRIERS_READ',PERMISSION_MY_CARRIERS_RW='PERMISSION_MY_CARRIERS_RW',PERMISSION_CARRIER_GROUP='PERMISSION_CARRIER_GROUP',PERMISSION_CARRIER_GROUP_READ='PERMISSION_CARRIER_GROUP_READ',PERMISSION_CARRIER_GROUP_RW='PERMISSION_CARRIER_GROUP_RW',PERMISSION_PARTNERS='PERMISSION_PARTNERS',PERMISSION_CARRIER_CATALOGUE='PERMISSION_CARRIER_CATALOGUE',PERMISSION_SUPPLIER_MANIFEST='PERMISSION_SUPPLIER_MANIFEST',PERMISSION_RESERVATION='PERMISSION_RESERVATION',PERMISSION_EXCEPTIONS='PERMISSION_EXCEPTIONS',PERMISSION_DEMANDS='PERMISSION_DEMANDS',PERMISSION_SHIPMENTS='PERMISSION_SHIPMENTS',PERMISSION_MOBILE_APP='PERMISSION_MOBILE_APP',PERMISSION_ADMIN='PERMISSION_ADMIN',PERMISSION_LOCATIONS='PERMISSION_LOCATIONS',PERMISSION_LOCATIONS_LOV='PERMISSION_LOCATIONS_LOV',PERMISSION_TIMESLOTS='PERMISSION_TIMESLOTS',PERMISSION_TIMESLOT_READ='PERMISSION_TIMESLOT_READ',PERMISSION_TIMESLOT_FULLREAD='PERMISSION_TIMESLOT_FULLREAD',PERMISSION_TIMESLOT_CREATE='PERMISSION_TIMESLOT_CREATE',PERMISSION_TIMESLOT_DELETE='PERMISSION_TIMESLOT_DELETE',PERMISSION_TIMESLOT_CHANGE_WORKFLOW='PERMISSION_TIMESLOT_CHANGE_WORKFLOW',PERMISSION_TIMESLOT_CHANGE_ORDER='PERMISSION_TIMESLOT_CHANGE_ORDER',PERMISSION_TIMESLOT_CHANGE_SLOT='PERMISSION_TIMESLOT_CHANGE_SLOT',PERMISSION_TIMESLOT_CHANGE_CARRIER='PERMISSION_TIMESLOT_CHANGE_CARRIER',PERMISSION_TIMESLOT_CHANGE_CARRIER_INFO='PERMISSION_TIMESLOT_CHANGE_CARRIER_INFO',PERMISSION_TIMESLOT_DUPLICATE='PERMISSION_TIMESLOT_DUPLICATE',PERMISSION_TIMESLOT_CALENDAR='PERMISSION_TIMESLOT_CALENDAR',PERMISSION_TIMESLOT_PUT2TABLE='PERMISSION_TIMESLOT_PUT2TABLE',PERMISSION_TIMESLOT_CHANGE_LABELS='PERMISSION_TIMESLOT_CHANGE_LABELS',PERMISSION_TIMESLOT_CHANGE_PARTIES='PERMISSION_TIMESLOT_CHANGE_PARTIES',PERMISSION_TIMESLOT_CHANGE_STATUS='PERMISSION_TIMESLOT_CHANGE_STATUS',PERMISSION_TIMESLOT_CHANGE_INFO='PERMISSION_TIMESLOT_CHANGE_INFO',PERMISSION_TIMESLOT_DETAIL_READ='PERMISSION_TIMESLOT_DETAIL_READ',PERMISSION_TIMESLOT_DETAIL_RW='PERMISSION_TIMESLOT_DETAIL_RW',PERMISSION_TIMESLOT_DETAIL_AUDITLOG_READ='PERMISSION_TIMESLOT_DETAIL_AUDITLOG_READ',PERMISSION_TIMESLOT_DASHBOARD_READ='PERMISSION_TIMESLOT_DASHBOARD_READ',PERMISSION_TIMESLOT_DASHBOARD_RW='PERMISSION_TIMESLOT_DASHBOARD_RW',PERMISSION_TIMESLOT_DASHBOARDMULTI_READ='PERMISSION_TIMESLOT_DASHBOARDMULTI_READ',PERMISSION_TIMESLOT_DASHBOARDMULTI_RW='PERMISSION_TIMESLOT_DASHBOARDMULTI_RW',PERMISSION_TIMESLOT_LIST_READ='PERMISSION_TIMESLOT_LIST_READ',PERMISSION_TIMESLOT_LIST_RW='PERMISSION_TIMESLOT_LIST_RW',PERMISSION_READ_LOCATIONS='PERMISSION_READ_LOCATIONS',PERMISSION_CREATE_LOCATIONS='PERMISSION_CREATE_LOCATIONS',PERMISSION_DELETE_LOCATIONS='PERMISSION_DELETE_LOCATIONS',PERMISSION_CREATE_RAMPS='PERMISSION_CREATE_RAMPS',PERMISSION_DELETE_RAMPS='PERMISSION_DELETE_RAMPS',PERMISSION_UPDATE_RAMPS='PERMISSION_UPDATE_RAMPS',PERMISSION_CREATE_EXCEPTIONS='PERMISSION_CREATE_EXCEPTIONS',PERMISSION_DELETE_EXCEPTIONS='PERMISSION_DELETE_EXCEPTIONS',PERMISSION_CAM_ENTRYLOG='PERMISSION_CAM_ENTRYLOG',PERMISSION_CAM_SETTINGS='PERMISSION_CAM_SETTINGS',PERMISSION_CAM_SETTINGS_REGISTERED_CAMS='PERMISSION_CAM_SETTINGS_REGISTERED_CAMS',PERMISSION_SN_FIX='PERMISSION_SN_FIX',PERMISSION_SN_CANCEL='PERMISSION_SN_CANCEL',PERMISSION_SUPP_NOTIFICATION_RW='PERMISSION_SUPP_NOTIFICATION_RW',PERMISSION_SN_DETAIL_AUDITLOG_READ='PERMISSION_SN_DETAIL_AUDITLOG_READ',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_RW='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_RW',PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ_WITHOUTPRICE='PERMISSION_EXPEDITION_DETAIL_TRANSPORTATIONTABS_READ_WITHOUTPRICE',PERMISSION_EXPEDITION_LIST_READ='PERMISSION_EXPEDITION_LIST_READ',PERMISSION_EXPEDITION_LIST_RW='PERMISSION_EXPEDITION_LIST_RW',PERMISSION_EXPEDITION_LIST_READ_WITHOUTPRICE='PERMISSION_EXPEDITION_LIST_READ_WITHOUTPRICE',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_READ='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_READ',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_RW',PERMISSION_EXPEDITION_MESSAGES_READ='PERMISSION_EXPEDITION_MESSAGES_READ',PERMISSION_EXPEDITION_MESSAGES_RW='PERMISSION_EXPEDITION_MESSAGES_RW',PERMISSION_EXPEDITION_CREATE='PERMISSION_EXPEDITION_CREATE',PERMISSION_PARTNER_LOCATION_MIGRATION='PERMISSION_PARTNER_LOCATION_MIGRATION',PERMISSION_CARRIER_EXPEDITION_RW='PERMISSION_CARRIER_EXPEDITION_RW',PERMISSION_SUPP_SHIPMENT_RW='PERMISSION_SUPP_SHIPMENT_RW',PERMISSION_COMPANY_NOTIFICATIONS='PERMISSION_COMPANY_NOTIFICATIONS',PERMISSION_COMPANY_INHERITED_COMPANIES='PERMISSION_COMPANY_INHERITED_COMPANIES',PERMISSION_SETTINGS_MAIL='PERMISSION_SETTINGS_MAIL',RESTRICT_NO_EXP='RESTRICT_NO_EXP',RESTRICT_NO_EXP_NO_TIMESLOT='RESTRICT_NO_EXP_NO_TIMESLOT',RESTRICT_NO_SUPPNOTIFICATION='RESTRICT_NO_SUPPNOTIFICATION',RESTRICT_NO_SETTINGS='RESTRICT_NO_SETTINGS',PERMISSION_SETTINGS_PARTNERS_READ='PERMISSION_SETTINGS_PARTNERS_READ',PERMISSION_SETTINGS_PARTNERS_RW='PERMISSION_SETTINGS_PARTNERS_RW',PERMISSION_REPORT='PERMISSION_REPORT',PERMISSION_SHIPMENT_MANUALIMPORT='PERMISSION_SHIPMENT_MANUALIMPORT',PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_READ='PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_READ',PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW='PERMISSION_EXPEDITION_DETAIL_TAB_SHIPMENT_RW',PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_READ='PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_READ',PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_RW='PERMISSION_EXPEDITION_DETAIL_TAB_INTERNALINFO_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CUSTOMS_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CMR_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CMR_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CMR_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CMR_RW',PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_READ='PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_READ',PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_RW='PERMISSION_EXPEDITION_DETAIL_TAB_CHAT_RW',PERMISSION_EXPEDITION_DETAIL_AUDITLOG_READ='PERMISSION_EXPEDITION_DETAIL_AUDITLOG_READ',PERMISSION_EXPEDITION_PRICE='PERMISSION_EXPEDITION_PRICE',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_ORDERS_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_ORDERS_RW',PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_INVOICES_RW='PERMISSION_EXPEDITION_DETAIL_ATTACHMENTS_INVOICES_RW',PERMISSION_EXPEDITION_CREATE_DISTRIBUTION_RW='PERMISSION_EXPEDITION_CREATE_DISTRIBUTION_RW',PERMISSION_SETTINGS_COMPANY_PROFILE='PERMISSION_SETTINGS_COMPANY_PROFILE',PERMISSION_SETTINGS_COMPANY_NOTIFICATIONS='PERMISSION_SETTINGS_COMPANY_NOTIFICATIONS',PERMISSION_SETTINGS_INHERITED_COMPANIES_READ='PERMISSION_SETTINGS_INHERITED_COMPANIES_READ',PERMISSION_TIMESLOT_VISITORS_WRITE='PERMISSION_TIMESLOT_VISITORS_WRITE',PERMISSION_TIMESLOT_VISITORS_READ='PERMISSION_TIMESLOT_VISITORS_READ',PERMISSION_TIMESLOT_VISITORS_HOST='PERMISSION_TIMESLOT_VISITORS_HOST',PERMISSION_ADMIN_CODELISTS='PERMISSION_ADMIN_CODELISTS',PERMISSION_RINGIL_ALLOW_RUN_TEST='PERMISSION_RINGIL_ALLOW_RUN_TEST',PERMISSION_SETTINGS_COMPANY_CREATE_USER='PERMISSION_SETTINGS_COMPANY_CREATE_USER',PERMISSION_ORDER_DISCREPANCY_RW='PERMISSION_ORDER_DISCREPANCY_RW',PERMISSION_TIMESLOT_INTERNALNOTE_RW='PERMISSION_TIMESLOT_INTERNALNOTE_RW',PERMISSION_EXPEDITION_EXPORT='PERMISSION_EXPEDITION_EXPORT',PERMISSION_TIMESLOT_EXPORT='PERMISSION_TIMESLOT_EXPORT',PERMISSION_SUPP_NOTIFICATION_EXPORT='PERMISSION_SUPP_NOTIFICATION_EXPORT',PERMISSION_CAM_LOG_EXPORT='PERMISSION_CAM_LOG_EXPORT',PERMISSION_NOTIFICATION_EXPORT='PERMISSION_NOTIFICATION_EXPORT',PERMISSION_EXPEDITION_FULL_CHANGE_PRICE='PERMISSION_EXPEDITION_FULL_CHANGE_PRICE',PERMISSION_EXPEDITION_INTERNAL_COMMENT_READ='PERMISSION_EXPEDITION_INTERNAL_COMMENT_READ',PERMISSION_EXPEDITION_INTERNAL_COMMENT_RW='PERMISSION_EXPEDITION_INTERNAL_COMMENT_RW',PERMISSION_DASHBOARD_TMS_TASKS='PERMISSION_DASHBOARD_TMS_TASKS',PERMISSION_DASHBOARD_TMS_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_TMS_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_TMS_GRAPHS_PARTNER='PERMISSION_DASHBOARD_TMS_GRAPHS_PARTNER',PERMISSION_DASHBOARD_TS_TASKS='PERMISSION_DASHBOARD_TS_TASKS',PERMISSION_DASHBOARD_TS_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_TS_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_TS_GRAPHS_PARTNER='PERMISSION_DASHBOARD_TS_GRAPHS_PARTNER',PERMISSION_DASHBOARD_SN_TASKS='PERMISSION_DASHBOARD_SN_TASKS',PERMISSION_DASHBOARD_SN_GRAPHS_CUSTOMER='PERMISSION_DASHBOARD_SN_GRAPHS_CUSTOMER',PERMISSION_DASHBOARD_SN_GRAPHS_PARTNER='PERMISSION_DASHBOARD_SN_GRAPHS_PARTNER',PERMISSION_DASHBOARD_CD_GRAPHS='PERMISSION_DASHBOARD_CD_GRAPHS',PERMISSION_SN_LIST_RW='PERMISSION_SN_LIST_RW',PERMISSION_SN_LIST_READ='PERMISSION_SN_LIST_READ',PERMISSION_SN_EFXX_CREATE='PERMISSION_SN_EFXX_CREATE',PERMISSION_SN_EFXX_DETAIL_TAB_SN_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_INTERNALINFO_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_READ',PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_RW='PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_RW',PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_READ='PERMISSION_SN_EFXX_DETAIL_TAB_SN_CHAT_READ',PERMISSION_SN_DXX_CREATE='PERMISSION_SN_DXX_CREATE',PERMISSION_SN_DXX_DETAIL_TAB_SN_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_INTERNALINFO_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_READ',PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_ATTACHMENTS_INVOICES_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_RW='PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_RW',PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_READ='PERMISSION_SN_DXX_DETAIL_TAB_SN_CHAT_READ',PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_RW='PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_RW',PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_READ='PERMISSION_SN_DXX_DETAIL_TAB_CUSTOMS_READ',PERMISSION_CALENDAR_LAYOUT_READ='PERMISSION_CALENDAR_LAYOUT_READ',PERMISSION_CALENDAR_LAYOUT_RW='PERMISSION_CALENDAR_LAYOUT_RW',PERMISSION_VISITOR_RECORD_DETAIL_AUDITLOG_READ='PERMISSION_VISITOR_RECORD_DETAIL_AUDITLOG_READ',PERMISSION_LOCATION_DETAIL_AUDITLOG_READ='PERMISSION_LOCATION_DETAIL_AUDITLOG_READ',PERMISSION_EMAIL_HISTORY_EXPORT='PERMISSION_EMAIL_HISTORY_EXPORT',PERMISSION_EMAIL_HISTORY_READ='PERMISSION_EMAIL_HISTORY_READ',PERMISSION_EMAIL_HISTORY_RW='PERMISSION_EMAIL_HISTORY_RW',PERMISSION_JOBS_READ='PERMISSION_JOBS_READ',PERMISSION_JOBS_RW='PERMISSION_JOBS_RW',PERMISSION_MULTIDUPLICATION_V3='PERMISSION_MULTIDUPLICATION_V3',PERMISSION_AI_PRICECHECK='PERMISSION_AI_PRICECHECK',PERMISSION_AI_DISPATCHER_READ='PERMISSION_AI_DISPATCHER_READ',PERMISSION_AI_DISPATCHER_RW='PERMISSION_AI_DISPATCHER_RW',PERMISSION_AI_ASSISTANT='PERMISSION_AI_ASSISTANT',PERMISSION_COMPANY_FOLDERS_RW='PERMISSION_COMPANY_FOLDERS_RW' }
export enum CompanyModulesEnum { EXPEDITION='EXPEDITION',CARRIER='CARRIER',TIMESLOTS='TIMESLOTS',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',CUSTOMS_DECLARATION='CUSTOMS_DECLARATION' }
export enum PseudoStatesEnum { ASSIGNING='ASSIGNING',NOT_WIN='NOT_WIN',WIN='WIN',OFFERED='OFFERED',REJECTED='REJECTED',CANCELED='CANCELED' }
export enum PriceTypeEnum { AGREED='AGREED',OFFERED='OFFERED',FIXED='FIXED',EXPECTED='EXPECTED',REJECTED='REJECTED' }
export enum PseudoStateEnum { ASSIGNING='ASSIGNING',NOT_WIN='NOT_WIN',WIN='WIN',OFFERED='OFFERED',REJECTED='REJECTED',CANCELED='CANCELED' }
export enum CarrierExpeditionStatusEnum { ASSIGNED='ASSIGNED',READY_TO_SHIPMENT='READY_TO_SHIPMENT',ACTIVE='ACTIVE',WAITING_FOR_DOCS='WAITING_FOR_DOCS',CANCELED='CANCELED',FINISHED='FINISHED' }
export enum ExpeditionStatusEnum { IMPORTED='IMPORTED',NEW='NEW',ASSIGNING='ASSIGNING',ASSIGNED='ASSIGNED',READY_TO_SHIPMENT='READY_TO_SHIPMENT',ACTIVE='ACTIVE',WAITING_FOR_DOCS='WAITING_FOR_DOCS',CANCELED='CANCELED',FINISHED='FINISHED' }
export enum ExpeditionTypeEnum { LESS_TRUCK_LOAD='LESS_TRUCK_LOAD',FULL_TRUCK_LOAD='FULL_TRUCK_LOAD',SBERKA='SBERKA',FCL='FCL',LCL='LCL',TAXI='TAXI',CHARTER='CHARTER',EXPEDITED='EXPEDITED',CUSTOM_CLEARANCE='CUSTOM_CLEARANCE' }
export enum LastExpeditionStatusEnum { IMPORTED='IMPORTED',NEW='NEW',ASSIGNING='ASSIGNING',ASSIGNED='ASSIGNED',READY_TO_SHIPMENT='READY_TO_SHIPMENT',ACTIVE='ACTIVE',WAITING_FOR_DOCS='WAITING_FOR_DOCS',CANCELED='CANCELED',FINISHED='FINISHED' }
export enum CurrencyLockTypeEnum { NONE='NONE',ONLY_SELECTED='ONLY_SELECTED' }
export enum ActionTypeEnum { LOADING='LOADING',UNLOADING='UNLOADING',BOTH='BOTH' }
export enum DistributionTypeEnum { SPOT='SPOT',FIXED_PRICE='FIXED_PRICE' }
export enum CarrierQuoteStateEnum { NEW='NEW',OFFERED_PRICE='OFFERED_PRICE',REJECTED_BY_CUSTOMER='REJECTED_BY_CUSTOMER',REJECTED_BY_CARRIER='REJECTED_BY_CARRIER',ACCEPTED_BY_CUSTOMER='ACCEPTED_BY_CUSTOMER',ACCEPTED_NEED_RECONFIRM='ACCEPTED_NEED_RECONFIRM' }
export enum CustomerQuoteStateEnum { NEW='NEW',ACCEPTED_BY_CARRIER='ACCEPTED_BY_CARRIER',REJECTED_BY_CARRIER='REJECTED_BY_CARRIER',ASSIGNED_MANUALLY_BY_CUSTOMER='ASSIGNED_MANUALLY_BY_CUSTOMER' }
export enum LoadingTypesEnum { FROM_SIDE='FROM_SIDE',FROM_TOP='FROM_TOP',FROM_BACK='FROM_BACK',NOT_SPECIFIED='NOT_SPECIFIED',FROM_BACK_OR_SIDE='FROM_BACK_OR_SIDE' }
export enum CompanyModuleEnum { EXPEDITION='EXPEDITION',CARRIER='CARRIER',TIMESLOTS='TIMESLOTS',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',CUSTOMS_DECLARATION='CUSTOMS_DECLARATION' }
export enum EmailTypeEnum { NEW_SPOT_DEMAND_V2='NEW_SPOT_DEMAND_V2',NEW_FIXED_DEMAND_V2='NEW_FIXED_DEMAND_V2',REJECTED_DEMAND_V2='REJECTED_DEMAND_V2',WIN_DEMAND_V2='WIN_DEMAND_V2',EXPIRED_DEMAND_V2='EXPIRED_DEMAND_V2',EXPEDITION_CANCELED_V2='EXPEDITION_CANCELED_V2',CHANGE_PARAM_DISTRIBUTION_V2='CHANGE_PARAM_DISTRIBUTION_V2',CHANGE_CARRIER_REQ_V2='CHANGE_CARRIER_REQ_V2',CHANGE_LOCATION_REQ_V2='CHANGE_LOCATION_REQ_V2',EXPEDITION_CHANGED='EXPEDITION_CHANGED',NEW_DOCUMENT_V2='NEW_DOCUMENT_V2',NEW_MESSAGE_V2='NEW_MESSAGE_V2',UNCONFIRMED_LOADING_V2='UNCONFIRMED_LOADING_V2',UNCONFIRMED_UNLOADING_V2='UNCONFIRMED_UNLOADING_V2',UNCONFIRMED_BOTH_V2='UNCONFIRMED_BOTH_V2',UNCONFIRMED_NO_ACTION_V2='UNCONFIRMED_NO_ACTION_V2',NOT_ASSIGNED_CAR_PLATE_V2='NOT_ASSIGNED_CAR_PLATE_V2',SWITCH_TO_MANUAL_EXPEDITION='SWITCH_TO_MANUAL_EXPEDITION',CARRIER_EXTRA_COST_ADD='CARRIER_EXTRA_COST_ADD',CARRIER_PUBLISHED_EXPEDITION='CARRIER_PUBLISHED_EXPEDITION',CARRIER_EXTRA_COST_REMOVE='CARRIER_EXTRA_COST_REMOVE',CONFIRMED_FIXED_PRICE_WIN='CONFIRMED_FIXED_PRICE_WIN',CONFIRMED_SPOT_PRICE_WIN='CONFIRMED_SPOT_PRICE_WIN',CU_ACCEPT_FIXED_PRICE='CU_ACCEPT_FIXED_PRICE',CU_DECLINED_FIXED_PRICE='CU_DECLINED_FIXED_PRICE',CU_SPOT_EXPIRED='CU_SPOT_EXPIRED',CU_FIXED_PRICE_EXPIRED='CU_FIXED_PRICE_EXPIRED',CU_NEW_MESSAGE='CU_NEW_MESSAGE',CU_FILE_UPLOADED='CU_FILE_UPLOADED',CU_CAR_PLATE_ASSIGN='CU_CAR_PLATE_ASSIGN',CU_CARGO_LOADED='CU_CARGO_LOADED',CU_CARGO_UNLOADED='CU_CARGO_UNLOADED',CU_CARGO_LOADED_UNLOADED='CU_CARGO_LOADED_UNLOADED',CU_NO_ACTION_LOADED='CU_NO_ACTION_LOADED',CU_NEW_DEMAND='CU_NEW_DEMAND',CU_CANCEL_DEMAND='CU_CANCEL_DEMAND',CU_CHANGE_TIMESLOTS='CU_CHANGE_TIMESLOTS',CU_RECONFIRMED_EXPEDITION='CU_RECONFIRMED_EXPEDITION',CU_NEW_SUPPLIER_MANIFEST='CU_NEW_SUPPLIER_MANIFEST',CU_CA_NEW_RESERVATION='CU_CA_NEW_RESERVATION',CU_CA_DELETED_RESERVATION='CU_CA_DELETED_RESERVATION',CU_CA_RESERVATION_NO_ORDERS_REMINDER='CU_CA_RESERVATION_NO_ORDERS_REMINDER',CU_CA_RESERVATION_ARCHIVED='CU_CA_RESERVATION_ARCHIVED',NO_ORDER_RESERVATION_ARCHIVED='NO_ORDER_RESERVATION_ARCHIVED',CU_CA_RESERVATION_NO_SHOW='CU_CA_RESERVATION_NO_SHOW',CU_RESPONSIBLE_PERSON_ASSIGNED='CU_RESPONSIBLE_PERSON_ASSIGNED',CU_SUBSCRIBER_ASSIGNED='CU_SUBSCRIBER_ASSIGNED',DIRECT_ASSIGNMENT='DIRECT_ASSIGNMENT',SKIP_EXPEDITION='SKIP_EXPEDITION',CU_CHANGE_CAR_PLATE='CU_CHANGE_CAR_PLATE',CONTACT_CHANGE_CAR_PLATE='CONTACT_CHANGE_CAR_PLATE',CONTACT_CHANGE_CAR_INFO='CONTACT_CHANGE_CAR_INFO',CONTACT_CHANGE_TIMESLOTS='CONTACT_CHANGE_TIMESLOTS',CONTACT_CARGO_LOADED='CONTACT_CARGO_LOADED',CA_CHANGE_CARRIER_NOTE='CA_CHANGE_CARRIER_NOTE',CA_DECLINED_GROUP_DEMAND_OFFER='CA_DECLINED_GROUP_DEMAND_OFFER',CA_NEW_GROUP_DEMAND='CA_NEW_GROUP_DEMAND',NEW_ATTACHMENT_CONTACT_PERSON='NEW_ATTACHMENT_CONTACT_PERSON',CA_CHANGE_VALIDITY_GROUP_DEMAND='CA_CHANGE_VALIDITY_GROUP_DEMAND',CA_EXPIRED_GROUP_DEMAND='CA_EXPIRED_GROUP_DEMAND',NEW_DOCUMENT_SH='NEW_DOCUMENT_SH',NEW_DOCUMENT_SN='NEW_DOCUMENT_SN',NEW_DOCUMENT_SM='NEW_DOCUMENT_SM',NEW_MESSAGE_SN='NEW_MESSAGE_SN',NEW_MESSAGE_GD='NEW_MESSAGE_GD',CA_NO_CMR_INVOICE='CA_NO_CMR_INVOICE',CUSTOMER_NEW_SUPPLIER_NOTIFICATION='CUSTOMER_NEW_SUPPLIER_NOTIFICATION',SUPPLIER_NOTIFICATION_CHANGE_STATUS='SUPPLIER_NOTIFICATION_CHANGE_STATUS',EXPEDITION_ENTER_TIMESLOT='EXPEDITION_ENTER_TIMESLOT',RESERVATION_CAR_PLATE_UPDATE='RESERVATION_CAR_PLATE_UPDATE',RESERVATION_ORDER_UPDATE='RESERVATION_ORDER_UPDATE',RESERVATION_NOTE_UPDATE='RESERVATION_NOTE_UPDATE',RESERVATION_NAME_UPDATE='RESERVATION_NAME_UPDATE',RESERVATION_DRIVER_PHONE_UPDATE='RESERVATION_DRIVER_PHONE_UPDATE',RESERVATION_DRIVER_INFO_UPDATE='RESERVATION_DRIVER_INFO_UPDATE',RESERVATION_CARRIER_UPDATE='RESERVATION_CARRIER_UPDATE',RESERVATION_CARRIER_NOTE_UPDATE='RESERVATION_CARRIER_NOTE_UPDATE',RESERVATION_TIMESLOT_UPDATE='RESERVATION_TIMESLOT_UPDATE',APPROACHING_END_OF_GD='APPROACHING_END_OF_GD',SN_CHANGE_TIMESLOT='SN_CHANGE_TIMESLOT',SUPPLIER_NOTIFICATION_CHANGED='SUPPLIER_NOTIFICATION_CHANGED',CA_CANCELED_GROUP_DEMAND='CA_CANCELED_GROUP_DEMAND',INFORM_EXPEDITION_SENT='INFORM_EXPEDITION_SENT',INFORM_INVOICE_CARRIER_ISSUES='INFORM_INVOICE_CARRIER_ISSUES',NEW_CUSTOMS_DECLARATION_ASSIGN='NEW_CUSTOMS_DECLARATION_ASSIGN',DISTRIBUTION_VALID_TILL_CHANGE='DISTRIBUTION_VALID_TILL_CHANGE',TIEBREAKER='TIEBREAKER',GROUPED_LADEN_FACTOR_WIN='GROUPED_LADEN_FACTOR_WIN',INFORM_INVOICE_EXPEDITION_NOT_FOUND='INFORM_INVOICE_EXPEDITION_NOT_FOUND',INFORM_INVOICE_MISSING_ORDER_REFERENCE='INFORM_INVOICE_MISSING_ORDER_REFERENCE',INFORM_INVOICE_PDF_NEVER_ARRIVED='INFORM_INVOICE_PDF_NEVER_ARRIVED',AI_DISPATCHER_NOTIFICATION='AI_DISPATCHER_NOTIFICATION' }
export enum SupplierNotificationTypeEnum { FCA='FCA',DAP='DAP',EFXX='EFXX',DXX='DXX' }
export enum ContainerInfoCodeEnum { CONTAINER_20='CONTAINER_20',CONTAINER_40='CONTAINER_40',CONTAINER_40HQ='CONTAINER_40HQ',CONTAINER_45='CONTAINER_45',CONTAINER_45HQ='CONTAINER_45HQ' }
export enum SupplierNotificationStatusEnum { NEW='NEW',CANCELED='CANCELED' }
export enum ShipmentStateCodeEnum { WAITING='WAITING',READY='READY' }
export enum CustomsTypeCodeEnum { EU='EU',UNDER_CUSTOMS='UNDER_CUSTOMS' }
export enum TransportationTypeEnum { GROUND='GROUND',TRAIN='TRAIN',AIR='AIR',BOAT='BOAT' }
export enum AccessTypeEnum { ALL='ALL',INTERNAL='INTERNAL' }
export enum ReservationActionTypesEnum { LOADING='LOADING',UNLOADING='UNLOADING' }
export enum VisibilityEnum { PUBLIC='PUBLIC',PRIVATE='PRIVATE',VISIBLE_TO_COMPANIES='VISIBLE_TO_COMPANIES' }
export enum LoadingTypeEnum { FROM_SIDE='FROM_SIDE',FROM_TOP='FROM_TOP',FROM_BACK='FROM_BACK',NOT_SPECIFIED='NOT_SPECIFIED',FROM_BACK_OR_SIDE='FROM_BACK_OR_SIDE' }
export enum LocationSharingPrivilegeEnum { VIEW_EVENT_DETAIL='VIEW_EVENT_DETAIL' }
export enum OpenHourExceptionTypeEnum { CLOSED='CLOSED',OPEN='OPEN' }
export enum OpeningModeEnum { CLOSED='CLOSED',OPEN='OPEN',PARTIALLY_OPEN='PARTIALLY_OPEN' }
export enum LocationSelectModeEnum { ALL_LOCATIONS='ALL_LOCATIONS',SELECTED_LOCATIONS='SELECTED_LOCATIONS' }
export enum EntityTypeEnum { EXPEDITION='EXPEDITION',SUPPLIER_MANIFEST='SUPPLIER_MANIFEST',SHIPMENT='SHIPMENT',SUPPLIER_NOTIFICATION='SUPPLIER_NOTIFICATION',TIMESLOT='TIMESLOT',TIMESLOT_CALENDAR='TIMESLOT_CALENDAR',EXPEDITION_TEMPLATE='EXPEDITION_TEMPLATE',GROUP_DEMAND='GROUP_DEMAND',ATTACHMENTS='ATTACHMENTS',CMR_DOCUMENT='CMR_DOCUMENT',CUSTOMER_NOTIFICATION='CUSTOMER_NOTIFICATION',VISITOR_RECORD='VISITOR_RECORD',CARRIER_COMPANY='CARRIER_COMPANY',INVOICE_CARRIER='INVOICE_CARRIER',CAMERA_LOG='CAMERA_LOG',USER='USER',NOTIFICATION='NOTIFICATION',EMAIL_HISTORY='EMAIL_HISTORY',ASYNC_JOB='ASYNC_JOB' }
export enum GroupDemandStateEnum { NEW='NEW',FINISHED='FINISHED' }
export enum StateEnum { NEW='NEW',FINISHED='FINISHED' }
export enum DocumentTypeEnum { INVOICE='INVOICE',CMR='CMR',DELIVERY_LIST='DELIVERY_LIST',AWB='AWB',BILL_OF_LADING='BILL_OF_LADING',TELEX='TELEX',DGD_IMO='DGD_IMO',CUSTOMS_DOC='CUSTOMS_DOC',CUSTOMS_DOCUMENT='CUSTOMS_DOCUMENT',PACKING_LIST='PACKING_LIST',MATERIAL_SAFETY_SHEET='MATERIAL_SAFETY_SHEET',ORDER='ORDER',INSURANCE='INSURANCE',PHOTO='PHOTO',PHYTOSANITARY_CERT='PHYTOSANITARY_CERT',VETERINARY_CERT='VETERINARY_CERT',GENERAL_DOC='GENERAL_DOC',OTHER='OTHER',DACHSER_XML='DACHSER_XML',ETRANSPORT_RO='ETRANSPORT_RO',CUSTOMS_DEBT='CUSTOMS_DEBT',ORDER_CONFIRMATION='ORDER_CONFIRMATION',POD='POD',INVOICE_CARRIER='INVOICE_CARRIER',QUOTATION_MATERIALS='QUOTATION_MATERIALS',ARCHIVE='ARCHIVE' }
export enum FeaturesEnum { PDF='PDF',EW='EW',SN_EXTERNAL_IDS='SN_EXTERNAL_IDS',ADD_ATTACHMENTS_TO_MAIL='ADD_ATTACHMENTS_TO_MAIL',ADDRESS_DIRECTLY_USERS='ADDRESS_DIRECTLY_USERS',NOTIFY_MISSING_CMR_AND_INVOICE='NOTIFY_MISSING_CMR_AND_INVOICE',DACHSER_XML_EXPORT='DACHSER_XML_EXPORT',DAP='DAP',ENTRY_CAMS='ENTRY_CAMS',ETRANSPORT_RO='ETRANSPORT_RO',CMR='CMR',CUSTOMS='CUSTOMS',SHOW_WINNING_DEMAND_IN_REJECTED_EMAIL='SHOW_WINNING_DEMAND_IN_REJECTED_EMAIL',AREA_VISITORS='AREA_VISITORS',CUSTOM_EXP_APP_ID='CUSTOM_EXP_APP_ID',EXPEDITION_RESERVATION_LINK='EXPEDITION_RESERVATION_LINK',ORDER_DISCREPANCY='ORDER_DISCREPANCY',RES_DUPLICATION_WITH_EXP='RES_DUPLICATION_WITH_EXP',LADEN_FACTOR='LADEN_FACTOR',RESERVATION_TRUCK_TYPE='RESERVATION_TRUCK_TYPE',PDF_ORDER_CONFIRMATION='PDF_ORDER_CONFIRMATION',MESSENGER_TIMESLOT_GO_TO_RAMP='MESSENGER_TIMESLOT_GO_TO_RAMP',MESSENGER_TIMESLOT_ON_TIME_CHECK='MESSENGER_TIMESLOT_ON_TIME_CHECK',CURRENCY_LOCK='CURRENCY_LOCK',DACHSER_API='DACHSER_API',SKODA_EXTERNAL_LOGGING_ENABLED='SKODA_EXTERNAL_LOGGING_ENABLED',LINKED_CAR_PLATES_RES_EXP='LINKED_CAR_PLATES_RES_EXP',YARD_TABLE='YARD_TABLE',SHIPMENT_MANUAL_IMPORT='SHIPMENT_MANUAL_IMPORT',TEMPLATES='TEMPLATES',VISITOR_RECORDS='VISITOR_RECORDS',AI_INVOICE_VALIDATION='AI_INVOICE_VALIDATION',SIGNING_CMR='SIGNING_CMR',HIDE_EMPTY_TAG='HIDE_EMPTY_TAG',TIMESLOT_STATISTICS='TIMESLOT_STATISTICS',AI_CARRIER_AUTO_SELECTION='AI_CARRIER_AUTO_SELECTION',EXTENDED_FILE_TYPE_VALIDATION='EXTENDED_FILE_TYPE_VALIDATION',AI_CHAT_CLASSIFICATION='AI_CHAT_CLASSIFICATION',TEMP_CARRIER_SELECTION='TEMP_CARRIER_SELECTION',AI_PRICE_ALERT='AI_PRICE_ALERT',MIGRATION_NEW_CARRIER_SHIPMENT_LIST='MIGRATION_NEW_CARRIER_SHIPMENT_LIST',SCHENKER_API='SCHENKER_API',PUBLISH_INVOICE_VIA_API='PUBLISH_INVOICE_VIA_API',SKODA_PUBLISH_EXPEDITION_TO_SAP='SKODA_PUBLISH_EXPEDITION_TO_SAP',MULTIPLE_DISTRIBUTIONS='MULTIPLE_DISTRIBUTIONS',NOT_MANDATORY_DIMENSIONS='NOT_MANDATORY_DIMENSIONS',DHL_API='DHL_API',FEDEX_API='FEDEX_API',EXPEDITION_NOTIFY_WAREHOUSE='EXPEDITION_NOTIFY_WAREHOUSE',EXPEDITION_SHIPPING_CLAIM='EXPEDITION_SHIPPING_CLAIM',EXPEDITION_NOTIFY='EXPEDITION_NOTIFY',GENERIC_EXPORT_API='GENERIC_EXPORT_API',PDF_EXPEDITION_DETAIL='PDF_EXPEDITION_DETAIL',EXPEDITION_INTERNAL_COMMENT='EXPEDITION_INTERNAL_COMMENT',EXPEDITION_APPROVE_EXTRA_TRANSPORT_MAILTO='EXPEDITION_APPROVE_EXTRA_TRANSPORT_MAILTO',QUOTE_ENFORCE_CARRIER_PHONE='QUOTE_ENFORCE_CARRIER_PHONE',QUOTE_VALID_TILL_READ_ONLY='QUOTE_VALID_TILL_READ_ONLY',QUOTE_VALID_TILL_VISIBLE='QUOTE_VALID_TILL_VISIBLE',DISTRIBUTION_CARRIER_TIEBREAK='DISTRIBUTION_CARRIER_TIEBREAK',REQUEST_NOTIFIED_PERSON_IN_SN='REQUEST_NOTIFIED_PERSON_IN_SN',RESERVATION_ON_BEHALF_OF='RESERVATION_ON_BEHALF_OF',SHOW_PRICE_PER_KM='SHOW_PRICE_PER_KM',SHOW_PRICE_PER_HU='SHOW_PRICE_PER_HU',VOLUME_OF_ORDER='VOLUME_OF_ORDER',DISABLE_CARRIER_QUOTE_TIMESLOTS='DISABLE_CARRIER_QUOTE_TIMESLOTS',DISABLE_CARRIER_PROGRESS_TIMESLOTS='DISABLE_CARRIER_PROGRESS_TIMESLOTS',CODE_LIST_NOTIFICATION_EMAILS='CODE_LIST_NOTIFICATION_EMAILS',LAZY_LOAD_DETAIL_SECTIONS='LAZY_LOAD_DETAIL_SECTIONS',EXPEDITION_MERGE='EXPEDITION_MERGE',MULTIDUPLICATION_V3='MULTIDUPLICATION_V3',ENABLE_SENDER_EMAIL_HISTORY='ENABLE_SENDER_EMAIL_HISTORY',SN_MERGE_TO_EXPEDITION='SN_MERGE_TO_EXPEDITION',SUPERSEDE_LOCATION='SUPERSEDE_LOCATION',AI_DISPATCHER='AI_DISPATCHER' }
export enum AiPriceAlertsMinimalSeverityEnum { SEVERITY_UNDEFINED='SEVERITY_UNDEFINED',SEVERITY_0='SEVERITY_0',SEVERITY_1='SEVERITY_1',SEVERITY_2='SEVERITY_2',SEVERITY_3='SEVERITY_3',SEVERITY_4='SEVERITY_4' }
export enum InvoicePublishServiceTypeEnum { DISABLED='DISABLED',ITAB_REST_API='ITAB_REST_API' }
export enum PriceDisplayTypeEnum { NO_SHOW_ADDITIONAL_PRICE='NO_SHOW_ADDITIONAL_PRICE',SHOW_PREFERRED_PRICE='SHOW_PREFERRED_PRICE',SHOW_ORIGINAL_PRICE='SHOW_ORIGINAL_PRICE' }
export enum ExternalIdTypeEnum { PAP_NOTINO='PAP_NOTINO',SAP='SAP',COMPANY='COMPANY' }
export enum ResponseDeadlineModeEnum { RELATIVE='RELATIVE',ABSOLUTE='ABSOLUTE' }
export enum ActionEnum { FORCE_NEEDED='FORCE_NEEDED' } 


 export interface RingilApiType {
  getCustomDataForCMRV2: (expeditionId: string,applicationId: string, onSuccess: ((data : GetCmrCustomDataV2ResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCustomDataForCMRV2: (expeditionId: string,applicationId: string,body: UpdateCmrCustomDataV2RequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserTableFilterFavourites: (viewKey: string,body: SaveUserTableFilterFavouritesRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteUserTableFilterFavourites: (viewKey: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateReportPermission: (reportDefinitionId: string,companyId: string,body: UpdateReportPermissionRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateDocumentMetadata: (documentId: string,body: UpdateDocumentRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getInfoTurnOffResolvedEmails: (onSuccess: ((data : TurnOffResolvedEmailRequestInDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  turnOffResolvedEmails: (body: TurnOffResolvedEmailRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateTableView: (tableKey: string,viewId: string,body: UpdateTableViewInDTO, onSuccess: ((data : TableViewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteTableView: (tableKey: string,viewId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setTableViewVisibility: (tableKey: string,viewId: string,body: SetTableViewVisibilityInDTO, onSuccess: ((data : TableViewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveTableViewPrefs: (tableKey: string,body: TableViewPrefsInDTO, onSuccess: ((data : TableViewPrefsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateTransportTypeDAPSupplierNotification: (supplierNotificationId: string,body: UpdateTransportTypeDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateShipmentNumberDAPSupplierNotification: (supplierNotificationId: string,body: UpdateShipmentDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateResponsiblePersonDAPSupplierNotification: (supplierNotificationId: string,body: UpdateResponsiblePersonDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateOrdersDAPSupplierNotification: (supplierNotificationId: string,body: UpdateOrdersDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotifyUsersDAPSupplierNotification: (supplierNotificationId: string,body: UpdateNotifyUsersDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotifyByRoleDAPSupplierNotification: (supplierNotificationId: string,body: UpdateNotifyByRoleDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNoteDAPSupplierNotification: (supplierNotificationId: string,body: UpdateNoteDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateSupplierLocationDAPSupplierNotification: (supplierNotificationId: string,body: UpdateLocationDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCustomerLocationDAPSupplierNotification: (supplierNotificationId: string,body: UpdateLocationDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateInternalInvoiceDAPSupplierNotification: (supplierNotificationId: string,body: UpdateInternalInvoiceDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateInternalNoteDAPSupplierNotification: (supplierNotificationId: string,body: UpdateInternalNoteDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateFolderSupplierNotification: (supplierNotificationId: string,body: UpdateFolderSNInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCarrierNameDAPSupplierNotification: (supplierNotificationId: string,body: UpdateCarrierNameDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  sendToEurowag: (body: SendToEurowagInDTO, onSuccess: ((data : SendToEurowagOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateReservationFlags: (reservationId: string,body: UpdateReservationFlagsInDTO, onSuccess: ((data : UpdateReservationFlagsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReservationStatisticsForDay: (body: ReservationStatisticsRequestInDTO, onSuccess: ((data : ReservationStatisticsResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  readCustomerNotification: (notificationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveSchenkerAdditionalData: (quoteDemandId: string,body: SchenkerAdditionalInfoInDTO, onSuccess: ((data : SchenkerAdditionalInfoOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteSchenkerAdditionalData: (quoteDemandId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveFedexAdditionalData: (quoteDemandId: string,body: FedexCustomsInfoInDTO, onSuccess: ((data : FedexCustomsInfoDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteFedexAdditionalData: (quoteDemandId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveFedexCertOverrides: (quoteDemandId: string,body: FedexCertOverridesDTO, onSuccess: ((data : FedexCertOverridesDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveDHLAdditionalData: (quoteDemandId: string,body: DHLExportDeclarationInfoInDTO, onSuccess: ((data : DHLExportDeclarationInfoOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteDHLAdditionalData: (quoteDemandId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserNotificationTypeSettings: (onSuccess: ((data : NotificationTypeSettingOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setUserNotificationTypeSetting: (body: SetNotificationTypeSettingInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  readNotificationMessages: (body: ReadNotificationRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  readAllNotificationMessages: (onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setExternalIds: (companyId: string,body: SetExternalIdForCompanyInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFedexShipmentSettings: (onSuccess: ((data : FedexShipmentSettingsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveFedexShipmentSettings: (body: FedexShipmentSettingsDTO, onSuccess: ((data : FedexShipmentSettingsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  renameFedexAccount: (accountId: string,body: FedexAccountRenameInDTO, onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteFedexAccount: (accountId: string, onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExternalManipulationUnit: (id: string,body: CreateExternalManipulationUnitRequestDTO, onSuccess: ((data : ExternalManipulationUnitDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteExternalManipulationUnit: (id: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExpeditionUtnCode: (expeditionId: string,body: UpdateExpeditionUtnCodeRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExpeditionTrackingNumber: (expeditionId: string,body: UpdateExpeditionTrackingNumberRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExpeditionRoUit: (expeditionId: string,body: UpdateExpeditionRoUitRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExpeditionPolandSent: (expeditionId: string,body: UpdateExpeditionPolandSentRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExpeditionName: (expeditionId: string,body: UpdateExpeditionNameRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  editCompanyLocationTimeslotExpedition: (expeditionId: string,locationId: string,body: EditLocationTimeslotExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  editLoadingLocationOrderExpedition: (expeditionId: string,locationId: string,body: EditLoadingLocationOrderExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  editManualLocationExpedition: (expeditionId: string,locationId: string,body: EditLocationManualExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  editCompanyLocationExpedition: (expeditionId: string,locationId: string,body: EditLocationCompanyLocationExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  editInternalInfoExpedition: (expeditionId: string,body: EditInternalInfoExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExpeditionIncoterms: (expeditionId: string,body: UpdateExpeditionIncotermsRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateExpeditionHuEkaer: (expeditionId: string,body: UpdateExpeditionHuEkaerRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  editHeaderExpedition: (expeditionId: string,body: EditHeaderExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeExpeditionDistributionPrice: (expeditionId: string,body: ChangePriceInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeFinalPrice: (expeditionId: string,body: ChangeFinalPriceInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeExpeditionDistributionDate: (expeditionId: string,body: ChangeExpeditionDistributionDateInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getMultiduplicationV3ItemDetail: (jobId: string,itemId: string, onSuccess: ((data : MultiduplicationV3ItemDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateMultiduplicationV3Item: (jobId: string,itemId: string,body: MultiduplicationV3ItemOverrideInDTO, onSuccess: ((data : MultiduplicationV3ItemDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteMultiduplicationV3Item: (jobId: string,itemId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  keepMultiduplicationV3Items: (jobId: string,body: MultiduplicationV3KeepItemsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  favoriteExpedition: (expeditionId: string,body: FavoriteExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveDuplicationExpedition: (body: SaveDuplicationExpeditionRequestInDTO, onSuccess: ((data : CheckDuplicationExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkDuplicationExpedition: (body: CheckDuplicationExpeditionRequestInDTO, onSuccess: ((data : CheckDuplicationExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  expUpdateMassAction: (body: MassActionExpeditionInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getMassActionExpeditionData: (body: MassActionInfoExpeditionInDTO, onSuccess: ((data : MassActionExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateETransport: (reservationId: string,body: ETransportDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  editAttachment: (documentId: string,body: AttachmentIdWithTypeV2InDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDhlAccountSettings: (onSuccess: ((data : DhlAccountSettingsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveDhlAccountSettings: (body: DhlAccountSettingsInDTO, onSuccess: ((data : DhlAccountSettingsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteDhlAccountSettings: (onSuccess: ((data : DhlAccountSettingsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createOrUpdateCompanyPartnerInfo: (body: CompanyPartnerInfoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  companyGetNotificationTypeSettings: (onSuccess: ((data : NotificationTypeSettingOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  companySetNotificationTypeSetting: (body: SetNotificationTypeSettingInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCompanyFolderCustomer: (folderId: string,body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCompanyFolderCustomer: (folderId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCompanyCodeList: (body: UpdateCompanyCodeListRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyCodeList: (body: CreateCompanyCodeListRequest, onSuccess: ((data : CreateCompanyCodeListResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  massActionCompanyCodeList: (body: MassActionCompanyCodeListRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeGDName: (groupDemandId: string,body: ChangeGDNameRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCalendarLayoutModel: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCalendarLayoutModel: (modelId: string,body: UpdateCalendarLayoutModelInDTO, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveDraft: (modelId: string,body: SaveCalendarLayoutDraftInDTO, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  discardDraft: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDefault: (onSuccess: ((data : CalendarLayoutDefaultOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setDefault: (body: SetCalendarLayoutDefaultInDTO, onSuccess: ((data : CalendarLayoutDefaultOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  attachmentUpdateMassAction: (body: MassActionAttachmentInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getRule: (ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateRule: (ruleId: string,body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteRule: (ruleId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminEditWebAlert: (webAlertId: string,body: AdminWebAlertRequestInDTO, onSuccess: ((data : AdminWebAlertResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDeleteWebAlert: (webAlertId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminUpdateCompanyDetail: (companyId: string,body: UpdateCompanyDetailInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated Upsert timeslot module settings
   */
  upsertTimeslotModuleSettings: (companyId: string,body: UpsertTimeslotModuleSettingRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getSnModuleSettings: (companyId: string, onSuccess: ((data : SnModuleSettingsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  upsertSnModuleSettings: (companyId: string,body: SnModuleSettingsDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReminderModuleSettings: (companyId: string, onSuccess: ((data : ReminderSettingsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  upsertReminderModuleSettings: (companyId: string,body: ReminderSettingsDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExpeditionModuleSettings: (companyId: string, onSuccess: ((data : ExpeditionModuleSettingsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  upsertExpeditionModuleSettings: (companyId: string,body: ExpeditionModuleSettingsDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetCompanyNotificationTypeSettings: (companyId: string, onSuccess: ((data : NotificationTypeSettingOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminSetCompanyNotificationTypeSetting: (companyId: string,body: SetNotificationTypeSettingInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminReadAllCompanyNotifications: (companyId: string, onSuccess: ((data : AdminReadAllCompanyNotificationsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getBetaFeatures: (companyId: string, onSuccess: ((data : any)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setBetaFeatures: (companyId: string,body: SetBetaFeaturesInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetCargoTemplate: (cargoTemplateId: string, onSuccess: ((data : CargoTemplateDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminEditCargoTemplate: (cargoTemplateId: string,body: CargoTemplateRequestInDTO, onSuccess: ((data : CargoTemplateDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetRule: (companyId: string,ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminUpdateRule: (companyId: string,ruleId: string,body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDeleteRule: (companyId: string,ruleId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminUpdateUser: (userId: string,body: UserCompanyUserInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  acceptEurowagQuote: (customerId: string,applicationId: string,ewQuoteId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuValidateCarriersForExpeditionsV3: (body: ValidationCarriersRequestInDTO, onSuccess: ((data : FindCarrierResponseOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuAddCatalogCarrierGroupForCarrier: (carrierId: string,body: CarrierGroupsInIdsV2, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCheckIfGroupAlreadyExists: (body: CatalogCarrierGroupNameInDTO, onSuccess: ((data : CatalogCarrierGroupNameExistsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setPhoneToCurrentUser: (body: ProfileSettingsPhoneInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuMarkAllNotificationAsRead: (onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setNotifyTargets: (expeditionId: string,body: NotifyTargetInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuEditLocations: (companyId: string,applicationId: string,locationId: string,body: LocationEditInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetExpeditionInternalInformation: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionInternalInformationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateExpeditionInternalInformation: (companyId: string,applicationId: string,body: ExpeditionInternalInformationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuEditTimeOrPriceDistribution: (companyId: string,applicationId: string,body: UpdateDistributionInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateDistributionForExpedition: (companyId: string,applicationId: string,body: DistributionInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuEditCarrierRequirement: (companyId: string,applicationId: string,body: CarrierRequirementEditInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetEditTemplateName: (expeditionTemplateId: string, onSuccess: ((data : EditDataTemplateNameOuDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateEditTemplateName: (expeditionTemplateId: string,body: EditTemplateNameInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetEditTemplateLocationAndOrder: (expeditionTemplateId: string,locationId: string, onSuccess: ((data : EditDataLocationAndOrderOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateEditTemplateLocationAndOrder: (expeditionTemplateId: string,locationId: string,body: EditLocationAndOrderInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetEditInternalInformation: (expeditionTemplateId: string, onSuccess: ((data : EditTemplateInternalInformationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateEditInternalInformation: (expeditionTemplateId: string,body: EditTemplateInternalInformation, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateEditDistribution: (expeditionTemplateId: string,body: DistributionTemplateInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetEditTemplateCarrierRequirement: (expeditionTemplateId: string, onSuccess: ((data : EditDataTemplateCarrierRequirementOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateEditTemplateCarrierRequirement: (expeditionTemplateId: string,body: EditTemplateCarrierRequirementInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateMassActionInternalInformation: (body: MassInternalInfoExpeditionsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetPartnerDetail: (partnerId: string, onSuccess: ((data : PartnerDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdatePartner: (partnerId: string,body: PartnerDetailInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDeletePartner: (partnerId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetEditPartnerLocation: (partnerId: string,locationId: string, onSuccess: ((data : PartnerLocationDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdatePartnerLocation: (partnerId: string,locationId: string,body: PartnerLocationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDeletePartnerLocation: (partnerId: string,locationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setModuleToCompany: (companyId: string,moduleType: string,body: SetCompanyModuleInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuChangeBlacklistCarrierUser: (carrierId: string,userId: string,body: BlacklistCarrierUserStateInDTO, onSuccess: ((data : BlacklistCarrierUserStateOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDetailCarrierGroupsPage: (carrierId: string,page: Pageable, onSuccess: ((data : PageResponseCarrierDetailGroupsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuAddCarrierGroupForCarrier: (carrierId: string,body: CarrierGroupsInIds, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDetailCarrierGroupCarriersPage: (carrierGroupId: string,page: Pageable,q: string, onSuccess: ((data : PageResponseCarrierCarrierGroupPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuAddCarrierToGroup: (carrierGroupId: string,body: CarriersInToGroupIds, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyUserDetail: (userId: string, onSuccess: ((data : UserCompanyUserDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateUserUnderCompany: (userId: string,body: UserCompanyUserInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeStatusUserUnderCompany: (userId: string,isBlocked: boolean, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminUpdateSecurityRole: (securityRoleId: string,body: UserSecurityRolesInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCompanyInfo: (body: CompanyInfoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetEditTimeslots: (companyId: string,applicationId: string, onSuccess: ((data : EditTimeslotCarrierOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caUpdateEditTimeslots: (companyId: string,applicationId: string,body: EditTimeslotCarrierInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caEditCarInfo: (companyId: string,applicationId: string,body: EditCarInfoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caMassEditCarInfo: (body: MassEditCarInfoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  expEditCarInfo: (expeditionId: string,body: EditCarInfoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminAllNotInheritedCompanyModules: (companyId: string, onSuccess: ((data : AdminModuleAllNotInheritedPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminToggleModuleForCompany: (companyId: string,body: AdminModuleNotInheritedInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getWorkflowPossibleTransition: (entityId: string,entityType: string, onSuccess: ((data : WorkflowPossibleTransitionOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  performTransitionOnEntity: (entityId: string,entityType: string,body: WorkflowTransitionInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getVisitorRecord: (id: string, onSuccess: ((data : VisitorRecordDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateVisitorRecord: (id: string,body: VisitorRecordInDTO, onSuccess: ((data : VisitorRecordOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  archiveVisitorRecord: (id: string,body: ArchiveVisitorRecordInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotificationSupplierUpdateDataForTimeslots: (supplierNotificationId: string,body: SNUpdateDataTimeslotsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotificationSupplierUpdateDataForLocationStatus: (supplierNotificationId: string,body: SNUpdateDataLocationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotificationSupplierUpdateInternalNote: (supplierNotificationId: string,body: SNUpdateDataInternalNoteInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotificationSupplierUpdateDataForInternalInfo: (supplierNotificationId: string,body: SNUpdateDataInternalInfoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotificationSupplierUpdateDataForInfoCargo: (supplierNotificationId: string,body: SNUpdateDataInfoCargoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateNotificationSupplierUpdateDataForCargo: (supplierNotificationId: string,body: SNUpdateDataCargosInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeArchiveStateSupplierNotification: (supplierNotificationId: string,body: SHSNArchivedInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateSupplierNotificationMassAction: (body: MassActionSupplierNotificationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateShipmentUpdateDataFoTimeslot: (shipmentId: string,body: SHUpdateDataTimeslotsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateShipmentUpdateDataForLocationStatus: (shipmentId: string,body: SHUpdateDataLocationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateShipmentUpdateDataFoCargo: (shipmentId: string,body: SHUpdateDataCargosInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateShipmentUpdateDataFoCargoInfo: (shipmentId: string,body: SHUpdateDataInfoCargoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeArchiveStateShipment: (shipmentId: string,body: SHSNArchivedInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateInvoice: (invoiceId: string,body: InvoiceInDTO, onSuccess: ((data : InvoiceOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuAddMoreCarriersToGDDistribution: (groupDemandId: string,body: GroupDemandsMoreCarrierInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuChangeGroupDemandDistributionValidTill: (groupDemandId: string,body: GroupDemandChangeValidTillInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetAttachmentDataToSpecificEmails: (entityType: string,entityId: string,fileIds: string[], onSuccess: ((data : AttachmentSendDataEmailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuSendAttachmentToSpecificEmail: (entityType: string,entityId: string,body: AttachmentSendEmailInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuSetLabelsForEntity: (entityType: string,entityId: string,body: EntityLabelsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateInternalComment: (commentId: string,body: InternalCommentUpdateInDTO, onSuccess: ((data : InternalCommentOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteInternalComment: (commentId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetInternalNote: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionInternalNoteOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateInternalNote: (companyId: string,applicationId: string,body: ExpeditionInternalNoteInDTO, onSuccess: ((data : ExpeditionInternalNoteOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeArchiveStateForExpedition: (companyId: string,applicationId: string,body: ExpeditionArchiveInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDynamicCustomerData: (applicationId: string,fieldName: string,companyId: string, onSuccess: ((data : DataOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  setCustomerDynamicData: (applicationId: string,fieldName: string,companyId: string,body: object, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateReservationTimeslot: (reservationId: string,body: EditReservationTimeslotsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateReservationTimeslotDuration: (reservationId: string,body: EditReservationTimeslotsDurationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateReservationOnBehalfOf: (reservationId: string,body: EditReservationOnBehalfOfInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateReservationCarrierEntity: (reservationId: string,body: EditReservationCarrierEntityInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateOrderDiscrepancies: (body: EditOrderDiscrepanciesRequestDTO, onSuccess: ((data : EditOrderDiscrepanciesResponseDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyLocationById: (locationId: string, onSuccess: ((data : CompanyLocationsDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCompanyLocations: (locationId: string,body: CompanyLocationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCompanyLocation: (locationId: string,forceDelete: boolean,softDelete: boolean, onSuccess: ((data : any)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  supersedeCompanyLocation: (locationId: string,body: SupersedeCompanyLocationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateRampsOrder: (locationId: string,body: CompanyLocationRampsOrderInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateLocationRampsConfig: (locationId: string,body: CompanyLocationRampsConfigInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getRampDetailForLocation: (locationId: string,rampId: string, onSuccess: ((data : CompanyLocationRampDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateRampForLocation: (locationId: string,rampId: string,body: CompanyLocationRampInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteRampForLocation: (locationId: string,rampId: string,forceDelete: boolean,softDelete: boolean, onSuccess: ((data : any)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  activateRampForLocation: (locationId: string,rampId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getLocationOpeningHours: (locationId: string, onSuccess: ((data : OpeningHourDefinitionsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateLocatioOpeningHours: (locationId: string,body: OpeningHourDefinitionsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateLocationContact: (locationId: string,contactId: string,body: LocationContactInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateLocationCmrSigningSender: (locationId: string,body: CompanyLocationCmrSigningInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateLocationCmrSigningReceiver: (locationId: string,body: CompanyLocationCmrSigningInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateLocationCarriersApi: (locationId: string,body: CompanyLocationCarriersApiInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateLocationBasicInfo: (locationId: string,body: CompanyLocationBasicInfoInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  activateCompanyLocation: (locationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  putOnLocRampTable: (locationId: string,reservationId: string, onSuccess: ((data : UpdateLocationRampTableResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  removeFromLocRampTable: (reservationId: string,locationId: string, onSuccess: ((data : LocationRampTableOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  replaceOnLocRampTable: (locationId: string,reservationId: string,overwriteReservationId: string, onSuccess: ((data : LocationRampTableOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  companyUserDriverSetDeleted: (companyUserId: string,body: SetCompanyUserDriverDeletedRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminEditShippingCompany: (id: string,body: EditShippingCompanyRequestInDTO, onSuccess: ((data : EditShippingCompanyResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDeleteShippingCompany: (id: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createOrderConfirmationPdf: (expeditionId: string, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  manualWebhookReservationAvailability: (reservationId: string, onSuccess: ((data : ManualWebhookAvailabilityOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  manualWebhookReservationSend: (reservationId: string, onSuccess: ((data : ManualWebhookSendOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  manualWebhookExpeditionAvailability: (expeditionId: string, onSuccess: ((data : ManualWebhookAvailabilityOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  manualWebhookExpeditionSend: (expeditionId: string, onSuccess: ((data : ManualWebhookSendOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserVisitorRecordFilters: (body: SaveUserVisitorRecordFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserTimeslotCalendarFilters: (body: SaveUserTimeslotCalendarFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserSupplierNotificationFilters: (body: SaveUserSupplierNotificationFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserReservationFilters: (body: SaveUserReservationFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserNotificationFilters: (body: SaveUserNotificationFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserJobFilters: (body: SaveUserJobFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserExpeditionFilters: (body: SaveUserExpeditionFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUserEmailHistoryFilters: (body: SaveUserEmailHistoryFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createTableView: (tableKey: string,body: CreateTableViewInDTO, onSuccess: ((data : TableViewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cancelSupplierNotification: (supplierNotificationId: string,body: CancelSnResponseInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createDAPSupplierNotification: (body: DAPSupplierNotificationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  handleWebhook: (onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  importPriceFromJson: (body: ImportPriceJsonToDbRequest, onSuccess: ((data : ImportPriceJsonToDbResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  importCountryConfigurations: (body: ImportSchenkerCountryConfigurationRequestInDTO, onSuccess: ((data : ImportSchenkerCountryConfigurationResponseDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUpdateCamera: (body: SaveUpdateCameraRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveUpdateAllowedCarPlate: (body: SaveUpdateAllowedCarPlateRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  runConsoleRunner: (body: RunnerRequest, onSuccess: ((data : RunnerResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateTruck: (reservationId: string,body: UpdateTruckRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateReservationName: (reservationId: string,body: UpdateReservationNameRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateReservationOrdersAndTimeslot: (reservationId: string,body: UpdateOrdersAndTimeslotRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateNote: (reservationId: string,body: UpdateNoteRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateNoteForCarrier: (reservationId: string,body: UpdateNoteForCarrierRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateInternalNote: (reservationId: string,body: UpdateInternalNoteRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateFolders: (reservationId: string,body: UpdateFoldersRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateDriverPhone: (reservationId: string,body: UpdateDriverPhoneRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateDriverNameAndID: (reservationId: string,body: UpdateDriverNameRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationUpdateCarPlate: (reservationId: string,body: UpdateCarPlateRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  unarchiveReservation: (reservationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reservationNotifyDriver: (reservationId: string,body: NotifyDriverRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  archiveReservation: (reservationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  massDeleteReservations: (body: MassDeleteReservationsInDTO, onSuccess: ((data : MassActionReservationsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  massArchiveReservations: (body: MassArchiveReservationsInDTO, onSuccess: ((data : MassActionReservationsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createReservationMultiDuplicationJob: (body: CreateReservationMultiDuplicationJobInDTO, onSuccess: ((data : ReservationMultiDuplicationJobStartedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkReservationIfExpeditionCanBeCreated: (body: CheckIfExpeditionCanBeCreatedRequestInDTO, onSuccess: ((data : CheckIfExpeditionCanBeCreatedResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  testPushPublish: (body: TestPushPublishRequest, onSuccess: ((data : TestPushPublishResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  registerCompany: (registerCode: string,body: RegisterCompanyRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  contactRingilCompanyForRegistration: (body: AdHocRegistrationCompanyRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkCompanyIfExists: (body: CheckIfCompanyExistsRequestInDTO, onSuccess: ((data : CheckIfCompanyExistsResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  rejectModules: (inheritedCompanyId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  acceptAllModules: (inheritedCompanyId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  acceptModuleMultiple: (body: MassActionAcceptModuleRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  regenerateCode: (body: RegenerateLinkedCodeRequestIdDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  retryJob: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  archiveJob: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  importCompanyCodeList: (codeListEnum: string,body: ImportCompanyCodeListRequest, onSuccess: ((data : ImportCompanyCodeListResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  importCompanyAndLocation: (body: ImportCompanyAndLocationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  importCameras: (body: ImportCamerasInput, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  importAllowedCarPlates: (body: ImportAllowedCarPlatesRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getConsoleRunners: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  startFedexRegistration: (body: FedexRegistrationStartInDTO, onSuccess: ((data : FedexRegistrationStepOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  sendFedexRegistrationPin: (body: FedexRegistrationPinSendInDTO, onSuccess: ((data : FedexRegistrationPinSentOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  confirmFedexRegistrationPin: (body: FedexRegistrationPinConfirmInDTO, onSuccess: ((data : FedexRegistrationStepOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  confirmFedexRegistrationInvoice: (body: FedexRegistrationInvoiceConfirmInDTO, onSuccess: ((data : FedexRegistrationStepOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  acceptFedexEula: (body: FedexEulaAcceptInDTO, onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFedexPickupAvailability: (body: FedexPickupAvailabilityInDTO, onSuccess: ((data : FedexPickupAvailabilityOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  uploadFedexEtdImage: (imageType: string,body: FedexEtdImageUploadInDTO, onSuccess: ((data : FedexEtdImagesOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteFedexEtdImage: (imageType: string, onSuccess: ((data : FedexEtdImagesOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  fedexCertRequote: (body: FedexCertRequoteInDTO, onSuccess: ((data : FedexCreateQuoteResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFedexAvailableProducts: (body: FedexAvailableProductsRequestDTO, onSuccess: ((data : FedexAvailableProductDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listExternalManipulationUnits: (pageable: Pageable,filter: ExternalManipulationFilterDTO, onSuccess: ((data : PageResponseExternalManipulationUnitDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createExternalManipulationUnit: (body: CreateExternalManipulationUnitRequestDTO, onSuccess: ((data : ExternalManipulationUnitDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  startExportJob: (body: ExportJobRequestInDTO, onSuccess: ((data : ExportJobStartedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createExportAsyncJob: (body: ExportJobRequestInDTO, onSuccess: ((data : ExportAsyncJobStartedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  dismissRobotSuggestion: (expeditionId: string,suggestionId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  acceptRobotSuggestion: (expeditionId: string,suggestionId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  finishLocationByCustomer: (expeditionId: string,locationId: string,body: FinishLocationByCustomerRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createDistribution: (expeditionId: string,body: SaveDistributionRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  downloadPODFromDachser: (expeditionId: string, onSuccess: ((data : CarrierPodResult)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createMultiduplicationV3Job: (body: MultiduplicationV3CreateJobInDTO, onSuccess: ((data : MultiduplicationV3JobStartedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  revalidateMultiduplicationV3Job: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  executeMultiduplicationV3Job: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  expeditionList: (page: Pageable,body: FilterRequestInDTO, onSuccess: ((data : ExpeditionListDataOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  importEnnoviExpedition: (body: EnnoviImportExpeditionRequestInDTO, onSuccess: ((data : EnnoviImportExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkImportEnnoviExpedition: (body: EnnoviImportExpeditionRequestInDTO, onSuccess: ((data : CheckEnnoviImportExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createDuplicationJob: (body: SaveDuplicationExpeditionRequestInDTO, onSuccess: ((data : DuplicationJobStartedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createExpeditionBulkDistributionJob: (body: ExpeditionBulkDistributionCreateJobInDTO, onSuccess: ((data : ExpeditionBulkDistributionJobStartedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  revalidateExpeditionBulkDistributionJob: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  executeExpeditionBulkDistributionJob: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createETransport: (reservationId: string,body: ETransportDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuResendResolvedEmail: (resolvedEmailId: string, onSuccess: ((data : ResendResolvedEmailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuBatchResendResolvedEmails: (body: BatchResendResolvedEmailsInDTO, onSuccess: ((data : BatchResendResolvedEmailsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  distributionCreateTiebreaker: (distributionId: string,body: CreateTiebreakerInDTO, onSuccess: ((data : CreateTiebreakerOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDHLAvailableProducts: (body: DHLAvailableProductsRequestDTO, onSuccess: ((data : DHLAvailableProductDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  declineEurowagQuote: (customerId: string,applicationId: string,ewQuoteId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  generateDachserExportAndDownload: (body: Expeditions, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listSNCustomsInvoices: (snId: string, onSuccess: ((data : ListCustomsInvoicesResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createSNCustomsInvoice: (snId: string,body: CreateCustomsInvoicesRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listExpeditionCustomsInvoices: (expeditionId: string, onSuccess: ((data : ListCustomsInvoicesResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createExpeditionCustomsInvoice: (expeditionId: string,body: CreateCustomsInvoicesRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCustomerNotification: (body: DeleteCustomerNotificationRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateUserUnderCompany: (companyId: string,body: UserCompanyUserInDTO, onSuccess: ((data : UserCompanyUserDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createExpeditionFromSN: (supplierNotificationId: string, onSuccess: ((data : ExpeditionCoordinate)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  copyAttachmentToEntity: (body: CopyAttachmentToEntityRequest, onSuccess: ((data : any)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated Compute reservation duration with manipulation units
   */
  computeReservationDurationWithManipulationUnits: (companyId: string,body: ComputeReservationDurationInDTO, onSuccess: ((data : ComputeReservationDurationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCustomsForSupplierNotification: (supplierNotificationId: string,companyId: string,body: CustomsCustomsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCustomsForExpedition: (expeditionId: string,companyId: string,body: CustomsCustomsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyFoldersCustomer: (entityType: string, onSuccess: ((data : CompanyFolderListOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyFolderCustomer: (body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  pocOpenGate: (companyLocationId: string,body: WSCameraGateOpeningRequest, onSuccess: ((data : WSCameraGateOpeningResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCalendarLayoutModels: (page: Pageable,filter: CalendarLayoutModelFilter, onSuccess: ((data : PageResponseCalendarLayoutModelRowOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCalendarLayoutModel: (body: CreateCalendarLayoutModelInDTO, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCalendarLayoutModels: (body: DeleteCalendarLayoutModelsInDTO, onSuccess: ((data : DeleteCalendarLayoutModelsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  revert: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  publish: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  archiveCalendarLayoutModels: (body: ArchiveCalendarLayoutModelsInDTO, onSuccess: ((data : ArchiveCalendarLayoutModelsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listAssignments: (page: Pageable,filter: CalendarLayoutAssignmentFilter, onSuccess: ((data : PageResponseCalendarLayoutAssignmentRowOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  applyAssignments: (body: ApplyCalendarLayoutAssignmentsInDTO, onSuccess: ((data : ApplyCalendarLayoutAssignmentsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCustomerNotification: (body: CreateCustomerNotificationRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listRules: (onSuccess: ((data : RuleListItemOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createRule: (body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  enableRule: (ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  disableRule: (ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  validateRule: (body: ValidateRuleInDTO, onSuccess: ((data : ValidateRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  formatRule: (body: FormatRuleInDTO, onSuccess: ((data : FormatRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  dryRunRule: (body: DryRunInDTO, onSuccess: ((data : DryRunOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminWebhookPreview: (body: WebhookTestRequestInDTO, onSuccess: ((data : WebhookTestPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminWebhookDeliveryRetry: (deliveryId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListWebAlert: (onSuccess: ((data : ListWebAlertResponseOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateWebAlert: (body: AdminWebAlertRequestInDTO, onSuccess: ((data : AdminWebAlertResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkCompanyDetailDuplicates: (companyId: string,body: CompanyDetailDuplicateCheckInDTO, onSuccess: ((data : CompanyDetailDuplicateCheckOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  duplicateEmailRequest: (emailRequestId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  resendResolvedEmail: (resolvedEmailId: string, onSuccess: ((data : ResendResolvedEmailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  batchResendResolvedEmails: (body: BatchResendResolvedEmailsInDTO, onSuccess: ((data : BatchResendResolvedEmailsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyNotificationSetting: (companyId: string, onSuccess: ((data : GetCompanyNotificationSettingResponseOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyNotificationSetting: (companyId: string,body: CreateCompanyNotificationSettingRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyFolder: (companyId: string,entityType: string, onSuccess: ((data : ListCompanyFolderResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyFolder: (companyId: string,body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  updateCompanyFolder: (companyId: string,folderId: string,body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCompanyFolder: (companyId: string,folderId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDeleteCompany: (companyId: string, onSuccess: ((data : AdminDeleteCompanyResponseDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListCargoTemplate: (page: Pageable,filter: CargoTemplateFilter, onSuccess: ((data : PageResponseCargoTemplateListItemOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateCargoTemplate: (body: CargoTemplateRequestInDTO, onSuccess: ((data : CargoTemplateDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCameraOpen: (locationId: string,body: CameraGateOpeningRequest, onSuccess: ((data : CameraGateOpeningResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListRules: (companyId: string, onSuccess: ((data : RuleListItemOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateRule: (companyId: string,body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminEnableRule: (companyId: string,ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDisableRule: (companyId: string,ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminValidateRule: (companyId: string,body: ValidateRuleInDTO, onSuccess: ((data : ValidateRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminFormatRule: (companyId: string,body: FormatRuleInDTO, onSuccess: ((data : FormatRuleOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDryRunRule: (companyId: string,body: DryRunInDTO, onSuccess: ((data : DryRunOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminMoveLogsteoUserToCompanyUser: (body: MoveLogsteoUserToCompanyUserRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminImportUser: (body: AdminImportUserRequest, onSuccess: ((data : AdminImportUserResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminImportCompany: (body: AdminImportCompanyRequest, onSuccess: ((data : AdminImportCompanyResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminImportCompanyLocation: (body: AdminImportCompanyLocationRequest, onSuccess: ((data : AdminImportCompanyLocationResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminHttpRequestChangeSettings: (body: AdminHTTPRequestSettingsUpdateRequest, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateUserInAuth0: (body: AdminCreateUserInAuth0InDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createOrUpdateAdditionalTerm: (body: CreateOrUpdateAdditionalTermInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetCarrierNote: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionCarrierNoteOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  aiCarrierAutoSelectionV3: (body: AiCarrierAutoSelectionInDTO, onSuccess: ((data : FindCarrierResponseOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createExpedition: (body: SaveExpeditionRequestInDTO, onSuccess: ((data : SaveExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCMRFromExpeditionV2: (expeditionId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFreeSlotsForLocationReservation: (localDate: string,eventDuration: number,locationId: string,reservationFilterOutIds: string[],body: ReservationDataInDTO, onSuccess: ((data : FreeSlotsWrapperOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  requestTimeslotOnTimeCheckMessage: (body: TimeslotOnTimeCheckRequestDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  requestTimeslotGoToRampMessage: (body: TimeslotGoToRampRequestDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetSpecificMessageGroupV2: (companyId: string,entityId: string,entityType: string,carrierId: string, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuSendMessageV2: (companyId: string,entityId: string,entityType: string,carrierId: string,body: SendMessagesInV3DTO, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuSendMultipleMessagesV2: (companyId: string,entityId: string,entityType: string,body: SendMessagesMultipleV3DTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetMessagesV2: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caSendMessageV2: (companyId: string,entityId: string,entityType: string,body: SendMessagesInV3DTO, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  genericUploadV2: (body: GenericAttachmentV2InDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  genericReProcess: (body: GenericAttachmentV2InDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuAddCatalogCarrierToMyCompany: (carrierId: string, onSuccess: ((data : CatalogCarrierAddOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createExpeditionDetailPdf: (expeditionId: string, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovDeliveryTerm: (body: DeliveryTermsCarriersRequestDTO, onSuccess: ((data : any)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetSubscriberInfo: (companyId: string,applicationId: string, onSuccess: ((data : SubscriberInfoOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuSetOrUnsetMeAsSubscriber: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuRejectDemand: (companyId: string,applicationId: string,quoteId: string,body: RejectMessageInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuAcceptDemand: (companyId: string,applicationId: string,quoteId: string,body: AcceptQuoteByCustomerRequestDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuReadNotification: (notificationId: string,companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuAddMoreCarriersToDistribution: (companyId: string,applicationId: string,body: AddMoreCarrierInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCancelExpedition: (companyId: string,applicationId: string,body: CancelExpeditionInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateExpeditionTemplate: (body: TemplateExpeditionInputInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateDistributionTemplate: (body: DistributionTemplateInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuUpdateCarrierNote: (companyId: string,applicationId: string,body: ExpeditionCarrierNoteInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuListPartners: (page: Pageable,q: string, onSuccess: ((data : PageResponsePartnerPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreatePartner: (body: PartnerDetailInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreatePartnerLocation: (partnerId: string,body: PartnerLocationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  migratePartnerLocationToCompanyLocation: (partnerId: string,locationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyLocationFromPartner: (partnerId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyLocationFromAllPartners: (onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuListCarriers: (page: Pageable,q: string, onSuccess: ((data : PageResponseCarrierListOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateCarrier: (body: CarrierCreateInDTO, onSuccess: ((data : CreatedIdEntityOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateCarrierUserByCustomer: (carrierId: string,body: AddCarrierUserInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuListCarrierGroups: (page: Pageable,q: string, onSuccess: ((data : PageResponseCarrierGroupListOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateCarrierGroup: (body: CarrierGroupNameInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createUserUnderCompany: (body: UserCompanyUserInDTO, onSuccess: ((data : UserCompanyUserDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  addWebAccessToVirtualUser: (userId: string,body: UserCompanyWebAccessEmailInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  sendLoginToMobileApp: (userId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetSecurityRoles: (onSuccess: ((data : CompanySecurityRolePreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateSecurityRole: (body: UserSecurityRolesInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetDemandDetail: (companyId: string,applicationId: string, onSuccess: ((data : QuoteDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caMakeAnotherNewQuote: (companyId: string,applicationId: string,body: MakeOfferInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caMakeQuote: (companyId: string,applicationId: string,quoteId: string,body: MakeOfferInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caCancelDemand: (companyId: string,applicationId: string,quoteId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetShipmentDetailProgressTabAssigned: (companyId: string,applicationId: string, onSuccess: ((data : JobProgressFormDataOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caSendAssignedShipmentForm: (companyId: string,applicationId: string,body: ShipmentProgressFormDataInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caFinishLocationWithData: (companyId: string,applicationId: string,locationId: string,body: FinishLocationActionWrapperInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caRejectFixedPrice: (companyId: string,applicationId: string,quoteId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caAcceptFixedPrice: (companyId: string,applicationId: string,quoteId: string,body: FixedPriceAcceptOfferInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caFinishShipment: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminAddInheritingModuleByCompany: (companyId: string,inheritedCompanyId: string,companyModule: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDeleteInheritingModuleByCompany: (companyId: string,inheritedCompanyId: string,companyModule: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createFirstCompanyRegistration: (body: FirstCompanyRegistrationInDTO, onSuccess: ((data : CreateFirstCompanyResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminRebuildDashboard: (onSuccess: ((data : DashboardRebuildTriggerDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminAddNotEnabledEmailNotificationForCompany: (companyId: string,emailType: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminDeleteNotEnabledEmailNotificationForCompany: (companyId: string,emailType: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getVisitorRecords: (page: Pageable,filter: VisitorRecordFilterInDTO, onSuccess: ((data : VisitorRecordListResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createVisitorRecord: (body: VisitorRecordInDTO, onSuccess: ((data : VisitorRecordOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listSupplierNotification: (page: Pageable,filter: AllSupplierNotificationFilter, onSuccess: ((data : SupplierNotificationListOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createSupplierNotification: (body: SupplierNotificationInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listShipment: (page: Pageable,filter: ShipmentListFilter, onSuccess: ((data : PageResponseListShipmentPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createShipment: (body: ShipmentInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  sendExternalQuote: (expeditionId: string, onSuccess: ((data : SendExternalQuoteResponseDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  submitInvoiceValidationResponse: (body: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listGroupDemands: (page: Pageable,filter: CustomerGroupDemandFilter, onSuccess: ((data : PageResponseGroupDemandListPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createGroupDemand: (body: GroupDemandInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createGroupDemandsDistribution: (groupDemandId: string,body: GroupDemandsDistributionInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDeleteGroupDemand: (groupDemandId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateExpeditionFromGroupDemandsSN: (groupDemandId: string,body: ExpeditionCreateFromGDPerSN, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  sendExpeditionTimeslotReminder: (ownerCompanyId: string,applicationId: string,locationId: string, onSuccess: ((data : ExpeditionTimeslotReminderOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuReconfirmedExpedition: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caReconfirmedExpedition: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  finishExpedition: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  generateAndAttachNewIntegrationToken: (userId: string, onSuccess: ((data : LinkTokenToUserOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeDocumentVisibility: (attachmentId: string,body: ChangeVisibilityInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  sendPowerBIToken: (body: PowerBiReportInDTO, onSuccess: ((data : PowerBiTokenDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listInternalComments: (entityType: string,entityId: string,page: Pageable, onSuccess: ((data : PageResponseInternalCommentOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createInternalComment: (body: InternalCommentInDTO, onSuccess: ((data : InternalCommentOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuSetResponsiblePersonToExpedition: (companyId: string,applicationId: string,userId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCreateExtraCostForExpedition: (companyId: string,applicationId: string,body: ExtraCostsInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuSetDirectAssignment: (companyId: string,applicationId: string,body: DirectAssigmentDataInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuPublishExpeditions: (body: ExpeditionToPublishInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createAdditionalInfoForCarrier: (carrierId: string,body: AdditionalInfoCarrierRequestInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  convertCsvToListObject: (body: CSVInDTO, onSuccess: ((data : undefined[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanySettings: (identifier: CompanySettingsIdInDTO, onSuccess: ((data : CompanySettingsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  saveCompanySettings: (body: CompanySettingsInDTO, onSuccess: ((data : CompanySettingsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReservations: (page: Pageable,filter: AllReservationsFilter, onSuccess: ((data : PageResponseReservationListPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createReservation: (body: ReservationDataInDTO, onSuccess: ((data : ReservationCoordinates)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReservationsForDayAndMultipleLocations: (body: RequestParamsForMultipleLocationReservationInDTO, onSuccess: ((data : ReservationCalendarGroupedOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkReservation: (reservationFilterOutIds: string[],body: ReservationDataInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyLocations: (q: string,showOnlyWithRamp: boolean, onSuccess: ((data : CompanyLocationsListPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyLocations: (body: CompanyLocationInDTO, onSuccess: ((data : CreateCompanyLocationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createRampForLocation: (locationId: string,body: CompanyLocationRampInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listLocationContacts: (locationId: string,page: Pageable,q: string,automaticPrefillToNotify: boolean, onSuccess: ((data : PageResponseLocationContactOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createLocationContact: (locationId: string,body: LocationContactInDTO, onSuccess: ((data : CreateLocationContactOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteLocationContacts: (locationId: string,contactIds: string[], onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  changeACLForLocations: (body: CompanyLocationMassActionChangeACLInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyLocationExceptions: (page: Pageable,filter: CompanyLocationExceptionFilterDTO, onSuccess: ((data : PageResponseCompanyLocationExceptionPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyLocationException: (body: CompanyLocationExceptionInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCompanyLocationExceptions: (exceptionIds: string[], onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listAllLabelsForCompany: (onSuccess: ((data : GetListLabelsPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createNewLabelForCompany: (body: CreateNewLabelInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyUsersDrivers: (page: Pageable,q: string, onSuccess: ((data : PageResponseLovDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  createCompanyUserDriver: (body: CreateCompanyUserDriverRequest, onSuccess: ((data : CreateCompanyUserDriverResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovAllCompaniesByInheritedModules: (body: InheritedModulesWrapper, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetGroupDemandDetailById: (groupDemandId: string, onSuccess: ((data : CarrierGroupDemandDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caCreateGroupDemandQuote: (groupDemandId: string,body: CarrierCreateQuoteGroupDemandInDTO, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  uploadAttachments: (body: AttachmentsUploadInDTO, onSuccess: ((data : AttachmentsUploadedOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated Upload attachment
   */
  uploadAttachment: (body: FileV2InDTO, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  downloadAttachmentsZip: (body: AttachmentsZipDownloadInDTO, onSuccess: ((data : Blob)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListShippingCompanies: (page: Pageable,filter: ListShippingCompaniesFilter, onSuccess: ((data : PageResponseListShippingCompaniesItemResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateShippingCompany: (body: CreateShippingCompanyRequestInDTO, onSuccess: ((data : CreateShippingCompanyResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListCarrier: (onSuccess: ((data : AdminCatalogListOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminCreateCarrier: (body: AdminCatalogCreatingInDTO, onSuccess: ((data : AdminCatalogCreatedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getTemplateToExpeditionDetail: (expeditionTemplateId: string, onSuccess: ((data : ExpeditionDetailV4OutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getMultipleExpeditionDetails: (expeditionIds: string[], onSuccess: ((data : MultipleExpeditionDetailV4OutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExpeditionV4Detail: (expeditionId: string, onSuccess: ((data : ExpeditionDetailV4OutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCGLocationsV2: (filter: CGV2LocationFilterInDTO, onSuccess: ((data : CGV2SmallCompanyOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getOneCGLocationV2: (locationId: string, onSuccess: ((data : CGV2LocationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getQuotesDbPaged: (expeditionId: string,distributionId: string,filter: ExpeditionQuoteCarrierFilterInDTO,pageable: Pageable, onSuccess: ((data : PageResponseQuotesPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCarPlates: (onSuccess: ((data : CarPlateDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListCompanies: (page: Pageable,q: string,ico: string, onSuccess: ((data : PageResponseCompanyListOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserTableFilterFavourites: (onSuccess: ((data : GetUserTableFilterFavouritesResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserVisitorRecordFilters: (onSuccess: ((data : GetUserVisitorRecordFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserTimeslotCalendarFilters: (onSuccess: ((data : GetUserTimeslotCalendarFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserSupplierNotificationFilters: (onSuccess: ((data : GetUserSupplierNotificationFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserReservationFilters: (onSuccess: ((data : GetUserReservationFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserNotificationFilters: (onSuccess: ((data : GetUserNotificationFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserJobFilters: (onSuccess: ((data : GetUserJobFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserExpeditionFilters: (onSuccess: ((data : GetUserExpeditionFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserEmailHistoryFilters: (onSuccess: ((data : GetUserEmailHistoryFiltersResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listAvailableUserDepartmentsForCurrentCompany: (onSuccess: ((data : ListUserDepartmentOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lookupTimezone: (city: string,country: string,postalCode: string,useHereMapFallback: boolean, onSuccess: ((data : any)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated This endpoint return setting for TS creator, if inheritor, tsOwnerCompanyId is from the owner 
   */
  getCreateEditReservationSettings: (tsOwnerCompanyId: string, onSuccess: ((data : ComputeReservationDurationConfiguration)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getTableViews: (tableKey: string, onSuccess: ((data : TableViewsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  detailDAPSupplierNotification: (supplierNotificationId: string, onSuccess: ((data : DetailDAPSNResponseOut)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated Get external orders for supplier from configured 3rd-party API
   */
  getExternalOrders: (companyOwnerId: string,supplierId: string,companyLocationId: string, onSuccess: ((data : GetExternalOrdersResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  exportReservations: (filter: AllReservationsFilter, onSuccess: ((data : ReservationDataExportResponseOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReservationMultiDuplicationJobDetail: (jobId: string, onSuccess: ((data : ReservationMultiDuplicationJobDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReservationMultiDuplicationJobItems: (jobId: string,filter: ReservationMultiDuplicationJobItemsFilter,page: Pageable, onSuccess: ((data : PageResponseReservationMultiDuplicationJobItemOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCarriersInputReservation: (linkToExpeditionLocationId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getPushToken: (onSuccess: ((data : GetPushTokenResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getPushSubscriptionToken: (channel: string, onSuccess: ((data : GetPushSubscriptionTokenResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getPriceAlert: (groupDemandId: string, onSuccess: ((data : TheOriginsPriceAlertResponseBody)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovGetPermissions: (onSuccess: ((data : LovGetPermissionResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getOpeningHoursForEntity: (entityId: string,entityType: string, onSuccess: ((data : OpeningHourDefinitionsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getIntegrationOrderForSupplier: (entity: string,selectedSupplierId: string,companyOwnerId: string, onSuccess: ((data : Order[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovGetAllEmailTypes: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listNotificationCenterMessage: (filter: NotificationCenterFilter,page: Pageable, onSuccess: ((data : PageResponseNotificationCenterMessageResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  countNotificationCenterMessage: (onSuccess: ((data : NotificationMessageCountResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovGetAllNotificationTypes: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCompanyCodeList: (codeListEnum: string,query: string, onSuccess: ((data : LovCompanyCodeListDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  loadEurowagProposals: (customerId: string,applicationId: string, onSuccess: ((data : LoadEWProposalsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListHttpRequest: (page: Pageable,filter: ListHTTPRequestFilter, onSuccess: ((data : ListHTTPRequestResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyCodeList: (filter: ListCompanyCodeListFilter,page: Pageable, onSuccess: ((data : PageResponseListCompanyCodeListItem)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyCameras: (onSuccess: ((data : ListCompanyCamerasResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listAllowedCarPlates: (filter: ListAllowedCarPlatesFilter,page: Pageable, onSuccess: ((data : PageResponseAllowedCarPlateResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getLinkedCompanies: (filter: GetLinkedCompaniesFilterInDTO,page: Pageable, onSuccess: ((data : PageResponseGetLinkedCompanyOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDetailLinkedCompany: (companyId: string, onSuccess: ((data : GetDetailLinkedCompanyResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getLinkedCompaniesExport: (filter: GetLinkedCompaniesFilterInDTO, onSuccess: ((data : GetLinkedCompanyOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getActiveLinkedCodes: (onSuccess: ((data : GetLinkedCodeOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAsyncJobDetail: (jobId: string, onSuccess: ((data : AsyncJobDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cancelAsyncJob: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  downloadExportAsyncJob: (jobId: string, onSuccess: ((data : ExportDownloadUrlOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listMyAsyncJobs: (limit: number, onSuccess: ((data : AsyncJobOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyJobs: (filter: CompanyJobsFilter,page: Pageable, onSuccess: ((data : PageResponseCompanyJobOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getJobBadgeCounts: (onSuccess: ((data : JobBadgeCountsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListJobsPaged: (filter: AdminJobsFilter,page: Pageable, onSuccess: ((data : PageResponseAdminAsyncJobOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reindexAllSn: (cleanReindex: boolean, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  reindexOneExpedition: (id: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getWebAppAlert: (onSuccess: ((data : GetWebAppAlertResponse[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAvailableTimezones: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetMultipleSupplierNotificationsForExpedition: (supplierNotificationIds: string[], onSuccess: ((data : SupplierNotificationToExpeditionOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReportPermission: (reportDefinitionId: string,companyId: string, onSuccess: ((data : ReportDefinitionCompanySettingResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listPowerBIReports: (onSuccess: ((data : GetPowerBIReportServiceResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getLinkedEntities: (entityType: string,entityId: string, onSuccess: ((data : GetLinkedEntitiesResponse[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getInheritedCompanies: (onSuccess: ((data : GetInheritedCompanyOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExpeditionV3Detail: (expeditionId: string, onSuccess: ((data : ExpeditionDetailV3OutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDocumentMetadata: (documentId: string, onSuccess: ((data : GetDocumentResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyNotificationsForInheritor: (onSuccess: ((data : CustomerNotificatonListResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyPartnerInfo: (companyPartnerId: string, onSuccess: ((data : PartnerInfo)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCGLocations: (onSuccess: ((data : CGCompanyOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAttachments: (filter: GetAttachmentsFilterInDTO,page: Pageable, onSuccess: ((data : PageResponseGetAttachmentsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  findResolvedEmails: (page: Pageable,filter: FindResolvedEmailFilter, onSuccess: ((data : PageResponseResolvedEmailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  findEmailRequest: (page: Pageable,filter: FindEmailRequestFilter, onSuccess: ((data : PageResponseEmailRequestOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFedexRegistrationStatus: (onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFedexEtdImages: (onSuccess: ((data : FedexEtdImagesOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listFedexAccounts: (pickupCompanyLocationId: string,deliveryCompanyLocationId: string, onSuccess: ((data : FedexAccountOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getSNFeatureConfiguration: (customerId: string, onSuccess: ((data : SnFeatureConfigurationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExternalOrdersByModule: (module: string,companyOwnerId: string,supplierId: string,companyLocationId: string, onSuccess: ((data : GetExternalOrdersResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getJobStatus: (jobId: string, onSuccess: ((data : ExportJobStatusOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  downloadExport: (jobId: string, onSuccess: ((data : ExportDownloadUrlOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  downloadExportProxy: (jobId: string, onSuccess: ((data : Blob)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listMyJobs: (onSuccess: ((data : ExportJobStatusOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  robotSuggestions: (expeditionId: string, onSuccess: ((data : RobotSuggestionOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getPreviousDistribution: (expeditionId: string, onSuccess: ((data : GetPreviousDistributionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFedexExpeditionTracking: (expeditionId: string, onSuccess: ((data : FedexExpeditionTrackingOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFedexExpeditionPickup: (expeditionId: string,locationId: string,dispatchDate: string, onSuccess: ((data : FedexExpeditionPickupOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDachserStatus: (expeditionId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  searchTemplateExpeditionByName: (query: string, onSuccess: ((data : SearchTemplateExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  searchExpeditionByNameOrAppId: (query: string, onSuccess: ((data : SearchExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getMultiduplicationV3JobDetail: (jobId: string, onSuccess: ((data : MultiduplicationV3JobDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteMultiduplicationV3Job: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getMultiduplicationV3JobItems: (jobId: string,filter: MultiduplicationV3ItemsFilter,page: Pageable, onSuccess: ((data : PageResponseMultiduplicationV3JobItemOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDuplicationJobDetail: (jobId: string, onSuccess: ((data : DuplicationJobDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDuplicationJobItems: (jobId: string,filter: DuplicationJobItemsFilter,page: Pageable, onSuccess: ((data : PageResponseDuplicationJobItemOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExpeditionBulkDistributionJobDetail: (jobId: string, onSuccess: ((data : ExpeditionBulkDistributionJobDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteExpeditionBulkDistributionJob: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExpeditionBulkDistributionJobItems: (jobId: string,filter: ExpeditionBulkDistributionJobItemsFilter,page: Pageable, onSuccess: ((data : PageResponseExpeditionBulkDistributionJobItemOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExpeditionModuleSettings_1: (companyId: string, onSuccess: ((data : ExpeditionModuleSettingsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getEtransportDetail: (reservationId: string, onSuccess: ((data : ETransportDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuFindEmailRecipients: (page: Pageable,filter: FindEmailHistoryFilter, onSuccess: ((data : PageResponseEmailHistoryRecipientRowOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDistributionSettings: (onSuccess: ((data : DistributionSettingsResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetHTTPRequest: (requestId: string, onSuccess: ((data : DetailHTTPRequestResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCustomsForSupplierNotification: (supplierNotificationId: string, onSuccess: ((data : CustomsDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCustomsForExpedition: (expeditionId: string, onSuccess: ((data : CustomsDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getInfoCancelExpedition: (applicationId: string,companyId: string, onSuccess: ((data : GetInfoCancelExpeditionResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listAllCustomerNotification: (page: Pageable,filter: ListAllCustomerNotificationFilter, onSuccess: ((data : PageResponseListAllCustomerNotification)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCustomerNotificationDetail: (notificationId: string, onSuccess: ((data : GetCustomerNotificationDetail)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getColumnOrderSetting: (companyId: string,entityType: string, onSuccess: ((data : GetColumnOrderSettingResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyFolderTargetsCustomer: (onSuccess: ((data : NotifyTargetOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkUserCanCreateReservation: (companyLocationId: string, onSuccess: ((data : CheckUserCanCreateReservationResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  checkLocationException: (locationId: string,startDate: string,endDate: string, onSuccess: ((data : CheckLocationExceptionOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCarrierList: (filter: GetLinkedCompaniesFilterInDTO,page: Pageable, onSuccess: ((data : PageResponseGetLinkedCompanyOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listArrivalsDeparturesLog: (filter: ListArrivalsDeparturesLogFilter,page: Pageable, onSuccess: ((data : PageResponseArrivalsDeparturesLogResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  loVCompanyCamerasByLocationId: (locationId: string, onSuccess: ((data : LoVCompanyCamerasResponseOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listEffectiveCalendarLayouts: (onSuccess: ((data : EffectiveCalendarLayoutOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAllowedCarPlate: (id: string, onSuccess: ((data : GetAllowedCarPlateResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listPlanned: (page: Pageable, onSuccess: ((data : PageResponsePlannedEventOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  metadata: (onSuccess: ((data : RuleMetadataOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listExecutions: (page: Pageable,ruleId: string,onlyMatched: boolean, onSuccess: ((data : PageResponseExecutionListItemOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExecution: (executionId: string, onSuccess: ((data : ExecutionDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  activity: (onSuccess: ((data : RobotActivityOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  activityFeed: (since: string,limit: number, onSuccess: ((data : RobotActivityFeedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminWebhookListDefinitions: (page: Pageable,filter: WebhookDefinitionFilter, onSuccess: ((data : PageResponseWebhookDefinitionOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminWebhookDeliveryPayload: (deliveryId: string, onSuccess: ((data : AdminWebhookDeliveryPayloadOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminWebhookDeliveryList: (filter: AdminWebhookDeliveryFilter,page: Pageable, onSuccess: ((data : PageResponseAdminWebhookDeliveryOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listResolvedEmails: (onSuccess: ((data : ListResolvedEmailsResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listEmailRequest: (onSuccess: ((data : ListEmailRequestResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated Find email communication history grouped by email request
   */
  findEmailHistory: (page: Pageable,filter: FindEmailHistoryFilter, onSuccess: ((data : PageResponseEmailHistoryRequestOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getResolvedEmailHtml: (resolvedEmailId: string, onSuccess: ((data : ResolvedEmailHtmlOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  findEmailRecipients: (page: Pageable,filter: FindEmailHistoryFilter, onSuccess: ((data : PageResponseEmailHistoryRecipientRowOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyFolderTargets: (companyId: string, onSuccess: ((data : NotifyTargetOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetCompanyLocation: (companyId: string,name: string,page: Pageable, onSuccess: ((data : PageResponseAdminCompanyLocationResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetNextOrderCargoTemplate: (onSuccess: ((data : NextOrderCargoTemplateOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListPlanned: (companyId: string,page: Pageable, onSuccess: ((data : PageResponsePlannedEventOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListExecutions: (companyId: string,page: Pageable,ruleId: string,onlyMatched: boolean, onSuccess: ((data : PageResponseExecutionListItemOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetExecution: (companyId: string,executionId: string, onSuccess: ((data : ExecutionDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminActivity: (companyId: string, onSuccess: ((data : RobotActivityOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminActivityFeed: (companyId: string,since: string,limit: number, onSuccess: ((data : RobotActivityFeedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminLovAllFeatures: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminHttpRequestGetSettings: (onSuccess: ((data : AdminHTTPRequestSettingsResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetUsers: (page: Pageable,filter: AdminGetUsersFilter, onSuccess: ((data : PageResponseAdminUserOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listAdditionalTerms: (page: Pageable, onSuccess: ((data : PageResponseListAdditionTermsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAdditionalTermById: (additionalTermId: string, onSuccess: ((data : GetAdditionalTermOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteAdditionalTermById: (additionalTermId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReports: (customerId: string, onSuccess: ((data : ManageReportsAdminReportsResponse[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  generateCMRPDFV2: (cmrId: string, onSuccess: ((data : CMRPDF)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated
   */
  cuFindCarriersOrCarrierGroupsV2: (q: string, onSuccess: ((data : FindCarrierCarrierOrGroupResponseOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getFreeSlotsForLocation: (localDate: string,eventDuration: number,locationId: string,reservationFilterOutIds: string[], onSuccess: ((data : FreeSlotsWrapperOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  queryAuditLog: (page: Pageable,filter: AuditFilter, onSuccess: ((data : PageResponseAuditEntryOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditEnums: (onSuccess: ((data : AuditEnumCatalogOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditCompanies: (entityType: string,role: string,entityId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditActors: (entityType: string,entityId: string,role: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditActions: (entityType: string,entityId: string, onSuccess: ((data : AuditActionLovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  queryAuditLogAdmin: (page: Pageable,companyId: string,filter: AuditFilter, onSuccess: ((data : PageResponseAuditEntryOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditEnumsAdmin: (onSuccess: ((data : AuditEnumCatalogOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditCompaniesAdmin: (role: string,companyId: string,entityType: string,entityId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditActorsAdmin: (companyId: string,entityType: string,entityId: string,role: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  auditActionsAdmin: (companyId: string,entityType: string,entityId: string, onSuccess: ((data : AuditActionLovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyFromAresByICO: (ico: string, onSuccess: ((data : AresResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetGroupsMessagesV2: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : ListGroupsMessagesOutV3DTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVAvailableCarriersForMessage: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : LoVCarriesToSendMessageOutV3DTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetCountMessagesV2: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : CountMessagesCarrierOutV3DTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listDocumentsForEntity: (entityType: string,entityId: string, onSuccess: ((data : AttachmentUploadedOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listQuotationMaterialsForEntity: (entityType: string,entityId: string, onSuccess: ((data : AttachmentUploadedOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  copyOfAttachmentsFromEntity: (entityType: string,entityId: string,asPrivate: boolean, onSuccess: ((data : AttachmentUploadedOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDocumentForEntity: (entityType: string,entityId: string,fileId: string, onSuccess: ((data : FileOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteDocumentForEntity: (entityType: string,entityId: string,fileId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuListExpeditionsV3: (filter: AllExpeditionCustomerFilter,page: Pageable, onSuccess: ((data : ExpeditionListDataOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVCatalogRegions: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVCatalogCarrierGroupsWithoutExisting: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVCatalogCountries: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetCatalogCarriers: (filter: CatalogCarrierFilter,page: Pageable, onSuccess: ((data : PageResponseCatalogCarrierPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovWeightModesForOrder: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getProfileForCurrentUser: (onSuccess: ((data : UserProfileOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUserInfo: (onSuccess: ((data : UserInfoOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovTruckTypes: (onSuccess: ((data : TruckTypeWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovTransportationTypes: (onSuccess: ((data : LovTransportationTypeOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovShipmentStateStatus: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovSHSNCargoTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovSecurityRolesV2: (onSuccess: ((data : LovSecurityRolesDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovSchenkerProductTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovSchenkerAddons: (productType: string, onSuccess: ((data : SchenkerLovForAddonTypeOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovResponsiblePersons: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovQuantityUnit: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovOnBehalfOfForInheritor: (inheritorId: string, onSuccess: ((data : LovCompanyCodeListDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovNavyShippingCompanies: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovLocationSharingPrivileges: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVIncotermsValues: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovExtraCosts: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovExpeditionTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovEmailStatus: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCustomsTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCustomsStatus: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listNotifyTargets: (onSuccess: ((data : NotifyTargetOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuListNotifications: (filter: NotificationListFilter,page: Pageable, onSuccess: ((data : PageResponseNotificationPreviewListOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuCountUnreadNotification: (onSuccess: ((data : CountNotificationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetLocationTemplatesAddressBook: (q: string,partnerId: string, onSuccess: ((data : ListAddressBooksOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetDetailExpeditionHeader: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionDetailTabPlanOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetDetailExpeditionPlan: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVAddMoreCarriers: (companyId: string,applicationId: string, onSuccess: ((data : AddMoreCarrierOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetDetailExpeditionCarrierTabAssigning: (companyId: string,applicationId: string, onSuccess: ((data : CarrierPageOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetDetailExpeditionCarrierQuotes: (companyId: string,applicationId: string,filter: ExpeditionDetailCarrierQuotesFilter, onSuccess: ((data : ExpeditionDetailCarrierQuotesResponseOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovDemandStateForDetailExpedition: (companyId: string,applicationId: string, onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovCarrierForDetailExpedition: (companyId: string,applicationId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetDetailExpeditionCarrierTabAssigned: (companyId: string,applicationId: string, onSuccess: ((data : CarrierPageAssignedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetTemplateData: (expeditionTemplateId: string, onSuccess: ((data : TemplateExpeditionOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDeleteTemplateRoute: (expeditionTemplateId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuListTemplates: (filter: CreatedByTemplateFiler,page: Pageable, onSuccess: ((data : PageResponseTemplatePreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetDistributionTemplateData: (distributionTemplateId: string, onSuccess: ((data : DistributionTemplateOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovExpeditionTemplates: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovEnabledCompanyModule: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDetailCarrier: (carrierId: string, onSuccess: ((data : CatalogCarrierDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDeleteCarrier: (carrierId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVCarrierGroups: (carrierId: string, onSuccess: ((data : CarrierCarrierGroupLov)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetCarrierInfoByCrnAndState: (crn: string,state: string, onSuccess: ((data : CarrierSearchOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDetailCarrierGroup: (carrierGroupId: string, onSuccess: ((data : CarrierGroupDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDeleteCarrierGroup: (carrierGroupId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLoVCarrierForGroup: (carrierGroupId: string, onSuccess: ((data : CarriersForGroupLov)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCurrency: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCurrencyForCompany: (parentCompanyId: string, onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCountry: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovContainerTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyForCurrentUser: (onSuccess: ((data : UserCompanyOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCompanyUsers: (page: Pageable,filter: CompanyUsersFilter, onSuccess: ((data : PageResponseUserCompanyUserPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getSecurityUsage: (filter: SecurityUsageFilterInDTO, onSuccess: ((data : SecurityUsageOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getUsersBySecurity: (page: Pageable,filter: SecurityUsageUserFilterInDTO, onSuccess: ((data : PageResponseSecurityUsageUserOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  G: (onSuccess: ((data : CompanySecurityGroupPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCompanyFolders: (q: string,entityType: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovCarriers: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caListDemands: (filter: AllQuoteStateFilter,page: Pageable, onSuccess: ((data : PageResponseQuotePreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caListShipments: (filter: AllJobCarrierFilter,page: Pageable, onSuccess: ((data : PageResponseJobPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetShipmentDetailHeader: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionDetailTabPlanOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetShipmentDetailProgressTabForReadyToShipment: (companyId: string,applicationId: string, onSuccess: ((data : ShipmentPageR2SOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caGetDetailShipmentPlan: (companyId: string,applicationId: string, onSuccess: ((data : JobDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getQuoteDetailById: (quoteId: string, onSuccess: ((data : QuoteDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caLovDispatcher: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovExpeditionDispatcher: (expeditionId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCarrierApiTypeValues: (carrierApiType: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCargoType: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  /**
   * @deprecated Get all special cargo requirements
   */
  lovSpecialRequirements: (onSuccess: ((data : LovWithoutIdWithFillingDataDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovSpecialRequirementsWithParentData: (inheritorId: string, onSuccess: ((data : LovWithoutIdWithFillingDataDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovSpecialRequirementsWithParentDataAndNotification: (inheritorId: string,supplierNotificationId: string, onSuccess: ((data : LovWithoutIdWithFillingDataDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCargoItemType: (onSuccess: ((data : CargoTemplateWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovCargoItemTypeForCompany: (inheritorId: string, onSuccess: ((data : CargoTemplateWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getModulesInheritedForCompany: (companyId: string, onSuccess: ((data : InheritedModuleOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminListInheritingCompaniesByCompany: (companyId: string, onSuccess: ((data : AdminModuleInheritingPreviewDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetModulesForInheritedCompanyDependsOnParentCompany: (companyId: string,inheritedCompanyId: string, onSuccess: ((data : AdminModuleAllInheritedPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminLovExternalIdTypes: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminLovCargoTemplates: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminLovAllSpecialReqs: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminLoVAllCompanies: (onSuccess: ((data : LovCompanyDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAdminDashboardBuildMeta: (onSuccess: ((data : DashboardBuildMetaDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetNotificationForCompany: (companyId: string, onSuccess: ((data : AdminCompanyNotificationEnablingOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  isEntityManagedByWorkflow: (entityId: string,entityType: string, onSuccess: ((data : WorkflowEntityIsManagedOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAllStateForCurrentWFForCompany: (entityType: string, onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getLocationsWithEnabledVisitor: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovUsersForCompany: (q: string,companyId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovUsersWithSpecificRole: (q: string,role: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovUsersWithSpecificPermission: (q: string,permission: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  detailSupplierNotificationById: (supplierNotificationId: string, onSuccess: ((data : DetailSupplierNotificationOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetSupplierNotificationForDuplication: (supplierNotificationId: string, onSuccess: ((data : SupplierNotificationDataForSNOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetSupplierNotificationForExpedition: (supplierNotificationId: string, onSuccess: ((data : SupplierNotificationToExpeditionOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  detailShipmentById: (shipmentId: string, onSuccess: ((data : DetailShipmentOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getShipmentDataForSupplierNotification: (shipmentId: string, onSuccess: ((data : ShipmentDataForSNOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovSecurityGroups: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getMapDataForExpedition: (companyId: string,applicationId: string, onSuccess: ((data : MapDataOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getMapLastTruckPosition: (companyId: string,applicationId: string, onSuccess: ((data : MapDataLastTruckPosition)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovLoadingTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getInvoiceByAttachmentId: (attachmentId: string, onSuccess: ((data : InvoiceOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getGroupDemandDetailByIdCompleteView: (groupDemandId: string, onSuccess: ((data : GroupDemandDetailCompleteViewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovExternalIdTypes: (onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovDriverTemplates: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovDriverTemplatesForExp: (expeditionId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDescribeModel: (modelPrefix: string,modelName: string, onSuccess: ((data : PropertyWithSubProperties)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionConsigneeTasks: (onSuccess: ((data : ConsigneeTasksDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionCarrierTasks: (onSuccess: ((data : CarrierTasksDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionSupplierNotifications: (partnerRole: string,statsRange: string, onSuccess: ((data : SupplierNotificationStatisticsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionSupplierNotificationsTopPartners: (partnerRole: string,statsRange: string,supplierNotificationSortBy: string,supplierNotificationSortDir: string, onSuccess: ((data : NotificationPartnerRowDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionShipments: (shipmentRole: string,statsRange: string, onSuccess: ((data : ShipmentStatisticsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionShipmentsTopPartners: (shipmentRole: string,statsRange: string,shipmentSortBy: string,shipmentSortDir: string, onSuccess: ((data : ShipmentTopRowDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionReservations: (partnerRole: string,statsRange: string, onSuccess: ((data : ReservationStatisticsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionReservationsLocations: (partnerRole: string,statsRange: string,reservationSortBy: string,reservationSortDir: string, onSuccess: ((data : ReservationLocationRowDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionCustomsDeclarations: (statsRange: string, onSuccess: ((data : CustomsDeclarationStatisticsDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardSectionCustomsDeclarationsTopPartners: (statsRange: string,customsDeclarationSortBy: string,customsDeclarationSortDir: string, onSuccess: ((data : CustomsDeclarationTopPartnerRowDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardAvailability: (onSuccess: ((data : DashboardAvailabilityDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovPartners: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetLabelsForEntity: (entityType: string,applicationId: string, onSuccess: ((data : LabelPreviewWithoutTypeOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listExtraCostsForExpedition: (companyId: string,applicationId: string, onSuccess: ((data : ExtraCostsPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuGetUnpublishedCount: (onSuccess: ((data : ExpeditionUnpublishedCountOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovDepartments: (q: string, onSuccess: ((data : string[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovGetAllLocationsForCompanyId: (q: string,showOnlyWithRamp: boolean,filterPartnerLocations: boolean,includeLocationId: string,companyModule: string,companyId: string, onSuccess: ((data : LovCompanyLocationWithOpeningHours[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getInheritCompanySettings: (identifier: CompanySettingsIdInDTO,companyId: string,companyType: string, onSuccess: ((data : CompanySettingsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReservationDetail: (reservationId: string, onSuccess: ((data : ReservationDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteReservation: (reservationId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getReservationForRampDashboard: (locationId: string, onSuccess: ((data : ReservationRampDashboardOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getModulesDashboard: (onSuccess: ((data : ModulesPreviewDataOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getRampsForCompanyLocation: (locationId: string,showTemporaryClosed: boolean, onSuccess: ((data : CompanyLocationRampWithOpeningHoursOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyLocationFutureReservationsCount: (locationId: string, onSuccess: ((data : CompanyLocationFutureReservationsOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getExceptionsForCompanyLocation: (locationId: string, onSuccess: ((data : CompanyLocationExceptionPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCmrSigningImageSender: (locationId: string, onSuccess: ((data : CmrSigningImageOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCmrSigningImageReceiver: (locationId: string, onSuccess: ((data : CmrSigningImageOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getSharedRampsForCompanyLocation: (locationId: string,companyId: string,showTemporaryClosed: boolean, onSuccess: ((data : CompanyLocationRampWithOpeningHoursOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getRampsOpeningHoursForDateRange: (requestParams: RampsOpeningHoursDateRangeRequestInDTO, onSuccess: ((data : RampOpeningHoursByDateRangeOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCompanyLocationsPaged: (q: string,showOnlyWithRamp: boolean,showOnlyPartnerLocation: boolean,showDeleted: boolean,page: Pageable, onSuccess: ((data : PageResponseCompanyLocationsListPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getLoVCompanyLocations: (showOnlyWithRamp: boolean, onSuccess: ((data : CompanyLocationWithOpeningHours[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getRampsForMultipleCompanyLocations: (requestParams: RequestParamsForMultipleLocationsInDTO, onSuccess: ((data : CompanyLocationRampWithOpeningHoursOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getDashboardLocations: (q: string,showOnlyWithRamp: boolean, onSuccess: ((data : CompanyLocationsListPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getLocRampTable: (locationId: string, onSuccess: ((data : LocationRampTableOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getAllLabelsForCompanyEntityType: (entityType: string,q: string, onSuccess: ((data : LabelPreviewWithoutTypeOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  listCustomDataByType: (customDataType: string, onSuccess: ((data : CompanyCustomDataPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovOwnersIncludingSelf: (companyModule: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovInheritorsIncludingSelf: (companyModule: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovAllCompaniesByInheritModule: (companyModule: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovUsersOfCompanyWithSpecificRole: (companyId: string,role: string,q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovUsersOfCompanyWithSpecificPermission: (companyId: string,permission: string,q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  getCMRDetail: (expeditionId: string, onSuccess: ((data : GetCMRDetailResponse)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  caListGroupDemands: (page: Pageable,filter: GroupDemandFilter, onSuccess: ((data : PageResponseGroupDemandCarrierListPreviewOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuLovCustomersForCarrier: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  downloadAttachment: (attachmentId: string, onSuccess: ((data : AttachmentDownloadOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteAttachment: (attachmentId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  lovAttachmentDocumentType: (onSuccess: ((data : LovDocumentTypeOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  adminGetCompanyDetail: (companyId: string, onSuccess: ((data : AdminCompanyDetailOutDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCarPlate: (id: string, onSuccess: ((data : DeleteCompanyCarPlateResponseDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteUserFilter: (filterId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCompanyUserDepartment: (id: string, onSuccess: ((data : DeleteCompanyUserDepartmentResponseDTO)=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cancelExportJob: (jobId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteExpeditionBulkDistributionItem: (jobId: string,itemId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCam: (camId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteAllowedCamPlate: (allowedCarPlateId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCustomsInvoice: (invoiceId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCompanyCodeList: (id: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  archiveLabel: (labelId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteCompanyNotificationSetting: (companyId: string,notificationSettingId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuRemoveGroupOnCarrierDetail: (carrierId: string,carrierGroupId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuRemoveCarrierFromCarrierGroup: (carrierId: string,carrierGroupId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  deleteDocumentForExpedition: (companyId: string,applicationId: string,fileId: string, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
  cuDeleteExtraCostForExpedition: (companyId: string,applicationId: string,extraCostId: string, onSuccess: ((data : ExtraCostsPreviewOutDTO[])=>void), hashAuthentication?: string, callbacks?: Callbacks) => void;
}

export const ringilApiGenerator = (backendUrl: string, executeRequest: ExecuteRequest): RingilApiType => {
  const apiMethods = {
    getCustomDataForCMRV2: (expeditionId: string,applicationId: string, onSuccess: ((data : GetCmrCustomDataV2ResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/crm/expedition/${expeditionId}/cmr/${applicationId}/custom-data`, {},  [], false, false, 'getCustomDataForCMRV2', onSuccess, callbacks, hashAuthentication);
    },
    updateCustomDataForCMRV2: (expeditionId: string,applicationId: string,body: UpdateCmrCustomDataV2RequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v2.0/crm/expedition/${expeditionId}/cmr/${applicationId}/custom-data`, body,  [], false, false, 'updateCustomDataForCMRV2', onSuccess, callbacks, hashAuthentication);
    },
    saveUserTableFilterFavourites: (viewKey: string,body: SaveUserTableFilterFavouritesRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/users/table-filter-favourites/${viewKey}`, body,  [], false, false, 'saveUserTableFilterFavourites', onSuccess, callbacks, hashAuthentication);
    },
    deleteUserTableFilterFavourites: (viewKey: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/users/table-filter-favourites/${viewKey}`, {},  [], false, false, 'deleteUserTableFilterFavourites', onSuccess, callbacks, hashAuthentication);
    },
    updateReportPermission: (reportDefinitionId: string,companyId: string,body: UpdateReportPermissionRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/update-report-permission/${reportDefinitionId}/${companyId}`, body,  [], false, false, 'updateReportPermission', onSuccess, callbacks, hashAuthentication);
    },
    updateDocumentMetadata: (documentId: string,body: UpdateDocumentRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/update-document-metadata/${documentId}`, body,  [], false, false, 'updateDocumentMetadata', onSuccess, callbacks, hashAuthentication);
    },
    getInfoTurnOffResolvedEmails: (onSuccess: ((data : TurnOffResolvedEmailRequestInDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/turn-off-resolved-emails`, {},  [], false, false, 'getInfoTurnOffResolvedEmails', onSuccess, callbacks, hashAuthentication);
    },
    turnOffResolvedEmails: (body: TurnOffResolvedEmailRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/turn-off-resolved-emails`, body,  [], false, false, 'turnOffResolvedEmails', onSuccess, callbacks, hashAuthentication);
    },
    updateTableView: (tableKey: string,viewId: string,body: UpdateTableViewInDTO, onSuccess: ((data : TableViewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/table-views/${tableKey}/views/${viewId}`, body,  [], false, false, 'updateTableView', onSuccess, callbacks, hashAuthentication);
    },
    deleteTableView: (tableKey: string,viewId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/table-views/${tableKey}/views/${viewId}`, {},  [], false, false, 'deleteTableView', onSuccess, callbacks, hashAuthentication);
    },
    setTableViewVisibility: (tableKey: string,viewId: string,body: SetTableViewVisibilityInDTO, onSuccess: ((data : TableViewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/table-views/${tableKey}/views/${viewId}/visibility`, body,  [], false, false, 'setTableViewVisibility', onSuccess, callbacks, hashAuthentication);
    },
    saveTableViewPrefs: (tableKey: string,body: TableViewPrefsInDTO, onSuccess: ((data : TableViewPrefsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/table-views/${tableKey}/prefs`, body,  [], false, false, 'saveTableViewPrefs', onSuccess, callbacks, hashAuthentication);
    },
    updateTransportTypeDAPSupplierNotification: (supplierNotificationId: string,body: UpdateTransportTypeDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-transport-type`, body,  [], false, false, 'updateTransportTypeDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateShipmentNumberDAPSupplierNotification: (supplierNotificationId: string,body: UpdateShipmentDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-shipment-number`, body,  [], false, false, 'updateShipmentNumberDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateResponsiblePersonDAPSupplierNotification: (supplierNotificationId: string,body: UpdateResponsiblePersonDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-responsible-person`, body,  [], false, false, 'updateResponsiblePersonDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateOrdersDAPSupplierNotification: (supplierNotificationId: string,body: UpdateOrdersDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-orders`, body,  [], false, false, 'updateOrdersDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateNotifyUsersDAPSupplierNotification: (supplierNotificationId: string,body: UpdateNotifyUsersDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-notify-users`, body,  [], false, false, 'updateNotifyUsersDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateNotifyByRoleDAPSupplierNotification: (supplierNotificationId: string,body: UpdateNotifyByRoleDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-notify-by-role`, body,  [], false, false, 'updateNotifyByRoleDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateNoteDAPSupplierNotification: (supplierNotificationId: string,body: UpdateNoteDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-note`, body,  [], false, false, 'updateNoteDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateSupplierLocationDAPSupplierNotification: (supplierNotificationId: string,body: UpdateLocationDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-location-supplier`, body,  [], false, false, 'updateSupplierLocationDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateCustomerLocationDAPSupplierNotification: (supplierNotificationId: string,body: UpdateLocationDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-location-customer`, body,  [], false, false, 'updateCustomerLocationDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateInternalInvoiceDAPSupplierNotification: (supplierNotificationId: string,body: UpdateInternalInvoiceDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-invoice`, body,  [], false, false, 'updateInternalInvoiceDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateInternalNoteDAPSupplierNotification: (supplierNotificationId: string,body: UpdateInternalNoteDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-internal-note`, body,  [], false, false, 'updateInternalNoteDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateFolderSupplierNotification: (supplierNotificationId: string,body: UpdateFolderSNInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-folder`, body,  [], false, false, 'updateFolderSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateCarrierNameDAPSupplierNotification: (supplierNotificationId: string,body: UpdateCarrierNameDAPSNOutDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap/update-carrier-name`, body,  [], false, false, 'updateCarrierNameDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    sendToEurowag: (body: SendToEurowagInDTO, onSuccess: ((data : SendToEurowagOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/send-to-eurowag`, body,  [], false, false, 'sendToEurowag', onSuccess, callbacks, hashAuthentication);
    },
    updateReservationFlags: (reservationId: string,body: UpdateReservationFlagsInDTO, onSuccess: ((data : UpdateReservationFlagsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/reservation/${reservationId}/flags`, body,  [], false, false, 'updateReservationFlags', onSuccess, callbacks, hashAuthentication);
    },
    getReservationStatisticsForDay: (body: ReservationStatisticsRequestInDTO, onSuccess: ((data : ReservationStatisticsResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/reservation/statistics`, body,  [], false, false, 'getReservationStatisticsForDay', onSuccess, callbacks, hashAuthentication);
    },
    readCustomerNotification: (notificationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/read-customer-notification/${notificationId}`, {},  [], false, false, 'readCustomerNotification', onSuccess, callbacks, hashAuthentication);
    },
    saveSchenkerAdditionalData: (quoteDemandId: string,body: SchenkerAdditionalInfoInDTO, onSuccess: ((data : SchenkerAdditionalInfoOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/quote-demand/${quoteDemandId}/additional-data/schenker/declarant-info`, body,  [], false, false, 'saveSchenkerAdditionalData', onSuccess, callbacks, hashAuthentication);
    },
    deleteSchenkerAdditionalData: (quoteDemandId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/quote-demand/${quoteDemandId}/additional-data/schenker/declarant-info`, {},  [], false, false, 'deleteSchenkerAdditionalData', onSuccess, callbacks, hashAuthentication);
    },
    saveFedexAdditionalData: (quoteDemandId: string,body: FedexCustomsInfoInDTO, onSuccess: ((data : FedexCustomsInfoDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/quote-demand/${quoteDemandId}/additional-data/fedex/customs-info`, body,  [], false, false, 'saveFedexAdditionalData', onSuccess, callbacks, hashAuthentication);
    },
    deleteFedexAdditionalData: (quoteDemandId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/quote-demand/${quoteDemandId}/additional-data/fedex/customs-info`, {},  [], false, false, 'deleteFedexAdditionalData', onSuccess, callbacks, hashAuthentication);
    },
    saveFedexCertOverrides: (quoteDemandId: string,body: FedexCertOverridesDTO, onSuccess: ((data : FedexCertOverridesDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/quote-demand/${quoteDemandId}/additional-data/fedex/cert-overrides`, body,  [], false, false, 'saveFedexCertOverrides', onSuccess, callbacks, hashAuthentication);
    },
    saveDHLAdditionalData: (quoteDemandId: string,body: DHLExportDeclarationInfoInDTO, onSuccess: ((data : DHLExportDeclarationInfoOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/quote-demand/${quoteDemandId}/additional-data/dhl/export-declaration`, body,  [], false, false, 'saveDHLAdditionalData', onSuccess, callbacks, hashAuthentication);
    },
    deleteDHLAdditionalData: (quoteDemandId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/quote-demand/${quoteDemandId}/additional-data/dhl/export-declaration`, {},  [], false, false, 'deleteDHLAdditionalData', onSuccess, callbacks, hashAuthentication);
    },
    getUserNotificationTypeSettings: (onSuccess: ((data : NotificationTypeSettingOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/notification-center/settings/email-types`, {},  [], false, false, 'getUserNotificationTypeSettings', onSuccess, callbacks, hashAuthentication);
    },
    setUserNotificationTypeSetting: (body: SetNotificationTypeSettingInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/notification-center/settings/email-types`, body,  [], false, false, 'setUserNotificationTypeSetting', onSuccess, callbacks, hashAuthentication);
    },
    readNotificationMessages: (body: ReadNotificationRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/notification-center/read`, body,  [], false, false, 'readNotificationMessages', onSuccess, callbacks, hashAuthentication);
    },
    readAllNotificationMessages: (onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/notification-center/read-all`, {},  [], false, false, 'readAllNotificationMessages', onSuccess, callbacks, hashAuthentication);
    },
    setExternalIds: (companyId: string,body: SetExternalIdForCompanyInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/linked-company/${companyId}/external-ids`, body,  [], false, false, 'setExternalIds', onSuccess, callbacks, hashAuthentication);
    },
    getFedexShipmentSettings: (onSuccess: ((data : FedexShipmentSettingsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/fedex/shipment-settings`, {},  [], false, false, 'getFedexShipmentSettings', onSuccess, callbacks, hashAuthentication);
    },
    saveFedexShipmentSettings: (body: FedexShipmentSettingsDTO, onSuccess: ((data : FedexShipmentSettingsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/fedex/shipment-settings`, body,  [], false, false, 'saveFedexShipmentSettings', onSuccess, callbacks, hashAuthentication);
    },
    renameFedexAccount: (accountId: string,body: FedexAccountRenameInDTO, onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/fedex/registration/accounts/${accountId}`, body,  [], false, false, 'renameFedexAccount', onSuccess, callbacks, hashAuthentication);
    },
    deleteFedexAccount: (accountId: string, onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/fedex/registration/accounts/${accountId}`, {},  [], false, false, 'deleteFedexAccount', onSuccess, callbacks, hashAuthentication);
    },
    updateExternalManipulationUnit: (id: string,body: CreateExternalManipulationUnitRequestDTO, onSuccess: ((data : ExternalManipulationUnitDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/external-manipulation-unit/${id}`, body,  [], false, false, 'updateExternalManipulationUnit', onSuccess, callbacks, hashAuthentication);
    },
    deleteExternalManipulationUnit: (id: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/external-manipulation-unit/${id}`, {},  [], false, false, 'deleteExternalManipulationUnit', onSuccess, callbacks, hashAuthentication);
    },
    updateExpeditionUtnCode: (expeditionId: string,body: UpdateExpeditionUtnCodeRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/utn-code`, body,  [], false, false, 'updateExpeditionUtnCode', onSuccess, callbacks, hashAuthentication);
    },
    updateExpeditionTrackingNumber: (expeditionId: string,body: UpdateExpeditionTrackingNumberRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/tracking-number`, body,  [], false, false, 'updateExpeditionTrackingNumber', onSuccess, callbacks, hashAuthentication);
    },
    updateExpeditionRoUit: (expeditionId: string,body: UpdateExpeditionRoUitRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/ro-uit`, body,  [], false, false, 'updateExpeditionRoUit', onSuccess, callbacks, hashAuthentication);
    },
    updateExpeditionPolandSent: (expeditionId: string,body: UpdateExpeditionPolandSentRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/poland-sent`, body,  [], false, false, 'updateExpeditionPolandSent', onSuccess, callbacks, hashAuthentication);
    },
    updateExpeditionName: (expeditionId: string,body: UpdateExpeditionNameRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/name`, body,  [], false, false, 'updateExpeditionName', onSuccess, callbacks, hashAuthentication);
    },
    editCompanyLocationTimeslotExpedition: (expeditionId: string,locationId: string,body: EditLocationTimeslotExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/location/${locationId}/timeslot`, body,  [], false, false, 'editCompanyLocationTimeslotExpedition', onSuccess, callbacks, hashAuthentication);
    },
    editLoadingLocationOrderExpedition: (expeditionId: string,locationId: string,body: EditLoadingLocationOrderExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/location/${locationId}/order/loading`, body,  [], false, false, 'editLoadingLocationOrderExpedition', onSuccess, callbacks, hashAuthentication);
    },
    editManualLocationExpedition: (expeditionId: string,locationId: string,body: EditLocationManualExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/location/${locationId}/address/manual`, body,  [], false, false, 'editManualLocationExpedition', onSuccess, callbacks, hashAuthentication);
    },
    editCompanyLocationExpedition: (expeditionId: string,locationId: string,body: EditLocationCompanyLocationExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/location/${locationId}/address/company-location`, body,  [], false, false, 'editCompanyLocationExpedition', onSuccess, callbacks, hashAuthentication);
    },
    editInternalInfoExpedition: (expeditionId: string,body: EditInternalInfoExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/internal-info`, body,  [], false, false, 'editInternalInfoExpedition', onSuccess, callbacks, hashAuthentication);
    },
    updateExpeditionIncoterms: (expeditionId: string,body: UpdateExpeditionIncotermsRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/incoterms`, body,  [], false, false, 'updateExpeditionIncoterms', onSuccess, callbacks, hashAuthentication);
    },
    updateExpeditionHuEkaer: (expeditionId: string,body: UpdateExpeditionHuEkaerRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/hu-ekaer`, body,  [], false, false, 'updateExpeditionHuEkaer', onSuccess, callbacks, hashAuthentication);
    },
    editHeaderExpedition: (expeditionId: string,body: EditHeaderExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/edit/header`, body,  [], false, false, 'editHeaderExpedition', onSuccess, callbacks, hashAuthentication);
    },
    changeExpeditionDistributionPrice: (expeditionId: string,body: ChangePriceInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/change-price`, body,  [], false, false, 'changeExpeditionDistributionPrice', onSuccess, callbacks, hashAuthentication);
    },
    changeFinalPrice: (expeditionId: string,body: ChangeFinalPriceInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/change-final-price`, body,  [], false, false, 'changeFinalPrice', onSuccess, callbacks, hashAuthentication);
    },
    changeExpeditionDistributionDate: (expeditionId: string,body: ChangeExpeditionDistributionDateInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/${expeditionId}/change-expedition-distribution-date`, body,  [], false, false, 'changeExpeditionDistributionDate', onSuccess, callbacks, hashAuthentication);
    },
    getMultiduplicationV3ItemDetail: (jobId: string,itemId: string, onSuccess: ((data : MultiduplicationV3ItemDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}/items/${itemId}`, {},  [], false, false, 'getMultiduplicationV3ItemDetail', onSuccess, callbacks, hashAuthentication);
    },
    updateMultiduplicationV3Item: (jobId: string,itemId: string,body: MultiduplicationV3ItemOverrideInDTO, onSuccess: ((data : MultiduplicationV3ItemDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}/items/${itemId}`, body,  [], false, false, 'updateMultiduplicationV3Item', onSuccess, callbacks, hashAuthentication);
    },
    deleteMultiduplicationV3Item: (jobId: string,itemId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}/items/${itemId}`, {},  [], false, false, 'deleteMultiduplicationV3Item', onSuccess, callbacks, hashAuthentication);
    },
    keepMultiduplicationV3Items: (jobId: string,body: MultiduplicationV3KeepItemsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}/items/keep`, body,  [], false, false, 'keepMultiduplicationV3Items', onSuccess, callbacks, hashAuthentication);
    },
    favoriteExpedition: (expeditionId: string,body: FavoriteExpeditionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/favorite/${expeditionId}`, body,  [], false, false, 'favoriteExpedition', onSuccess, callbacks, hashAuthentication);
    },
    saveDuplicationExpedition: (body: SaveDuplicationExpeditionRequestInDTO, onSuccess: ((data : CheckDuplicationExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/duplication/save`, body,  [], false, false, 'saveDuplicationExpedition', onSuccess, callbacks, hashAuthentication);
    },
    checkDuplicationExpedition: (body: CheckDuplicationExpeditionRequestInDTO, onSuccess: ((data : CheckDuplicationExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/expedition/duplication/check`, body,  [], false, false, 'checkDuplicationExpedition', onSuccess, callbacks, hashAuthentication);
    },
    expUpdateMassAction: (body: MassActionExpeditionInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/exp-mass-action`, body,  [], false, false, 'expUpdateMassAction', onSuccess, callbacks, hashAuthentication);
    },
    getMassActionExpeditionData: (body: MassActionInfoExpeditionInDTO, onSuccess: ((data : MassActionExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/exp-mass-action`, body,  [], false, false, 'getMassActionExpeditionData', onSuccess, callbacks, hashAuthentication);
    },
    updateETransport: (reservationId: string,body: ETransportDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/etransport/${reservationId}/update`, body,  [], false, false, 'updateETransport', onSuccess, callbacks, hashAuthentication);
    },
    editAttachment: (documentId: string,body: AttachmentIdWithTypeV2InDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/document/${documentId}`, body,  [], false, false, 'editAttachment', onSuccess, callbacks, hashAuthentication);
    },
    getDhlAccountSettings: (onSuccess: ((data : DhlAccountSettingsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/dhl/account-settings`, {},  [], false, false, 'getDhlAccountSettings', onSuccess, callbacks, hashAuthentication);
    },
    saveDhlAccountSettings: (body: DhlAccountSettingsInDTO, onSuccess: ((data : DhlAccountSettingsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/dhl/account-settings`, body,  [], false, false, 'saveDhlAccountSettings', onSuccess, callbacks, hashAuthentication);
    },
    deleteDhlAccountSettings: (onSuccess: ((data : DhlAccountSettingsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/dhl/account-settings`, {},  [], false, false, 'deleteDhlAccountSettings', onSuccess, callbacks, hashAuthentication);
    },
    createOrUpdateCompanyPartnerInfo: (body: CompanyPartnerInfoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/create-or-update-company-partner-info`, body,  [], false, false, 'createOrUpdateCompanyPartnerInfo', onSuccess, callbacks, hashAuthentication);
    },
    companyGetNotificationTypeSettings: (onSuccess: ((data : NotificationTypeSettingOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/company/notification-settings`, {},  [], false, false, 'companyGetNotificationTypeSettings', onSuccess, callbacks, hashAuthentication);
    },
    companySetNotificationTypeSetting: (body: SetNotificationTypeSettingInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/company/notification-settings`, body,  [], false, false, 'companySetNotificationTypeSetting', onSuccess, callbacks, hashAuthentication);
    },
    updateCompanyFolderCustomer: (folderId: string,body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/company/folders/${folderId}`, body,  [], false, false, 'updateCompanyFolderCustomer', onSuccess, callbacks, hashAuthentication);
    },
    deleteCompanyFolderCustomer: (folderId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/company/folders/${folderId}`, {},  [], false, false, 'deleteCompanyFolderCustomer', onSuccess, callbacks, hashAuthentication);
    },
    updateCompanyCodeList: (body: UpdateCompanyCodeListRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/company-code-list`, body,  [], false, false, 'updateCompanyCodeList', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyCodeList: (body: CreateCompanyCodeListRequest, onSuccess: ((data : CreateCompanyCodeListResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/company-code-list`, body,  [], false, false, 'createCompanyCodeList', onSuccess, callbacks, hashAuthentication);
    },
    massActionCompanyCodeList: (body: MassActionCompanyCodeListRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/company-code-list/mass-action`, body,  [], false, false, 'massActionCompanyCodeList', onSuccess, callbacks, hashAuthentication);
    },
    changeGDName: (groupDemandId: string,body: ChangeGDNameRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/change-gd-name/${groupDemandId}`, body,  [], false, false, 'changeGDName', onSuccess, callbacks, hashAuthentication);
    },
    getCalendarLayoutModel: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/calendar-layout/models/${modelId}`, {},  [], false, false, 'getCalendarLayoutModel', onSuccess, callbacks, hashAuthentication);
    },
    updateCalendarLayoutModel: (modelId: string,body: UpdateCalendarLayoutModelInDTO, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/calendar-layout/models/${modelId}`, body,  [], false, false, 'updateCalendarLayoutModel', onSuccess, callbacks, hashAuthentication);
    },
    saveDraft: (modelId: string,body: SaveCalendarLayoutDraftInDTO, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/calendar-layout/models/${modelId}/draft`, body,  [], false, false, 'saveDraft', onSuccess, callbacks, hashAuthentication);
    },
    discardDraft: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/calendar-layout/models/${modelId}/draft`, {},  [], false, false, 'discardDraft', onSuccess, callbacks, hashAuthentication);
    },
    getDefault: (onSuccess: ((data : CalendarLayoutDefaultOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/calendar-layout/default`, {},  [], false, false, 'getDefault', onSuccess, callbacks, hashAuthentication);
    },
    setDefault: (body: SetCalendarLayoutDefaultInDTO, onSuccess: ((data : CalendarLayoutDefaultOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/calendar-layout/default`, body,  [], false, false, 'setDefault', onSuccess, callbacks, hashAuthentication);
    },
    attachmentUpdateMassAction: (body: MassActionAttachmentInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/attachment-mass-action`, body,  [], false, false, 'attachmentUpdateMassAction', onSuccess, callbacks, hashAuthentication);
    },
    getRule: (ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/rules/${ruleId}`, {},  [], false, false, 'getRule', onSuccess, callbacks, hashAuthentication);
    },
    updateRule: (ruleId: string,body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/ai-dispatcher/rules/${ruleId}`, body,  [], false, false, 'updateRule', onSuccess, callbacks, hashAuthentication);
    },
    deleteRule: (ruleId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/ai-dispatcher/rules/${ruleId}`, {},  [], false, false, 'deleteRule', onSuccess, callbacks, hashAuthentication);
    },
    adminEditWebAlert: (webAlertId: string,body: AdminWebAlertRequestInDTO, onSuccess: ((data : AdminWebAlertResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/web-alert/${webAlertId}`, body,  [], false, false, 'adminEditWebAlert', onSuccess, callbacks, hashAuthentication);
    },
    adminDeleteWebAlert: (webAlertId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/admin/web-alert/${webAlertId}`, {},  [], false, false, 'adminDeleteWebAlert', onSuccess, callbacks, hashAuthentication);
    },
    adminUpdateCompanyDetail: (companyId: string,body: UpdateCompanyDetailInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/update-company-detail/${companyId}`, body,  [], false, false, 'adminUpdateCompanyDetail', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated Upsert timeslot module settings
     */
    upsertTimeslotModuleSettings: (companyId: string,body: UpsertTimeslotModuleSettingRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/timeslot-module-settings/${companyId}`, body,  [], false, false, 'upsertTimeslotModuleSettings', onSuccess, callbacks, hashAuthentication);
    },
    getSnModuleSettings: (companyId: string, onSuccess: ((data : SnModuleSettingsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/sn-module-settings/${companyId}`, {},  [], false, false, 'getSnModuleSettings', onSuccess, callbacks, hashAuthentication);
    },
    upsertSnModuleSettings: (companyId: string,body: SnModuleSettingsDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/sn-module-settings/${companyId}`, body,  [], false, false, 'upsertSnModuleSettings', onSuccess, callbacks, hashAuthentication);
    },
    getReminderModuleSettings: (companyId: string, onSuccess: ((data : ReminderSettingsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/reminder-module-settings/${companyId}`, {},  [], false, false, 'getReminderModuleSettings', onSuccess, callbacks, hashAuthentication);
    },
    upsertReminderModuleSettings: (companyId: string,body: ReminderSettingsDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/reminder-module-settings/${companyId}`, body,  [], false, false, 'upsertReminderModuleSettings', onSuccess, callbacks, hashAuthentication);
    },
    getExpeditionModuleSettings: (companyId: string, onSuccess: ((data : ExpeditionModuleSettingsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/expedition-module-settings/${companyId}`, {},  [], false, false, 'getExpeditionModuleSettings', onSuccess, callbacks, hashAuthentication);
    },
    upsertExpeditionModuleSettings: (companyId: string,body: ExpeditionModuleSettingsDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/expedition-module-settings/${companyId}`, body,  [], false, false, 'upsertExpeditionModuleSettings', onSuccess, callbacks, hashAuthentication);
    },
    adminGetCompanyNotificationTypeSettings: (companyId: string, onSuccess: ((data : NotificationTypeSettingOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/company/${companyId}/notification-setting/email-types`, {},  [], false, false, 'adminGetCompanyNotificationTypeSettings', onSuccess, callbacks, hashAuthentication);
    },
    adminSetCompanyNotificationTypeSetting: (companyId: string,body: SetNotificationTypeSettingInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/company/${companyId}/notification-setting/email-types`, body,  [], false, false, 'adminSetCompanyNotificationTypeSetting', onSuccess, callbacks, hashAuthentication);
    },
    adminReadAllCompanyNotifications: (companyId: string, onSuccess: ((data : AdminReadAllCompanyNotificationsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/company/${companyId}/notification-center/read-all`, {},  [], false, false, 'adminReadAllCompanyNotifications', onSuccess, callbacks, hashAuthentication);
    },
    getBetaFeatures: (companyId: string, onSuccess: ((data : any)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/company/${companyId}/beta-features`, {},  [], false, false, 'getBetaFeatures', onSuccess, callbacks, hashAuthentication);
    },
    setBetaFeatures: (companyId: string,body: SetBetaFeaturesInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/company/${companyId}/beta-features`, body,  [], false, false, 'setBetaFeatures', onSuccess, callbacks, hashAuthentication);
    },
    adminGetCargoTemplate: (cargoTemplateId: string, onSuccess: ((data : CargoTemplateDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/cargo-template/${cargoTemplateId}`, {},  [], false, false, 'adminGetCargoTemplate', onSuccess, callbacks, hashAuthentication);
    },
    adminEditCargoTemplate: (cargoTemplateId: string,body: CargoTemplateRequestInDTO, onSuccess: ((data : CargoTemplateDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/cargo-template/${cargoTemplateId}`, body,  [], false, false, 'adminEditCargoTemplate', onSuccess, callbacks, hashAuthentication);
    },
    adminGetRule: (companyId: string,ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/${ruleId}`, {},  [{companyId}], false, false, 'adminGetRule', onSuccess, callbacks, hashAuthentication);
    },
    adminUpdateRule: (companyId: string,ruleId: string,body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/${ruleId}`, body,  [{companyId}], false, false, 'adminUpdateRule', onSuccess, callbacks, hashAuthentication);
    },
    adminDeleteRule: (companyId: string,ruleId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/${ruleId}`, {},  [{companyId}], false, false, 'adminDeleteRule', onSuccess, callbacks, hashAuthentication);
    },
    adminUpdateUser: (userId: string,body: UserCompanyUserInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/admin-user-update/${userId}`, body,  [], false, false, 'adminUpdateUser', onSuccess, callbacks, hashAuthentication);
    },
    acceptEurowagQuote: (customerId: string,applicationId: string,ewQuoteId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/v1.0/accept-eurowag-quote/${customerId}/${applicationId}/${ewQuoteId}`, {},  [], false, false, 'acceptEurowagQuote', onSuccess, callbacks, hashAuthentication);
    },
    cuValidateCarriersForExpeditionsV3: (body: ValidationCarriersRequestInDTO, onSuccess: ((data : FindCarrierResponseOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/3.0/customer/carriers-and-groups/validation`, body,  [], false, false, 'cuValidateCarriersForExpeditionsV3', onSuccess, callbacks, hashAuthentication);
    },
    cuAddCatalogCarrierGroupForCarrier: (carrierId: string,body: CarrierGroupsInIdsV2, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.2/customer/companies/carriers/${carrierId}/groups`, body,  [], false, false, 'cuAddCatalogCarrierGroupForCarrier', onSuccess, callbacks, hashAuthentication);
    },
    cuCheckIfGroupAlreadyExists: (body: CatalogCarrierGroupNameInDTO, onSuccess: ((data : CatalogCarrierGroupNameExistsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.2/customer/companies/carriers/groups/check`, body,  [], false, false, 'cuCheckIfGroupAlreadyExists', onSuccess, callbacks, hashAuthentication);
    },
    setPhoneToCurrentUser: (body: ProfileSettingsPhoneInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/user-profile/phone`, body,  [], false, false, 'setPhoneToCurrentUser', onSuccess, callbacks, hashAuthentication);
    },
    cuMarkAllNotificationAsRead: (onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/notification/read/all`, {},  [], false, false, 'cuMarkAllNotificationAsRead', onSuccess, callbacks, hashAuthentication);
    },
    setNotifyTargets: (expeditionId: string,body: NotifyTargetInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/${expeditionId}/subscriber/notify-targets`, body,  [], false, false, 'setNotifyTargets', onSuccess, callbacks, hashAuthentication);
    },
    cuEditLocations: (companyId: string,applicationId: string,locationId: string,body: LocationEditInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/location/${locationId}`, body,  [], false, false, 'cuEditLocations', onSuccess, callbacks, hashAuthentication);
    },
    cuGetExpeditionInternalInformation: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionInternalInformationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/internal-information`, {},  [], false, false, 'cuGetExpeditionInternalInformation', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateExpeditionInternalInformation: (companyId: string,applicationId: string,body: ExpeditionInternalInformationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/internal-information`, body,  [], false, false, 'cuUpdateExpeditionInternalInformation', onSuccess, callbacks, hashAuthentication);
    },
    cuEditTimeOrPriceDistribution: (companyId: string,applicationId: string,body: UpdateDistributionInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/distribution`, body,  [], false, false, 'cuEditTimeOrPriceDistribution', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateDistributionForExpedition: (companyId: string,applicationId: string,body: DistributionInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/distribution`, body,  [], false, false, 'cuCreateDistributionForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuEditCarrierRequirement: (companyId: string,applicationId: string,body: CarrierRequirementEditInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/carrier-requirement`, body,  [], false, false, 'cuEditCarrierRequirement', onSuccess, callbacks, hashAuthentication);
    },
    cuGetEditTemplateName: (expeditionTemplateId: string, onSuccess: ((data : EditDataTemplateNameOuDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/name`, {},  [], false, false, 'cuGetEditTemplateName', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateEditTemplateName: (expeditionTemplateId: string,body: EditTemplateNameInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/name`, body,  [], false, false, 'cuUpdateEditTemplateName', onSuccess, callbacks, hashAuthentication);
    },
    cuGetEditTemplateLocationAndOrder: (expeditionTemplateId: string,locationId: string, onSuccess: ((data : EditDataLocationAndOrderOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/location/${locationId}/location-and-order`, {},  [], false, false, 'cuGetEditTemplateLocationAndOrder', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateEditTemplateLocationAndOrder: (expeditionTemplateId: string,locationId: string,body: EditLocationAndOrderInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/location/${locationId}/location-and-order`, body,  [], false, false, 'cuUpdateEditTemplateLocationAndOrder', onSuccess, callbacks, hashAuthentication);
    },
    cuGetEditInternalInformation: (expeditionTemplateId: string, onSuccess: ((data : EditTemplateInternalInformationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/internal-information`, {},  [], false, false, 'cuGetEditInternalInformation', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateEditInternalInformation: (expeditionTemplateId: string,body: EditTemplateInternalInformation, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/internal-information`, body,  [], false, false, 'cuUpdateEditInternalInformation', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateEditDistribution: (expeditionTemplateId: string,body: DistributionTemplateInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/distribution`, body,  [], false, false, 'cuUpdateEditDistribution', onSuccess, callbacks, hashAuthentication);
    },
    cuGetEditTemplateCarrierRequirement: (expeditionTemplateId: string, onSuccess: ((data : EditDataTemplateCarrierRequirementOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/carrier-requirement`, {},  [], false, false, 'cuGetEditTemplateCarrierRequirement', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateEditTemplateCarrierRequirement: (expeditionTemplateId: string,body: EditTemplateCarrierRequirementInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}/carrier-requirement`, body,  [], false, false, 'cuUpdateEditTemplateCarrierRequirement', onSuccess, callbacks, hashAuthentication);
    },
    updateMassActionInternalInformation: (body: MassInternalInfoExpeditionsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/expedition/internal-information/mass-action`, body,  [], false, false, 'updateMassActionInternalInformation', onSuccess, callbacks, hashAuthentication);
    },
    cuGetPartnerDetail: (partnerId: string, onSuccess: ((data : PartnerDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}`, {},  [], false, false, 'cuGetPartnerDetail', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdatePartner: (partnerId: string,body: PartnerDetailInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}`, body,  [], false, false, 'cuUpdatePartner', onSuccess, callbacks, hashAuthentication);
    },
    cuDeletePartner: (partnerId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}`, {},  [], false, false, 'cuDeletePartner', onSuccess, callbacks, hashAuthentication);
    },
    cuGetEditPartnerLocation: (partnerId: string,locationId: string, onSuccess: ((data : PartnerLocationDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}/location/${locationId}`, {},  [], false, false, 'cuGetEditPartnerLocation', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdatePartnerLocation: (partnerId: string,locationId: string,body: PartnerLocationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}/location/${locationId}`, body,  [], false, false, 'cuUpdatePartnerLocation', onSuccess, callbacks, hashAuthentication);
    },
    cuDeletePartnerLocation: (partnerId: string,locationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}/location/${locationId}`, {},  [], false, false, 'cuDeletePartnerLocation', onSuccess, callbacks, hashAuthentication);
    },
    setModuleToCompany: (companyId: string,moduleType: string,body: SetCompanyModuleInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/companies/modules/${companyId}/module/${moduleType}`, body,  [], false, false, 'setModuleToCompany', onSuccess, callbacks, hashAuthentication);
    },
    cuChangeBlacklistCarrierUser: (carrierId: string,userId: string,body: BlacklistCarrierUserStateInDTO, onSuccess: ((data : BlacklistCarrierUserStateOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}/users/${userId}/blacklist`, body,  [], false, false, 'cuChangeBlacklistCarrierUser', onSuccess, callbacks, hashAuthentication);
    },
    cuDetailCarrierGroupsPage: (carrierId: string,page: Pageable, onSuccess: ((data : PageResponseCarrierDetailGroupsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}/groups`, {},  [page], false, false, 'cuDetailCarrierGroupsPage', onSuccess, callbacks, hashAuthentication);
    },
    cuAddCarrierGroupForCarrier: (carrierId: string,body: CarrierGroupsInIds, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}/groups`, body,  [], false, false, 'cuAddCarrierGroupForCarrier', onSuccess, callbacks, hashAuthentication);
    },
    cuDetailCarrierGroupCarriersPage: (carrierGroupId: string,page: Pageable,q: string, onSuccess: ((data : PageResponseCarrierCarrierGroupPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/carrier-groups/${carrierGroupId}/carrier`, {},  [page, {q}], false, false, 'cuDetailCarrierGroupCarriersPage', onSuccess, callbacks, hashAuthentication);
    },
    cuAddCarrierToGroup: (carrierGroupId: string,body: CarriersInToGroupIds, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/customer/carrier-groups/${carrierGroupId}/carrier`, body,  [], false, false, 'cuAddCarrierToGroup', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyUserDetail: (userId: string, onSuccess: ((data : UserCompanyUserDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company/user/${userId}`, {},  [], false, false, 'getCompanyUserDetail', onSuccess, callbacks, hashAuthentication);
    },
    updateUserUnderCompany: (userId: string,body: UserCompanyUserInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/company/user/${userId}`, body,  [], false, false, 'updateUserUnderCompany', onSuccess, callbacks, hashAuthentication);
    },
    changeStatusUserUnderCompany: (userId: string,isBlocked: boolean, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/company/user/${userId}/change-status/${isBlocked}`, {},  [], false, false, 'changeStatusUserUnderCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminUpdateSecurityRole: (securityRoleId: string,body: UserSecurityRolesInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/company/security-roles/${securityRoleId}`, body,  [], false, false, 'adminUpdateSecurityRole', onSuccess, callbacks, hashAuthentication);
    },
    updateCompanyInfo: (body: CompanyInfoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/company/info`, body,  [], false, false, 'updateCompanyInfo', onSuccess, callbacks, hashAuthentication);
    },
    caGetEditTimeslots: (companyId: string,applicationId: string, onSuccess: ((data : EditTimeslotCarrierOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/progress/timeslots`, {},  [], false, false, 'caGetEditTimeslots', onSuccess, callbacks, hashAuthentication);
    },
    caUpdateEditTimeslots: (companyId: string,applicationId: string,body: EditTimeslotCarrierInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/progress/timeslots`, body,  [], false, false, 'caUpdateEditTimeslots', onSuccess, callbacks, hashAuthentication);
    },
    caEditCarInfo: (companyId: string,applicationId: string,body: EditCarInfoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/progress/car-info`, body,  [], false, false, 'caEditCarInfo', onSuccess, callbacks, hashAuthentication);
    },
    caMassEditCarInfo: (body: MassEditCarInfoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/carrier/job/progress/mass-edit-car-info`, body,  [], false, false, 'caMassEditCarInfo', onSuccess, callbacks, hashAuthentication);
    },
    expEditCarInfo: (expeditionId: string,body: EditCarInfoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/carrier/job/expedition/car-info/${expeditionId}`, body,  [], false, false, 'expEditCarInfo', onSuccess, callbacks, hashAuthentication);
    },
    adminAllNotInheritedCompanyModules: (companyId: string, onSuccess: ((data : AdminModuleAllNotInheritedPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/${companyId}/module/not-inheriting`, {},  [], false, false, 'adminAllNotInheritedCompanyModules', onSuccess, callbacks, hashAuthentication);
    },
    adminToggleModuleForCompany: (companyId: string,body: AdminModuleNotInheritedInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.1/admin/${companyId}/module/not-inheriting`, body,  [], false, false, 'adminToggleModuleForCompany', onSuccess, callbacks, hashAuthentication);
    },
    getWorkflowPossibleTransition: (entityId: string,entityType: string, onSuccess: ((data : WorkflowPossibleTransitionOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/workflow/${entityType}/${entityId}/transitions`, {},  [], false, false, 'getWorkflowPossibleTransition', onSuccess, callbacks, hashAuthentication);
    },
    performTransitionOnEntity: (entityId: string,entityType: string,body: WorkflowTransitionInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/workflow/${entityType}/${entityId}/transitions`, body,  [], false, false, 'performTransitionOnEntity', onSuccess, callbacks, hashAuthentication);
    },
    getVisitorRecord: (id: string, onSuccess: ((data : VisitorRecordDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/visitor-record/${id}`, {},  [], false, false, 'getVisitorRecord', onSuccess, callbacks, hashAuthentication);
    },
    updateVisitorRecord: (id: string,body: VisitorRecordInDTO, onSuccess: ((data : VisitorRecordOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/visitor-record/${id}`, body,  [], false, false, 'updateVisitorRecord', onSuccess, callbacks, hashAuthentication);
    },
    archiveVisitorRecord: (id: string,body: ArchiveVisitorRecordInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/visitor-record/${id}/archive`, body,  [], false, false, 'archiveVisitorRecord', onSuccess, callbacks, hashAuthentication);
    },
    updateNotificationSupplierUpdateDataForTimeslots: (supplierNotificationId: string,body: SNUpdateDataTimeslotsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/update-data/timeslots`, body,  [], false, false, 'updateNotificationSupplierUpdateDataForTimeslots', onSuccess, callbacks, hashAuthentication);
    },
    updateNotificationSupplierUpdateDataForLocationStatus: (supplierNotificationId: string,body: SNUpdateDataLocationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/update-data/location`, body,  [], false, false, 'updateNotificationSupplierUpdateDataForLocationStatus', onSuccess, callbacks, hashAuthentication);
    },
    updateNotificationSupplierUpdateInternalNote: (supplierNotificationId: string,body: SNUpdateDataInternalNoteInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/update-data/internal-note`, body,  [], false, false, 'updateNotificationSupplierUpdateInternalNote', onSuccess, callbacks, hashAuthentication);
    },
    updateNotificationSupplierUpdateDataForInternalInfo: (supplierNotificationId: string,body: SNUpdateDataInternalInfoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/update-data/internal-info`, body,  [], false, false, 'updateNotificationSupplierUpdateDataForInternalInfo', onSuccess, callbacks, hashAuthentication);
    },
    updateNotificationSupplierUpdateDataForInfoCargo: (supplierNotificationId: string,body: SNUpdateDataInfoCargoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/update-data/info-cargo`, body,  [], false, false, 'updateNotificationSupplierUpdateDataForInfoCargo', onSuccess, callbacks, hashAuthentication);
    },
    updateNotificationSupplierUpdateDataForCargo: (supplierNotificationId: string,body: SNUpdateDataCargosInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/update-data/cargo`, body,  [], false, false, 'updateNotificationSupplierUpdateDataForCargo', onSuccess, callbacks, hashAuthentication);
    },
    changeArchiveStateSupplierNotification: (supplierNotificationId: string,body: SHSNArchivedInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/archive`, body,  [], false, false, 'changeArchiveStateSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateSupplierNotificationMassAction: (body: MassActionSupplierNotificationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/supplier-notification/mass-action`, body,  [], false, false, 'updateSupplierNotificationMassAction', onSuccess, callbacks, hashAuthentication);
    },
    updateShipmentUpdateDataFoTimeslot: (shipmentId: string,body: SHUpdateDataTimeslotsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/shipment/${shipmentId}/update-data/timeslots`, body,  [], false, false, 'updateShipmentUpdateDataFoTimeslot', onSuccess, callbacks, hashAuthentication);
    },
    updateShipmentUpdateDataForLocationStatus: (shipmentId: string,body: SHUpdateDataLocationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/shipment/${shipmentId}/update-data/location`, body,  [], false, false, 'updateShipmentUpdateDataForLocationStatus', onSuccess, callbacks, hashAuthentication);
    },
    updateShipmentUpdateDataFoCargo: (shipmentId: string,body: SHUpdateDataCargosInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/shipment/${shipmentId}/update-data/cargo`, body,  [], false, false, 'updateShipmentUpdateDataFoCargo', onSuccess, callbacks, hashAuthentication);
    },
    updateShipmentUpdateDataFoCargoInfo: (shipmentId: string,body: SHUpdateDataInfoCargoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/shipment/${shipmentId}/update-data/cargo-info`, body,  [], false, false, 'updateShipmentUpdateDataFoCargoInfo', onSuccess, callbacks, hashAuthentication);
    },
    changeArchiveStateShipment: (shipmentId: string,body: SHSNArchivedInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/shipment/${shipmentId}/archive`, body,  [], false, false, 'changeArchiveStateShipment', onSuccess, callbacks, hashAuthentication);
    },
    updateInvoice: (invoiceId: string,body: InvoiceInDTO, onSuccess: ((data : InvoiceOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/invoices/${invoiceId}`, body,  [], false, false, 'updateInvoice', onSuccess, callbacks, hashAuthentication);
    },
    cuAddMoreCarriersToGDDistribution: (groupDemandId: string,body: GroupDemandsMoreCarrierInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/group-demand/${groupDemandId}/more-carriers`, body,  [], false, false, 'cuAddMoreCarriersToGDDistribution', onSuccess, callbacks, hashAuthentication);
    },
    cuChangeGroupDemandDistributionValidTill: (groupDemandId: string,body: GroupDemandChangeValidTillInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/group-demand/${groupDemandId}/change-valid-till`, body,  [], false, false, 'cuChangeGroupDemandDistributionValidTill', onSuccess, callbacks, hashAuthentication);
    },
    cuGetAttachmentDataToSpecificEmails: (entityType: string,entityId: string,fileIds: string[], onSuccess: ((data : AttachmentSendDataEmailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/document/${entityType}/${entityId}/file/email`, {},  [{fileIds}], false, false, 'cuGetAttachmentDataToSpecificEmails', onSuccess, callbacks, hashAuthentication);
    },
    cuSendAttachmentToSpecificEmail: (entityType: string,entityId: string,body: AttachmentSendEmailInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/document/${entityType}/${entityId}/file/email`, body,  [], false, false, 'cuSendAttachmentToSpecificEmail', onSuccess, callbacks, hashAuthentication);
    },
    cuSetLabelsForEntity: (entityType: string,entityId: string,body: EntityLabelsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/customer/labels/${entityType}/${entityId}`, body,  [], false, false, 'cuSetLabelsForEntity', onSuccess, callbacks, hashAuthentication);
    },
    updateInternalComment: (commentId: string,body: InternalCommentUpdateInDTO, onSuccess: ((data : InternalCommentOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/customer/internal-comment/${commentId}`, body,  [], false, false, 'updateInternalComment', onSuccess, callbacks, hashAuthentication);
    },
    deleteInternalComment: (commentId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/customer/internal-comment/${commentId}`, {},  [], false, false, 'deleteInternalComment', onSuccess, callbacks, hashAuthentication);
    },
    cuGetInternalNote: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionInternalNoteOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/internal-note`, {},  [], false, false, 'cuGetInternalNote', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateInternalNote: (companyId: string,applicationId: string,body: ExpeditionInternalNoteInDTO, onSuccess: ((data : ExpeditionInternalNoteOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/internal-note`, body,  [], false, false, 'cuUpdateInternalNote', onSuccess, callbacks, hashAuthentication);
    },
    changeArchiveStateForExpedition: (companyId: string,applicationId: string,body: ExpeditionArchiveInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/archive`, body,  [], false, false, 'changeArchiveStateForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuDynamicCustomerData: (applicationId: string,fieldName: string,companyId: string, onSuccess: ((data : DataOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/expedition/dynamic/${companyId}/${applicationId}/${fieldName}`, {},  [], false, false, 'cuDynamicCustomerData', onSuccess, callbacks, hashAuthentication);
    },
    setCustomerDynamicData: (applicationId: string,fieldName: string,companyId: string,body: object, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/customer/expedition/dynamic/${companyId}/${applicationId}/${fieldName}`, body,  [], false, false, 'setCustomerDynamicData', onSuccess, callbacks, hashAuthentication);
    },
    updateReservationTimeslot: (reservationId: string,body: EditReservationTimeslotsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/reservation/${reservationId}/timeslot-info`, body,  [], false, false, 'updateReservationTimeslot', onSuccess, callbacks, hashAuthentication);
    },
    updateReservationTimeslotDuration: (reservationId: string,body: EditReservationTimeslotsDurationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/reservation/${reservationId}/timeslot-duration`, body,  [], false, false, 'updateReservationTimeslotDuration', onSuccess, callbacks, hashAuthentication);
    },
    updateReservationOnBehalfOf: (reservationId: string,body: EditReservationOnBehalfOfInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/reservation/${reservationId}/on-behalf-of`, body,  [], false, false, 'updateReservationOnBehalfOf', onSuccess, callbacks, hashAuthentication);
    },
    updateReservationCarrierEntity: (reservationId: string,body: EditReservationCarrierEntityInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/reservation/${reservationId}/carrier`, body,  [], false, false, 'updateReservationCarrierEntity', onSuccess, callbacks, hashAuthentication);
    },
    updateOrderDiscrepancies: (body: EditOrderDiscrepanciesRequestDTO, onSuccess: ((data : EditOrderDiscrepanciesResponseDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/reservation/orders/discrepancies`, body,  [], false, false, 'updateOrderDiscrepancies', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyLocationById: (locationId: string, onSuccess: ((data : CompanyLocationsDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}`, {},  [], false, false, 'getCompanyLocationById', onSuccess, callbacks, hashAuthentication);
    },
    updateCompanyLocations: (locationId: string,body: CompanyLocationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}`, body,  [], false, false, 'updateCompanyLocations', onSuccess, callbacks, hashAuthentication);
    },
    deleteCompanyLocation: (locationId: string,forceDelete: boolean,softDelete: boolean, onSuccess: ((data : any)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/company/location/${locationId}`, {},  [{forceDelete}, {softDelete}], false, false, 'deleteCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    supersedeCompanyLocation: (locationId: string,body: SupersedeCompanyLocationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/supersede`, body,  [], false, false, 'supersedeCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    updateRampsOrder: (locationId: string,body: CompanyLocationRampsOrderInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/ramps/order`, body,  [], false, false, 'updateRampsOrder', onSuccess, callbacks, hashAuthentication);
    },
    updateLocationRampsConfig: (locationId: string,body: CompanyLocationRampsConfigInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/ramps-config`, body,  [], false, false, 'updateLocationRampsConfig', onSuccess, callbacks, hashAuthentication);
    },
    getRampDetailForLocation: (locationId: string,rampId: string, onSuccess: ((data : CompanyLocationRampDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/ramp/${rampId}`, {},  [], false, false, 'getRampDetailForLocation', onSuccess, callbacks, hashAuthentication);
    },
    updateRampForLocation: (locationId: string,rampId: string,body: CompanyLocationRampInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/ramp/${rampId}`, body,  [], false, false, 'updateRampForLocation', onSuccess, callbacks, hashAuthentication);
    },
    deleteRampForLocation: (locationId: string,rampId: string,forceDelete: boolean,softDelete: boolean, onSuccess: ((data : any)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/company/location/${locationId}/ramp/${rampId}`, {},  [{forceDelete}, {softDelete}], false, false, 'deleteRampForLocation', onSuccess, callbacks, hashAuthentication);
    },
    activateRampForLocation: (locationId: string,rampId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/ramp/${rampId}/activate`, {},  [], false, false, 'activateRampForLocation', onSuccess, callbacks, hashAuthentication);
    },
    getLocationOpeningHours: (locationId: string, onSuccess: ((data : OpeningHourDefinitionsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/opening-hours`, {},  [], false, false, 'getLocationOpeningHours', onSuccess, callbacks, hashAuthentication);
    },
    updateLocatioOpeningHours: (locationId: string,body: OpeningHourDefinitionsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/opening-hours`, body,  [], false, false, 'updateLocatioOpeningHours', onSuccess, callbacks, hashAuthentication);
    },
    updateLocationContact: (locationId: string,contactId: string,body: LocationContactInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/contacts/${contactId}`, body,  [], false, false, 'updateLocationContact', onSuccess, callbacks, hashAuthentication);
    },
    updateLocationCmrSigningSender: (locationId: string,body: CompanyLocationCmrSigningInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/cmr-signing/sender`, body,  [], false, false, 'updateLocationCmrSigningSender', onSuccess, callbacks, hashAuthentication);
    },
    updateLocationCmrSigningReceiver: (locationId: string,body: CompanyLocationCmrSigningInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/cmr-signing/receiver`, body,  [], false, false, 'updateLocationCmrSigningReceiver', onSuccess, callbacks, hashAuthentication);
    },
    updateLocationCarriersApi: (locationId: string,body: CompanyLocationCarriersApiInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/carriers-api`, body,  [], false, false, 'updateLocationCarriersApi', onSuccess, callbacks, hashAuthentication);
    },
    updateLocationBasicInfo: (locationId: string,body: CompanyLocationBasicInfoInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/basic-info`, body,  [], false, false, 'updateLocationBasicInfo', onSuccess, callbacks, hashAuthentication);
    },
    activateCompanyLocation: (locationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/location/${locationId}/activate`, {},  [], false, false, 'activateCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    putOnLocRampTable: (locationId: string,reservationId: string, onSuccess: ((data : UpdateLocationRampTableResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/loc-ramp-table/${locationId}/${reservationId}`, {},  [], false, false, 'putOnLocRampTable', onSuccess, callbacks, hashAuthentication);
    },
    removeFromLocRampTable: (reservationId: string,locationId: string, onSuccess: ((data : LocationRampTableOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/company/loc-ramp-table/${locationId}/${reservationId}`, {},  [], false, false, 'removeFromLocRampTable', onSuccess, callbacks, hashAuthentication);
    },
    replaceOnLocRampTable: (locationId: string,reservationId: string,overwriteReservationId: string, onSuccess: ((data : LocationRampTableOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company/loc-ramp-table/${locationId}/${reservationId}/${overwriteReservationId}`, {},  [], false, false, 'replaceOnLocRampTable', onSuccess, callbacks, hashAuthentication);
    },
    companyUserDriverSetDeleted: (companyUserId: string,body: SetCompanyUserDriverDeletedRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/company-user-driver/${companyUserId}/deleted`, body,  [], false, false, 'companyUserDriverSetDeleted', onSuccess, callbacks, hashAuthentication);
    },
    adminEditShippingCompany: (id: string,body: EditShippingCompanyRequestInDTO, onSuccess: ((data : EditShippingCompanyResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('put', `${backendUrl}/api/1.0/admin/shipping-company/${id}`, body,  [], false, false, 'adminEditShippingCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminDeleteShippingCompany: (id: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/admin/shipping-company/${id}`, {},  [], false, false, 'adminDeleteShippingCompany', onSuccess, callbacks, hashAuthentication);
    },
    createOrderConfirmationPdf: (expeditionId: string, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v2.0/order/confirmation/pdf/${expeditionId}`, {},  [], false, false, 'createOrderConfirmationPdf', onSuccess, callbacks, hashAuthentication);
    },
    manualWebhookReservationAvailability: (reservationId: string, onSuccess: ((data : ManualWebhookAvailabilityOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/webhook/manual/reservation/${reservationId}`, {},  [], false, false, 'manualWebhookReservationAvailability', onSuccess, callbacks, hashAuthentication);
    },
    manualWebhookReservationSend: (reservationId: string, onSuccess: ((data : ManualWebhookSendOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/webhook/manual/reservation/${reservationId}`, {},  [], false, false, 'manualWebhookReservationSend', onSuccess, callbacks, hashAuthentication);
    },
    manualWebhookExpeditionAvailability: (expeditionId: string, onSuccess: ((data : ManualWebhookAvailabilityOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/webhook/manual/expedition/${expeditionId}`, {},  [], false, false, 'manualWebhookExpeditionAvailability', onSuccess, callbacks, hashAuthentication);
    },
    manualWebhookExpeditionSend: (expeditionId: string, onSuccess: ((data : ManualWebhookSendOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/webhook/manual/expedition/${expeditionId}`, {},  [], false, false, 'manualWebhookExpeditionSend', onSuccess, callbacks, hashAuthentication);
    },
    saveUserVisitorRecordFilters: (body: SaveUserVisitorRecordFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/visitor-record`, body,  [], false, false, 'saveUserVisitorRecordFilters', onSuccess, callbacks, hashAuthentication);
    },
    saveUserTimeslotCalendarFilters: (body: SaveUserTimeslotCalendarFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/timeslot-calendar`, body,  [], false, false, 'saveUserTimeslotCalendarFilters', onSuccess, callbacks, hashAuthentication);
    },
    saveUserSupplierNotificationFilters: (body: SaveUserSupplierNotificationFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/supplier-notification`, body,  [], false, false, 'saveUserSupplierNotificationFilters', onSuccess, callbacks, hashAuthentication);
    },
    saveUserReservationFilters: (body: SaveUserReservationFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/reservation`, body,  [], false, false, 'saveUserReservationFilters', onSuccess, callbacks, hashAuthentication);
    },
    saveUserNotificationFilters: (body: SaveUserNotificationFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/notification`, body,  [], false, false, 'saveUserNotificationFilters', onSuccess, callbacks, hashAuthentication);
    },
    saveUserJobFilters: (body: SaveUserJobFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/job`, body,  [], false, false, 'saveUserJobFilters', onSuccess, callbacks, hashAuthentication);
    },
    saveUserExpeditionFilters: (body: SaveUserExpeditionFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/expedition`, body,  [], false, false, 'saveUserExpeditionFilters', onSuccess, callbacks, hashAuthentication);
    },
    saveUserEmailHistoryFilters: (body: SaveUserEmailHistoryFiltersResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/users/filter/email-history`, body,  [], false, false, 'saveUserEmailHistoryFilters', onSuccess, callbacks, hashAuthentication);
    },
    createTableView: (tableKey: string,body: CreateTableViewInDTO, onSuccess: ((data : TableViewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/table-views/${tableKey}/views`, body,  [], false, false, 'createTableView', onSuccess, callbacks, hashAuthentication);
    },
    cancelSupplierNotification: (supplierNotificationId: string,body: CancelSnResponseInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/cancel`, body,  [], false, false, 'cancelSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    createDAPSupplierNotification: (body: DAPSupplierNotificationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/supplier-notification/dap`, body,  [], false, false, 'createDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    handleWebhook: (onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/something-changed-webhook`, {},  [], false, false, 'handleWebhook', onSuccess, callbacks, hashAuthentication);
    },
    importPriceFromJson: (body: ImportPriceJsonToDbRequest, onSuccess: ((data : ImportPriceJsonToDbResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/schenker/price/import`, body,  [], false, false, 'importPriceFromJson', onSuccess, callbacks, hashAuthentication);
    },
    importCountryConfigurations: (body: ImportSchenkerCountryConfigurationRequestInDTO, onSuccess: ((data : ImportSchenkerCountryConfigurationResponseDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/schenker/country-configuration/import`, body,  [], false, false, 'importCountryConfigurations', onSuccess, callbacks, hashAuthentication);
    },
    saveUpdateCamera: (body: SaveUpdateCameraRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/save-update-camera`, body,  [], false, false, 'saveUpdateCamera', onSuccess, callbacks, hashAuthentication);
    },
    saveUpdateAllowedCarPlate: (body: SaveUpdateAllowedCarPlateRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/save-update-allowed-car-plate`, body,  [], false, false, 'saveUpdateAllowedCarPlate', onSuccess, callbacks, hashAuthentication);
    },
    runConsoleRunner: (body: RunnerRequest, onSuccess: ((data : RunnerResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/run-runner`, body,  [], false, false, 'runConsoleRunner', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateTruck: (reservationId: string,body: UpdateTruckRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-truck`, body,  [], false, false, 'reservationUpdateTruck', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateReservationName: (reservationId: string,body: UpdateReservationNameRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-reservation-name`, body,  [], false, false, 'reservationUpdateReservationName', onSuccess, callbacks, hashAuthentication);
    },
    updateReservationOrdersAndTimeslot: (reservationId: string,body: UpdateOrdersAndTimeslotRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-orders-timeslot`, body,  [], false, false, 'updateReservationOrdersAndTimeslot', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateNote: (reservationId: string,body: UpdateNoteRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-note`, body,  [], false, false, 'reservationUpdateNote', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateNoteForCarrier: (reservationId: string,body: UpdateNoteForCarrierRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-note-for-carrier`, body,  [], false, false, 'reservationUpdateNoteForCarrier', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateInternalNote: (reservationId: string,body: UpdateInternalNoteRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-internal-note`, body,  [], false, false, 'reservationUpdateInternalNote', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateFolders: (reservationId: string,body: UpdateFoldersRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-folders`, body,  [], false, false, 'reservationUpdateFolders', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateDriverPhone: (reservationId: string,body: UpdateDriverPhoneRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-driver-phone`, body,  [], false, false, 'reservationUpdateDriverPhone', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateDriverNameAndID: (reservationId: string,body: UpdateDriverNameRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-driver-name`, body,  [], false, false, 'reservationUpdateDriverNameAndID', onSuccess, callbacks, hashAuthentication);
    },
    reservationUpdateCarPlate: (reservationId: string,body: UpdateCarPlateRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/update-car-plate`, body,  [], false, false, 'reservationUpdateCarPlate', onSuccess, callbacks, hashAuthentication);
    },
    unarchiveReservation: (reservationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/unarchive`, {},  [], false, false, 'unarchiveReservation', onSuccess, callbacks, hashAuthentication);
    },
    reservationNotifyDriver: (reservationId: string,body: NotifyDriverRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/notify-driver`, body,  [], false, false, 'reservationNotifyDriver', onSuccess, callbacks, hashAuthentication);
    },
    archiveReservation: (reservationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/${reservationId}/archive`, {},  [], false, false, 'archiveReservation', onSuccess, callbacks, hashAuthentication);
    },
    massDeleteReservations: (body: MassDeleteReservationsInDTO, onSuccess: ((data : MassActionReservationsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/mass-action/delete`, body,  [], false, false, 'massDeleteReservations', onSuccess, callbacks, hashAuthentication);
    },
    massArchiveReservations: (body: MassArchiveReservationsInDTO, onSuccess: ((data : MassActionReservationsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/mass-action/archive`, body,  [], false, false, 'massArchiveReservations', onSuccess, callbacks, hashAuthentication);
    },
    createReservationMultiDuplicationJob: (body: CreateReservationMultiDuplicationJobInDTO, onSuccess: ((data : ReservationMultiDuplicationJobStartedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/duplication/job`, body,  [], false, false, 'createReservationMultiDuplicationJob', onSuccess, callbacks, hashAuthentication);
    },
    checkReservationIfExpeditionCanBeCreated: (body: CheckIfExpeditionCanBeCreatedRequestInDTO, onSuccess: ((data : CheckIfExpeditionCanBeCreatedResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/reservation/check/expedition/create`, body,  [], false, false, 'checkReservationIfExpeditionCanBeCreated', onSuccess, callbacks, hashAuthentication);
    },
    testPushPublish: (body: TestPushPublishRequest, onSuccess: ((data : TestPushPublishResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/push/test-publish`, body,  [], false, false, 'testPushPublish', onSuccess, callbacks, hashAuthentication);
    },
    registerCompany: (registerCode: string,body: RegisterCompanyRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/public/company/register/${registerCode}`, body,  [], true, false, 'registerCompany', onSuccess, callbacks);
    },
    contactRingilCompanyForRegistration: (body: AdHocRegistrationCompanyRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/public/company/register/contact-ringil`, body,  [], true, false, 'contactRingilCompanyForRegistration', onSuccess, callbacks);
    },
    checkCompanyIfExists: (body: CheckIfCompanyExistsRequestInDTO, onSuccess: ((data : CheckIfCompanyExistsResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/public/company/register/check-if-exists`, body,  [], true, false, 'checkCompanyIfExists', onSuccess, callbacks);
    },
    rejectModules: (inheritedCompanyId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/linked-company/${inheritedCompanyId}/reject-modules`, {},  [], false, false, 'rejectModules', onSuccess, callbacks, hashAuthentication);
    },
    acceptAllModules: (inheritedCompanyId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/linked-company/${inheritedCompanyId}/accept-all-modules`, {},  [], false, false, 'acceptAllModules', onSuccess, callbacks, hashAuthentication);
    },
    acceptModuleMultiple: (body: MassActionAcceptModuleRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/linked-company/accept-module-multiple`, body,  [], false, false, 'acceptModuleMultiple', onSuccess, callbacks, hashAuthentication);
    },
    regenerateCode: (body: RegenerateLinkedCodeRequestIdDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/linked-code/regenerate`, body,  [], false, false, 'regenerateCode', onSuccess, callbacks, hashAuthentication);
    },
    retryJob: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/jobs/${jobId}/retry`, {},  [], false, false, 'retryJob', onSuccess, callbacks, hashAuthentication);
    },
    archiveJob: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/jobs/${jobId}/archive`, {},  [], false, false, 'archiveJob', onSuccess, callbacks, hashAuthentication);
    },
    importCompanyCodeList: (codeListEnum: string,body: ImportCompanyCodeListRequest, onSuccess: ((data : ImportCompanyCodeListResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/import-company-code-list`, body,  [{codeListEnum}], false, false, 'importCompanyCodeList', onSuccess, callbacks, hashAuthentication);
    },
    importCompanyAndLocation: (body: ImportCompanyAndLocationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/import-company-and-location/import`, body,  [], false, false, 'importCompanyAndLocation', onSuccess, callbacks, hashAuthentication);
    },
    importCameras: (body: ImportCamerasInput, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/import-cameras`, body,  [], false, false, 'importCameras', onSuccess, callbacks, hashAuthentication);
    },
    importAllowedCarPlates: (body: ImportAllowedCarPlatesRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/import-allowed-car-plates`, body,  [], false, false, 'importAllowedCarPlates', onSuccess, callbacks, hashAuthentication);
    },
    getConsoleRunners: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/get-console-runners`, {},  [], false, false, 'getConsoleRunners', onSuccess, callbacks, hashAuthentication);
    },
    startFedexRegistration: (body: FedexRegistrationStartInDTO, onSuccess: ((data : FedexRegistrationStepOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/registration/start`, body,  [], false, false, 'startFedexRegistration', onSuccess, callbacks, hashAuthentication);
    },
    sendFedexRegistrationPin: (body: FedexRegistrationPinSendInDTO, onSuccess: ((data : FedexRegistrationPinSentOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/registration/pin/send`, body,  [], false, false, 'sendFedexRegistrationPin', onSuccess, callbacks, hashAuthentication);
    },
    confirmFedexRegistrationPin: (body: FedexRegistrationPinConfirmInDTO, onSuccess: ((data : FedexRegistrationStepOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/registration/pin/confirm`, body,  [], false, false, 'confirmFedexRegistrationPin', onSuccess, callbacks, hashAuthentication);
    },
    confirmFedexRegistrationInvoice: (body: FedexRegistrationInvoiceConfirmInDTO, onSuccess: ((data : FedexRegistrationStepOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/registration/invoice/confirm`, body,  [], false, false, 'confirmFedexRegistrationInvoice', onSuccess, callbacks, hashAuthentication);
    },
    acceptFedexEula: (body: FedexEulaAcceptInDTO, onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/registration/eula/accept`, body,  [], false, false, 'acceptFedexEula', onSuccess, callbacks, hashAuthentication);
    },
    getFedexPickupAvailability: (body: FedexPickupAvailabilityInDTO, onSuccess: ((data : FedexPickupAvailabilityOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/pickup-availability`, body,  [], false, false, 'getFedexPickupAvailability', onSuccess, callbacks, hashAuthentication);
    },
    uploadFedexEtdImage: (imageType: string,body: FedexEtdImageUploadInDTO, onSuccess: ((data : FedexEtdImagesOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/etd/images/${imageType}`, body,  [], false, false, 'uploadFedexEtdImage', onSuccess, callbacks, hashAuthentication);
    },
    deleteFedexEtdImage: (imageType: string, onSuccess: ((data : FedexEtdImagesOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/fedex/etd/images/${imageType}`, {},  [], false, false, 'deleteFedexEtdImage', onSuccess, callbacks, hashAuthentication);
    },
    fedexCertRequote: (body: FedexCertRequoteInDTO, onSuccess: ((data : FedexCreateQuoteResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/cert/requote`, body,  [], false, false, 'fedexCertRequote', onSuccess, callbacks, hashAuthentication);
    },
    getFedexAvailableProducts: (body: FedexAvailableProductsRequestDTO, onSuccess: ((data : FedexAvailableProductDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/fedex/available-products`, body,  [], false, false, 'getFedexAvailableProducts', onSuccess, callbacks, hashAuthentication);
    },
    listExternalManipulationUnits: (pageable: Pageable,filter: ExternalManipulationFilterDTO, onSuccess: ((data : PageResponseExternalManipulationUnitDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/external-manipulation-unit`, {},  [pageable, filter], false, false, 'listExternalManipulationUnits', onSuccess, callbacks, hashAuthentication);
    },
    createExternalManipulationUnit: (body: CreateExternalManipulationUnitRequestDTO, onSuccess: ((data : ExternalManipulationUnitDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/external-manipulation-unit`, body,  [], false, false, 'createExternalManipulationUnit', onSuccess, callbacks, hashAuthentication);
    },
    startExportJob: (body: ExportJobRequestInDTO, onSuccess: ((data : ExportJobStartedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/export/jobs`, body,  [], false, false, 'startExportJob', onSuccess, callbacks, hashAuthentication);
    },
    createExportAsyncJob: (body: ExportJobRequestInDTO, onSuccess: ((data : ExportAsyncJobStartedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/export/jobs/async`, body,  [], false, false, 'createExportAsyncJob', onSuccess, callbacks, hashAuthentication);
    },
    dismissRobotSuggestion: (expeditionId: string,suggestionId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/${expeditionId}/robot-suggestions/${suggestionId}/dismissed`, {},  [], false, false, 'dismissRobotSuggestion', onSuccess, callbacks, hashAuthentication);
    },
    acceptRobotSuggestion: (expeditionId: string,suggestionId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/${expeditionId}/robot-suggestions/${suggestionId}/accepted`, {},  [], false, false, 'acceptRobotSuggestion', onSuccess, callbacks, hashAuthentication);
    },
    finishLocationByCustomer: (expeditionId: string,locationId: string,body: FinishLocationByCustomerRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/${expeditionId}/location/${locationId}/finish`, body,  [], false, false, 'finishLocationByCustomer', onSuccess, callbacks, hashAuthentication);
    },
    createDistribution: (expeditionId: string,body: SaveDistributionRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/${expeditionId}/distribution`, body,  [], false, false, 'createDistribution', onSuccess, callbacks, hashAuthentication);
    },
    downloadPODFromDachser: (expeditionId: string, onSuccess: ((data : CarrierPodResult)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/${expeditionId}/dachser-pod`, {},  [], false, false, 'downloadPODFromDachser', onSuccess, callbacks, hashAuthentication);
    },
    createMultiduplicationV3Job: (body: MultiduplicationV3CreateJobInDTO, onSuccess: ((data : MultiduplicationV3JobStartedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/multiduplication`, body,  [], false, false, 'createMultiduplicationV3Job', onSuccess, callbacks, hashAuthentication);
    },
    revalidateMultiduplicationV3Job: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}/revalidate`, {},  [], false, false, 'revalidateMultiduplicationV3Job', onSuccess, callbacks, hashAuthentication);
    },
    executeMultiduplicationV3Job: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}/execute`, {},  [], false, false, 'executeMultiduplicationV3Job', onSuccess, callbacks, hashAuthentication);
    },
    expeditionList: (page: Pageable,body: FilterRequestInDTO, onSuccess: ((data : ExpeditionListDataOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/list/filtering`, body,  [page], false, false, 'expeditionList', onSuccess, callbacks, hashAuthentication);
    },
    importEnnoviExpedition: (body: EnnoviImportExpeditionRequestInDTO, onSuccess: ((data : EnnoviImportExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/import-ennovi`, body,  [], false, false, 'importEnnoviExpedition', onSuccess, callbacks, hashAuthentication);
    },
    checkImportEnnoviExpedition: (body: EnnoviImportExpeditionRequestInDTO, onSuccess: ((data : CheckEnnoviImportExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/import-ennovi/check`, body,  [], false, false, 'checkImportEnnoviExpedition', onSuccess, callbacks, hashAuthentication);
    },
    createDuplicationJob: (body: SaveDuplicationExpeditionRequestInDTO, onSuccess: ((data : DuplicationJobStartedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/duplication/job`, body,  [], false, false, 'createDuplicationJob', onSuccess, callbacks, hashAuthentication);
    },
    createExpeditionBulkDistributionJob: (body: ExpeditionBulkDistributionCreateJobInDTO, onSuccess: ((data : ExpeditionBulkDistributionJobStartedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/distribution/job`, body,  [], false, false, 'createExpeditionBulkDistributionJob', onSuccess, callbacks, hashAuthentication);
    },
    revalidateExpeditionBulkDistributionJob: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/distribution/job/${jobId}/revalidate`, {},  [], false, false, 'revalidateExpeditionBulkDistributionJob', onSuccess, callbacks, hashAuthentication);
    },
    executeExpeditionBulkDistributionJob: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/expedition/distribution/job/${jobId}/execute`, {},  [], false, false, 'executeExpeditionBulkDistributionJob', onSuccess, callbacks, hashAuthentication);
    },
    createETransport: (reservationId: string,body: ETransportDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/etransport/${reservationId}/create`, body,  [], false, false, 'createETransport', onSuccess, callbacks, hashAuthentication);
    },
    cuResendResolvedEmail: (resolvedEmailId: string, onSuccess: ((data : ResendResolvedEmailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/email-history/resolved/${resolvedEmailId}/resend`, {},  [], false, false, 'cuResendResolvedEmail', onSuccess, callbacks, hashAuthentication);
    },
    cuBatchResendResolvedEmails: (body: BatchResendResolvedEmailsInDTO, onSuccess: ((data : BatchResendResolvedEmailsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/email-history/resolved/resend`, body,  [], false, false, 'cuBatchResendResolvedEmails', onSuccess, callbacks, hashAuthentication);
    },
    distributionCreateTiebreaker: (distributionId: string,body: CreateTiebreakerInDTO, onSuccess: ((data : CreateTiebreakerOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/distribution/${distributionId}/tiebreaker`, body,  [], false, false, 'distributionCreateTiebreaker', onSuccess, callbacks, hashAuthentication);
    },
    getDHLAvailableProducts: (body: DHLAvailableProductsRequestDTO, onSuccess: ((data : DHLAvailableProductDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/dhl/available-products`, body,  [], false, false, 'getDHLAvailableProducts', onSuccess, callbacks, hashAuthentication);
    },
    declineEurowagQuote: (customerId: string,applicationId: string,ewQuoteId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/decline-eurowag-quote/${customerId}/${applicationId}/${ewQuoteId}`, {},  [], false, false, 'declineEurowagQuote', onSuccess, callbacks, hashAuthentication);
    },
    generateDachserExportAndDownload: (body: Expeditions, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/dachser-export/`, body,  [], false, false, 'generateDachserExportAndDownload', onSuccess, callbacks, hashAuthentication);
    },
    listSNCustomsInvoices: (snId: string, onSuccess: ((data : ListCustomsInvoicesResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/customs/supplier-notification/${snId}/invoices`, {},  [], false, false, 'listSNCustomsInvoices', onSuccess, callbacks, hashAuthentication);
    },
    createSNCustomsInvoice: (snId: string,body: CreateCustomsInvoicesRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/customs/supplier-notification/${snId}/invoices`, body,  [], false, false, 'createSNCustomsInvoice', onSuccess, callbacks, hashAuthentication);
    },
    listExpeditionCustomsInvoices: (expeditionId: string, onSuccess: ((data : ListCustomsInvoicesResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/customs/expedition/${expeditionId}/invoices`, {},  [], false, false, 'listExpeditionCustomsInvoices', onSuccess, callbacks, hashAuthentication);
    },
    createExpeditionCustomsInvoice: (expeditionId: string,body: CreateCustomsInvoicesRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/customs/expedition/${expeditionId}/invoices`, body,  [], false, false, 'createExpeditionCustomsInvoice', onSuccess, callbacks, hashAuthentication);
    },
    deleteCustomerNotification: (body: DeleteCustomerNotificationRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/customer-notification/delete`, body,  [], false, false, 'deleteCustomerNotification', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateUserUnderCompany: (companyId: string,body: UserCompanyUserInDTO, onSuccess: ((data : UserCompanyUserDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/create-user/${companyId}/user`, body,  [], false, false, 'adminCreateUserUnderCompany', onSuccess, callbacks, hashAuthentication);
    },
    createExpeditionFromSN: (supplierNotificationId: string, onSuccess: ((data : ExpeditionCoordinate)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/create-expedition-from-sn/${supplierNotificationId}`, {},  [], false, false, 'createExpeditionFromSN', onSuccess, callbacks, hashAuthentication);
    },
    copyAttachmentToEntity: (body: CopyAttachmentToEntityRequest, onSuccess: ((data : any)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/copy-attachment-to-entity/`, body,  [], false, false, 'copyAttachmentToEntity', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated Compute reservation duration with manipulation units
     */
    computeReservationDurationWithManipulationUnits: (companyId: string,body: ComputeReservationDurationInDTO, onSuccess: ((data : ComputeReservationDurationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/compute-reservation-duration/${companyId}`, body,  [], false, false, 'computeReservationDurationWithManipulationUnits', onSuccess, callbacks, hashAuthentication);
    },
    updateCustomsForSupplierNotification: (supplierNotificationId: string,companyId: string,body: CustomsCustomsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/company/${companyId}/update-customs/supplier-notification/${supplierNotificationId}`, body,  [], false, false, 'updateCustomsForSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    updateCustomsForExpedition: (expeditionId: string,companyId: string,body: CustomsCustomsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/company/${companyId}/update-customs/expedition/${expeditionId}`, body,  [], false, false, 'updateCustomsForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyFoldersCustomer: (entityType: string, onSuccess: ((data : CompanyFolderListOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/company/folders`, {},  [{entityType}], false, false, 'listCompanyFoldersCustomer', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyFolderCustomer: (body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/company/folders`, body,  [], false, false, 'createCompanyFolderCustomer', onSuccess, callbacks, hashAuthentication);
    },
    pocOpenGate: (companyLocationId: string,body: WSCameraGateOpeningRequest, onSuccess: ((data : WSCameraGateOpeningResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/camera-gateway/${companyLocationId}/gate-opening/poc`, body,  [], false, false, 'pocOpenGate', onSuccess, callbacks, hashAuthentication);
    },
    listCalendarLayoutModels: (page: Pageable,filter: CalendarLayoutModelFilter, onSuccess: ((data : PageResponseCalendarLayoutModelRowOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/calendar-layout/models`, {},  [page, filter], false, false, 'listCalendarLayoutModels', onSuccess, callbacks, hashAuthentication);
    },
    createCalendarLayoutModel: (body: CreateCalendarLayoutModelInDTO, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/calendar-layout/models`, body,  [], false, false, 'createCalendarLayoutModel', onSuccess, callbacks, hashAuthentication);
    },
    deleteCalendarLayoutModels: (body: DeleteCalendarLayoutModelsInDTO, onSuccess: ((data : DeleteCalendarLayoutModelsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/calendar-layout/models`, body,  [], false, false, 'deleteCalendarLayoutModels', onSuccess, callbacks, hashAuthentication);
    },
    revert: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/calendar-layout/models/${modelId}/revert`, {},  [], false, false, 'revert', onSuccess, callbacks, hashAuthentication);
    },
    publish: (modelId: string, onSuccess: ((data : CalendarLayoutModelDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/calendar-layout/models/${modelId}/publish`, {},  [], false, false, 'publish', onSuccess, callbacks, hashAuthentication);
    },
    archiveCalendarLayoutModels: (body: ArchiveCalendarLayoutModelsInDTO, onSuccess: ((data : ArchiveCalendarLayoutModelsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/calendar-layout/models/archive`, body,  [], false, false, 'archiveCalendarLayoutModels', onSuccess, callbacks, hashAuthentication);
    },
    listAssignments: (page: Pageable,filter: CalendarLayoutAssignmentFilter, onSuccess: ((data : PageResponseCalendarLayoutAssignmentRowOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/calendar-layout/assignments`, {},  [page, filter], false, false, 'listAssignments', onSuccess, callbacks, hashAuthentication);
    },
    applyAssignments: (body: ApplyCalendarLayoutAssignmentsInDTO, onSuccess: ((data : ApplyCalendarLayoutAssignmentsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/calendar-layout/assignments`, body,  [], false, false, 'applyAssignments', onSuccess, callbacks, hashAuthentication);
    },
    createCustomerNotification: (body: CreateCustomerNotificationRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/api/v1.0/customer/customer-notification/create`, body,  [], false, false, 'createCustomerNotification', onSuccess, callbacks, hashAuthentication);
    },
    listRules: (onSuccess: ((data : RuleListItemOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/rules`, {},  [], false, false, 'listRules', onSuccess, callbacks, hashAuthentication);
    },
    createRule: (body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/ai-dispatcher/rules`, body,  [], false, false, 'createRule', onSuccess, callbacks, hashAuthentication);
    },
    enableRule: (ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/ai-dispatcher/rules/${ruleId}/enable`, {},  [], false, false, 'enableRule', onSuccess, callbacks, hashAuthentication);
    },
    disableRule: (ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/ai-dispatcher/rules/${ruleId}/disable`, {},  [], false, false, 'disableRule', onSuccess, callbacks, hashAuthentication);
    },
    validateRule: (body: ValidateRuleInDTO, onSuccess: ((data : ValidateRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/ai-dispatcher/rules/validate`, body,  [], false, false, 'validateRule', onSuccess, callbacks, hashAuthentication);
    },
    formatRule: (body: FormatRuleInDTO, onSuccess: ((data : FormatRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/ai-dispatcher/rules/format`, body,  [], false, false, 'formatRule', onSuccess, callbacks, hashAuthentication);
    },
    dryRunRule: (body: DryRunInDTO, onSuccess: ((data : DryRunOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/ai-dispatcher/rules/dry-run`, body,  [], false, false, 'dryRunRule', onSuccess, callbacks, hashAuthentication);
    },
    adminWebhookPreview: (body: WebhookTestRequestInDTO, onSuccess: ((data : WebhookTestPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/webhook-test/preview`, body,  [], false, false, 'adminWebhookPreview', onSuccess, callbacks, hashAuthentication);
    },
    adminWebhookDeliveryRetry: (deliveryId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/webhook-delivery/${deliveryId}/retry`, {},  [], false, false, 'adminWebhookDeliveryRetry', onSuccess, callbacks, hashAuthentication);
    },
    adminListWebAlert: (onSuccess: ((data : ListWebAlertResponseOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/web-alert`, {},  [], false, false, 'adminListWebAlert', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateWebAlert: (body: AdminWebAlertRequestInDTO, onSuccess: ((data : AdminWebAlertResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/web-alert`, body,  [], false, false, 'adminCreateWebAlert', onSuccess, callbacks, hashAuthentication);
    },
    checkCompanyDetailDuplicates: (companyId: string,body: CompanyDetailDuplicateCheckInDTO, onSuccess: ((data : CompanyDetailDuplicateCheckOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/update-company-detail/${companyId}/duplicate-check`, body,  [], false, false, 'checkCompanyDetailDuplicates', onSuccess, callbacks, hashAuthentication);
    },
    duplicateEmailRequest: (emailRequestId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/email-request/${emailRequestId}/duplicate`, {},  [], false, false, 'duplicateEmailRequest', onSuccess, callbacks, hashAuthentication);
    },
    resendResolvedEmail: (resolvedEmailId: string, onSuccess: ((data : ResendResolvedEmailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/email-history/resolved/${resolvedEmailId}/resend`, {},  [], false, false, 'resendResolvedEmail', onSuccess, callbacks, hashAuthentication);
    },
    batchResendResolvedEmails: (body: BatchResendResolvedEmailsInDTO, onSuccess: ((data : BatchResendResolvedEmailsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/email-history/resolved/resend`, body,  [], false, false, 'batchResendResolvedEmails', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyNotificationSetting: (companyId: string, onSuccess: ((data : GetCompanyNotificationSettingResponseOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/company/${companyId}/notification-setting`, {},  [], false, false, 'getCompanyNotificationSetting', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyNotificationSetting: (companyId: string,body: CreateCompanyNotificationSettingRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/company/${companyId}/notification-setting`, body,  [], false, false, 'createCompanyNotificationSetting', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyFolder: (companyId: string,entityType: string, onSuccess: ((data : ListCompanyFolderResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/company/${companyId}/folder`, {},  [{entityType}], false, false, 'listCompanyFolder', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyFolder: (companyId: string,body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/company/${companyId}/folder`, body,  [], false, false, 'createCompanyFolder', onSuccess, callbacks, hashAuthentication);
    },
    updateCompanyFolder: (companyId: string,folderId: string,body: CompanyFolderInDTO, onSuccess: ((data : CompanyFolderOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/company/${companyId}/folder/${folderId}`, body,  [], false, false, 'updateCompanyFolder', onSuccess, callbacks, hashAuthentication);
    },
    deleteCompanyFolder: (companyId: string,folderId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/admin/company/${companyId}/folder/${folderId}`, {},  [], false, false, 'deleteCompanyFolder', onSuccess, callbacks, hashAuthentication);
    },
    adminDeleteCompany: (companyId: string, onSuccess: ((data : AdminDeleteCompanyResponseDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/company/delete-company/${companyId}`, {},  [], false, false, 'adminDeleteCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminListCargoTemplate: (page: Pageable,filter: CargoTemplateFilter, onSuccess: ((data : PageResponseCargoTemplateListItemOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/cargo-template`, {},  [page, filter], false, false, 'adminListCargoTemplate', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateCargoTemplate: (body: CargoTemplateRequestInDTO, onSuccess: ((data : CargoTemplateDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/cargo-template`, body,  [], false, false, 'adminCreateCargoTemplate', onSuccess, callbacks, hashAuthentication);
    },
    adminCameraOpen: (locationId: string,body: CameraGateOpeningRequest, onSuccess: ((data : CameraGateOpeningResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/camera/${locationId}/open`, body,  [], false, false, 'adminCameraOpen', onSuccess, callbacks, hashAuthentication);
    },
    adminListRules: (companyId: string, onSuccess: ((data : RuleListItemOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules`, {},  [{companyId}], false, false, 'adminListRules', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateRule: (companyId: string,body: SaveRuleInDTO, onSuccess: ((data : SaveRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules`, body,  [{companyId}], false, false, 'adminCreateRule', onSuccess, callbacks, hashAuthentication);
    },
    adminEnableRule: (companyId: string,ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/${ruleId}/enable`, {},  [{companyId}], false, false, 'adminEnableRule', onSuccess, callbacks, hashAuthentication);
    },
    adminDisableRule: (companyId: string,ruleId: string, onSuccess: ((data : RuleDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/${ruleId}/disable`, {},  [{companyId}], false, false, 'adminDisableRule', onSuccess, callbacks, hashAuthentication);
    },
    adminValidateRule: (companyId: string,body: ValidateRuleInDTO, onSuccess: ((data : ValidateRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/validate`, body,  [{companyId}], false, false, 'adminValidateRule', onSuccess, callbacks, hashAuthentication);
    },
    adminFormatRule: (companyId: string,body: FormatRuleInDTO, onSuccess: ((data : FormatRuleOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/format`, body,  [{companyId}], false, false, 'adminFormatRule', onSuccess, callbacks, hashAuthentication);
    },
    adminDryRunRule: (companyId: string,body: DryRunInDTO, onSuccess: ((data : DryRunOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin/ai-dispatcher/rules/dry-run`, body,  [{companyId}], false, false, 'adminDryRunRule', onSuccess, callbacks, hashAuthentication);
    },
    adminMoveLogsteoUserToCompanyUser: (body: MoveLogsteoUserToCompanyUserRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin-move-logsteo-user-to-company-user`, body,  [], false, false, 'adminMoveLogsteoUserToCompanyUser', onSuccess, callbacks, hashAuthentication);
    },
    adminImportUser: (body: AdminImportUserRequest, onSuccess: ((data : AdminImportUserResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin-import-user`, body,  [], false, false, 'adminImportUser', onSuccess, callbacks, hashAuthentication);
    },
    adminImportCompany: (body: AdminImportCompanyRequest, onSuccess: ((data : AdminImportCompanyResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin-import-company`, body,  [], false, false, 'adminImportCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminImportCompanyLocation: (body: AdminImportCompanyLocationRequest, onSuccess: ((data : AdminImportCompanyLocationResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin-import-company-location`, body,  [], false, false, 'adminImportCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    adminHttpRequestChangeSettings: (body: AdminHTTPRequestSettingsUpdateRequest, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin-http-request-settings/update`, body,  [], false, false, 'adminHttpRequestChangeSettings', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateUserInAuth0: (body: AdminCreateUserInAuth0InDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/admin-create-user-in-auth-0`, body,  [], false, false, 'adminCreateUserInAuth0', onSuccess, callbacks, hashAuthentication);
    },
    createOrUpdateAdditionalTerm: (body: CreateOrUpdateAdditionalTermInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/v1.0/additional-terms/manage`, body,  [], false, false, 'createOrUpdateAdditionalTerm', onSuccess, callbacks, hashAuthentication);
    },
    cuGetCarrierNote: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionCarrierNoteOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/get-carrier-note/${companyId}/${applicationId}`, {},  [], false, false, 'cuGetCarrierNote', onSuccess, callbacks, hashAuthentication);
    },
    aiCarrierAutoSelectionV3: (body: AiCarrierAutoSelectionInDTO, onSuccess: ((data : FindCarrierResponseOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/3.0/customer/carriers-and-groups/autoselection`, body,  [], false, false, 'aiCarrierAutoSelectionV3', onSuccess, callbacks, hashAuthentication);
    },
    createExpedition: (body: SaveExpeditionRequestInDTO, onSuccess: ((data : SaveExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/2.0/customer/expeditions`, body,  [], false, false, 'createExpedition', onSuccess, callbacks, hashAuthentication);
    },
    createCMRFromExpeditionV2: (expeditionId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/2.0/create-cmr-controller/expedition/${expeditionId}`, {},  [], false, false, 'createCMRFromExpeditionV2', onSuccess, callbacks, hashAuthentication);
    },
    getFreeSlotsForLocationReservation: (localDate: string,eventDuration: number,locationId: string,reservationFilterOutIds: string[],body: ReservationDataInDTO, onSuccess: ((data : FreeSlotsWrapperOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/2.0/calendar/free-slots-for-location/reservation`, body,  [{localDate}, {eventDuration}, {locationId}, {reservationFilterOutIds}], false, false, 'getFreeSlotsForLocationReservation', onSuccess, callbacks, hashAuthentication);
    },
    requestTimeslotOnTimeCheckMessage: (body: TimeslotOnTimeCheckRequestDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/2.0/ai/messenger/ontime-check`, body,  [], false, false, 'requestTimeslotOnTimeCheckMessage', onSuccess, callbacks, hashAuthentication);
    },
    requestTimeslotGoToRampMessage: (body: TimeslotGoToRampRequestDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/2.0/ai/messenger/gotoramp`, body,  [], false, false, 'requestTimeslotGoToRampMessage', onSuccess, callbacks, hashAuthentication);
    },
    cuGetSpecificMessageGroupV2: (companyId: string,entityId: string,entityType: string,carrierId: string, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/customer/${carrierId}`, {},  [], false, false, 'cuGetSpecificMessageGroupV2', onSuccess, callbacks, hashAuthentication);
    },
    cuSendMessageV2: (companyId: string,entityId: string,entityType: string,carrierId: string,body: SendMessagesInV3DTO, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/customer/${carrierId}`, body,  [], false, false, 'cuSendMessageV2', onSuccess, callbacks, hashAuthentication);
    },
    cuSendMultipleMessagesV2: (companyId: string,entityId: string,entityType: string,body: SendMessagesMultipleV3DTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/customer/multiple`, body,  [], false, false, 'cuSendMultipleMessagesV2', onSuccess, callbacks, hashAuthentication);
    },
    caGetMessagesV2: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/carrier`, {},  [], false, false, 'caGetMessagesV2', onSuccess, callbacks, hashAuthentication);
    },
    caSendMessageV2: (companyId: string,entityId: string,entityType: string,body: SendMessagesInV3DTO, onSuccess: ((data : ListMessagesOutV3DTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/carrier`, body,  [], false, false, 'caSendMessageV2', onSuccess, callbacks, hashAuthentication);
    },
    genericUploadV2: (body: GenericAttachmentV2InDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.2/document/generic-upload`, body,  [], false, false, 'genericUploadV2', onSuccess, callbacks, hashAuthentication);
    },
    genericReProcess: (body: GenericAttachmentV2InDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.2/document/generic-reprocess`, body,  [], false, false, 'genericReProcess', onSuccess, callbacks, hashAuthentication);
    },
    cuAddCatalogCarrierToMyCompany: (carrierId: string, onSuccess: ((data : CatalogCarrierAddOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.2/customer/companies/carriers/${carrierId}/add`, {},  [], false, false, 'cuAddCatalogCarrierToMyCompany', onSuccess, callbacks, hashAuthentication);
    },
    createExpeditionDetailPdf: (expeditionId: string, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/generate-pdf-expedition-detail/${expeditionId}`, {},  [], false, false, 'createExpeditionDetailPdf', onSuccess, callbacks, hashAuthentication);
    },
    lovDeliveryTerm: (body: DeliveryTermsCarriersRequestDTO, onSuccess: ((data : any)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/delivery-term`, body,  [], false, false, 'lovDeliveryTerm', onSuccess, callbacks, hashAuthentication);
    },
    cuGetSubscriberInfo: (companyId: string,applicationId: string, onSuccess: ((data : SubscriberInfoOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/subscriber`, {},  [], false, false, 'cuGetSubscriberInfo', onSuccess, callbacks, hashAuthentication);
    },
    cuSetOrUnsetMeAsSubscriber: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/subscriber`, {},  [], false, false, 'cuSetOrUnsetMeAsSubscriber', onSuccess, callbacks, hashAuthentication);
    },
    cuRejectDemand: (companyId: string,applicationId: string,quoteId: string,body: RejectMessageInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/quote/${quoteId}/reject`, body,  [], false, false, 'cuRejectDemand', onSuccess, callbacks, hashAuthentication);
    },
    cuAcceptDemand: (companyId: string,applicationId: string,quoteId: string,body: AcceptQuoteByCustomerRequestDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/quote/${quoteId}/accept`, body,  [], false, false, 'cuAcceptDemand', onSuccess, callbacks, hashAuthentication);
    },
    cuReadNotification: (notificationId: string,companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/notification/${notificationId}/read`, {},  [], false, false, 'cuReadNotification', onSuccess, callbacks, hashAuthentication);
    },
    cuAddMoreCarriersToDistribution: (companyId: string,applicationId: string,body: AddMoreCarrierInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/distribution/carriers`, body,  [], false, false, 'cuAddMoreCarriersToDistribution', onSuccess, callbacks, hashAuthentication);
    },
    cuCancelExpedition: (companyId: string,applicationId: string,body: CancelExpeditionInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/cancel`, body,  [], false, false, 'cuCancelExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateExpeditionTemplate: (body: TemplateExpeditionInputInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/template`, body,  [], false, false, 'cuCreateExpeditionTemplate', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateDistributionTemplate: (body: DistributionTemplateInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/template/distribution`, body,  [], false, false, 'cuCreateDistributionTemplate', onSuccess, callbacks, hashAuthentication);
    },
    cuUpdateCarrierNote: (companyId: string,applicationId: string,body: ExpeditionCarrierNoteInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/expedition/carrier-note/${companyId}/${applicationId}`, body,  [], false, false, 'cuUpdateCarrierNote', onSuccess, callbacks, hashAuthentication);
    },
    cuListPartners: (page: Pageable,q: string, onSuccess: ((data : PageResponsePartnerPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/partner`, {},  [page, {q}], false, false, 'cuListPartners', onSuccess, callbacks, hashAuthentication);
    },
    cuCreatePartner: (body: PartnerDetailInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/companies/partner`, body,  [], false, false, 'cuCreatePartner', onSuccess, callbacks, hashAuthentication);
    },
    cuCreatePartnerLocation: (partnerId: string,body: PartnerLocationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}/location`, body,  [], false, false, 'cuCreatePartnerLocation', onSuccess, callbacks, hashAuthentication);
    },
    migratePartnerLocationToCompanyLocation: (partnerId: string,locationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}/location/${locationId}/migrate`, {},  [], false, false, 'migratePartnerLocationToCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyLocationFromPartner: (partnerId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/companies/partner/${partnerId}/create-company-location`, {},  [], false, false, 'createCompanyLocationFromPartner', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyLocationFromAllPartners: (onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/companies/partner/create-company-locations`, {},  [], false, false, 'createCompanyLocationFromAllPartners', onSuccess, callbacks, hashAuthentication);
    },
    cuListCarriers: (page: Pageable,q: string, onSuccess: ((data : PageResponseCarrierListOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/carrier`, {},  [page, {q}], false, false, 'cuListCarriers', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateCarrier: (body: CarrierCreateInDTO, onSuccess: ((data : CreatedIdEntityOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/companies/carrier`, body,  [], false, false, 'cuCreateCarrier', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateCarrierUserByCustomer: (carrierId: string,body: AddCarrierUserInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}/users`, body,  [], false, false, 'cuCreateCarrierUserByCustomer', onSuccess, callbacks, hashAuthentication);
    },
    cuListCarrierGroups: (page: Pageable,q: string, onSuccess: ((data : PageResponseCarrierGroupListOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/carrier-groups`, {},  [page, {q}], false, false, 'cuListCarrierGroups', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateCarrierGroup: (body: CarrierGroupNameInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/customer/carrier-groups`, body,  [], false, false, 'cuCreateCarrierGroup', onSuccess, callbacks, hashAuthentication);
    },
    createUserUnderCompany: (body: UserCompanyUserInDTO, onSuccess: ((data : UserCompanyUserDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/company/user`, body,  [], false, false, 'createUserUnderCompany', onSuccess, callbacks, hashAuthentication);
    },
    addWebAccessToVirtualUser: (userId: string,body: UserCompanyWebAccessEmailInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/company/user/${userId}/web-access`, body,  [], false, false, 'addWebAccessToVirtualUser', onSuccess, callbacks, hashAuthentication);
    },
    sendLoginToMobileApp: (userId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/company/user/${userId}/mobile-access`, {},  [], false, false, 'sendLoginToMobileApp', onSuccess, callbacks, hashAuthentication);
    },
    adminGetSecurityRoles: (onSuccess: ((data : CompanySecurityRolePreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company/security-roles`, {},  [], false, false, 'adminGetSecurityRoles', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateSecurityRole: (body: UserSecurityRolesInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/company/security-roles`, body,  [], false, false, 'adminCreateSecurityRole', onSuccess, callbacks, hashAuthentication);
    },
    caGetDemandDetail: (companyId: string,applicationId: string, onSuccess: ((data : QuoteDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/quote`, {},  [], false, false, 'caGetDemandDetail', onSuccess, callbacks, hashAuthentication);
    },
    caMakeAnotherNewQuote: (companyId: string,applicationId: string,body: MakeOfferInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/quote`, body,  [], false, false, 'caMakeAnotherNewQuote', onSuccess, callbacks, hashAuthentication);
    },
    caMakeQuote: (companyId: string,applicationId: string,quoteId: string,body: MakeOfferInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/quote/${quoteId}`, body,  [], false, false, 'caMakeQuote', onSuccess, callbacks, hashAuthentication);
    },
    caCancelDemand: (companyId: string,applicationId: string,quoteId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/quote/${quoteId}/cancel`, {},  [], false, false, 'caCancelDemand', onSuccess, callbacks, hashAuthentication);
    },
    caGetShipmentDetailProgressTabAssigned: (companyId: string,applicationId: string, onSuccess: ((data : JobProgressFormDataOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/progress`, {},  [], false, false, 'caGetShipmentDetailProgressTabAssigned', onSuccess, callbacks, hashAuthentication);
    },
    caSendAssignedShipmentForm: (companyId: string,applicationId: string,body: ShipmentProgressFormDataInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/progress`, body,  [], false, false, 'caSendAssignedShipmentForm', onSuccess, callbacks, hashAuthentication);
    },
    caFinishLocationWithData: (companyId: string,applicationId: string,locationId: string,body: FinishLocationActionWrapperInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/location/${locationId}/finish-data`, body,  [], false, false, 'caFinishLocationWithData', onSuccess, callbacks, hashAuthentication);
    },
    caRejectFixedPrice: (companyId: string,applicationId: string,quoteId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/fixed-price/${quoteId}/reject`, {},  [], false, false, 'caRejectFixedPrice', onSuccess, callbacks, hashAuthentication);
    },
    caAcceptFixedPrice: (companyId: string,applicationId: string,quoteId: string,body: FixedPriceAcceptOfferInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/fixed-price/${quoteId}/accept`, body,  [], false, false, 'caAcceptFixedPrice', onSuccess, callbacks, hashAuthentication);
    },
    caFinishShipment: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/finish`, {},  [], false, false, 'caFinishShipment', onSuccess, callbacks, hashAuthentication);
    },
    adminAddInheritingModuleByCompany: (companyId: string,inheritedCompanyId: string,companyModule: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/admin/${companyId}/module/inherited/${inheritedCompanyId}/${companyModule}`, {},  [], false, false, 'adminAddInheritingModuleByCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminDeleteInheritingModuleByCompany: (companyId: string,inheritedCompanyId: string,companyModule: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/admin/${companyId}/module/inherited/${inheritedCompanyId}/${companyModule}`, {},  [], false, false, 'adminDeleteInheritingModuleByCompany', onSuccess, callbacks, hashAuthentication);
    },
    createFirstCompanyRegistration: (body: FirstCompanyRegistrationInDTO, onSuccess: ((data : CreateFirstCompanyResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/admin/registration/first-company`, body,  [], false, false, 'createFirstCompanyRegistration', onSuccess, callbacks, hashAuthentication);
    },
    adminRebuildDashboard: (onSuccess: ((data : DashboardRebuildTriggerDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/admin/dashboard/rebuild`, {},  [], false, false, 'adminRebuildDashboard', onSuccess, callbacks, hashAuthentication);
    },
    adminAddNotEnabledEmailNotificationForCompany: (companyId: string,emailType: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.1/admin/company/${companyId}/notifications/${emailType}`, {},  [], false, false, 'adminAddNotEnabledEmailNotificationForCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminDeleteNotEnabledEmailNotificationForCompany: (companyId: string,emailType: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/admin/company/${companyId}/notifications/${emailType}`, {},  [], false, false, 'adminDeleteNotEnabledEmailNotificationForCompany', onSuccess, callbacks, hashAuthentication);
    },
    getVisitorRecords: (page: Pageable,filter: VisitorRecordFilterInDTO, onSuccess: ((data : VisitorRecordListResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/visitor-record`, {},  [page, filter], false, false, 'getVisitorRecords', onSuccess, callbacks, hashAuthentication);
    },
    createVisitorRecord: (body: VisitorRecordInDTO, onSuccess: ((data : VisitorRecordOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/visitor-record`, body,  [], false, false, 'createVisitorRecord', onSuccess, callbacks, hashAuthentication);
    },
    listSupplierNotification: (page: Pageable,filter: AllSupplierNotificationFilter, onSuccess: ((data : SupplierNotificationListOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/supplier-notification`, {},  [page, filter], false, false, 'listSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    createSupplierNotification: (body: SupplierNotificationInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/supplier-notification`, body,  [], false, false, 'createSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    listShipment: (page: Pageable,filter: ShipmentListFilter, onSuccess: ((data : PageResponseListShipmentPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/shipment`, {},  [page, filter], false, false, 'listShipment', onSuccess, callbacks, hashAuthentication);
    },
    createShipment: (body: ShipmentInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/shipment`, body,  [], false, false, 'createShipment', onSuccess, callbacks, hashAuthentication);
    },
    sendExternalQuote: (expeditionId: string, onSuccess: ((data : SendExternalQuoteResponseDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/sap/external-quote/${expeditionId}/send`, {},  [], false, false, 'sendExternalQuote', onSuccess, callbacks, hashAuthentication);
    },
    submitInvoiceValidationResponse: (body: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/invoices/test/validation-response`, body,  [], false, false, 'submitInvoiceValidationResponse', onSuccess, callbacks, hashAuthentication);
    },
    listGroupDemands: (page: Pageable,filter: CustomerGroupDemandFilter, onSuccess: ((data : PageResponseGroupDemandListPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/group-demand`, {},  [page, filter], false, false, 'listGroupDemands', onSuccess, callbacks, hashAuthentication);
    },
    createGroupDemand: (body: GroupDemandInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/group-demand`, body,  [], false, false, 'createGroupDemand', onSuccess, callbacks, hashAuthentication);
    },
    createGroupDemandsDistribution: (groupDemandId: string,body: GroupDemandsDistributionInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/group-demand/${groupDemandId}`, body,  [], false, false, 'createGroupDemandsDistribution', onSuccess, callbacks, hashAuthentication);
    },
    cuDeleteGroupDemand: (groupDemandId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/group-demand/${groupDemandId}`, {},  [], false, false, 'cuDeleteGroupDemand', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateExpeditionFromGroupDemandsSN: (groupDemandId: string,body: ExpeditionCreateFromGDPerSN, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/group-demand/${groupDemandId}/expedition`, body,  [], false, false, 'cuCreateExpeditionFromGroupDemandsSN', onSuccess, callbacks, hashAuthentication);
    },
    sendExpeditionTimeslotReminder: (ownerCompanyId: string,applicationId: string,locationId: string, onSuccess: ((data : ExpeditionTimeslotReminderOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/expedition/${ownerCompanyId}/${applicationId}/timeslot-reminder/${locationId}/send`, {},  [], false, false, 'sendExpeditionTimeslotReminder', onSuccess, callbacks, hashAuthentication);
    },
    cuReconfirmedExpedition: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/expedition/${companyId}/${applicationId}/reconfirmed/customer`, {},  [], false, false, 'cuReconfirmedExpedition', onSuccess, callbacks, hashAuthentication);
    },
    caReconfirmedExpedition: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/expedition/${companyId}/${applicationId}/reconfirmed/carrier`, {},  [], false, false, 'caReconfirmedExpedition', onSuccess, callbacks, hashAuthentication);
    },
    finishExpedition: (companyId: string,applicationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/expedition/${companyId}/${applicationId}/finish/no-check`, {},  [], false, false, 'finishExpedition', onSuccess, callbacks, hashAuthentication);
    },
    generateAndAttachNewIntegrationToken: (userId: string, onSuccess: ((data : LinkTokenToUserOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/driver/user/user/${userId}`, {},  [], false, false, 'generateAndAttachNewIntegrationToken', onSuccess, callbacks, hashAuthentication);
    },
    changeDocumentVisibility: (attachmentId: string,body: ChangeVisibilityInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/document/change-visibility/${attachmentId}`, body,  [], false, false, 'changeDocumentVisibility', onSuccess, callbacks, hashAuthentication);
    },
    sendPowerBIToken: (body: PowerBiReportInDTO, onSuccess: ((data : PowerBiTokenDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/customer/reporting/powerbi/token`, body,  [], false, false, 'sendPowerBIToken', onSuccess, callbacks, hashAuthentication);
    },
    listInternalComments: (entityType: string,entityId: string,page: Pageable, onSuccess: ((data : PageResponseInternalCommentOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/internal-comment`, {},  [{entityType}, {entityId}, page], false, false, 'listInternalComments', onSuccess, callbacks, hashAuthentication);
    },
    createInternalComment: (body: InternalCommentInDTO, onSuccess: ((data : InternalCommentOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/customer/internal-comment`, body,  [], false, false, 'createInternalComment', onSuccess, callbacks, hashAuthentication);
    },
    cuSetResponsiblePersonToExpedition: (companyId: string,applicationId: string,userId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/responsible-person/${userId}`, {},  [], false, false, 'cuSetResponsiblePersonToExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuCreateExtraCostForExpedition: (companyId: string,applicationId: string,body: ExtraCostsInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/extra-costs`, body,  [], false, false, 'cuCreateExtraCostForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuSetDirectAssignment: (companyId: string,applicationId: string,body: DirectAssigmentDataInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/direct-assignment`, body,  [], false, false, 'cuSetDirectAssignment', onSuccess, callbacks, hashAuthentication);
    },
    cuPublishExpeditions: (body: ExpeditionToPublishInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/customer/expedition/publish`, body,  [], false, false, 'cuPublishExpeditions', onSuccess, callbacks, hashAuthentication);
    },
    createAdditionalInfoForCarrier: (carrierId: string,body: AdditionalInfoCarrierRequestInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/customer/carriers/${carrierId}/additional-info`, body,  [], false, false, 'createAdditionalInfoForCarrier', onSuccess, callbacks, hashAuthentication);
    },
    convertCsvToListObject: (body: CSVInDTO, onSuccess: ((data : undefined[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/csv/convert`, body,  [], false, false, 'convertCsvToListObject', onSuccess, callbacks, hashAuthentication);
    },
    getCompanySettings: (identifier: CompanySettingsIdInDTO, onSuccess: ((data : CompanySettingsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/settings`, {},  [identifier], false, false, 'getCompanySettings', onSuccess, callbacks, hashAuthentication);
    },
    saveCompanySettings: (body: CompanySettingsInDTO, onSuccess: ((data : CompanySettingsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/settings`, body,  [], false, false, 'saveCompanySettings', onSuccess, callbacks, hashAuthentication);
    },
    getReservations: (page: Pageable,filter: AllReservationsFilter, onSuccess: ((data : PageResponseReservationListPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/reservation`, {},  [page, filter], false, false, 'getReservations', onSuccess, callbacks, hashAuthentication);
    },
    createReservation: (body: ReservationDataInDTO, onSuccess: ((data : ReservationCoordinates)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/reservation`, body,  [], false, false, 'createReservation', onSuccess, callbacks, hashAuthentication);
    },
    getReservationsForDayAndMultipleLocations: (body: RequestParamsForMultipleLocationReservationInDTO, onSuccess: ((data : ReservationCalendarGroupedOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/reservation/location`, body,  [], false, false, 'getReservationsForDayAndMultipleLocations', onSuccess, callbacks, hashAuthentication);
    },
    checkReservation: (reservationFilterOutIds: string[],body: ReservationDataInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/reservation/check`, body,  [{reservationFilterOutIds}], false, false, 'checkReservation', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyLocations: (q: string,showOnlyWithRamp: boolean, onSuccess: ((data : CompanyLocationsListPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location`, {},  [{q}, {showOnlyWithRamp}], false, false, 'getCompanyLocations', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyLocations: (body: CompanyLocationInDTO, onSuccess: ((data : CreateCompanyLocationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/location`, body,  [], false, false, 'createCompanyLocations', onSuccess, callbacks, hashAuthentication);
    },
    createRampForLocation: (locationId: string,body: CompanyLocationRampInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/location/${locationId}/ramp`, body,  [], false, false, 'createRampForLocation', onSuccess, callbacks, hashAuthentication);
    },
    listLocationContacts: (locationId: string,page: Pageable,q: string,automaticPrefillToNotify: boolean, onSuccess: ((data : PageResponseLocationContactOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/contacts`, {},  [page, {q}, {automaticPrefillToNotify}], false, false, 'listLocationContacts', onSuccess, callbacks, hashAuthentication);
    },
    createLocationContact: (locationId: string,body: LocationContactInDTO, onSuccess: ((data : CreateLocationContactOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/location/${locationId}/contacts`, body,  [], false, false, 'createLocationContact', onSuccess, callbacks, hashAuthentication);
    },
    deleteLocationContacts: (locationId: string,contactIds: string[], onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/company/location/${locationId}/contacts`, {},  [{contactIds}], false, false, 'deleteLocationContacts', onSuccess, callbacks, hashAuthentication);
    },
    changeACLForLocations: (body: CompanyLocationMassActionChangeACLInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/location/mass-action/change-acl`, body,  [], false, false, 'changeACLForLocations', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyLocationExceptions: (page: Pageable,filter: CompanyLocationExceptionFilterDTO, onSuccess: ((data : PageResponseCompanyLocationExceptionPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/exception`, {},  [page, filter], false, false, 'getCompanyLocationExceptions', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyLocationException: (body: CompanyLocationExceptionInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/location/exception`, body,  [], false, false, 'createCompanyLocationException', onSuccess, callbacks, hashAuthentication);
    },
    deleteCompanyLocationExceptions: (exceptionIds: string[], onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/company/location/exception`, {},  [{exceptionIds}], false, false, 'deleteCompanyLocationExceptions', onSuccess, callbacks, hashAuthentication);
    },
    listAllLabelsForCompany: (onSuccess: ((data : GetListLabelsPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/labels`, {},  [], false, false, 'listAllLabelsForCompany', onSuccess, callbacks, hashAuthentication);
    },
    createNewLabelForCompany: (body: CreateNewLabelInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company/labels`, body,  [], false, false, 'createNewLabelForCompany', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyUsersDrivers: (page: Pageable,q: string, onSuccess: ((data : PageResponseLovDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company-user-driver`, {},  [page, {q}], false, false, 'listCompanyUsersDrivers', onSuccess, callbacks, hashAuthentication);
    },
    createCompanyUserDriver: (body: CreateCompanyUserDriverRequest, onSuccess: ((data : CreateCompanyUserDriverResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/company-user-driver`, body,  [], false, false, 'createCompanyUserDriver', onSuccess, callbacks, hashAuthentication);
    },
    lovAllCompaniesByInheritedModules: (body: InheritedModulesWrapper, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/companies/modules/inherited`, body,  [], false, false, 'lovAllCompaniesByInheritedModules', onSuccess, callbacks, hashAuthentication);
    },
    caGetGroupDemandDetailById: (groupDemandId: string, onSuccess: ((data : CarrierGroupDemandDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/carrier/group-demand/${groupDemandId}`, {},  [], false, false, 'caGetGroupDemandDetailById', onSuccess, callbacks, hashAuthentication);
    },
    caCreateGroupDemandQuote: (groupDemandId: string,body: CarrierCreateQuoteGroupDemandInDTO, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/carrier/group-demand/${groupDemandId}`, body,  [], false, false, 'caCreateGroupDemandQuote', onSuccess, callbacks, hashAuthentication);
    },
    uploadAttachments: (body: AttachmentsUploadInDTO, onSuccess: ((data : AttachmentsUploadedOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/attachments`, body,  [], false, false, 'uploadAttachments', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated Upload attachment
     */
    uploadAttachment: (body: FileV2InDTO, onSuccess: ((data : AttachmentUploadedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/attachment`, body,  [], false, false, 'uploadAttachment', onSuccess, callbacks, hashAuthentication);
    },
    downloadAttachmentsZip: (body: AttachmentsZipDownloadInDTO, onSuccess: ((data : Blob)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/attachment/download-zip`, body,  [], false, true, 'downloadAttachmentsZip', onSuccess, callbacks, hashAuthentication);
    },
    adminListShippingCompanies: (page: Pageable,filter: ListShippingCompaniesFilter, onSuccess: ((data : PageResponseListShippingCompaniesItemResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/admin/shipping-company`, {},  [page, filter], false, false, 'adminListShippingCompanies', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateShippingCompany: (body: CreateShippingCompanyRequestInDTO, onSuccess: ((data : CreateShippingCompanyResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/admin/shipping-company`, body,  [], false, false, 'adminCreateShippingCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminListCarrier: (onSuccess: ((data : AdminCatalogListOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/admin/companies/carriers`, {},  [], false, false, 'adminListCarrier', onSuccess, callbacks, hashAuthentication);
    },
    adminCreateCarrier: (body: AdminCatalogCreatingInDTO, onSuccess: ((data : AdminCatalogCreatedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('post', `${backendUrl}/api/1.0/admin/companies/carriers`, body,  [], false, false, 'adminCreateCarrier', onSuccess, callbacks, hashAuthentication);
    },
    getTemplateToExpeditionDetail: (expeditionTemplateId: string, onSuccess: ((data : ExpeditionDetailV4OutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/template/get-expedition-detail/${expeditionTemplateId}`, {},  [], false, false, 'getTemplateToExpeditionDetail', onSuccess, callbacks, hashAuthentication);
    },
    getMultipleExpeditionDetails: (expeditionIds: string[], onSuccess: ((data : MultipleExpeditionDetailV4OutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/get-expedition-detail`, {},  [{expeditionIds}], false, false, 'getMultipleExpeditionDetails', onSuccess, callbacks, hashAuthentication);
    },
    getExpeditionV4Detail: (expeditionId: string, onSuccess: ((data : ExpeditionDetailV4OutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/get-expedition-detail/${expeditionId}`, {},  [], false, false, 'getExpeditionV4Detail', onSuccess, callbacks, hashAuthentication);
    },
    getCGLocationsV2: (filter: CGV2LocationFilterInDTO, onSuccess: ((data : CGV2SmallCompanyOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/get-cg-locations`, {},  [filter], false, false, 'getCGLocationsV2', onSuccess, callbacks, hashAuthentication);
    },
    getOneCGLocationV2: (locationId: string, onSuccess: ((data : CGV2LocationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/get-cg-locations/${locationId}`, {},  [], false, false, 'getOneCGLocationV2', onSuccess, callbacks, hashAuthentication);
    },
    getQuotesDbPaged: (expeditionId: string,distributionId: string,filter: ExpeditionQuoteCarrierFilterInDTO,pageable: Pageable, onSuccess: ((data : PageResponseQuotesPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/expeditions/${expeditionId}/distributions/${distributionId}/quotes`, {},  [filter, pageable], false, false, 'getQuotesDbPaged', onSuccess, callbacks, hashAuthentication);
    },
    listCarPlates: (onSuccess: ((data : CarPlateDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v2.0/carplate`, {},  [], false, false, 'listCarPlates', onSuccess, callbacks, hashAuthentication);
    },
    adminListCompanies: (page: Pageable,q: string,ico: string, onSuccess: ((data : PageResponseCompanyListOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.1/admin/list-company`, {},  [page, {q}, {ico}], false, false, 'adminListCompanies', onSuccess, callbacks, hashAuthentication);
    },
    getUserTableFilterFavourites: (onSuccess: ((data : GetUserTableFilterFavouritesResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/table-filter-favourites`, {},  [], false, false, 'getUserTableFilterFavourites', onSuccess, callbacks, hashAuthentication);
    },
    getUserVisitorRecordFilters: (onSuccess: ((data : GetUserVisitorRecordFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/visitor-record`, {},  [], false, false, 'getUserVisitorRecordFilters', onSuccess, callbacks, hashAuthentication);
    },
    getUserTimeslotCalendarFilters: (onSuccess: ((data : GetUserTimeslotCalendarFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/timeslot-calendar`, {},  [], false, false, 'getUserTimeslotCalendarFilters', onSuccess, callbacks, hashAuthentication);
    },
    getUserSupplierNotificationFilters: (onSuccess: ((data : GetUserSupplierNotificationFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/supplier-notification`, {},  [], false, false, 'getUserSupplierNotificationFilters', onSuccess, callbacks, hashAuthentication);
    },
    getUserReservationFilters: (onSuccess: ((data : GetUserReservationFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/reservation`, {},  [], false, false, 'getUserReservationFilters', onSuccess, callbacks, hashAuthentication);
    },
    getUserNotificationFilters: (onSuccess: ((data : GetUserNotificationFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/notification`, {},  [], false, false, 'getUserNotificationFilters', onSuccess, callbacks, hashAuthentication);
    },
    getUserJobFilters: (onSuccess: ((data : GetUserJobFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/job`, {},  [], false, false, 'getUserJobFilters', onSuccess, callbacks, hashAuthentication);
    },
    getUserExpeditionFilters: (onSuccess: ((data : GetUserExpeditionFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/expedition`, {},  [], false, false, 'getUserExpeditionFilters', onSuccess, callbacks, hashAuthentication);
    },
    getUserEmailHistoryFilters: (onSuccess: ((data : GetUserEmailHistoryFiltersResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/users/filters/email-history`, {},  [], false, false, 'getUserEmailHistoryFilters', onSuccess, callbacks, hashAuthentication);
    },
    listAvailableUserDepartmentsForCurrentCompany: (onSuccess: ((data : ListUserDepartmentOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/user/department`, {},  [], false, false, 'listAvailableUserDepartmentsForCurrentCompany', onSuccess, callbacks, hashAuthentication);
    },
    lookupTimezone: (city: string,country: string,postalCode: string,useHereMapFallback: boolean, onSuccess: ((data : any)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/timezone/lookup`, {},  [{city}, {country}, {postalCode}, {useHereMapFallback}], false, false, 'lookupTimezone', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated This endpoint return setting for TS creator, if inheritor, tsOwnerCompanyId is from the owner 
     */
    getCreateEditReservationSettings: (tsOwnerCompanyId: string, onSuccess: ((data : ComputeReservationDurationConfiguration)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/timeslot-module-settings/create-edit-reservation/${tsOwnerCompanyId}`, {},  [], false, false, 'getCreateEditReservationSettings', onSuccess, callbacks, hashAuthentication);
    },
    getTableViews: (tableKey: string, onSuccess: ((data : TableViewsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/table-views/${tableKey}`, {},  [], false, false, 'getTableViews', onSuccess, callbacks, hashAuthentication);
    },
    detailDAPSupplierNotification: (supplierNotificationId: string, onSuccess: ((data : DetailDAPSNResponseOut)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/supplier-notification/${supplierNotificationId}/dap`, {},  [], false, false, 'detailDAPSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated Get external orders for supplier from configured 3rd-party API
     */
    getExternalOrders: (companyOwnerId: string,supplierId: string,companyLocationId: string, onSuccess: ((data : GetExternalOrdersResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/reservation/external-orders`, {},  [{companyOwnerId}, {supplierId}, {companyLocationId}], false, false, 'getExternalOrders', onSuccess, callbacks, hashAuthentication);
    },
    exportReservations: (filter: AllReservationsFilter, onSuccess: ((data : ReservationDataExportResponseOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/reservation/export`, {},  [filter], false, false, 'exportReservations', onSuccess, callbacks, hashAuthentication);
    },
    getReservationMultiDuplicationJobDetail: (jobId: string, onSuccess: ((data : ReservationMultiDuplicationJobDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/reservation/duplication/job/${jobId}`, {},  [], false, false, 'getReservationMultiDuplicationJobDetail', onSuccess, callbacks, hashAuthentication);
    },
    getReservationMultiDuplicationJobItems: (jobId: string,filter: ReservationMultiDuplicationJobItemsFilter,page: Pageable, onSuccess: ((data : PageResponseReservationMultiDuplicationJobItemOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/reservation/duplication/job/${jobId}/items`, {},  [filter, page], false, false, 'getReservationMultiDuplicationJobItems', onSuccess, callbacks, hashAuthentication);
    },
    getCarriersInputReservation: (linkToExpeditionLocationId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/reservation/carrier/input`, {},  [{linkToExpeditionLocationId}], false, false, 'getCarriersInputReservation', onSuccess, callbacks, hashAuthentication);
    },
    getPushToken: (onSuccess: ((data : GetPushTokenResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/push/token`, {},  [], false, false, 'getPushToken', onSuccess, callbacks, hashAuthentication);
    },
    getPushSubscriptionToken: (channel: string, onSuccess: ((data : GetPushSubscriptionTokenResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/push/subscription-token`, {},  [{channel}], false, false, 'getPushSubscriptionToken', onSuccess, callbacks, hashAuthentication);
    },
    getPriceAlert: (groupDemandId: string, onSuccess: ((data : TheOriginsPriceAlertResponseBody)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/price-alert-service/${groupDemandId}`, {},  [], false, false, 'getPriceAlert', onSuccess, callbacks, hashAuthentication);
    },
    lovGetPermissions: (onSuccess: ((data : LovGetPermissionResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/permissions`, {},  [], false, false, 'lovGetPermissions', onSuccess, callbacks, hashAuthentication);
    },
    getOpeningHoursForEntity: (entityId: string,entityType: string, onSuccess: ((data : OpeningHourDefinitionsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/opening-hours-controller/opening-hours/${entityId}/${entityType}`, {},  [{entityType}], false, false, 'getOpeningHoursForEntity', onSuccess, callbacks, hashAuthentication);
    },
    getIntegrationOrderForSupplier: (entity: string,selectedSupplierId: string,companyOwnerId: string, onSuccess: ((data : Order[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/notino-pap-service/orders/${entity}/${selectedSupplierId}/${companyOwnerId}`, {},  [], false, false, 'getIntegrationOrderForSupplier', onSuccess, callbacks, hashAuthentication);
    },
    lovGetAllEmailTypes: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/notification-center/lov/email-types`, {},  [], false, false, 'lovGetAllEmailTypes', onSuccess, callbacks, hashAuthentication);
    },
    listNotificationCenterMessage: (filter: NotificationCenterFilter,page: Pageable, onSuccess: ((data : PageResponseNotificationCenterMessageResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/notification-center/list`, {},  [filter, page], false, false, 'listNotificationCenterMessage', onSuccess, callbacks, hashAuthentication);
    },
    countNotificationCenterMessage: (onSuccess: ((data : NotificationMessageCountResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/notification-center/count`, {},  [], false, false, 'countNotificationCenterMessage', onSuccess, callbacks, hashAuthentication);
    },
    lovGetAllNotificationTypes: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/lov-get-all-notification-types`, {},  [], false, false, 'lovGetAllNotificationTypes', onSuccess, callbacks, hashAuthentication);
    },
    lovCompanyCodeList: (codeListEnum: string,query: string, onSuccess: ((data : LovCompanyCodeListDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/lov-company-code-list`, {},  [{codeListEnum}, {query}], false, false, 'lovCompanyCodeList', onSuccess, callbacks, hashAuthentication);
    },
    loadEurowagProposals: (customerId: string,applicationId: string, onSuccess: ((data : LoadEWProposalsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/load-ew-proposals/${customerId}/${applicationId}`, {},  [{customerId}, {applicationId}], false, false, 'loadEurowagProposals', onSuccess, callbacks, hashAuthentication);
    },
    adminListHttpRequest: (page: Pageable,filter: ListHTTPRequestFilter, onSuccess: ((data : ListHTTPRequestResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/list-http-request/list`, {},  [page, filter], false, false, 'adminListHttpRequest', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyCodeList: (filter: ListCompanyCodeListFilter,page: Pageable, onSuccess: ((data : PageResponseListCompanyCodeListItem)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/list-company-code-list`, {},  [filter, page], false, false, 'listCompanyCodeList', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyCameras: (onSuccess: ((data : ListCompanyCamerasResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/list-company-cameras`, {},  [], false, false, 'listCompanyCameras', onSuccess, callbacks, hashAuthentication);
    },
    listAllowedCarPlates: (filter: ListAllowedCarPlatesFilter,page: Pageable, onSuccess: ((data : PageResponseAllowedCarPlateResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/list-allowed-car-plates`, {},  [filter, page], false, false, 'listAllowedCarPlates', onSuccess, callbacks, hashAuthentication);
    },
    getLinkedCompanies: (filter: GetLinkedCompaniesFilterInDTO,page: Pageable, onSuccess: ((data : PageResponseGetLinkedCompanyOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/linked-company`, {},  [filter, page], false, false, 'getLinkedCompanies', onSuccess, callbacks, hashAuthentication);
    },
    getDetailLinkedCompany: (companyId: string, onSuccess: ((data : GetDetailLinkedCompanyResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/linked-company/${companyId}/detail`, {},  [], false, false, 'getDetailLinkedCompany', onSuccess, callbacks, hashAuthentication);
    },
    getLinkedCompaniesExport: (filter: GetLinkedCompaniesFilterInDTO, onSuccess: ((data : GetLinkedCompanyOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/linked-company/export`, {},  [filter], false, false, 'getLinkedCompaniesExport', onSuccess, callbacks, hashAuthentication);
    },
    getActiveLinkedCodes: (onSuccess: ((data : GetLinkedCodeOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/linked-code`, {},  [], false, false, 'getActiveLinkedCodes', onSuccess, callbacks, hashAuthentication);
    },
    getAsyncJobDetail: (jobId: string, onSuccess: ((data : AsyncJobDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/jobs/${jobId}`, {},  [], false, false, 'getAsyncJobDetail', onSuccess, callbacks, hashAuthentication);
    },
    cancelAsyncJob: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/jobs/${jobId}`, {},  [], false, false, 'cancelAsyncJob', onSuccess, callbacks, hashAuthentication);
    },
    downloadExportAsyncJob: (jobId: string, onSuccess: ((data : ExportDownloadUrlOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/jobs/${jobId}/export/download`, {},  [], false, false, 'downloadExportAsyncJob', onSuccess, callbacks, hashAuthentication);
    },
    listMyAsyncJobs: (limit: number, onSuccess: ((data : AsyncJobOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/jobs/my`, {},  [{limit}], false, false, 'listMyAsyncJobs', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyJobs: (filter: CompanyJobsFilter,page: Pageable, onSuccess: ((data : PageResponseCompanyJobOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/jobs/company`, {},  [filter, page], false, false, 'listCompanyJobs', onSuccess, callbacks, hashAuthentication);
    },
    getJobBadgeCounts: (onSuccess: ((data : JobBadgeCountsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/jobs/company/badge-counts`, {},  [], false, false, 'getJobBadgeCounts', onSuccess, callbacks, hashAuthentication);
    },
    adminListJobsPaged: (filter: AdminJobsFilter,page: Pageable, onSuccess: ((data : PageResponseAdminAsyncJobOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/jobs/admin/list`, {},  [filter, page], false, false, 'adminListJobsPaged', onSuccess, callbacks, hashAuthentication);
    },
    reindexAllSn: (cleanReindex: boolean, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/index-supplier-notification/reindex`, {},  [{cleanReindex}], false, false, 'reindexAllSn', onSuccess, callbacks, hashAuthentication);
    },
    reindexOneExpedition: (id: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/index-expedition/reindex/${id}`, {},  [], false, false, 'reindexOneExpedition', onSuccess, callbacks, hashAuthentication);
    },
    getWebAppAlert: (onSuccess: ((data : GetWebAppAlertResponse[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-web-app-alert`, {},  [], false, false, 'getWebAppAlert', onSuccess, callbacks, hashAuthentication);
    },
    getAvailableTimezones: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-timezones`, {},  [], false, false, 'getAvailableTimezones', onSuccess, callbacks, hashAuthentication);
    },
    cuGetMultipleSupplierNotificationsForExpedition: (supplierNotificationIds: string[], onSuccess: ((data : SupplierNotificationToExpeditionOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-supplier-notification-for-expedition`, {},  [{supplierNotificationIds}], false, false, 'cuGetMultipleSupplierNotificationsForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    getReportPermission: (reportDefinitionId: string,companyId: string, onSuccess: ((data : ReportDefinitionCompanySettingResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-report-permission/${reportDefinitionId}/${companyId}`, {},  [], false, false, 'getReportPermission', onSuccess, callbacks, hashAuthentication);
    },
    listPowerBIReports: (onSuccess: ((data : GetPowerBIReportServiceResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-power-bi-report`, {},  [], false, false, 'listPowerBIReports', onSuccess, callbacks, hashAuthentication);
    },
    getLinkedEntities: (entityType: string,entityId: string, onSuccess: ((data : GetLinkedEntitiesResponse[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-linked-entities/${entityType}/${entityId}`, {},  [], false, false, 'getLinkedEntities', onSuccess, callbacks, hashAuthentication);
    },
    getInheritedCompanies: (onSuccess: ((data : GetInheritedCompanyOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-inherited-companies`, {},  [], false, false, 'getInheritedCompanies', onSuccess, callbacks, hashAuthentication);
    },
    getExpeditionV3Detail: (expeditionId: string, onSuccess: ((data : ExpeditionDetailV3OutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-expedition-detail/${expeditionId}`, {},  [], false, false, 'getExpeditionV3Detail', onSuccess, callbacks, hashAuthentication);
    },
    getDocumentMetadata: (documentId: string, onSuccess: ((data : GetDocumentResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-document-metadata/${documentId}`, {},  [], false, false, 'getDocumentMetadata', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyNotificationsForInheritor: (onSuccess: ((data : CustomerNotificatonListResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-customer-notification`, {},  [], false, false, 'getCompanyNotificationsForInheritor', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyPartnerInfo: (companyPartnerId: string, onSuccess: ((data : PartnerInfo)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-company-partner-info/${companyPartnerId}`, {},  [], false, false, 'getCompanyPartnerInfo', onSuccess, callbacks, hashAuthentication);
    },
    getCGLocations: (onSuccess: ((data : CGCompanyOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-cg-locations`, {},  [], false, false, 'getCGLocations', onSuccess, callbacks, hashAuthentication);
    },
    getAttachments: (filter: GetAttachmentsFilterInDTO,page: Pageable, onSuccess: ((data : PageResponseGetAttachmentsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/get-attachments`, {},  [filter, page], false, false, 'getAttachments', onSuccess, callbacks, hashAuthentication);
    },
    findResolvedEmails: (page: Pageable,filter: FindResolvedEmailFilter, onSuccess: ((data : PageResponseResolvedEmailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/find-resolved-emails`, {},  [page, filter], false, false, 'findResolvedEmails', onSuccess, callbacks, hashAuthentication);
    },
    findEmailRequest: (page: Pageable,filter: FindEmailRequestFilter, onSuccess: ((data : PageResponseEmailRequestOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/find-email-request`, {},  [page, filter], false, false, 'findEmailRequest', onSuccess, callbacks, hashAuthentication);
    },
    getFedexRegistrationStatus: (onSuccess: ((data : FedexRegistrationStatusOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/fedex/registration/status`, {},  [], false, false, 'getFedexRegistrationStatus', onSuccess, callbacks, hashAuthentication);
    },
    getFedexEtdImages: (onSuccess: ((data : FedexEtdImagesOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/fedex/etd/images`, {},  [], false, false, 'getFedexEtdImages', onSuccess, callbacks, hashAuthentication);
    },
    listFedexAccounts: (pickupCompanyLocationId: string,deliveryCompanyLocationId: string, onSuccess: ((data : FedexAccountOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/fedex/accounts`, {},  [{pickupCompanyLocationId}, {deliveryCompanyLocationId}], false, false, 'listFedexAccounts', onSuccess, callbacks, hashAuthentication);
    },
    getSNFeatureConfiguration: (customerId: string, onSuccess: ((data : SnFeatureConfigurationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/feature-configuration/${customerId}`, {},  [], false, false, 'getSNFeatureConfiguration', onSuccess, callbacks, hashAuthentication);
    },
    getExternalOrdersByModule: (module: string,companyOwnerId: string,supplierId: string,companyLocationId: string, onSuccess: ((data : GetExternalOrdersResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/external-orders`, {},  [{module}, {companyOwnerId}, {supplierId}, {companyLocationId}], false, false, 'getExternalOrdersByModule', onSuccess, callbacks, hashAuthentication);
    },
    getJobStatus: (jobId: string, onSuccess: ((data : ExportJobStatusOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/export/jobs/${jobId}/status`, {},  [], false, false, 'getJobStatus', onSuccess, callbacks, hashAuthentication);
    },
    downloadExport: (jobId: string, onSuccess: ((data : ExportDownloadUrlOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/export/jobs/${jobId}/download`, {},  [], false, false, 'downloadExport', onSuccess, callbacks, hashAuthentication);
    },
    downloadExportProxy: (jobId: string, onSuccess: ((data : Blob)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/export/jobs/${jobId}/download-proxy`, {},  [], false, true, 'downloadExportProxy', onSuccess, callbacks, hashAuthentication);
    },
    listMyJobs: (onSuccess: ((data : ExportJobStatusOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/export/jobs/my`, {},  [], false, false, 'listMyJobs', onSuccess, callbacks, hashAuthentication);
    },
    robotSuggestions: (expeditionId: string, onSuccess: ((data : RobotSuggestionOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/${expeditionId}/robot-suggestions`, {},  [], false, false, 'robotSuggestions', onSuccess, callbacks, hashAuthentication);
    },
    getPreviousDistribution: (expeditionId: string, onSuccess: ((data : GetPreviousDistributionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/${expeditionId}/previous-distribution`, {},  [], false, false, 'getPreviousDistribution', onSuccess, callbacks, hashAuthentication);
    },
    getFedexExpeditionTracking: (expeditionId: string, onSuccess: ((data : FedexExpeditionTrackingOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/${expeditionId}/fedex-tracking`, {},  [], false, false, 'getFedexExpeditionTracking', onSuccess, callbacks, hashAuthentication);
    },
    getFedexExpeditionPickup: (expeditionId: string,locationId: string,dispatchDate: string, onSuccess: ((data : FedexExpeditionPickupOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/${expeditionId}/fedex-pickup`, {},  [{locationId}, {dispatchDate}], false, false, 'getFedexExpeditionPickup', onSuccess, callbacks, hashAuthentication);
    },
    getDachserStatus: (expeditionId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/${expeditionId}/dachser-status`, {},  [], false, false, 'getDachserStatus', onSuccess, callbacks, hashAuthentication);
    },
    searchTemplateExpeditionByName: (query: string, onSuccess: ((data : SearchTemplateExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/template/search`, {},  [{query}], false, false, 'searchTemplateExpeditionByName', onSuccess, callbacks, hashAuthentication);
    },
    searchExpeditionByNameOrAppId: (query: string, onSuccess: ((data : SearchExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/search`, {},  [{query}], false, false, 'searchExpeditionByNameOrAppId', onSuccess, callbacks, hashAuthentication);
    },
    getMultiduplicationV3JobDetail: (jobId: string, onSuccess: ((data : MultiduplicationV3JobDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}`, {},  [], false, false, 'getMultiduplicationV3JobDetail', onSuccess, callbacks, hashAuthentication);
    },
    deleteMultiduplicationV3Job: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}`, {},  [], false, false, 'deleteMultiduplicationV3Job', onSuccess, callbacks, hashAuthentication);
    },
    getMultiduplicationV3JobItems: (jobId: string,filter: MultiduplicationV3ItemsFilter,page: Pageable, onSuccess: ((data : PageResponseMultiduplicationV3JobItemOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/multiduplication/${jobId}/items`, {},  [filter, page], false, false, 'getMultiduplicationV3JobItems', onSuccess, callbacks, hashAuthentication);
    },
    getDuplicationJobDetail: (jobId: string, onSuccess: ((data : DuplicationJobDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/duplication/job/${jobId}`, {},  [], false, false, 'getDuplicationJobDetail', onSuccess, callbacks, hashAuthentication);
    },
    getDuplicationJobItems: (jobId: string,filter: DuplicationJobItemsFilter,page: Pageable, onSuccess: ((data : PageResponseDuplicationJobItemOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/duplication/job/${jobId}/items`, {},  [filter, page], false, false, 'getDuplicationJobItems', onSuccess, callbacks, hashAuthentication);
    },
    getExpeditionBulkDistributionJobDetail: (jobId: string, onSuccess: ((data : ExpeditionBulkDistributionJobDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/distribution/job/${jobId}`, {},  [], false, false, 'getExpeditionBulkDistributionJobDetail', onSuccess, callbacks, hashAuthentication);
    },
    deleteExpeditionBulkDistributionJob: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/expedition/distribution/job/${jobId}`, {},  [], false, false, 'deleteExpeditionBulkDistributionJob', onSuccess, callbacks, hashAuthentication);
    },
    getExpeditionBulkDistributionJobItems: (jobId: string,filter: ExpeditionBulkDistributionJobItemsFilter,page: Pageable, onSuccess: ((data : PageResponseExpeditionBulkDistributionJobItemOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition/distribution/job/${jobId}/items`, {},  [filter, page], false, false, 'getExpeditionBulkDistributionJobItems', onSuccess, callbacks, hashAuthentication);
    },
    getExpeditionModuleSettings_1: (companyId: string, onSuccess: ((data : ExpeditionModuleSettingsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/expedition-module-settings/${companyId}`, {},  [], false, false, 'getExpeditionModuleSettings_1', onSuccess, callbacks, hashAuthentication);
    },
    getEtransportDetail: (reservationId: string, onSuccess: ((data : ETransportDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/etransport/${reservationId}`, {},  [], false, false, 'getEtransportDetail', onSuccess, callbacks, hashAuthentication);
    },
    cuFindEmailRecipients: (page: Pageable,filter: FindEmailHistoryFilter, onSuccess: ((data : PageResponseEmailHistoryRecipientRowOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/email-history/recipients`, {},  [page, filter], false, false, 'cuFindEmailRecipients', onSuccess, callbacks, hashAuthentication);
    },
    getDistributionSettings: (onSuccess: ((data : DistributionSettingsResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/distribution/settings`, {},  [], false, false, 'getDistributionSettings', onSuccess, callbacks, hashAuthentication);
    },
    adminGetHTTPRequest: (requestId: string, onSuccess: ((data : DetailHTTPRequestResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/detail-http-request/${requestId}`, {},  [], false, false, 'adminGetHTTPRequest', onSuccess, callbacks, hashAuthentication);
    },
    getCustomsForSupplierNotification: (supplierNotificationId: string, onSuccess: ((data : CustomsDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/customs/supplier-notification/${supplierNotificationId}`, {},  [], false, false, 'getCustomsForSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    getCustomsForExpedition: (expeditionId: string, onSuccess: ((data : CustomsDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/customs/expedition/${expeditionId}`, {},  [], false, false, 'getCustomsForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    getInfoCancelExpedition: (applicationId: string,companyId: string, onSuccess: ((data : GetInfoCancelExpeditionResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/customer/expedition/${companyId}/${applicationId}/cancel`, {},  [], false, false, 'getInfoCancelExpedition', onSuccess, callbacks, hashAuthentication);
    },
    listAllCustomerNotification: (page: Pageable,filter: ListAllCustomerNotificationFilter, onSuccess: ((data : PageResponseListAllCustomerNotification)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/customer/customer-notification/list`, {},  [page, filter], false, false, 'listAllCustomerNotification', onSuccess, callbacks, hashAuthentication);
    },
    getCustomerNotificationDetail: (notificationId: string, onSuccess: ((data : GetCustomerNotificationDetail)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/customer/customer-notification/detail/${notificationId}`, {},  [], false, false, 'getCustomerNotificationDetail', onSuccess, callbacks, hashAuthentication);
    },
    getColumnOrderSetting: (companyId: string,entityType: string, onSuccess: ((data : GetColumnOrderSettingResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/company/${companyId}/column-order/${entityType}`, {},  [], false, false, 'getColumnOrderSetting', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyFolderTargetsCustomer: (onSuccess: ((data : NotifyTargetOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/company/folders/targets`, {},  [], false, false, 'listCompanyFolderTargetsCustomer', onSuccess, callbacks, hashAuthentication);
    },
    checkUserCanCreateReservation: (companyLocationId: string, onSuccess: ((data : CheckUserCanCreateReservationResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/check-user-can-create-reservation/${companyLocationId}`, {},  [], false, false, 'checkUserCanCreateReservation', onSuccess, callbacks, hashAuthentication);
    },
    checkLocationException: (locationId: string,startDate: string,endDate: string, onSuccess: ((data : CheckLocationExceptionOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/check-location-exception/${locationId}/${startDate}/${endDate}`, {},  [], false, false, 'checkLocationException', onSuccess, callbacks, hashAuthentication);
    },
    getCarrierList: (filter: GetLinkedCompaniesFilterInDTO,page: Pageable, onSuccess: ((data : PageResponseGetLinkedCompanyOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/carrier-list`, {},  [filter, page], false, false, 'getCarrierList', onSuccess, callbacks, hashAuthentication);
    },
    listArrivalsDeparturesLog: (filter: ListArrivalsDeparturesLogFilter,page: Pageable, onSuccess: ((data : PageResponseArrivalsDeparturesLogResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/camera/logs`, {},  [filter, page], false, false, 'listArrivalsDeparturesLog', onSuccess, callbacks, hashAuthentication);
    },
    loVCompanyCamerasByLocationId: (locationId: string, onSuccess: ((data : LoVCompanyCamerasResponseOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/camera/location/${locationId}/lov`, {},  [], false, false, 'loVCompanyCamerasByLocationId', onSuccess, callbacks, hashAuthentication);
    },
    listEffectiveCalendarLayouts: (onSuccess: ((data : EffectiveCalendarLayoutOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/calendar-layout/effective`, {},  [], false, false, 'listEffectiveCalendarLayouts', onSuccess, callbacks, hashAuthentication);
    },
    getAllowedCarPlate: (id: string, onSuccess: ((data : GetAllowedCarPlateResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/allowed-car-plate/${id}`, {},  [], false, false, 'getAllowedCarPlate', onSuccess, callbacks, hashAuthentication);
    },
    listPlanned: (page: Pageable, onSuccess: ((data : PageResponsePlannedEventOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/planned`, {},  [page], false, false, 'listPlanned', onSuccess, callbacks, hashAuthentication);
    },
    metadata: (onSuccess: ((data : RuleMetadataOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/metadata`, {},  [], false, false, 'metadata', onSuccess, callbacks, hashAuthentication);
    },
    listExecutions: (page: Pageable,ruleId: string,onlyMatched: boolean, onSuccess: ((data : PageResponseExecutionListItemOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/executions`, {},  [page, {ruleId}, {onlyMatched}], false, false, 'listExecutions', onSuccess, callbacks, hashAuthentication);
    },
    getExecution: (executionId: string, onSuccess: ((data : ExecutionDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/executions/${executionId}`, {},  [], false, false, 'getExecution', onSuccess, callbacks, hashAuthentication);
    },
    activity: (onSuccess: ((data : RobotActivityOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/activity`, {},  [], false, false, 'activity', onSuccess, callbacks, hashAuthentication);
    },
    activityFeed: (since: string,limit: number, onSuccess: ((data : RobotActivityFeedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/ai-dispatcher/activity/feed`, {},  [{since}, {limit}], false, false, 'activityFeed', onSuccess, callbacks, hashAuthentication);
    },
    adminWebhookListDefinitions: (page: Pageable,filter: WebhookDefinitionFilter, onSuccess: ((data : PageResponseWebhookDefinitionOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/webhook-test/definitions`, {},  [page, filter], false, false, 'adminWebhookListDefinitions', onSuccess, callbacks, hashAuthentication);
    },
    adminWebhookDeliveryPayload: (deliveryId: string, onSuccess: ((data : AdminWebhookDeliveryPayloadOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/webhook-delivery/${deliveryId}/payload`, {},  [], false, false, 'adminWebhookDeliveryPayload', onSuccess, callbacks, hashAuthentication);
    },
    adminWebhookDeliveryList: (filter: AdminWebhookDeliveryFilter,page: Pageable, onSuccess: ((data : PageResponseAdminWebhookDeliveryOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/webhook-delivery/list`, {},  [filter, page], false, false, 'adminWebhookDeliveryList', onSuccess, callbacks, hashAuthentication);
    },
    listResolvedEmails: (onSuccess: ((data : ListResolvedEmailsResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/list-resolved-emails`, {},  [], false, false, 'listResolvedEmails', onSuccess, callbacks, hashAuthentication);
    },
    listEmailRequest: (onSuccess: ((data : ListEmailRequestResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/list-email-request`, {},  [], false, false, 'listEmailRequest', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated Find email communication history grouped by email request
     */
    findEmailHistory: (page: Pageable,filter: FindEmailHistoryFilter, onSuccess: ((data : PageResponseEmailHistoryRequestOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/email-history`, {},  [page, filter], false, false, 'findEmailHistory', onSuccess, callbacks, hashAuthentication);
    },
    getResolvedEmailHtml: (resolvedEmailId: string, onSuccess: ((data : ResolvedEmailHtmlOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/email-history/resolved/${resolvedEmailId}/html`, {},  [], false, false, 'getResolvedEmailHtml', onSuccess, callbacks, hashAuthentication);
    },
    findEmailRecipients: (page: Pageable,filter: FindEmailHistoryFilter, onSuccess: ((data : PageResponseEmailHistoryRecipientRowOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/email-history/recipients`, {},  [page, filter], false, false, 'findEmailRecipients', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyFolderTargets: (companyId: string, onSuccess: ((data : NotifyTargetOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/company/${companyId}/folder/targets`, {},  [], false, false, 'listCompanyFolderTargets', onSuccess, callbacks, hashAuthentication);
    },
    adminGetCompanyLocation: (companyId: string,name: string,page: Pageable, onSuccess: ((data : PageResponseAdminCompanyLocationResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/company/${companyId}/company-location`, {},  [{name}, page], false, false, 'adminGetCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    adminGetNextOrderCargoTemplate: (onSuccess: ((data : NextOrderCargoTemplateOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/cargo-template/next-order`, {},  [], false, false, 'adminGetNextOrderCargoTemplate', onSuccess, callbacks, hashAuthentication);
    },
    adminListPlanned: (companyId: string,page: Pageable, onSuccess: ((data : PageResponsePlannedEventOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/ai-dispatcher/planned`, {},  [{companyId}, page], false, false, 'adminListPlanned', onSuccess, callbacks, hashAuthentication);
    },
    adminListExecutions: (companyId: string,page: Pageable,ruleId: string,onlyMatched: boolean, onSuccess: ((data : PageResponseExecutionListItemOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/ai-dispatcher/executions`, {},  [{companyId}, page, {ruleId}, {onlyMatched}], false, false, 'adminListExecutions', onSuccess, callbacks, hashAuthentication);
    },
    adminGetExecution: (companyId: string,executionId: string, onSuccess: ((data : ExecutionDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/ai-dispatcher/executions/${executionId}`, {},  [{companyId}], false, false, 'adminGetExecution', onSuccess, callbacks, hashAuthentication);
    },
    adminActivity: (companyId: string, onSuccess: ((data : RobotActivityOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/ai-dispatcher/activity`, {},  [{companyId}], false, false, 'adminActivity', onSuccess, callbacks, hashAuthentication);
    },
    adminActivityFeed: (companyId: string,since: string,limit: number, onSuccess: ((data : RobotActivityFeedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/ai-dispatcher/activity/feed`, {},  [{companyId}, {since}, {limit}], false, false, 'adminActivityFeed', onSuccess, callbacks, hashAuthentication);
    },
    adminLovAllFeatures: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin/admin-lov-features`, {},  [], false, false, 'adminLovAllFeatures', onSuccess, callbacks, hashAuthentication);
    },
    adminHttpRequestGetSettings: (onSuccess: ((data : AdminHTTPRequestSettingsResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin-http-request-settings/get`, {},  [], false, false, 'adminHttpRequestGetSettings', onSuccess, callbacks, hashAuthentication);
    },
    adminGetUsers: (page: Pageable,filter: AdminGetUsersFilter, onSuccess: ((data : PageResponseAdminUserOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/admin-get-users`, {},  [page, filter], false, false, 'adminGetUsers', onSuccess, callbacks, hashAuthentication);
    },
    listAdditionalTerms: (page: Pageable, onSuccess: ((data : PageResponseListAdditionTermsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/additional-terms`, {},  [page], false, false, 'listAdditionalTerms', onSuccess, callbacks, hashAuthentication);
    },
    getAdditionalTermById: (additionalTermId: string, onSuccess: ((data : GetAdditionalTermOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/v1.0/additional-terms/${additionalTermId}`, {},  [], false, false, 'getAdditionalTermById', onSuccess, callbacks, hashAuthentication);
    },
    deleteAdditionalTermById: (additionalTermId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/additional-terms/${additionalTermId}`, {},  [], false, false, 'deleteAdditionalTermById', onSuccess, callbacks, hashAuthentication);
    },
    getReports: (customerId: string, onSuccess: ((data : ManageReportsAdminReportsResponse[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/manage-reports-admin/reports/${customerId}`, {},  [], false, false, 'getReports', onSuccess, callbacks, hashAuthentication);
    },
    generateCMRPDFV2: (cmrId: string, onSuccess: ((data : CMRPDF)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/generate-cmr-pdf/cmr/${cmrId}`, {},  [], false, false, 'generateCMRPDFV2', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated
     */
    cuFindCarriersOrCarrierGroupsV2: (q: string, onSuccess: ((data : FindCarrierCarrierOrGroupResponseOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/customer/carriers-and-groups`, {},  [{q}], false, false, 'cuFindCarriersOrCarrierGroupsV2', onSuccess, callbacks, hashAuthentication);
    },
    getFreeSlotsForLocation: (localDate: string,eventDuration: number,locationId: string,reservationFilterOutIds: string[], onSuccess: ((data : FreeSlotsWrapperOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/calendar/free-slots-for-location`, {},  [{localDate}, {eventDuration}, {locationId}, {reservationFilterOutIds}], false, false, 'getFreeSlotsForLocation', onSuccess, callbacks, hashAuthentication);
    },
    queryAuditLog: (page: Pageable,filter: AuditFilter, onSuccess: ((data : PageResponseAuditEntryOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/audit`, {},  [page, filter], false, false, 'queryAuditLog', onSuccess, callbacks, hashAuthentication);
    },
    auditEnums: (onSuccess: ((data : AuditEnumCatalogOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/audit/lov/enums`, {},  [], false, false, 'auditEnums', onSuccess, callbacks, hashAuthentication);
    },
    auditCompanies: (entityType: string,role: string,entityId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/audit/lov/companies`, {},  [{entityType}, {role}, {entityId}], false, false, 'auditCompanies', onSuccess, callbacks, hashAuthentication);
    },
    auditActors: (entityType: string,entityId: string,role: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/audit/lov/actors`, {},  [{entityType}, {entityId}, {role}], false, false, 'auditActors', onSuccess, callbacks, hashAuthentication);
    },
    auditActions: (entityType: string,entityId: string, onSuccess: ((data : AuditActionLovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/audit/lov/actions`, {},  [{entityType}, {entityId}], false, false, 'auditActions', onSuccess, callbacks, hashAuthentication);
    },
    queryAuditLogAdmin: (page: Pageable,companyId: string,filter: AuditFilter, onSuccess: ((data : PageResponseAuditEntryOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/admin/audit`, {},  [page, {companyId}, filter], false, false, 'queryAuditLogAdmin', onSuccess, callbacks, hashAuthentication);
    },
    auditEnumsAdmin: (onSuccess: ((data : AuditEnumCatalogOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/admin/audit/lov/enums`, {},  [], false, false, 'auditEnumsAdmin', onSuccess, callbacks, hashAuthentication);
    },
    auditCompaniesAdmin: (role: string,companyId: string,entityType: string,entityId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/admin/audit/lov/companies`, {},  [{role}, {companyId}, {entityType}, {entityId}], false, false, 'auditCompaniesAdmin', onSuccess, callbacks, hashAuthentication);
    },
    auditActorsAdmin: (companyId: string,entityType: string,entityId: string,role: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/admin/audit/lov/actors`, {},  [{companyId}, {entityType}, {entityId}, {role}], false, false, 'auditActorsAdmin', onSuccess, callbacks, hashAuthentication);
    },
    auditActionsAdmin: (companyId: string,entityType: string,entityId: string, onSuccess: ((data : AuditActionLovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/2.0/admin/audit/lov/actions`, {},  [{companyId}, {entityType}, {entityId}], false, false, 'auditActionsAdmin', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyFromAresByICO: (ico: string, onSuccess: ((data : AresResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.4/ares/find-company-by-ico`, {},  [{ico}], false, false, 'getCompanyFromAresByICO', onSuccess, callbacks, hashAuthentication);
    },
    cuGetGroupsMessagesV2: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : ListGroupsMessagesOutV3DTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/customer`, {},  [], false, false, 'cuGetGroupsMessagesV2', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVAvailableCarriersForMessage: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : LoVCarriesToSendMessageOutV3DTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/carriers`, {},  [], false, false, 'cuLoVAvailableCarriersForMessage', onSuccess, callbacks, hashAuthentication);
    },
    caGetCountMessagesV2: (companyId: string,entityId: string,entityType: string, onSuccess: ((data : CountMessagesCarrierOutV3DTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/messages/${companyId}/${entityId}/${entityType}/messages/carrier/count`, {},  [], false, false, 'caGetCountMessagesV2', onSuccess, callbacks, hashAuthentication);
    },
    listDocumentsForEntity: (entityType: string,entityId: string, onSuccess: ((data : AttachmentUploadedOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/document/${entityType}/${entityId}/files`, {},  [], false, false, 'listDocumentsForEntity', onSuccess, callbacks, hashAuthentication);
    },
    listQuotationMaterialsForEntity: (entityType: string,entityId: string, onSuccess: ((data : AttachmentUploadedOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/document/${entityType}/${entityId}/files/quotation-materials`, {},  [], false, false, 'listQuotationMaterialsForEntity', onSuccess, callbacks, hashAuthentication);
    },
    copyOfAttachmentsFromEntity: (entityType: string,entityId: string,asPrivate: boolean, onSuccess: ((data : AttachmentUploadedOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/document/${entityType}/${entityId}/files/copy`, {},  [{asPrivate}], false, false, 'copyOfAttachmentsFromEntity', onSuccess, callbacks, hashAuthentication);
    },
    getDocumentForEntity: (entityType: string,entityId: string,fileId: string, onSuccess: ((data : FileOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/document/${entityType}/${entityId}/file/${fileId}`, {},  [], false, false, 'getDocumentForEntity', onSuccess, callbacks, hashAuthentication);
    },
    deleteDocumentForEntity: (entityType: string,entityId: string,fileId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.2/document/${entityType}/${entityId}/file/${fileId}`, {},  [], false, false, 'deleteDocumentForEntity', onSuccess, callbacks, hashAuthentication);
    },
    cuListExpeditionsV3: (filter: AllExpeditionCustomerFilter,page: Pageable, onSuccess: ((data : ExpeditionListDataOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/customer/expeditions`, {},  [filter, page], false, false, 'cuListExpeditionsV3', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVCatalogRegions: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/customer/companies/carriers/region/lov`, {},  [], false, false, 'cuLoVCatalogRegions', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVCatalogCarrierGroupsWithoutExisting: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/customer/companies/carriers/groups/lov`, {},  [], false, false, 'cuLoVCatalogCarrierGroupsWithoutExisting', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVCatalogCountries: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/customer/companies/carriers/country/lov`, {},  [], false, false, 'cuLoVCatalogCountries', onSuccess, callbacks, hashAuthentication);
    },
    cuGetCatalogCarriers: (filter: CatalogCarrierFilter,page: Pageable, onSuccess: ((data : PageResponseCatalogCarrierPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.2/customer/companies/carriers/catalog`, {},  [filter, page], false, false, 'cuGetCatalogCarriers', onSuccess, callbacks, hashAuthentication);
    },
    lovWeightModesForOrder: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/weight-mode-order`, {},  [], false, false, 'lovWeightModesForOrder', onSuccess, callbacks, hashAuthentication);
    },
    getProfileForCurrentUser: (onSuccess: ((data : UserProfileOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/user-profile`, {},  [], false, false, 'getProfileForCurrentUser', onSuccess, callbacks, hashAuthentication);
    },
    getUserInfo: (onSuccess: ((data : UserInfoOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/user-profile/user-info`, {},  [], false, false, 'getUserInfo', onSuccess, callbacks, hashAuthentication);
    },
    lovTruckTypes: (onSuccess: ((data : TruckTypeWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/truck-types`, {},  [], false, false, 'lovTruckTypes', onSuccess, callbacks, hashAuthentication);
    },
    lovTransportationTypes: (onSuccess: ((data : LovTransportationTypeOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/transportation-types`, {},  [], false, false, 'lovTransportationTypes', onSuccess, callbacks, hashAuthentication);
    },
    lovShipmentStateStatus: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/shipment-state-status`, {},  [], false, false, 'lovShipmentStateStatus', onSuccess, callbacks, hashAuthentication);
    },
    lovSHSNCargoTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/sh-sn/cargo-type`, {},  [], false, false, 'lovSHSNCargoTypes', onSuccess, callbacks, hashAuthentication);
    },
    lovSecurityRolesV2: (onSuccess: ((data : LovSecurityRolesDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/security-roles/lov`, {},  [], false, false, 'lovSecurityRolesV2', onSuccess, callbacks, hashAuthentication);
    },
    lovSchenkerProductTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/schenker/product-types`, {},  [], false, false, 'lovSchenkerProductTypes', onSuccess, callbacks, hashAuthentication);
    },
    lovSchenkerAddons: (productType: string, onSuccess: ((data : SchenkerLovForAddonTypeOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/schenker/addons/${productType}`, {},  [], false, false, 'lovSchenkerAddons', onSuccess, callbacks, hashAuthentication);
    },
    cuLovResponsiblePersons: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/responsible-person`, {},  [], false, false, 'cuLovResponsiblePersons', onSuccess, callbacks, hashAuthentication);
    },
    lovQuantityUnit: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/quantity-unit`, {},  [], false, false, 'lovQuantityUnit', onSuccess, callbacks, hashAuthentication);
    },
    lovOnBehalfOfForInheritor: (inheritorId: string, onSuccess: ((data : LovCompanyCodeListDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/on-behalf-of/${inheritorId}`, {},  [], false, false, 'lovOnBehalfOfForInheritor', onSuccess, callbacks, hashAuthentication);
    },
    lovNavyShippingCompanies: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/navy-shipping-companies`, {},  [], false, false, 'lovNavyShippingCompanies', onSuccess, callbacks, hashAuthentication);
    },
    lovLocationSharingPrivileges: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/location-sharing-privileges`, {},  [], false, false, 'lovLocationSharingPrivileges', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVIncotermsValues: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/incoterms`, {},  [], false, false, 'cuLoVIncotermsValues', onSuccess, callbacks, hashAuthentication);
    },
    lovExtraCosts: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/extra-costs`, {},  [], false, false, 'lovExtraCosts', onSuccess, callbacks, hashAuthentication);
    },
    lovExpeditionTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/expedition-types`, {},  [], false, false, 'lovExpeditionTypes', onSuccess, callbacks, hashAuthentication);
    },
    cuLovEmailStatus: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/email-status`, {},  [], false, false, 'cuLovEmailStatus', onSuccess, callbacks, hashAuthentication);
    },
    lovCustomsTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customs-types`, {},  [], false, false, 'lovCustomsTypes', onSuccess, callbacks, hashAuthentication);
    },
    lovCustomsStatus: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customs-status`, {},  [], false, false, 'lovCustomsStatus', onSuccess, callbacks, hashAuthentication);
    },
    listNotifyTargets: (onSuccess: ((data : NotifyTargetOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/subscriber/notify-targets`, {},  [], false, false, 'listNotifyTargets', onSuccess, callbacks, hashAuthentication);
    },
    cuListNotifications: (filter: NotificationListFilter,page: Pageable, onSuccess: ((data : PageResponseNotificationPreviewListOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/notification`, {},  [filter, page], false, false, 'cuListNotifications', onSuccess, callbacks, hashAuthentication);
    },
    cuCountUnreadNotification: (onSuccess: ((data : CountNotificationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/notification/count`, {},  [], false, false, 'cuCountUnreadNotification', onSuccess, callbacks, hashAuthentication);
    },
    cuGetLocationTemplatesAddressBook: (q: string,partnerId: string, onSuccess: ((data : ListAddressBooksOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/location-template`, {},  [{q}, {partnerId}], false, false, 'cuGetLocationTemplatesAddressBook', onSuccess, callbacks, hashAuthentication);
    },
    cuGetDetailExpeditionHeader: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionDetailTabPlanOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}`, {},  [], false, false, 'cuGetDetailExpeditionHeader', onSuccess, callbacks, hashAuthentication);
    },
    cuGetDetailExpeditionPlan: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/plan`, {},  [], false, false, 'cuGetDetailExpeditionPlan', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVAddMoreCarriers: (companyId: string,applicationId: string, onSuccess: ((data : AddMoreCarrierOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/distribution/more-carrier`, {},  [], false, false, 'cuLoVAddMoreCarriers', onSuccess, callbacks, hashAuthentication);
    },
    cuGetDetailExpeditionCarrierTabAssigning: (companyId: string,applicationId: string, onSuccess: ((data : CarrierPageOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/carrier`, {},  [], false, false, 'cuGetDetailExpeditionCarrierTabAssigning', onSuccess, callbacks, hashAuthentication);
    },
    cuGetDetailExpeditionCarrierQuotes: (companyId: string,applicationId: string,filter: ExpeditionDetailCarrierQuotesFilter, onSuccess: ((data : ExpeditionDetailCarrierQuotesResponseOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/carrier/quotes`, {},  [filter], false, false, 'cuGetDetailExpeditionCarrierQuotes', onSuccess, callbacks, hashAuthentication);
    },
    cuLovDemandStateForDetailExpedition: (companyId: string,applicationId: string, onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/carrier/quotes/lov/demand-state`, {},  [], false, false, 'cuLovDemandStateForDetailExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuLovCarrierForDetailExpedition: (companyId: string,applicationId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/carrier/quotes/lov/carrier`, {},  [], false, false, 'cuLovCarrierForDetailExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuGetDetailExpeditionCarrierTabAssigned: (companyId: string,applicationId: string, onSuccess: ((data : CarrierPageAssignedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/${companyId}/${applicationId}/carrier/assigned`, {},  [], false, false, 'cuGetDetailExpeditionCarrierTabAssigned', onSuccess, callbacks, hashAuthentication);
    },
    cuGetTemplateData: (expeditionTemplateId: string, onSuccess: ((data : TemplateExpeditionOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}`, {},  [], false, false, 'cuGetTemplateData', onSuccess, callbacks, hashAuthentication);
    },
    cuDeleteTemplateRoute: (expeditionTemplateId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/customer/expedition/template/${expeditionTemplateId}`, {},  [], false, false, 'cuDeleteTemplateRoute', onSuccess, callbacks, hashAuthentication);
    },
    cuListTemplates: (filter: CreatedByTemplateFiler,page: Pageable, onSuccess: ((data : PageResponseTemplatePreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/template/list`, {},  [filter, page], false, false, 'cuListTemplates', onSuccess, callbacks, hashAuthentication);
    },
    cuGetDistributionTemplateData: (distributionTemplateId: string, onSuccess: ((data : DistributionTemplateOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition/template/distribution/${distributionTemplateId}`, {},  [], false, false, 'cuGetDistributionTemplateData', onSuccess, callbacks, hashAuthentication);
    },
    cuLovExpeditionTemplates: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/expedition-template`, {},  [{q}], false, false, 'cuLovExpeditionTemplates', onSuccess, callbacks, hashAuthentication);
    },
    lovEnabledCompanyModule: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/modules/lov`, {},  [], false, false, 'lovEnabledCompanyModule', onSuccess, callbacks, hashAuthentication);
    },
    cuDetailCarrier: (carrierId: string, onSuccess: ((data : CatalogCarrierDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}`, {},  [], false, false, 'cuDetailCarrier', onSuccess, callbacks, hashAuthentication);
    },
    cuDeleteCarrier: (carrierId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}`, {},  [], false, false, 'cuDeleteCarrier', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVCarrierGroups: (carrierId: string, onSuccess: ((data : CarrierCarrierGroupLov)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}/groups/lov`, {},  [], false, false, 'cuLoVCarrierGroups', onSuccess, callbacks, hashAuthentication);
    },
    cuGetCarrierInfoByCrnAndState: (crn: string,state: string, onSuccess: ((data : CarrierSearchOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/companies/carrier/search`, {},  [{crn}, {state}], false, false, 'cuGetCarrierInfoByCrnAndState', onSuccess, callbacks, hashAuthentication);
    },
    cuDetailCarrierGroup: (carrierGroupId: string, onSuccess: ((data : CarrierGroupDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/carrier-groups/${carrierGroupId}`, {},  [], false, false, 'cuDetailCarrierGroup', onSuccess, callbacks, hashAuthentication);
    },
    cuDeleteCarrierGroup: (carrierGroupId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/customer/carrier-groups/${carrierGroupId}`, {},  [], false, false, 'cuDeleteCarrierGroup', onSuccess, callbacks, hashAuthentication);
    },
    cuLoVCarrierForGroup: (carrierGroupId: string, onSuccess: ((data : CarriersForGroupLov)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/customer/carrier-groups/${carrierGroupId}/carrier/lov`, {},  [], false, false, 'cuLoVCarrierForGroup', onSuccess, callbacks, hashAuthentication);
    },
    lovCurrency: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/currency`, {},  [], false, false, 'lovCurrency', onSuccess, callbacks, hashAuthentication);
    },
    lovCurrencyForCompany: (parentCompanyId: string, onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/currency/${parentCompanyId}`, {},  [], false, false, 'lovCurrencyForCompany', onSuccess, callbacks, hashAuthentication);
    },
    lovCountry: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/country`, {},  [], true, false, 'lovCountry', onSuccess, callbacks);
    },
    lovContainerTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/container-types`, {},  [], false, false, 'lovContainerTypes', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyForCurrentUser: (onSuccess: ((data : UserCompanyOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company`, {},  [], false, false, 'getCompanyForCurrentUser', onSuccess, callbacks, hashAuthentication);
    },
    listCompanyUsers: (page: Pageable,filter: CompanyUsersFilter, onSuccess: ((data : PageResponseUserCompanyUserPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company/users`, {},  [page, filter], false, false, 'listCompanyUsers', onSuccess, callbacks, hashAuthentication);
    },
    getSecurityUsage: (filter: SecurityUsageFilterInDTO, onSuccess: ((data : SecurityUsageOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company/security-usage`, {},  [filter], false, false, 'getSecurityUsage', onSuccess, callbacks, hashAuthentication);
    },
    getUsersBySecurity: (page: Pageable,filter: SecurityUsageUserFilterInDTO, onSuccess: ((data : PageResponseSecurityUsageUserOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company/security-usage/users`, {},  [page, filter], false, false, 'getUsersBySecurity', onSuccess, callbacks, hashAuthentication);
    },
    G: (onSuccess: ((data : CompanySecurityGroupPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company/security-group/`, {},  [], false, false, 'G', onSuccess, callbacks, hashAuthentication);
    },
    lovCompanyFolders: (q: string,entityType: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/company/folders`, {},  [{q}, {entityType}], false, false, 'lovCompanyFolders', onSuccess, callbacks, hashAuthentication);
    },
    cuLovCarriers: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carriers`, {},  [{q}], false, false, 'cuLovCarriers', onSuccess, callbacks, hashAuthentication);
    },
    caListDemands: (filter: AllQuoteStateFilter,page: Pageable, onSuccess: ((data : PageResponseQuotePreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/quotes`, {},  [filter, page], false, false, 'caListDemands', onSuccess, callbacks, hashAuthentication);
    },
    caListShipments: (filter: AllJobCarrierFilter,page: Pageable, onSuccess: ((data : PageResponseJobPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/jobs`, {},  [filter, page], false, false, 'caListShipments', onSuccess, callbacks, hashAuthentication);
    },
    caGetShipmentDetailHeader: (companyId: string,applicationId: string, onSuccess: ((data : ExpeditionDetailTabPlanOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}`, {},  [], false, false, 'caGetShipmentDetailHeader', onSuccess, callbacks, hashAuthentication);
    },
    caGetShipmentDetailProgressTabForReadyToShipment: (companyId: string,applicationId: string, onSuccess: ((data : ShipmentPageR2SOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/progress/assigned`, {},  [], false, false, 'caGetShipmentDetailProgressTabForReadyToShipment', onSuccess, callbacks, hashAuthentication);
    },
    caGetDetailShipmentPlan: (companyId: string,applicationId: string, onSuccess: ((data : JobDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/job/${companyId}/${applicationId}/plan`, {},  [], false, false, 'caGetDetailShipmentPlan', onSuccess, callbacks, hashAuthentication);
    },
    getQuoteDetailById: (quoteId: string, onSuccess: ((data : QuoteDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier/job/quote/${quoteId}`, {},  [], false, false, 'getQuoteDetailById', onSuccess, callbacks, hashAuthentication);
    },
    caLovDispatcher: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier-dispatcher`, {},  [], false, false, 'caLovDispatcher', onSuccess, callbacks, hashAuthentication);
    },
    lovExpeditionDispatcher: (expeditionId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier-dispatcher/${expeditionId}`, {},  [], false, false, 'lovExpeditionDispatcher', onSuccess, callbacks, hashAuthentication);
    },
    lovCarrierApiTypeValues: (carrierApiType: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/carrier-api-product/${carrierApiType}`, {},  [], false, false, 'lovCarrierApiTypeValues', onSuccess, callbacks, hashAuthentication);
    },
    lovCargoType: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/cargo-type`, {},  [], false, false, 'lovCargoType', onSuccess, callbacks, hashAuthentication);
    },
    /**
     * @deprecated Get all special cargo requirements
     */
    lovSpecialRequirements: (onSuccess: ((data : LovWithoutIdWithFillingDataDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/cargo-special-requirement`, {},  [], false, false, 'lovSpecialRequirements', onSuccess, callbacks, hashAuthentication);
    },
    lovSpecialRequirementsWithParentData: (inheritorId: string, onSuccess: ((data : LovWithoutIdWithFillingDataDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/cargo-special-requirement/${inheritorId}`, {},  [], false, false, 'lovSpecialRequirementsWithParentData', onSuccess, callbacks, hashAuthentication);
    },
    lovSpecialRequirementsWithParentDataAndNotification: (inheritorId: string,supplierNotificationId: string, onSuccess: ((data : LovWithoutIdWithFillingDataDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/cargo-special-requirement/${inheritorId}/${supplierNotificationId}`, {},  [], false, false, 'lovSpecialRequirementsWithParentDataAndNotification', onSuccess, callbacks, hashAuthentication);
    },
    lovCargoItemType: (onSuccess: ((data : CargoTemplateWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/cargo-item-type`, {},  [], false, false, 'lovCargoItemType', onSuccess, callbacks, hashAuthentication);
    },
    lovCargoItemTypeForCompany: (inheritorId: string, onSuccess: ((data : CargoTemplateWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/cargo-item-type/${inheritorId}`, {},  [], false, false, 'lovCargoItemTypeForCompany', onSuccess, callbacks, hashAuthentication);
    },
    getModulesInheritedForCompany: (companyId: string, onSuccess: ((data : InheritedModuleOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/${companyId}/module/my-inherited`, {},  [], false, false, 'getModulesInheritedForCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminListInheritingCompaniesByCompany: (companyId: string, onSuccess: ((data : AdminModuleInheritingPreviewDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/${companyId}/module/inherited`, {},  [], false, false, 'adminListInheritingCompaniesByCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminGetModulesForInheritedCompanyDependsOnParentCompany: (companyId: string,inheritedCompanyId: string, onSuccess: ((data : AdminModuleAllInheritedPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/${companyId}/module/inherited/${inheritedCompanyId}/modules`, {},  [], false, false, 'adminGetModulesForInheritedCompanyDependsOnParentCompany', onSuccess, callbacks, hashAuthentication);
    },
    adminLovExternalIdTypes: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/lov/external-id-types/lov`, {},  [], false, false, 'adminLovExternalIdTypes', onSuccess, callbacks, hashAuthentication);
    },
    adminLovCargoTemplates: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/lov/cargo-templates`, {},  [], false, false, 'adminLovCargoTemplates', onSuccess, callbacks, hashAuthentication);
    },
    adminLovAllSpecialReqs: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/lov/all-special-reqs`, {},  [], false, false, 'adminLovAllSpecialReqs', onSuccess, callbacks, hashAuthentication);
    },
    adminLoVAllCompanies: (onSuccess: ((data : LovCompanyDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/lov/all-companies`, {},  [], false, false, 'adminLoVAllCompanies', onSuccess, callbacks, hashAuthentication);
    },
    getAdminDashboardBuildMeta: (onSuccess: ((data : DashboardBuildMetaDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/dashboard/build-meta`, {},  [], false, false, 'getAdminDashboardBuildMeta', onSuccess, callbacks, hashAuthentication);
    },
    adminGetNotificationForCompany: (companyId: string, onSuccess: ((data : AdminCompanyNotificationEnablingOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.1/admin/company/${companyId}/notifications`, {},  [], false, false, 'adminGetNotificationForCompany', onSuccess, callbacks, hashAuthentication);
    },
    isEntityManagedByWorkflow: (entityId: string,entityType: string, onSuccess: ((data : WorkflowEntityIsManagedOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/workflow/${entityType}/${entityId}/managed`, {},  [], false, false, 'isEntityManagedByWorkflow', onSuccess, callbacks, hashAuthentication);
    },
    getAllStateForCurrentWFForCompany: (entityType: string, onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/workflow/${entityType}/states`, {},  [], false, false, 'getAllStateForCurrentWFForCompany', onSuccess, callbacks, hashAuthentication);
    },
    getLocationsWithEnabledVisitor: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/visitor-record/lov/locations`, {},  [], false, false, 'getLocationsWithEnabledVisitor', onSuccess, callbacks, hashAuthentication);
    },
    lovUsersForCompany: (q: string,companyId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/users/${companyId}`, {},  [{q}], false, false, 'lovUsersForCompany', onSuccess, callbacks, hashAuthentication);
    },
    lovUsersWithSpecificRole: (q: string,role: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/users/role/${role}`, {},  [{q}], false, false, 'lovUsersWithSpecificRole', onSuccess, callbacks, hashAuthentication);
    },
    lovUsersWithSpecificPermission: (q: string,permission: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/users/permission/${permission}`, {},  [{q}], false, false, 'lovUsersWithSpecificPermission', onSuccess, callbacks, hashAuthentication);
    },
    detailSupplierNotificationById: (supplierNotificationId: string, onSuccess: ((data : DetailSupplierNotificationOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}`, {},  [], false, false, 'detailSupplierNotificationById', onSuccess, callbacks, hashAuthentication);
    },
    cuGetSupplierNotificationForDuplication: (supplierNotificationId: string, onSuccess: ((data : SupplierNotificationDataForSNOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/supplier-notification`, {},  [], false, false, 'cuGetSupplierNotificationForDuplication', onSuccess, callbacks, hashAuthentication);
    },
    cuGetSupplierNotificationForExpedition: (supplierNotificationId: string, onSuccess: ((data : SupplierNotificationToExpeditionOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/supplier-notification/${supplierNotificationId}/expedition`, {},  [], false, false, 'cuGetSupplierNotificationForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    detailShipmentById: (shipmentId: string, onSuccess: ((data : DetailShipmentOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/shipment/${shipmentId}`, {},  [], false, false, 'detailShipmentById', onSuccess, callbacks, hashAuthentication);
    },
    getShipmentDataForSupplierNotification: (shipmentId: string, onSuccess: ((data : ShipmentDataForSNOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/shipment/${shipmentId}/notification-data`, {},  [], false, false, 'getShipmentDataForSupplierNotification', onSuccess, callbacks, hashAuthentication);
    },
    lovSecurityGroups: (onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/security-groups/lov`, {},  [], false, false, 'lovSecurityGroups', onSuccess, callbacks, hashAuthentication);
    },
    getMapDataForExpedition: (companyId: string,applicationId: string, onSuccess: ((data : MapDataOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/map-information/${companyId}/${applicationId}`, {},  [], false, false, 'getMapDataForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    getMapLastTruckPosition: (companyId: string,applicationId: string, onSuccess: ((data : MapDataLastTruckPosition)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/map-information/${companyId}/${applicationId}/truck-position`, {},  [], false, false, 'getMapLastTruckPosition', onSuccess, callbacks, hashAuthentication);
    },
    lovLoadingTypes: (onSuccess: ((data : LovWithoutIdDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/loading-types`, {},  [], false, false, 'lovLoadingTypes', onSuccess, callbacks, hashAuthentication);
    },
    getInvoiceByAttachmentId: (attachmentId: string, onSuccess: ((data : InvoiceOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/invoices/by-attachment/${attachmentId}`, {},  [], false, false, 'getInvoiceByAttachmentId', onSuccess, callbacks, hashAuthentication);
    },
    getGroupDemandDetailByIdCompleteView: (groupDemandId: string, onSuccess: ((data : GroupDemandDetailCompleteViewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/group-demand/${groupDemandId}/completed`, {},  [], false, false, 'getGroupDemandDetailByIdCompleteView', onSuccess, callbacks, hashAuthentication);
    },
    lovExternalIdTypes: (onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/external-id-types/lov`, {},  [], false, false, 'lovExternalIdTypes', onSuccess, callbacks, hashAuthentication);
    },
    lovDriverTemplates: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/driver-template`, {},  [{q}], false, false, 'lovDriverTemplates', onSuccess, callbacks, hashAuthentication);
    },
    lovDriverTemplatesForExp: (expeditionId: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/driver-template/${expeditionId}`, {},  [], false, false, 'lovDriverTemplatesForExp', onSuccess, callbacks, hashAuthentication);
    },
    getDescribeModel: (modelPrefix: string,modelName: string, onSuccess: ((data : PropertyWithSubProperties)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/describe/${modelPrefix}/${modelName}`, {},  [], false, false, 'getDescribeModel', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionConsigneeTasks: (onSuccess: ((data : ConsigneeTasksDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/tasks/consignee`, {},  [], false, false, 'getDashboardSectionConsigneeTasks', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionCarrierTasks: (onSuccess: ((data : CarrierTasksDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/tasks/carrier`, {},  [], false, false, 'getDashboardSectionCarrierTasks', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionSupplierNotifications: (partnerRole: string,statsRange: string, onSuccess: ((data : SupplierNotificationStatisticsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/supplier-notifications`, {},  [{partnerRole}, {statsRange}], false, false, 'getDashboardSectionSupplierNotifications', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionSupplierNotificationsTopPartners: (partnerRole: string,statsRange: string,supplierNotificationSortBy: string,supplierNotificationSortDir: string, onSuccess: ((data : NotificationPartnerRowDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/supplier-notifications/top-partners`, {},  [{partnerRole}, {statsRange}, {supplierNotificationSortBy}, {supplierNotificationSortDir}], false, false, 'getDashboardSectionSupplierNotificationsTopPartners', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionShipments: (shipmentRole: string,statsRange: string, onSuccess: ((data : ShipmentStatisticsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/shipments`, {},  [{shipmentRole}, {statsRange}], false, false, 'getDashboardSectionShipments', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionShipmentsTopPartners: (shipmentRole: string,statsRange: string,shipmentSortBy: string,shipmentSortDir: string, onSuccess: ((data : ShipmentTopRowDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/shipments/top-partners`, {},  [{shipmentRole}, {statsRange}, {shipmentSortBy}, {shipmentSortDir}], false, false, 'getDashboardSectionShipmentsTopPartners', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionReservations: (partnerRole: string,statsRange: string, onSuccess: ((data : ReservationStatisticsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/reservations`, {},  [{partnerRole}, {statsRange}], false, false, 'getDashboardSectionReservations', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionReservationsLocations: (partnerRole: string,statsRange: string,reservationSortBy: string,reservationSortDir: string, onSuccess: ((data : ReservationLocationRowDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/reservations/locations`, {},  [{partnerRole}, {statsRange}, {reservationSortBy}, {reservationSortDir}], false, false, 'getDashboardSectionReservationsLocations', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionCustomsDeclarations: (statsRange: string, onSuccess: ((data : CustomsDeclarationStatisticsDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/customs-declarations`, {},  [{statsRange}], false, false, 'getDashboardSectionCustomsDeclarations', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardSectionCustomsDeclarationsTopPartners: (statsRange: string,customsDeclarationSortBy: string,customsDeclarationSortDir: string, onSuccess: ((data : CustomsDeclarationTopPartnerRowDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/statistics/customs-declarations/top-partners`, {},  [{statsRange}, {customsDeclarationSortBy}, {customsDeclarationSortDir}], false, false, 'getDashboardSectionCustomsDeclarationsTopPartners', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardAvailability: (onSuccess: ((data : DashboardAvailabilityDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/dashboard/availability`, {},  [], false, false, 'getDashboardAvailability', onSuccess, callbacks, hashAuthentication);
    },
    cuLovPartners: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/partners`, {},  [{q}], false, false, 'cuLovPartners', onSuccess, callbacks, hashAuthentication);
    },
    cuGetLabelsForEntity: (entityType: string,applicationId: string, onSuccess: ((data : LabelPreviewWithoutTypeOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/labels/${entityType}/${applicationId}`, {},  [], false, false, 'cuGetLabelsForEntity', onSuccess, callbacks, hashAuthentication);
    },
    listExtraCostsForExpedition: (companyId: string,applicationId: string, onSuccess: ((data : ExtraCostsPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/extra-costs/list`, {},  [], false, false, 'listExtraCostsForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuGetUnpublishedCount: (onSuccess: ((data : ExpeditionUnpublishedCountOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/expedition/publish/unpublished/count`, {},  [], false, false, 'cuGetUnpublishedCount', onSuccess, callbacks, hashAuthentication);
    },
    cuLovDepartments: (q: string, onSuccess: ((data : string[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/customer/departments`, {},  [{q}], false, false, 'cuLovDepartments', onSuccess, callbacks, hashAuthentication);
    },
    lovGetAllLocationsForCompanyId: (q: string,showOnlyWithRamp: boolean,filterPartnerLocations: boolean,includeLocationId: string,companyModule: string,companyId: string, onSuccess: ((data : LovCompanyLocationWithOpeningHours[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/${companyId}/${companyModule}/locations`, {},  [{q}, {showOnlyWithRamp}, {filterPartnerLocations}, {includeLocationId}], false, false, 'lovGetAllLocationsForCompanyId', onSuccess, callbacks, hashAuthentication);
    },
    getInheritCompanySettings: (identifier: CompanySettingsIdInDTO,companyId: string,companyType: string, onSuccess: ((data : CompanySettingsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/settings/${companyType}/${companyId}`, {},  [identifier], false, false, 'getInheritCompanySettings', onSuccess, callbacks, hashAuthentication);
    },
    getReservationDetail: (reservationId: string, onSuccess: ((data : ReservationDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/reservation/${reservationId}`, {},  [], false, false, 'getReservationDetail', onSuccess, callbacks, hashAuthentication);
    },
    deleteReservation: (reservationId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/company/reservation/${reservationId}`, {},  [], false, false, 'deleteReservation', onSuccess, callbacks, hashAuthentication);
    },
    getReservationForRampDashboard: (locationId: string, onSuccess: ((data : ReservationRampDashboardOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/reservation/location/${locationId}/ramp-dashboard`, {},  [], false, false, 'getReservationForRampDashboard', onSuccess, callbacks, hashAuthentication);
    },
    getModulesDashboard: (onSuccess: ((data : ModulesPreviewDataOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/modules`, {},  [], false, false, 'getModulesDashboard', onSuccess, callbacks, hashAuthentication);
    },
    getRampsForCompanyLocation: (locationId: string,showTemporaryClosed: boolean, onSuccess: ((data : CompanyLocationRampWithOpeningHoursOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/ramps`, {},  [{showTemporaryClosed}], false, false, 'getRampsForCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyLocationFutureReservationsCount: (locationId: string, onSuccess: ((data : CompanyLocationFutureReservationsOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/future-reservations-count`, {},  [], false, false, 'getCompanyLocationFutureReservationsCount', onSuccess, callbacks, hashAuthentication);
    },
    getExceptionsForCompanyLocation: (locationId: string, onSuccess: ((data : CompanyLocationExceptionPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/exception`, {},  [], false, false, 'getExceptionsForCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    getCmrSigningImageSender: (locationId: string, onSuccess: ((data : CmrSigningImageOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/cmr-signing/sender/image`, {},  [], false, false, 'getCmrSigningImageSender', onSuccess, callbacks, hashAuthentication);
    },
    getCmrSigningImageReceiver: (locationId: string, onSuccess: ((data : CmrSigningImageOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${locationId}/cmr-signing/receiver/image`, {},  [], false, false, 'getCmrSigningImageReceiver', onSuccess, callbacks, hashAuthentication);
    },
    getSharedRampsForCompanyLocation: (locationId: string,companyId: string,showTemporaryClosed: boolean, onSuccess: ((data : CompanyLocationRampWithOpeningHoursOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/${companyId}/${locationId}/ramps`, {},  [{showTemporaryClosed}], false, false, 'getSharedRampsForCompanyLocation', onSuccess, callbacks, hashAuthentication);
    },
    getRampsOpeningHoursForDateRange: (requestParams: RampsOpeningHoursDateRangeRequestInDTO, onSuccess: ((data : RampOpeningHoursByDateRangeOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/ramps/opening-hours-by-date`, {},  [requestParams], false, false, 'getRampsOpeningHoursForDateRange', onSuccess, callbacks, hashAuthentication);
    },
    getCompanyLocationsPaged: (q: string,showOnlyWithRamp: boolean,showOnlyPartnerLocation: boolean,showDeleted: boolean,page: Pageable, onSuccess: ((data : PageResponseCompanyLocationsListPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/paged`, {},  [{q}, {showOnlyWithRamp}, {showOnlyPartnerLocation}, {showDeleted}, page], false, false, 'getCompanyLocationsPaged', onSuccess, callbacks, hashAuthentication);
    },
    getLoVCompanyLocations: (showOnlyWithRamp: boolean, onSuccess: ((data : CompanyLocationWithOpeningHours[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/lov`, {},  [{showOnlyWithRamp}], false, false, 'getLoVCompanyLocations', onSuccess, callbacks, hashAuthentication);
    },
    getRampsForMultipleCompanyLocations: (requestParams: RequestParamsForMultipleLocationsInDTO, onSuccess: ((data : CompanyLocationRampWithOpeningHoursOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/localities/ramps`, {},  [requestParams], false, false, 'getRampsForMultipleCompanyLocations', onSuccess, callbacks, hashAuthentication);
    },
    getDashboardLocations: (q: string,showOnlyWithRamp: boolean, onSuccess: ((data : CompanyLocationsListPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/location/dashboard`, {},  [{q}, {showOnlyWithRamp}], false, false, 'getDashboardLocations', onSuccess, callbacks, hashAuthentication);
    },
    getLocRampTable: (locationId: string, onSuccess: ((data : LocationRampTableOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/loc-ramp-table/${locationId}`, {},  [], false, false, 'getLocRampTable', onSuccess, callbacks, hashAuthentication);
    },
    getAllLabelsForCompanyEntityType: (entityType: string,q: string, onSuccess: ((data : LabelPreviewWithoutTypeOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/labels/${entityType}`, {},  [{q}], false, false, 'getAllLabelsForCompanyEntityType', onSuccess, callbacks, hashAuthentication);
    },
    listCustomDataByType: (customDataType: string, onSuccess: ((data : CompanyCustomDataPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/company/custom-data/type/${customDataType}`, {},  [], false, false, 'listCustomDataByType', onSuccess, callbacks, hashAuthentication);
    },
    lovOwnersIncludingSelf: (companyModule: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/companies/${companyModule}/owners-including-self`, {},  [], false, false, 'lovOwnersIncludingSelf', onSuccess, callbacks, hashAuthentication);
    },
    lovInheritorsIncludingSelf: (companyModule: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/companies/${companyModule}/inheritors-including-self`, {},  [], false, false, 'lovInheritorsIncludingSelf', onSuccess, callbacks, hashAuthentication);
    },
    lovAllCompaniesByInheritModule: (companyModule: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/companies/${companyModule}/inherit`, {},  [], false, false, 'lovAllCompaniesByInheritModule', onSuccess, callbacks, hashAuthentication);
    },
    lovUsersOfCompanyWithSpecificRole: (companyId: string,role: string,q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/companies/${companyId}/users/role/${role}`, {},  [{q}], false, false, 'lovUsersOfCompanyWithSpecificRole', onSuccess, callbacks, hashAuthentication);
    },
    lovUsersOfCompanyWithSpecificPermission: (companyId: string,permission: string,q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/companies/${companyId}/users/permission/${permission}`, {},  [{q}], false, false, 'lovUsersOfCompanyWithSpecificPermission', onSuccess, callbacks, hashAuthentication);
    },
    getCMRDetail: (expeditionId: string, onSuccess: ((data : GetCMRDetailResponse)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/cmr/${expeditionId}`, {},  [], false, false, 'getCMRDetail', onSuccess, callbacks, hashAuthentication);
    },
    caListGroupDemands: (page: Pageable,filter: GroupDemandFilter, onSuccess: ((data : PageResponseGroupDemandCarrierListPreviewOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/carrier/group-demand`, {},  [page, filter], false, false, 'caListGroupDemands', onSuccess, callbacks, hashAuthentication);
    },
    cuLovCustomersForCarrier: (q: string, onSuccess: ((data : LovDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/carrier/customers`, {},  [{q}], false, false, 'cuLovCustomersForCarrier', onSuccess, callbacks, hashAuthentication);
    },
    downloadAttachment: (attachmentId: string, onSuccess: ((data : AttachmentDownloadOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/attachment/${attachmentId}`, {},  [], false, false, 'downloadAttachment', onSuccess, callbacks, hashAuthentication);
    },
    deleteAttachment: (attachmentId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/attachment/${attachmentId}`, {},  [], false, false, 'deleteAttachment', onSuccess, callbacks, hashAuthentication);
    },
    lovAttachmentDocumentType: (onSuccess: ((data : LovDocumentTypeOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/attachment-document-type`, {},  [], false, false, 'lovAttachmentDocumentType', onSuccess, callbacks, hashAuthentication);
    },
    adminGetCompanyDetail: (companyId: string, onSuccess: ((data : AdminCompanyDetailOutDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('get', `${backendUrl}/api/1.0/admin/company-detail/${companyId}`, {},  [], false, false, 'adminGetCompanyDetail', onSuccess, callbacks, hashAuthentication);
    },
    deleteCarPlate: (id: string, onSuccess: ((data : DeleteCompanyCarPlateResponseDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v2.0/carplate/${id}`, {},  [], false, false, 'deleteCarPlate', onSuccess, callbacks, hashAuthentication);
    },
    deleteUserFilter: (filterId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/users/filter/${filterId}`, {},  [], false, false, 'deleteUserFilter', onSuccess, callbacks, hashAuthentication);
    },
    deleteCompanyUserDepartment: (id: string, onSuccess: ((data : DeleteCompanyUserDepartmentResponseDTO)=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/user/department/${id}`, {},  [], false, false, 'deleteCompanyUserDepartment', onSuccess, callbacks, hashAuthentication);
    },
    cancelExportJob: (jobId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/export/jobs/${jobId}`, {},  [], false, false, 'cancelExportJob', onSuccess, callbacks, hashAuthentication);
    },
    deleteExpeditionBulkDistributionItem: (jobId: string,itemId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/expedition/distribution/job/${jobId}/items/${itemId}`, {},  [], false, false, 'deleteExpeditionBulkDistributionItem', onSuccess, callbacks, hashAuthentication);
    },
    deleteCam: (camId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/delete-cam/${camId}`, {},  [], false, false, 'deleteCam', onSuccess, callbacks, hashAuthentication);
    },
    deleteAllowedCamPlate: (allowedCarPlateId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/delete-allowed-car-plate/${allowedCarPlateId}`, {},  [], false, false, 'deleteAllowedCamPlate', onSuccess, callbacks, hashAuthentication);
    },
    deleteCustomsInvoice: (invoiceId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/customs/invoices/${invoiceId}`, {},  [], false, false, 'deleteCustomsInvoice', onSuccess, callbacks, hashAuthentication);
    },
    deleteCompanyCodeList: (id: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/company-code-list/${id}`, {},  [], false, false, 'deleteCompanyCodeList', onSuccess, callbacks, hashAuthentication);
    },
    archiveLabel: (labelId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/archive-label/${labelId}`, {},  [], false, false, 'archiveLabel', onSuccess, callbacks, hashAuthentication);
    },
    deleteCompanyNotificationSetting: (companyId: string,notificationSettingId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/v1.0/admin/company/${companyId}/notification-setting/${notificationSettingId}`, {},  [], false, false, 'deleteCompanyNotificationSetting', onSuccess, callbacks, hashAuthentication);
    },
    cuRemoveGroupOnCarrierDetail: (carrierId: string,carrierGroupId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/customer/companies/carrier/${carrierId}/groups/${carrierGroupId}`, {},  [], false, false, 'cuRemoveGroupOnCarrierDetail', onSuccess, callbacks, hashAuthentication);
    },
    cuRemoveCarrierFromCarrierGroup: (carrierId: string,carrierGroupId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.1/customer/carrier-groups/${carrierGroupId}/carrier/${carrierId}`, {},  [], false, false, 'cuRemoveCarrierFromCarrierGroup', onSuccess, callbacks, hashAuthentication);
    },
    deleteDocumentForExpedition: (companyId: string,applicationId: string,fileId: string, onSuccess: (()=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/document/${companyId}/${applicationId}/file/${fileId}`, {},  [], false, false, 'deleteDocumentForExpedition', onSuccess, callbacks, hashAuthentication);
    },
    cuDeleteExtraCostForExpedition: (companyId: string,applicationId: string,extraCostId: string, onSuccess: ((data : ExtraCostsPreviewOutDTO[])=>void), hashAuthentication: string = null, callbacks: Callbacks ={}): void => {
      executeRequest('delete', `${backendUrl}/api/1.0/customer/expedition/${companyId}/${applicationId}/extra-costs/${extraCostId}`, {},  [], false, false, 'cuDeleteExtraCostForExpedition', onSuccess, callbacks, hashAuthentication);
    },
  };

  return apiMethods;
};
